import React, {
  useState,
  useEffect,
  useContext,
  useRef,
  useMemo,
  useLayoutEffect,
  forwardRef,
} from "react";
// import toast, { Toaster } from 'react-hot-toast';
import {
  Image,
  Col,
  Row,
  Container,
  Form,
  Table,
  Button,
  ButtonGroup,
  Dropdown,
  Modal,
  ListGroup,
} from "react-bootstrap";
import {
  IconSales,
  IconBonus,
  IconAgentes,
  IconConfig,
  IconSalir,
  IconReportes,
  IconGrupos,
  IconOficina,
  IconStar,
  IconEmailActive,
  IconEmailInactive,
  IconPlus,
  IconMinSearch,
  IconCheckActive,
  IconCheckInactive,
  IconBanner24k,
  IconBannerDiamante,
  IconBannerBuenaRacha,
  IconBannerBono,
  IconBannerEscalon,
  IconEditar,
  IconAttachment,
  IconClose,
} from "./Icons";
import { TabNavigation } from "./TabNavigation/TabNavigation";
import { ResponsiveLine } from "@nivo/line";
import { ResponsivePie, ResponsivePieCanvas } from "@nivo/pie";
import Skeleton from "react-loading-skeleton";
import { MultiSelect } from "react-multi-select-component";
import { v4 as uuidv4 } from "uuid";
import { Link, useHistory } from "react-router-dom";
import {
  SwitchComponent,
  SwitchComponentFiles,
  SwitchComponentProd,
  SwitchOnOff,
  SwitchOnOffLeft,
  SwitchComponentPolizas,
} from "./Switch/Switch";
import { AuthContext } from "../auth/AuthContext";
import { types } from "../types/types";
import "./Components.css";
import moment, { months } from "moment";
import "moment/locale/es";
moment.locale("mx");


function Navbar({ state, updateState }) {
  const { openMenu } = state;
  return (
    <nav
      className={`ws_navbar ws_navbar_fixed ${
        !openMenu ? "ws_navbar_close" : ""
      } `}
    >
      <Image
        onClick={() => {
          updateState({ openMenu: !openMenu });
        }}
        src={`/img/menuOpen.svg`}
        alt="menu-open"
        className="ws_navbar_iconm"
      />

      <Image
        src={`/img/aryaLogo.svg`}
        alt="arya-logo"
        className="ws_navbar_iconm"
      />

      <div style={{ cursor: "pointer" }}>
        {/*<Image
          src={`/img/darkConfig.svg`}
          alt="icon-config"
          className="ws_navbar_iconm" />
        <span className="ws_navbar_text">Config</span>*/}
      </div>
    </nav>
  );
}

function NavbarLogin() {
  return (
    <nav
      className={`ws_navbar ws_navbar_fixed d-flex justify-content-center align-items-center ps-0`}
      style={{ marginLeft: "0px" }}
    >
      <Image
        src={`./img/aryaLogo.svg`}
        alt="arya-logo"
        className="ws_navbar_iconm"
      />
    </nav>
  );
}

function Asidebar({ state, updateState }) {
  const { openMenu, viewMobile } = state;

  const [active, setActive] = useState(0);
  let history = useHistory();
  const {
    usuario: { name },
    dispatch,
  } = useContext(AuthContext);

  const handleLogout = () => {
    history.replace("/login");
    dispatch({
      type: types.logout,
    });
  };

  const { usuario } = useContext(AuthContext);
  const { nombre,tipo } = usuario;


  return (
    <aside
      className={`ws_aside_left ${!openMenu ? "ws_aside_left_close" : ""} ${
        openMenu && viewMobile ? "ws_aside_left_mobile_open" : ""
      }`}
    >
      <a href="#" className="ws_brand">
        {nombre}
      </a>
      <div className="ws_sidebar">
        <ul>
          {/*
          <li>
            <Link to="/"
              onMouseEnter={
                () => {
                  console.log('hover')
                }
              }
              style={{color:'#ccc'}}
            ><IconDashboard color="#fff" width="40px" height="40px" />&nbsp;&nbsp;Dashboard</Link>
          </li>
          */}

          {
            (tipo=='1') && (
              <li>
                <Link
                  to="/"
                  style={{
                    color: active === 0 ? "#0ca1b4" : "inherit",
                    fontWeight: active === 0 ? "700" : "inherit",
                  }}
                  onClick={() => {
                    setActive(0);
                  }}
                >
                  <IconSales color="#fff" width="40px" height="40px" />
                  &nbsp;&nbsp;Ventas
                </Link>
              </li>
            )
          }
          
          {/*<li>
            <Link to="/operaciones" style={{color:'#ccc'}}><IconOperaciones color="#fff" width="40px" height="40px" />&nbsp;&nbsp;Operaciones</Link>
          </li>
          <li>
            <Link to="/clientes" style={{color:'#ccc'}}><IconClientes color="#fff" width="40px" height="40px" />&nbsp;&nbsp;Clientes</Link>
          </li>
          <li>
            <Link to="/segmentacion" style={{color:'#ccc'}}><IconSegmento color="#fff" width="40px" height="40px" />&nbsp;&nbsp;Segmentación</Link>
          </li>*/}
          <li>
            <Link
              to="/bonos"
              style={{
                color: active === 1 ? "#0ca1b4" : "inherit",
                fontWeight: active === 1 ? "700" : "inherit",
              }}
              onClick={() => {
                setActive(1);
              }}
            >
              <IconBonus color="#fff" width="40px" height="40px" />
              &nbsp;&nbsp;Logros
            </Link>
          </li>
          <hr className="ws_separator" />

          {
            (tipo=='1' || tipo=='2') && (
              <li>
                <Link
                  to="/oficinas"
                  style={{
                    color: active === 2 ? "#0ca1b4" : "inherit",
                    fontWeight: active === 2 ? "700" : "inherit",
                  }}
                  onClick={() => {
                    setActive(2);
                  }}
                >
                  <IconOficina color="#fff" width="40px" height="40px" />
                  &nbsp;&nbsp;Oficinas
                </Link>
              </li>
            )
          }
          
          <li>
            <Link
              to="/agentes"
              style={{
                color: active === 3 ? "#0ca1b4" : "inherit",
                fontWeight: active === 3 ? "700" : "inherit",
              }}
              onClick={() => {
                setActive(3);
              }}
            >
              <IconAgentes color="#fff" width="40px" height="40px" />
              &nbsp;&nbsp;Agentes
            </Link>
          </li>
          <hr className="ws_separator" />

          <li>
            <Link
              to="/grupos"
              style={{
                color: active === 4 ? "#0ca1b4" : "inherit",
                fontWeight: active === 4 ? "700" : "inherit",
              }}
              onClick={() => {
                setActive(4);
              }}
            >
              <IconGrupos color="#fff" width="40px" height="40px" />
              &nbsp;&nbsp;Grupos
            </Link>
          </li>

          <li>
            <Link
              to="/reportes"
              style={{
                color: active === 5 ? "#0ca1b4" : "inherit",
                fontWeight: active === 5 ? "700" : "inherit",
              }}
              onClick={() => {
                setActive(5);
              }}
            >
              <IconReportes color="#fff" width="40px" height="40px" />
              &nbsp;&nbsp;Reportes
            </Link>
          </li>

          {
            (tipo!='3') && (
              <li>
                <Link
                  to="/configuracion"
                  style={{
                    color: active === 6 ? "#0ca1b4" : "inherit",
                    fontWeight: active === 6 ? "700" : "inherit",
                  }}
                  onClick={() => {
                    setActive(6);
                  }}
                >
                  <IconConfig color="#fff" width="40px" height="40px" />
                  &nbsp;&nbsp;Configuración
                </Link>
              </li>
            )
          }
          
          {/* <li>
            <Link
              to="/administracion"
              style={{
                color: active === 7 ? "#0ca1b4" : "inherit",
                fontWeight: active === 7 ? "700" : "inherit",
              }}
              onClick={() => {
                setActive(7);
              }}
            >
              <IconReportes color="#fff" width="40px" height="40px" />
              &nbsp;&nbsp;Administración
            </Link>
          </li> */}
          <li>
            <a href="#" onClick={handleLogout}>
              <IconSalir color="#fff" width="40px" height="40px" />
              &nbsp;&nbsp;Salir
            </a>
          </li>
        </ul>
      </div>
    </aside>
  );
}

function BoxInfo({ state, updateState, background, color, title, value }) {
  return (
    <Col xs={6} sm={6} md={3} lg={2} className="mb-3">
      <div className="box_info" style={{ backgroundColor: background }}>
        <h2>{title}</h2>
        <div className="box_info_content" style={{ color: color }}>
          {value}
        </div>
      </div>
    </Col>
  );
}

function BoxVentas({
  state,
  updateState,
  tagColor,
  title,
  value,
  percent,
  date,
  loading,
}) {
  return (
    <Col xs={6} sm={6} md={4} lg={4} xl={3} xxl={2} className="mb-3">
      <div className="box_ventas">
        <h2 className="box_title">{!loading ? title : <Skeleton />}</h2>
        <p className="box_price">
          {!loading ? value != "" ? value : "" : <Skeleton />}
        </p>
        <p className="box_percent">
          {!loading ? (
            <span
              className="box_percent_text"
              style={{ backgroundColor: tagColor }}
            >
              {" "}
              {percent > 0 ? (
                <Image src={"/img/darkDropUp.svg"} />
              ) : (
                <Image src={"/img/darkDropDown.svg"} />
              )}{" "}
              {percent}%
            </span>
          ) : (
            <Skeleton />
          )}
        </p>
        <p className="box_date">{!loading ? date : <Skeleton />}</p>
      </div>
    </Col>
  );
}

function BoxMetas({
  state,
  updateState,
  data,
  year,
  totalCobranza,
  totalProduccion,
  totalSiniestralidad,
  size = { xs: 12, sm: 6, md: 6, lg: 6 },
}) {
  const [view, setView] = useState("datos");
  const [periodo, setPeriodo] = useState("anual");
  const [quatrimestre, setQuatrimestre] = useState("");
  const [month, setMonth] = useState("1");
  const [percentProduccion, setPercentProduccion] = useState("62");
  const [percentCobranza, setPercentCobranza] = useState("54");
  const [percentSiniestralidad, setPercentSiniestralidad] = useState("20");

  return (
    <Col xs={size.xs} sm={size.sm} md={size.md} className="mb-3">
      <div
        className="box_porcentaje"
        style={{
          position: "relative",
          paddingTop: "1rem",
          paddingBottom: "1rem",
          backgroundColor: view === "formulario" ? "#0ca1b4" : "#fff",
          color: view === "formulario" ? "#fff" : "",
        }}
      >
        {/* <div className="ws_backdrop d-flex justify-content-center align-items-center"><h1>No disponible por el momento</h1></div> */}
        <Container fluid>
          <Row>
            <Col>
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex flex-column justify-content-center align-items-center">
                  <h3 className="mt-2" style={{ fontSize: "1.2rem" }}>
                    Metas
                  </h3>
                  <h3 className="mt-2" style={{ fontSize: "1.3rem" }}>
                    {year}
                  </h3>
                </div>
                <Dropdown className="ws_dropdown">
                  <Dropdown.Toggle id="dropdown-basic">
                    <Image
                      src={`/img/${
                        view === "datos" ? "darkOpt" : "darkOpt2"
                      }.svg`}
                      alt="icon_opt"
                      className="ws_icon ms-2"
                    />
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item href="#">Quitar del dashboard</Dropdown.Item>
                    <Dropdown.Item href="#">Duplicar</Dropdown.Item>
                    <Dropdown.Item href="#">Mostrar en móvil</Dropdown.Item>
                    <Dropdown.Divider />
                    <Dropdown.Item href="#">Exportar</Dropdown.Item>
                    <Dropdown.Item href="#">Compartir</Dropdown.Item>
                    {view === "formulario" ? (
                      <Dropdown.Item
                        onClick={(e) => {
                          setView("datos");
                        }}
                      >
                        Ver metas
                      </Dropdown.Item>
                    ) : (
                      <Dropdown.Item
                        onClick={(e) => {
                          setView("formulario");
                        }}
                      >
                        Cambiar metas
                      </Dropdown.Item>
                    )}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </Col>
          </Row>

          {view === "datos" ? (
            <React.Fragment>
              <Row>
                <Col>
                  <ButtonGroup
                    aria-label="Basic example"
                    className="p-2 w-100 ws_btn_group"
                  >
                    <Button
                      className={`bg-qprimary active`}
                      onClick={(e) => {
                        handleChangeButton(e);
                      }}
                      attr-name="anual"
                    >
                      Anual
                    </Button>
                    <Button
                      className={`bg-qprimary`}
                      onClick={(e) => {
                        handleChangeButton(e);
                      }}
                      attr-name="cuatrimestral"
                    >
                      Cuatrimestral
                    </Button>
                    <Button
                      className={`bg-qprimary`}
                      onClick={(e) => {
                        handleChangeButton(e);
                      }}
                      attr-name="mensual"
                    >
                      Mensual
                    </Button>
                  </ButtonGroup>

                  {periodo === "cuatrimestral" || periodo === "mensual" ? (
                    <div className="ws_content_select_perdiodo p-2">
                      <Row>
                        <Col sm={6}>
                          <Form>
                            <Form.Group>
                              {periodo === "cuatrimestral" ? (
                                <Form.Select
                                  id="select1"
                                  aria-label="select1"
                                  key={uuidv4()}
                                  onChange={(e) => {
                                    setQuatrimestre(e.target.value);
                                  }}
                                >
                                  <option
                                    value=""
                                    selected={
                                      quatrimestre === "" ? true : false
                                    }
                                  >
                                    Selecciona un cuatrimestre
                                  </option>
                                  <option
                                    value="1"
                                    selected={
                                      quatrimestre === "1" ? true : false
                                    }
                                  >
                                    Q1
                                  </option>
                                  <option
                                    value="2"
                                    selected={
                                      quatrimestre === "2" ? true : false
                                    }
                                  >
                                    Q2
                                  </option>
                                  <option
                                    value="3"
                                    selected={
                                      quatrimestre === "3" ? true : false
                                    }
                                  >
                                    Q3
                                  </option>
                                </Form.Select>
                              ) : periodo === "mensual" ? (
                                <Form.Select
                                  id="select2"
                                  aria-label="select2"
                                  key={uuidv4()}
                                  onChange={(e) => {
                                    setMonth(e.target.value);
                                  }}
                                >
                                  <option
                                    value=""
                                    selected={month === "" ? true : false}
                                  >
                                    Selecciona un mes
                                  </option>
                                  <option
                                    value="1"
                                    selected={month === "1" ? true : false}
                                  >
                                    Enero
                                  </option>
                                  <option
                                    value="2"
                                    selected={month === "2" ? true : false}
                                  >
                                    Febrero
                                  </option>
                                  <option
                                    value="3"
                                    selected={month === "3" ? true : false}
                                  >
                                    Marzo
                                  </option>
                                  <option
                                    value="4"
                                    selected={month === "4" ? true : false}
                                  >
                                    Abril
                                  </option>
                                  <option
                                    value="5"
                                    selected={month === "5" ? true : false}
                                  >
                                    Mayo
                                  </option>
                                  <option
                                    value="6"
                                    selected={month === "6" ? true : false}
                                  >
                                    Junio
                                  </option>
                                  <option
                                    value="7"
                                    selected={month === "7" ? true : false}
                                  >
                                    Julio
                                  </option>
                                  <option
                                    value="8"
                                    selected={month === "8" ? true : false}
                                  >
                                    Agosto
                                  </option>
                                  <option
                                    value="9"
                                    selected={month === "9" ? true : false}
                                  >
                                    Septiembre
                                  </option>
                                  <option
                                    value="10"
                                    selected={month === "10" ? true : false}
                                  >
                                    Octubre
                                  </option>
                                  <option
                                    value="11"
                                    selected={month === "11" ? true : false}
                                  >
                                    Noviembre
                                  </option>
                                  <option
                                    value="12"
                                    selected={month === "12" ? true : false}
                                  >
                                    Diciembre
                                  </option>
                                </Form.Select>
                              ) : null}
                            </Form.Group>
                          </Form>
                        </Col>
                      </Row>
                    </div>
                  ) : null}
                </Col>
              </Row>
              <Row className="mt-1">
                <Col xs={12} lg={12} xl={4}>
                  <div className="box_pr_content ps-2 pe-2 m-2 ms-xl-2">
                    <p className="mb-0 pt-2">Producción</p>
                    <p className="mb-1">
                      <b>${number_format(totalProduccion, 2)}</b>
                    </p>
                    <div className="box_pr_bk_bar">
                      <div
                        className="box_pr_bar"
                        style={{ width: "75%" }}
                      ></div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center mt-2">
                      <p className="box_percent p-0">
                        {
                          <span
                            className="box_percent_text"
                            style={{ backgroundColor: "#ff1d25" }}
                          >
                            {" "}
                            {percentProduccion > 0 ? (
                              <Image src={"/img/darkDropUp.svg"} />
                            ) : (
                              <Image src={"img/darkDropDown.svg"} />
                            )}{" "}
                            {percentProduccion}%
                          </span>
                        }
                      </p>
                      <p>
                        <b>${number_format(totalProduccion, 2)}</b>
                      </p>
                    </div>
                    <div className="d-flex flex-column justify-content-end align-items-end">
                      <p className="mb-0" style={{ fontSize: ".9rem" }}>
                        Q1 2020
                      </p>
                      <p className="mb-0" style={{ fontSize: ".9rem" }}>
                        350k
                      </p>
                    </div>
                  </div>
                </Col>
                <Col xs={12} lg={12} xl={4}>
                  <div className="box_pr_content ps-2 pe-2 m-2 mt-xl-2">
                    <p className="mb-0 pt-2">Cobranza</p>
                    <p className="mb-1">
                      <b>${number_format(totalCobranza, 2)}</b>
                    </p>
                    <div className="box_pr_bk_bar">
                      <div
                        className="box_pr_bar"
                        style={{ width: "55%", backgroundColor: "#672d8f" }}
                      ></div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center mt-2">
                      <p className="box_percent p-0">
                        {
                          <span
                            className="box_percent_text"
                            style={{ backgroundColor: "#ff1d25" }}
                          >
                            {" "}
                            {percentCobranza > 0 ? (
                              <Image src={"/img/darkDropUp.svg"} />
                            ) : (
                              <Image src={"img/darkDropDown.svg"} />
                            )}{" "}
                            {percentCobranza}%
                          </span>
                        }
                      </p>
                      <p>
                        <b>${number_format(totalProduccion, 2)}</b>
                      </p>
                    </div>
                    <div className="d-flex flex-column justify-content-end align-items-end">
                      <p className="mb-0" style={{ fontSize: ".9rem" }}>
                        Q1 2020
                      </p>
                      <p className="mb-0" style={{ fontSize: ".9rem" }}>
                        320k
                      </p>
                    </div>
                  </div>
                </Col>
                <Col xs={12} lg={12} xl={4}>
                  <div className="box_pr_content ps-2 pe-2 m-2 me-xl-2">
                    <p className="mb-0 pt-2">Siniestralidad</p>
                    <p className="mb-1">
                      <b>${number_format(totalSiniestralidad, 2)}</b>
                    </p>
                    <div className="box_pr_bk_bar">
                      <div
                        className="box_pr_bar"
                        style={{ width: "26%", backgroundColor: "#ff1d25" }}
                      ></div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center mt-2">
                      <p className="box_percent p-0">
                        {
                          <span
                            className="box_percent_text"
                            style={{ backgroundColor: "#ff1d25" }}
                          >
                            {" "}
                            {percentSiniestralidad > 0 ? (
                              <Image src={"/img/darkDropUp.svg"} />
                            ) : (
                              <Image src={"img/darkDropDown.svg"} />
                            )}{" "}
                            {percentSiniestralidad}%
                          </span>
                        }
                      </p>
                      <p>
                        <b>${number_format(totalProduccion, 2)}</b>
                      </p>
                    </div>
                    <div className="d-flex flex-column justify-content-end align-items-end">
                      <p className="mb-0" style={{ fontSize: ".9rem" }}>
                        Q1 2020
                      </p>
                      <p className="mb-0" style={{ fontSize: ".9rem" }}>
                        105%
                      </p>
                    </div>
                  </div>
                </Col>
              </Row>
            </React.Fragment>
          ) : view === "formulario" ? (
            <React.Fragment>
              <div>
                <p>
                  Para medir tus metas primero debes asignar tus metas ya sea en
                  cantidad o porcentaje para las mismas
                </p>
              </div>
              <Row>
                <Col
                  xs={12}
                  md={{ span: 8, offset: 2 }}
                  lg={{ span: 10, offset: 1 }}
                >
                  <Row>
                    <Col
                      xs={12}
                      lg={2}
                      className="d-sm-none d-md-block text-center"
                    ></Col>
                    <Col
                      xs={12}
                      lg={2}
                      className="d-sm-none d-md-block text-center"
                    >
                      <p>2020</p>
                    </Col>
                    <Col
                      xs={12}
                      lg={2}
                      className="d-sm-none d-md-block text-center"
                    >
                      <p>operador</p>
                    </Col>
                    <Col
                      xs={12}
                      lg={2}
                      className="d-sm-none d-md-block text-center"
                    >
                      <p>2021</p>
                    </Col>
                    <Col
                      xs={12}
                      lg={2}
                      className="d-sm-none d-md-block text-center"
                    >
                      <p>Objetivos</p>
                    </Col>
                  </Row>

                  <Row>
                    <Col xs={12} lg={2}>
                      <p style={{ fontSize: "1.5rem" }} className="mb-2">
                        Producción
                      </p>
                    </Col>
                    <Col xs={12} lg={2}>
                      <Form.Control
                        type="text"
                        id="before_prod"
                        name="before_prod"
                        className="mb-2"
                        style={{
                          backgroundColor: "#0ca1b4",
                          borderColor: "#fff",
                          boxShadow: "none",
                          color: "#fff",
                        }}
                      />
                    </Col>
                    <Col xs={12} lg={2}>
                      <Form.Select
                        aria-label="Default select example"
                        className="mb-2"
                      >
                        <option value="1">Asignar %</option>
                        <option value="2">Restar %</option>
                        <option value="3">Restar Cantidad</option>
                        <option value="4">Asignar Cantidad</option>
                      </Form.Select>
                    </Col>
                    <Col xs={12} lg={2}>
                      <Form.Control
                        type="text"
                        id="current_prod"
                        name="current_prod"
                        className="mb-2"
                      />
                    </Col>
                    <Col xs={12} lg={2}>
                      <Form.Control
                        type="text"
                        id="objetivos"
                        name="objetivos"
                        className="mb-2"
                        style={{
                          backgroundColor: "#0ca1b4",
                          borderColor: "#fff",
                          boxShadow: "none",
                          color: "#fff",
                        }}
                      />
                    </Col>
                  </Row>

                  <Row>
                    <Col xs={12} lg={2}>
                      <p style={{ fontSize: "1.5rem" }} className="mb-2">
                        Cobranza
                      </p>
                    </Col>
                    <Col xs={12} lg={2}>
                      <Form.Control
                        type="text"
                        id="before_prod"
                        name="before_prod"
                        className="mb-2"
                        style={{
                          backgroundColor: "#0ca1b4",
                          borderColor: "#fff",
                          boxShadow: "none",
                          color: "#fff",
                        }}
                      />
                    </Col>
                    <Col xs={12} lg={2}>
                      <Form.Select
                        aria-label="Default select example"
                        className="mb-2"
                      >
                        <option value="1">Asignar %</option>
                        <option value="2">Restar %</option>
                        <option value="3">Restar Cantidad</option>
                        <option value="4">Asignar Cantidad</option>
                      </Form.Select>
                    </Col>
                    <Col xs={12} lg={2}>
                      <Form.Control
                        type="text"
                        id="current_prod"
                        name="current_prod"
                        className="mb-2"
                      />
                    </Col>
                    <Col xs={12} lg={2}>
                      <Form.Control
                        type="text"
                        id="objetivos"
                        name="objetivos"
                        className="mb-2"
                        style={{
                          backgroundColor: "#0ca1b4",
                          borderColor: "#fff",
                          boxShadow: "none",
                          color: "#fff",
                        }}
                      />
                    </Col>
                  </Row>

                  <Row>
                    <Col xs={12} lg={2}>
                      <p style={{ fontSize: "1.5rem" }} className="mb-2">
                        Siniestros
                      </p>
                    </Col>
                    <Col xs={12} lg={2}>
                      <Form.Control
                        type="text"
                        id="before_prod"
                        name="before_prod"
                        className="mb-2"
                        style={{
                          backgroundColor: "#0ca1b4",
                          borderColor: "#fff",
                          boxShadow: "none",
                          color: "#fff",
                        }}
                      />
                    </Col>
                    <Col xs={12} lg={2}>
                      <Form.Select
                        aria-label="Default select example"
                        className="mb-2"
                      >
                        <option value="1">Asignar %</option>
                        <option value="2">Restar %</option>
                        <option value="3">Restar Cantidad</option>
                        <option value="4">Asignar Cantidad</option>
                      </Form.Select>
                    </Col>
                    <Col xs={12} lg={2}>
                      <Form.Control
                        type="text"
                        id="current_prod"
                        name="current_prod"
                        className="mb-2"
                      />
                    </Col>
                    <Col xs={12} lg={2}>
                      <Form.Control
                        type="text"
                        id="objetivos"
                        name="objetivos"
                        className="mb-2"
                        style={{
                          backgroundColor: "#0ca1b4",
                          borderColor: "#fff",
                          boxShadow: "none",
                          color: "#fff",
                        }}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </React.Fragment>
          ) : null}
        </Container>
      </div>
    </Col>
  );

  function handleChangeButton(e) {
    const currentButton = e.target;
    const parents = currentButton.parentNode.childNodes;
    parents.forEach((element) => {
      element.classList.remove("active");
    });
    e.target.classList.add("active");
    let periodo = e.target.getAttribute("attr-name");
    setPeriodo(periodo);
  }
}

function BoxMetas2({
  state,
  updateState,
  data,
  year,
  totalCobranza,
  totalProduccion,
  totalSiniestralidad,
  idAgente,
  size = { xs: 12, sm: 6, md: 6, lg: 6 },
  datosMetas = [],
  reload,
}) {
  let { usuario } = useContext(AuthContext);

  const [view, setView] = useState(1);
  const [viewForm, setViewForm] = useState(1);
  const [periodo, setPeriodo] = useState("anual");
  const [quatrimestre, setQuatrimestre] = useState("");
  const [month, setMonth] = useState("1");
  const [percentProduccion, setPercentProduccion] = useState("62");
  const [percentCobranza, setPercentCobranza] = useState("54");
  const [percentSiniestralidad, setPercentSiniestralidad] = useState("20");

  const [totalMeta, setTotalMeta] = useState(0);
  const [arrMetasMonths, setArrMetasMonths] = useState([]);
  const [nombreMes, setNombreMes] = useState([
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
  ]);
  const [mesInicio, setMesInicio] = useState(0);

  let handleClickMeta = () => {
    console.log("here handle click meta");
    if (totalMeta != "") {
      setView(2);
    } else {
      alert("Para continuar es necesario ingresar una cantidad");
    }
  };

  useEffect(() => {
    if (view === 2) {
      generateMeta();
    }
  }, [view]);

  useEffect(() => {
    if (datosMetas.length < 1) {
      setViewForm(2);
    } else {
      setViewForm(1);
    }
  }, [datosMetas]);

  let totalMeta2 = 0;
  arrMetasMonths.map((t) => {
    totalMeta2 += parseFloat(t.cantidad);
  });

  let lastDataMeta = datosMetas.slice(-3);

  return (
    <Col xs={size.xs} sm={size.sm} md={size.md} className="mb-3">
      <div
        className="box_porcentaje"
        style={{
          position: "relative",
          paddingTop: "1rem",
          paddingBottom: "1rem",
          backgroundColor: view === "formulario" ? "#0ca1b4" : "#fff",
          color: view === "formulario" ? "#fff" : "",
        }}
      >
        {/* <div className="ws_backdrop d-flex justify-content-center align-items-center"><h1>No disponible por el momento</h1></div> */}
        <Container fluid>
          <Row>
            <Col>
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex flex-column justify-content-center align-items-center">
                  <h3 className="mt-2" style={{ fontSize: "1.2rem" }}>
                    Metas
                  </h3>
                  <h3 className="mt-2" style={{ fontSize: "1.3rem" }}>
                    {year}
                  </h3>
                </div>
                <Dropdown className="ws_dropdown">
                  <Dropdown.Toggle id="dropdown-basic">
                    <Image
                      src={`/img/${
                        viewForm === 1 ? "darkOpt" : "darkOpt2"
                      }.svg`}
                      alt="icon_opt"
                      className="ws_icon ms-2"
                    />
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {viewForm === 1 ? (
                      <Dropdown.Item
                        onClick={(e) => {
                          setViewForm(2);
                        }}
                      >
                        Cambiar metas
                      </Dropdown.Item>
                    ) : (
                      <Dropdown.Item
                        onClick={(e) => {
                          setViewForm(1);
                        }}
                      >
                        Ver metas
                      </Dropdown.Item>
                    )}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </Col>
          </Row>

          {viewForm === 1 ? (
            <React.Fragment>
              <Row className="mt-1">
                <Col xs={12} md={12} lg={12} xl={12}>
                  <div className="table-responsive" style={{ maxHeight: 450 }}>
                    <Table
                      striped
                      bordered
                      hover
                      size="sm"
                      className="ws_tabla"
                    >
                      <thead
                        style={{
                          backgroundColor: "#0a93af",
                          color: "#fff",
                          fontSize: ".9rem",
                        }}
                      >
                        <tr>
                          <th className="text-center">Fecha de revisión</th>
                          <th className="text-center">Obtenido</th>
                          <th className="text-center">Por lograr</th>
                          <th className="text-center">Porcentaje</th>
                        </tr>
                      </thead>
                      <tbody style={{ fontSize: ".9rem" }}>
                        {datosMetas.length > 0 ? (
                          datosMetas.map((t, e) => (
                            <tr>
                              <td className="ps-3">{t.fecha}</td>
                              <td className="ps-3">
                                ${number_format(t.obtenido, 2)}
                              </td>
                              <td className="ps-3">
                                ${number_format(t.logro, 2)}
                              </td>
                              <td>
                                <p className="mb-0">
                                  {number_format(
                                    (t.obtenido * 100) / t.logro,
                                    2
                                  ) + "%"}
                                </p>
                                <div
                                  className="box_pr_bk_bar"
                                  style={{
                                    border: "1px solid #ccc",
                                    height: "15px",
                                    padding: "3px",
                                    borderRadius: "10px",
                                  }}
                                >
                                  <div
                                    className="box_pr_bar"
                                    style={{
                                      width: (t.obtenido * 100) / t.logro + "%",
                                      maxWidth: "100%",
                                      minWidth: "0%",
                                      height: "7px",
                                    }}
                                  ></div>
                                </div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="4" className="text-center">
                              No hay datos disponibles
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                </Col>
                {/* <Col xs={12} lg={12} xl={4}>
                    <div className="box_pr_content ps-2 pe-2 m-2 ms-xl-2" style={{ minHeight: '120px' }}>
                      <p className="mb-0 pt-2">{moment().subtract(2, 'months').format('MMMM')}</p>
                      <p className="mb-1"><b>${(lastDataMeta[0]) ? number_format(lastDataMeta[0].acumulado_obtenido, 2) : '0.00'}</b></p>
                      <div className="box_pr_bk_bar mt-3">
                        <div className="box_pr_bar" style={{ width: `${(lastDataMeta[0]) ? (lastDataMeta[0].acumulado_obtenido * 100) / lastDataMeta[0].logro + '%' : '0%'}`, maxWidth: '100%', minWidth: '0%' }}></div>
                        <p>{(lastDataMeta[0]) ? number_format((lastDataMeta[0].acumulado_obtenido * 100) / lastDataMeta[0].logro, 2) + '%' : '0%'}</p>
                      </div>
                    </div>
                  </Col>
                  <Col xs={12} lg={12} xl={4}>
                    <div className="box_pr_content ps-2 pe-2 m-2 mt-xl-2" style={{ minHeight: '120px' }}>
                      <p className="mb-0 pt-2">{moment().subtract(1, 'months').format('MMMM')}</p>
                      <p className="mb-1"><b>${(lastDataMeta[1]) ? number_format(lastDataMeta[1].acumulado_obtenido, 2) : '0.00'}</b></p>
                      <div className="box_pr_bk_bar mt-3">
                        <div className="box_pr_bar" style={{ width: `${(lastDataMeta[1]) ? (lastDataMeta[1].acumulado_obtenido * 100) / lastDataMeta[1].logro + '%' : '0%'}`, maxWidth: '100%', minWidth: '0%', backgroundColor: '#672d8f' }}></div>
                        <p>{(lastDataMeta[1]) ? number_format((lastDataMeta[1].acumulado_obtenido * 100) / lastDataMeta[1].logro, 2) + '%' : '0%'}</p>
                      </div>
                    </div>
                  </Col>
                  <Col xs={12} lg={12} xl={4}>
                    <div className="box_pr_content ps-2 pe-2 m-2 me-xl-2" style={{ minHeight: '120px' }}>
                      <p className="mb-0 pt-2">{moment().format('MMMM')}</p>
                      <p className="mb-1"><b>${(lastDataMeta[2]) ? number_format(lastDataMeta[2].acumulado_obtenido, 2) : '0.00'}</b></p>
                      <div className="box_pr_bk_bar mt-3">
                        <div className="box_pr_bar" style={{ width: `${(lastDataMeta[2]) ? (lastDataMeta[2].acumulado_obtenido * 100) / lastDataMeta[2].logro + '%' : '0%'}`, maxWidth: '100%', minWidth: '0%', backgroundColor: '#672d8f' }}></div>
                        <p>{(lastDataMeta[2]) ? number_format((lastDataMeta[2].acumulado_obtenido * 100) / lastDataMeta[2].logro, 2) + '%' : '0%'}</p>
                      </div>
                    </div>
                  </Col> */}
              </Row>
            </React.Fragment>
          ) : viewForm === 2 ? (
            view === 2 ? (
              <React.Fragment>
                <Row>
                  <Col>
                    <p>
                      Total meta: ${number_format(totalMeta2, 2)} iniciando en:{" "}
                      {nombreMes[mesInicio]}
                    </p>

                    {arrMetasMonths.map((t, e) => (
                      <div>
                        <p>
                          {t.month}{" "}
                          <span style={{ fontSize: ".7rem" }}>
                            (${number_format(arrMetasMonths[e].cantidad, 2)})
                          </span>
                        </p>
                        <Form.Control
                          type={"number"}
                          className="mb-3"
                          onChange={(ev) => {
                            console.log(ev.target.value);
                            let newArr = [...arrMetasMonths];
                            newArr[e].cantidad = parseFloat(ev.target.value);
                            setArrMetasMonths(newArr);
                          }}
                          value={t.cantidad}
                        />
                      </div>
                    ))}

                    {/* <button onClick={() => { this.registerMeta() }}>Registrar</button> */}
                    <Form.Group className="mt-3">
                      <Button
                        className={"btn btn-secondary ws_btn_secundary me-2"}
                        onClick={() => {
                          setView(1);
                        }}
                      >
                        Atrás
                      </Button>
                      <Button
                        className={"btn btn-secondary ws_btn_secundary "}
                        onClick={() => {
                          registerMeta();
                        }}
                      >
                        Registrar
                      </Button>
                    </Form.Group>
                  </Col>
                </Row>
              </React.Fragment>
            ) : view === 1 ? (
              <React.Fragment>
                <div>
                  <p>
                    Para medir tus metas primero debes asignar una cantidad
                    mayor al cierre del año anterior.
                  </p>
                </div>
                <Row>
                  <Col>
                    <div className="table-responsive">
                      <Form>
                        <Form.Group className="mb-3">
                          <Form.Label>Mes Inicial</Form.Label>
                          <Form.Select
                            aria-label="Default select example"
                            value={mesInicio}
                            id="mes_inicio"
                            name="mes_inicio"
                            onChange={(e) => {
                              setMesInicio(e.target.value);
                            }}
                          >
                            {nombreMes.map((t, e) => (
                              <option value={e} key={e}>
                                {t}
                              </option>
                            ))}
                          </Form.Select>
                        </Form.Group>
                        <Form.Group className="mb-3">
                          <Form.Control
                            type={"number"}
                            onChange={(ev) => {
                              setTotalMeta(ev.target.value);
                            }}
                          />
                        </Form.Group>
                        <Form.Group className="mb-3">
                          <Button
                            className={"btn btn-secondary ws_btn_secundary "}
                            onClick={() => {
                              handleClickMeta();
                            }}
                          >
                            Generar
                          </Button>
                        </Form.Group>
                      </Form>
                    </div>
                  </Col>
                </Row>
              </React.Fragment>
            ) : null
          ) : null}
        </Container>
      </div>
    </Col>
  );

  function generateMeta() {
    let arrMetasMonths = [];

    if (totalMeta == 0) return false;

    let months = 12,
      totalSegmentado = totalMeta / (months - mesInicio),
      d = moment().format("YYYY") + `-${parseInt(mesInicio) + 1}-01`,
      count = 0;

    for (var i = mesInicio; i < months; i++) {
      arrMetasMonths.push({
        fecha: moment(d).add(count, "M").format("YYYY-MM-DD"),
        month: nombreMes[i],
        cantidad: totalSegmentado,
      });
      count++;
    }

    setArrMetasMonths(arrMetasMonths);
  }

  function registerMeta() {
    let totalMeta = 0;
    arrMetasMonths.map((t) => {
      totalMeta += parseFloat(t.cantidad);
    });

    const data = {
      id_login: usuario.id_usuario,
      id_usuario: idAgente,
      obj: arrMetasMonths,
      inicio: arrMetasMonths[0].fecha,
      fin: arrMetasMonths[arrMetasMonths.length - 1].fecha,
      logro: totalMeta,
    };

    fetch(
      "https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=addMetaAgente",
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(data),
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == "ok") {
          setArrMetasMonths([]);
          reload();
          setViewForm(1);
          alert("La meta ha sido registrada correctamente");
        }
        console.log("end", data);
      });
  }

  function handleChangeButton(e) {
    const currentButton = e.target;
    const parents = currentButton.parentNode.childNodes;
    parents.forEach((element) => {
      element.classList.remove("active");
    });
    e.target.classList.add("active");
    let periodo = e.target.getAttribute("attr-name");
    setPeriodo(periodo);
  }
}

function BoxMetasOficina({
  state,
  updateState,
  data,
  year,
  totalCobranza,
  totalProduccion,
  totalSiniestralidad,
  idOficina,
  size = { xs: 12, sm: 6, md: 6, lg: 6 },
  datosMetas = [],
  reload,
}) {
  let { usuario } = useContext(AuthContext);

  const [view, setView] = useState(1);
  const [viewForm, setViewForm] = useState(1);
  const [periodo, setPeriodo] = useState("anual");
  const [quatrimestre, setQuatrimestre] = useState("");
  const [month, setMonth] = useState("1");
  const [percentProduccion, setPercentProduccion] = useState("62");
  const [percentCobranza, setPercentCobranza] = useState("54");
  const [percentSiniestralidad, setPercentSiniestralidad] = useState("20");

  const [totalMeta, setTotalMeta] = useState(0);
  const [arrMetasMonths, setArrMetasMonths] = useState([]);
  const [nombreMes, setNombreMes] = useState([
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
  ]);
  const [mesInicio, setMesInicio] = useState(0);

  let handleClickMeta = () => {
    console.log("here handle click meta");
    if (totalMeta != "") {
      setView(2);
    } else {
      alert("Para continuar es necesario ingresar una cantidad");
    }
  };

  useEffect(() => {
    if (view === 2) {
      generateMeta();
    }
  }, [view]);

  useEffect(() => {
    if (datosMetas.length < 1) {
      setViewForm(2);
    } else {
      setViewForm(1);
    }
  }, [datosMetas]);

  let totalMeta2 = 0;
  arrMetasMonths.map((t) => {
    totalMeta2 += parseFloat(t.cantidad);
  });

  // console.log('length',datosMetas.length)

  // const MesActual = moment('2021-07-01').format('M')

  // console.log('mes_actual',MesActual)

  // let lastDataMeta = datosMetas.slice((MesActual-1),(MesActual+2));

  // var Fecha1 = '',Fecha2='',Fecha3='';
  // if(lastDataMeta[0]){
  //   const newFecha = lastDataMeta[0].fecha.split('/');
  //   Fecha1 = `${newFecha[2]}-${newFecha[1]}-${newFecha[0]}`
  // }
  // if(lastDataMeta[1]){
  //   const newFecha = lastDataMeta[1].fecha.split('/');
  //   Fecha2 = `${newFecha[2]}-${newFecha[1]}-${newFecha[0]}`
  // }
  // if(lastDataMeta[2]){
  //   const newFecha = lastDataMeta[2].fecha.split('/');
  //   Fecha3 = `${newFecha[2]}-${newFecha[1]}-${newFecha[0]}`
  // }

  // console.log('lastDataMeta',lastDataMeta)

  return (
    <Col xs={size.xs} sm={size.sm} md={size.md} className="mb-3">
      <div
        className="box_porcentaje"
        style={{
          position: "relative",
          paddingTop: "1rem",
          paddingBottom: "1rem",
          backgroundColor: view === "formulario" ? "#0ca1b4" : "#fff",
          color: view === "formulario" ? "#fff" : "",
        }}
      >
        {/* <div className="ws_backdrop d-flex justify-content-center align-items-center"><h1>No disponible por el momento</h1></div> */}
        <Container fluid>
          <Row>
            <Col>
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex flex-column justify-content-center align-items-center">
                  <h3 className="mt-2" style={{ fontSize: "1.2rem" }}>
                    Metas
                  </h3>
                  <h3 className="mt-2" style={{ fontSize: "1.3rem" }}>
                    {year}
                  </h3>
                </div>
                <Dropdown className="ws_dropdown">
                  <Dropdown.Toggle id="dropdown-basic">
                    <Image
                      src={`/img/${
                        viewForm === 1 ? "darkOpt" : "darkOpt2"
                      }.svg`}
                      alt="icon_opt"
                      className="ws_icon ms-2"
                    />
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {viewForm === 1 ? (
                      <Dropdown.Item
                        onClick={(e) => {
                          setViewForm(2);
                        }}
                      >
                        Cambiar metas
                      </Dropdown.Item>
                    ) : (
                      <Dropdown.Item
                        onClick={(e) => {
                          setViewForm(1);
                        }}
                      >
                        Ver metas
                      </Dropdown.Item>
                    )}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </Col>
          </Row>

          {viewForm === 1 ? (
            <React.Fragment>
              <Row className="mt-1">
                <Col xs={12} md={12} lg={12} xl={12}>
                  <div className="table-responsive" style={{ maxHeight: 450 }}>
                    <Table
                      striped
                      bordered
                      hover
                      size="sm"
                      className="ws_tabla"
                    >
                      <thead
                        style={{
                          backgroundColor: "#0a93af",
                          color: "#fff",
                          fontSize: ".9rem",
                        }}
                      >
                        <tr>
                          <th className="text-center">Fecha de revisión</th>
                          <th className="text-center">Obtenido</th>
                          <th className="text-center">Por lograr</th>
                          <th className="text-center">Porcentaje</th>
                        </tr>
                      </thead>
                      <tbody style={{ fontSize: ".9rem" }}>
                        {datosMetas.length > 0 ? (
                          datosMetas.map((t, e) => (
                            <tr>
                              <td className="ps-3">{t.fecha}</td>
                              <td className="ps-3">
                                ${number_format(t.obtenido, 2)}
                              </td>
                              <td className="ps-3">
                                ${number_format(t.logro, 2)}
                              </td>
                              <td>
                                <p className="mb-0">
                                  {number_format(
                                    (t.obtenido * 100) / t.logro,
                                    2
                                  ) + "%"}
                                </p>
                                <div
                                  className="box_pr_bk_bar"
                                  style={{
                                    border: "1px solid #ccc",
                                    height: "15px",
                                    padding: "3px",
                                    borderRadius: "10px",
                                  }}
                                >
                                  <div
                                    className="box_pr_bar"
                                    style={{
                                      width: (t.obtenido * 100) / t.logro + "%",
                                      maxWidth: "100%",
                                      minWidth: "0%",
                                      height: "7px",
                                    }}
                                  ></div>
                                </div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="4" className="text-center">
                              No hay datos disponibles
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                </Col>

                {/* <Col xs={12} lg={12} xl={4}>
                    <div className="box_pr_content ps-2 pe-2 m-2 ms-xl-2" style={{ minHeight: '120px' }}>
                      <p className="mb-0 pt-2">{ (lastDataMeta[0]) ? moment(Fecha1).format('MMMM') : '-'}</p>
                      <p className="mb-1"><b>${(lastDataMeta[0]) ? number_format(lastDataMeta[0].acumulado_obtenido, 2) : '0.00'}</b></p>
                      <div className="box_pr_bk_bar mt-3">
                        <div className="box_pr_bar" style={{ width: `${(lastDataMeta[0]) ? (lastDataMeta[0].acumulado_obtenido * 100) / lastDataMeta[0].logro + '%' : '0%'}`, maxWidth: '100%', minWidth: '0%' }}></div>
                        <p>{(lastDataMeta[0]) ? number_format((lastDataMeta[0].acumulado_obtenido * 100) / lastDataMeta[0].logro, 2) + '%' : '0%'}</p>
                      </div>
                    </div>
                  </Col>

                  <Col xs={12} lg={12} xl={4}>
                    <div className="box_pr_content ps-2 pe-2 m-2 mt-xl-2" style={{ minHeight: '120px' }}>
                      <p className="mb-0 pt-2">{(lastDataMeta[1]) ? moment(Fecha2).format('MMMM') : '-'}</p>
                      <p className="mb-1"><b>${(lastDataMeta[1]) ? number_format(lastDataMeta[1].acumulado_obtenido, 2) : '0.00'}</b></p>
                      <div className="box_pr_bk_bar mt-3">
                        <div className="box_pr_bar" style={{ width: `${(lastDataMeta[1]) ? (lastDataMeta[1].acumulado_obtenido * 100) / lastDataMeta[1].logro + '%' : '0%'}`, maxWidth: '100%', minWidth: '0%', backgroundColor: '#672d8f' }}></div>
                        <p>{(lastDataMeta[1]) ? number_format((lastDataMeta[1].acumulado_obtenido * 100) / lastDataMeta[1].logro, 2) + '%' : '0%'}</p>
                      </div>
                    </div>
                  </Col>

                  <Col xs={12} lg={12} xl={4}>
                    <div className="box_pr_content ps-2 pe-2 m-2 me-xl-2" style={{ minHeight: '120px' }}>
                      <p className="mb-0 pt-2">{(lastDataMeta[2]) ? moment(Fecha3).format('MMMM') : '-'}</p>
                      <p className="mb-1"><b>${(lastDataMeta[2]) ? number_format(lastDataMeta[2].acumulado_obtenido, 2) : '0.00'}</b></p>
                      <div className="box_pr_bk_bar mt-3">
                        <div className="box_pr_bar" style={{ width: `${(lastDataMeta[2]) ? (lastDataMeta[2].acumulado_obtenido * 100) / lastDataMeta[2].logro + '%' : '0%'}`, maxWidth: '100%', minWidth: '0%', backgroundColor: '#672d8f' }}></div>
                        <p>{(lastDataMeta[2]) ? number_format((lastDataMeta[2].acumulado_obtenido * 100) / lastDataMeta[2].logro, 2) + '%' : '0%'}</p>
                      </div>
                    </div>
                  </Col> */}
              </Row>
            </React.Fragment>
          ) : viewForm === 2 ? (
            view === 2 ? (
              <React.Fragment>
                <Row>
                  <Col>
                    <p>
                      Total meta: ${number_format(totalMeta2, 2)} iniciando en:{" "}
                      {nombreMes[mesInicio]}
                    </p>

                    {arrMetasMonths.map((t, e) => (
                      <div>
                        <p>
                          {t.month}{" "}
                          <span style={{ fontSize: ".7rem" }}>
                            (${number_format(arrMetasMonths[e].cantidad, 2)})
                          </span>
                        </p>
                        <Form.Control
                          type={"number"}
                          className="mb-3"
                          onChange={(ev) => {
                            console.log(ev.target.value);
                            let newArr = [...arrMetasMonths];
                            newArr[e].cantidad = parseFloat(ev.target.value);
                            setArrMetasMonths(newArr);
                          }}
                          value={t.cantidad}
                        />
                      </div>
                    ))}

                    {/* <button onClick={() => { this.registerMeta() }}>Registrar</button> */}
                    <Form.Group className="mt-3">
                      <Button
                        className={"btn btn-secondary ws_btn_secundary me-2"}
                        onClick={() => {
                          setView(1);
                        }}
                      >
                        Atrás
                      </Button>
                      <Button
                        className={"btn btn-secondary ws_btn_secundary "}
                        onClick={() => {
                          registerMeta();
                        }}
                      >
                        Registrar
                      </Button>
                    </Form.Group>
                  </Col>
                </Row>
              </React.Fragment>
            ) : view === 1 ? (
              <React.Fragment>
                <div>
                  <p>
                    Para medir tus metas primero debes asignar una cantidad
                    mayor al cierre del año anterior.
                  </p>
                </div>
                <Row>
                  <Col>
                    <div className="table-responsive">
                      <Form>
                        <Form.Group className="mb-3">
                          <Form.Label>Mes Inicial</Form.Label>
                          <Form.Select
                            aria-label="Default select example"
                            value={mesInicio}
                            id="mes_inicio"
                            name="mes_inicio"
                            onChange={(e) => {
                              setMesInicio(e.target.value);
                            }}
                          >
                            {nombreMes.map((t, e) => (
                              <option value={e} key={e}>
                                {t}
                              </option>
                            ))}
                          </Form.Select>
                        </Form.Group>
                        <Form.Group className="mb-3">
                          <Form.Control
                            type={"number"}
                            onChange={(ev) => {
                              setTotalMeta(ev.target.value);
                            }}
                          />
                        </Form.Group>
                        <Form.Group className="mb-3">
                          <Button
                            className={"btn btn-secondary ws_btn_secundary "}
                            onClick={() => {
                              handleClickMeta();
                            }}
                          >
                            Generar
                          </Button>
                        </Form.Group>
                      </Form>
                    </div>
                  </Col>
                </Row>
              </React.Fragment>
            ) : null
          ) : null}
        </Container>
      </div>
    </Col>
  );

  function generateMeta() {
    let arrMetasMonths = [];

    if (totalMeta == 0) return false;

    let months = 12,
      totalSegmentado = totalMeta / (months - mesInicio),
      d = moment().format("YYYY") + `-${parseInt(mesInicio) + 1}-01`,
      count = 0;

    for (var i = mesInicio; i < months; i++) {
      arrMetasMonths.push({
        fecha: moment(d).add(count, "M").format("YYYY-MM-DD"),
        month: nombreMes[i],
        cantidad: totalSegmentado,
      });
      count++;
    }

    setArrMetasMonths(arrMetasMonths);
  }

  function registerMeta() {
    let totalMeta = 0;
    arrMetasMonths.map((t) => {
      totalMeta += parseFloat(t.cantidad);
    });

    const data = {
      id_login: usuario.id_usuario,
      clave_oficina: idOficina,
      obj: arrMetasMonths,
      inicio: arrMetasMonths[0].fecha,
      fin: arrMetasMonths[arrMetasMonths.length - 1].fecha,
      logro: totalMeta,
    };

    fetch(
      "https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=addMetaOficina",
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(data),
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == "ok") {
          setArrMetasMonths([]);
          reload();
          setViewForm(1);
          alert("La meta ha sido registrada correctamente");
        }
        console.log("end", data);
      });
  }

  function handleChangeButton(e) {
    const currentButton = e.target;
    const parents = currentButton.parentNode.childNodes;
    parents.forEach((element) => {
      element.classList.remove("active");
    });
    e.target.classList.add("active");
    let periodo = e.target.getAttribute("attr-name");
    setPeriodo(periodo);
  }
}

function ContentHeader({ state, updateState, loadData, loadDataGrafica }) {
  const [dataTab, setDataTab] = useState([
    {
      name: "Dirección",
      onClick: (e) => {
        updateState(
          {
            viewTab: 0,
          },
          loadData(0)
        );
      },
    },
    {
      name: "OS",
      onClick: (e) => {
        updateState(
          {
            viewTab: 1,
          },
          loadData(1)
        );
      },
    },
    {
      name: "ODQ´S",
      onClick: (e) => {
        updateState(
          {
            viewTab: 2,
          },
          loadData(2)
        );
      },
    },
  ]);

  const { data, viewTab, loadingData } = state;

  const currentYear = new Date().getFullYear();
  const beforeYear = new Date(
    new Date().setFullYear(new Date().getFullYear() - 1)
  ).getFullYear();

  const {
    totalCobranzaCurrent = 0,
    totalCobranzaBefore = 0,
    totalProduccionCurrent = 0,
    totalProduccionBefore = 0,
    totalSiniestralidadCurrent = 0,
    totalSiniestralidadBefore = 0,
    ventasMonthCurrent = [],
    ventasYearCurrent = [],
    ventasYearBefore = [],
    ventasLast12Months = [],
    siniestralidadMonthCurrent = [],
    siniestralidaLast12Months = [],
  } = data[viewTab];

  return (
    <div className="ws_content_header ws_pl_0 ws_pr_0 mb-5">
      <TabNavigation data={dataTab} />

      <h1 className="ws_title_header">Mi Dashboard</h1>

      <Container fluid>
        <Row>
          {/* <TablaAgentes state={state} updateState={updateState} /> */}
          {/* <TablaFlotillas state={state} updateState={updateState} /> */}
        </Row>
      </Container>
    </div>
  );
}

function Dashboard({ state, updateState, loadData, loadDataGrafica }) {
  const { openMenu } = state;
  return (
    <div className={`ws_content_wrapper ${!openMenu ? "wrapper_close" : ""}`}>
      <ContentHeader
        state={state}
        updateState={updateState}
        loadData={loadData}
        loadDataGrafica={loadDataGrafica}
      />
    </div>
  );
}

function TablaFlotillas({ initState, updateState, data }) {
  return (
    <Col xs={12} md={6} className="mb-3">
      <div
        className="ws_box"
        style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
      >
        <Container fluid>
          <div className="ws_box_header mb-3">
            <h2 className="ws_table_agente_title pb-0 mb-0">Flotillas</h2>
            <div className="ws_box_right">
              <Dropdown className="ws_dropdown">
                <Dropdown.Toggle id="dropdown-basic">
                  <Image
                    src={"/img/darkOpt.svg"}
                    alt="icon_opt"
                    className="ws_icon ms-2"
                  />
                </Dropdown.Toggle>
                <Dropdown.Menu align="end">
                  <Dropdown.Item href="#">Quitar del dashboard</Dropdown.Item>
                  <Dropdown.Item href="#">Duplicar</Dropdown.Item>
                  <Dropdown.Item href="#">Ocultar en móvil</Dropdown.Item>
                  <Dropdown.Item href="#">Exportar</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
          <Table
            striped
            bordered
            hover
            size="sm"
            style={{ borderColor: "transparent" }}
            responsive
          >
            <thead
              style={{
                backgroundColor: "transparent",
                color: "#0a93af",
                fontSize: ".9rem",
              }}
            >
              <tr>
                <th rowSpan="2" width="50%" align="left">
                  Cliente
                </th>
                <th colSpan="3" className="text-center">
                  Total
                </th>
              </tr>
            </thead>
            <tbody style={{ fontSize: ".9rem" }}>
              <tr>
                <td>Flotilla01</td>
                <td className="text-center">$100.00</td>
              </tr>
              <tr>
                <td>Flotilla02</td>
                <td className="text-center">$100.00</td>
              </tr>
              <tr>
                <td>Flotilla03</td>
                <td className="text-center">$10.00</td>
              </tr>
              <tr>
                <td>Flotilla04</td>
                <td className="text-center">$100.00</td>
              </tr>
              <tr>
                <td>Flotilla05</td>
                <td className="text-center">$100.00</td>
              </tr>
            </tbody>
          </Table>
        </Container>
      </div>
    </Col>
  );
}

function TablaAgentes({
  initState,
  updateState,
  loadDataAgentes,
  setLoadDataAgentes,
  dataSelect = {
    clave_oficina: "",
    selectedOficinas: [],
    selectedAgentes: "0",
    selectedTipos: "0",
  },
}) {
  const { usuario } = useContext(AuthContext);
  const isInitialMount = useRef(true);
  const currentMonth = moment().format("M");
  const { profileOficinasAgentes, profileOficinas, exportFileTableAgentes } =
    initState;
  const currentYear = new Date().getFullYear();
  const [yearG, setYearG] = useState(currentYear);
  const [search, setSearch] = useState("");
  const [mode, setMode] = useState(true);
  const [month, setMonth] = useState(currentMonth);
  const [load, setLoad] = useState(false);
  const [array, setArray] = useState([]);
  const [dataAgentesMensual,setDataAgentesMensual] = useState([]);
  const [loadDataAgentesMensual,setLoadDataAgentesMensual] = useState(false);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
    } else {
      getAvancesAgentesByClaveOficina();
      getAvanceMensualAgentesByClaveOficina();
    }
  }, [yearG]);

  useEffect(() => {
    if (loadDataAgentes) {
      setLoad(true);
      getAvancesAgentesByClaveOficina();
      getAvanceMensualAgentesByClaveOficina();
    } else {
      const isSet = profileOficinasAgentes.find(
        (element) => element.id === dataSelect.clave_oficina
      );
      setLoad(true);
      getAvancesAgentesByClaveOficina();
      getAvanceMensualAgentesByClaveOficina();
    }
  }, [loadDataAgentes]);

  useEffect( () => {
    if(loadDataAgentesMensual){
      getAvanceMensualAgentesByClaveOficina();
    }
  },[month,yearG])

  if (load || loadDataAgentesMensual) {
    return (
      <Col xs={12} md={12} className="mb-3">
        <div
          className="ws_box"
          style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
        >
          <Container fluid>
            <div className="ws_box_header mb-3">
              <div className="d-flex justify-content-start align-items-end">
                <div>
                  <h2 className="ws_table_agente_title pb-0 mb-2">
                    Agentes <span className="ws_table_agente_number">0</span>
                  </h2>
                  <Skeleton width="200px" height={20} />
                </div>
              </div>
            </div>
            <Skeleton width="100%" height={400} />
          </Container>
        </div>
      </Col>
    );
  }

  return (
    <Col xs={12} md={12} className="mb-3">
      <div
        className="ws_box"
        style={{
          position: "relative",
          paddingTop: "1rem",
          paddingBottom: "1rem",
        }}
      >
        {exportFileTableAgentes && (
          <div className="ws_backdrop_reporte d-flex justify-content-center align-items-start">
            <h1>Generando reporte, espere por favor...</h1>
          </div>
        )}

        <Container fluid>
          <div className="ws_box_header mb-3">
            <div className="d-flex justify-content-start align-items-end">
              <div>
                <h2 className="ws_table_agente_title pb-0 mb-2">
                  Agentes{" "}
                  <span className="ws_table_agente_number">{array.length}</span>
                </h2>
                <div className="d-flex justify-content-center align-items-center">
                  <DatePickerW
                    onChange={(e) => {
                      setLoadDataAgentesMensual(true);
                      setYearG(e.target.value);
                      setLoad(true);
                    }}
                    year={currentYear}
                    selected={yearG}
                  />
                  {!mode ? (
                    <DatePickerMonthW
                      className="ms-2"
                      onChange={(e) => {
                        setLoadDataAgentesMensual(true);
                        setMonth(e.target.value);
                      }}
                      selected={month}
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
            <div className="d-flex flex-column justify-content-between align-items-end">
              <div className="d-flex flex-row justify-content-between align-self-center align-items-center">
                <Form>
                  <Form.Control
                    type="search"
                    placeholder="Buscar"
                    className="ws_input"
                    onChange={(e) => {
                      setSearch(e.target.value);
                    }}
                  />
                </Form>
                {
                  (mode) && (
                    <Dropdown className="ws_dropdown">
                      <Dropdown.Toggle id="dropdown-basic">
                        <Image
                          src={"/img/darkOpt.svg"}
                          alt="icon_opt"
                          className="ws_icon ms-2"
                        />
                      </Dropdown.Toggle>
                      <Dropdown.Menu align="end">
                        {/* <Dropdown.Item href="#">Quitar del dashboard</Dropdown.Item>
                        <Dropdown.Item href="#">Duplicar</Dropdown.Item>
                        <Dropdown.Item href="#">Ocultar en móvil</Dropdown.Item> */}
                        <Dropdown.Item
                          href="#"
                          onClick={(e) => {
                            updateState({
                              exportFileTableAgentes: true,
                            });
                            exportToExcelProduccionAgentes();
                          }}
                        >
                          Exportar Producción
                        </Dropdown.Item>
                        <Dropdown.Item
                          href="#"
                          onClick={(e) => {
                            updateState({
                              exportFileTableAgentes: true,
                            });
                            exportToExcelCobranzaAgentes();
                          }}
                        >
                          Exportar Cobranza
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  )
                }
                
              </div>
              <Button className="mt-3 btn btn-primary ws_btn_secundary" onClick={(e) => { setMode(!mode) }}>{mode ? 'Ver Prod / Cobr por mes' : 'Ver Prod / Cobr por año'}</Button>
            </div>
          </div>

          {mode ? (
            <div className="table-responsive" style={{ maxHeight: 450 }}>
              <Table
                striped
                bordered
                hover
                size="sm"
                className="ws_tabla_agentes"
              >
                <thead
                  style={{
                    backgroundColor: "#0a93af",
                    color: "#fff",
                    fontSize: ".9rem",
                  }}
                >
                  <tr>
                    <th rowSpan="2" width="30%" align="left" className="ps-3">
                      AGENTE
                    </th>
                    <th colSpan="3" className="text-center">
                      PRODUCCIÓN
                    </th>
                    <th colSpan="3" className="text-center">
                      COBRANZA
                    </th>
                    {/* <th rowSpan="2" width="5%" align="center">Opc</th> */}
                  </tr>
                  <tr>
                    <th className="text-center">{yearG - 1}</th>
                    <th className="text-center">{yearG}</th>
                    <th className="text-center">%</th>
                    <th className="text-center">{yearG - 1}</th>
                    <th className="text-center">{yearG}</th>
                    <th className="text-center">%</th>
                  </tr>
                </thead>
                <tbody style={{ fontSize: ".9rem" }}>
                  {array.length > 0 ? (
                    array.map((t, e) => {
                      let decClave = "";
                      t.claves.map((t0) => {
                        decClave += `,${t0}`;
                      });

                      if (
                        search === "" ||
                        (decClave &&
                          decClave.toString().indexOf(search) !== -1) ||
                        (t.n_completo &&
                          t.n_completo
                            .toLowerCase()
                            .indexOf(search.toLowerCase()) !== -1)
                      ) {
                        return (
                          <tr key={e}>
                            <td align="left" style={{ paddingLeft: 15 }}>
                              {/* <span
                                className="ws_color_secundario"
                                style={{ fontWeight: "700", marginRight: 10 }}
                              >
                                {t.claves[0]}
                              </span> */}
                              <span>
                                <Link
                                  to={`/agentes/${t.id_usuario}`}
                                  style={{ color: "#606060" }}
                                >
                                  {t.n_completo}
                                </Link>
                              </span>
                            </td>
                            <td className="text-center">
                              ${number_format(t.produccion_before, 2)}
                            </td>
                            <td className="text-center">
                              ${number_format(t.produccion_current, 2)}
                            </td>
                            <td className="text-center">
                              {number_format(t.prodIncreaseMonth, 2)}%
                            </td>
                            <td className="text-center">
                              ${number_format(t.cobranza_before, 2)}
                            </td>
                            <td className="text-center">
                              ${number_format(t.cobranza_current, 2)}
                            </td>
                            <td className="text-center">
                              {number_format(t.cobIncreaseMonth, 2)}%
                            </td>
                            {/* <td style={{ position: 'relative' }}>
                                  <Dropdown className="ws_dropdown">
                                    <Dropdown.Toggle id="dropdown-basic">
                                      <Image src={'/img/darkOpt.svg'} alt="icon_opt" className="ws_icon ms-2" style={{ width: 25, height: 25 }} />
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu align="end">
                                      <Dropdown.Item href="#">Ver Ficha</Dropdown.Item>
                                      <Dropdown.Item href="#">Ver Pólizas</Dropdown.Item>
                                      <Dropdown.Item href="#">Asignar Ejecutivo</Dropdown.Item>
                                      <Dropdown.Item href="#">Añadir a grupo</Dropdown.Item>
                                      <Dropdown.Item href="#">Exportar Pólizas</Dropdown.Item>
                                      <Dropdown.Item href="#">Compartir Perfil</Dropdown.Item>
                                    </Dropdown.Menu>
                                  </Dropdown>
                                </td> */}
                          </tr>
                        );
                      }
                    })
                  ) : (
                    <tr className="text-center">
                      <td colSpan="8">
                        <p style={{ fontSize: "1rem" }}>No hay datos</p>
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          ) : (
            <div className="table-responsive" style={{ maxHeight: 450 }}>
              <Table
                striped
                bordered
                hover
                size="sm"
                className="ws_tabla_agentes"
              >
                <thead
                  style={{
                    backgroundColor: "#0a93af",
                    color: "#fff",
                    fontSize: ".9rem",
                  }}
                >
                  <tr>
                    <th rowSpan="2" width="30%" align="left" className="ps-3">
                      AGENTE
                    </th>
                    <th colSpan="3" className="text-center">
                      PRODUCCIÓN
                    </th>
                    <th colSpan="3" className="text-center">
                      COBRANZA
                    </th>
                    {/* <th rowSpan="2" width="5%" align="center">Opc</th> */}
                  </tr>
                  <tr>
                    <th className="text-center">
                      <p style={{textTransform:'capitalize'}} className="mb-0">{moment(month).format('MMMM')}</p>
                      {yearG - 1}
                    </th>
                    <th className="text-center">
                      <p style={{textTransform:'capitalize'}} className="mb-0">{moment(month).format('MMMM')}</p>
                      {yearG}
                    </th>
                    <th className="text-center">%</th>
                    <th className="text-center">
                      <p style={{textTransform:'capitalize'}} className="mb-0">{moment(month).format('MMMM')}</p>
                      {yearG - 1}
                    </th>
                    <th className="text-center">
                      <p style={{textTransform:'capitalize'}} className="mb-0">{moment(month).format('MMMM')}</p>
                      {yearG}
                    </th>
                    <th className="text-center">%</th>
                  </tr>
                </thead>
                <tbody style={{ fontSize: ".9rem" }}>
                  {dataAgentesMensual.length > 0 ? (
                    dataAgentesMensual.map((t, e) => {
                      let decClave = "";
                      t.claves.map((t0) => {
                        decClave += `,${t0}`;
                      });

                      if (
                        search === "" ||
                        (decClave &&
                          decClave.toString().indexOf(search) !== -1) ||
                        (t.n_completo &&
                          t.n_completo
                            .toLowerCase()
                            .indexOf(search.toLowerCase()) !== -1)
                      ) {
                        return (
                          <tr key={e}>
                            <td align="left" style={{ paddingLeft: 15 }}>
                              {/* <span
                                className="ws_color_secundario"
                                style={{ fontWeight: "700", marginRight: 10 }}
                              >
                                {t.claves[0]}
                              </span> */}
                              <span>
                                <Link
                                  to={`/agentes/${t.id_usuario}`}
                                  style={{ color: "#606060" }}
                                >
                                  {t.n_completo}
                                </Link>
                              </span>
                            </td>
                            <td className="text-center">
                              ${number_format(t.produccion_before, 2)}
                            </td>
                            <td className="text-center">
                              ${number_format(t.produccion_current, 2)}
                            </td>
                            <td className="text-center">
                              {number_format(t.prodIncreaseMonth, 2)}%
                            </td>
                            <td className="text-center">
                              ${number_format(t.cobranza_before, 2)}
                            </td>
                            <td className="text-center">
                              ${number_format(t.cobranza_current, 2)}
                            </td>
                            <td className="text-center">
                              {number_format(t.cobIncreaseMonth, 2)}%
                            </td>
                          </tr>
                        );
                      }
                    })
                  ) : (
                    <tr className="text-center">
                      <td colSpan="8">
                        <p style={{ fontSize: "1rem" }}>No hay datos</p>
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          )}
        </Container>
      </div>
    </Col>
  );

  function exportToExcelProduccionAgentes() {
    const dataSend = {
      id_login: usuario.id_usuario,
      year: yearG,
      oficinas: dataSelect.selectedOficinas,
      agentes: dataSelect.selectedAgentes,
      tipo_agente: dataSelect.selectedTipos,
    };

    if (dataSelect.clave_oficina != "") {
      dataSend["clave_oficina"] = dataSelect.clave_oficina;
    }

    fetch(
      `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=exportToExcelProduccionAgentes`,
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(dataSend),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        updateState({
          exportFileTableAgentes: false,
        });
        window.location.href = res.link;
      });
  }

  function exportToExcelCobranzaAgentes() {
    const dataSend = {
      id_login: usuario.id_usuario,
      year: yearG,
      oficinas: dataSelect.selectedOficinas,
      agentes: dataSelect.selectedAgentes,
      tipo_agente: dataSelect.selectedTipos,
    };

    if (dataSelect.clave_oficina != "") {
      dataSend["clave_oficina"] = dataSelect.clave_oficina;
    }

    fetch(
      `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=exportToExcelCobranzaAgentes`,
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(dataSend),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        updateState({
          exportFileTableAgentes: false,
        });
        window.location.href = res.link;
      });
  }

  function getAvancesAgentesByClaveOficina() {
    const dataSend = {
      id_login: usuario.id_usuario,
      year: yearG,
      oficinas: dataSelect.selectedOficinas,
      agentes: dataSelect.selectedAgentes,
      tipo_agente: dataSelect.selectedTipos,
    };

    if (dataSelect.clave_oficina != "") {
      dataSend["clave_oficina"] = dataSelect.clave_oficina;
    }

    fetch(
      `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=getAvancesAgentesByClaveOficina`,
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(dataSend),
      }
    )
      .then((res) => res.json())
      .then((res) => {

        res.list.sort((a,b)=>{
          if (a.cobranza_current > b.cobranza_current) return -1;
        });

        res.id = dataSelect.clave_oficina;
        const isSet = profileOficinasAgentes.find(
          (element) => element.id === dataSelect.clave_oficina
        );
        if (isSet) {
          const indexP = profileOficinasAgentes.findIndex(
            (element) => element.id === dataSelect.clave_oficina
          );
          profileOficinasAgentes[indexP] = res;
          updateState({ loadingData: false, profileOficinasAgentes });
          setArray(res.list);
          setLoad(false);
          setLoadDataAgentes(false);
        } else {
          updateState({
            loadingData: false,
            profileOficinasAgentes: profileOficinasAgentes.concat(res),
          });
          setArray(res.list);
          setLoad(false);
          setLoadDataAgentes(false);
        }
      });
  }

  function getAvanceMensualAgentesByClaveOficina() {
    setLoadDataAgentesMensual(true);
    const dataSend = {
      id_login: usuario.id_usuario,
      year: yearG,
      tipo_agente: dataSelect.selectedTipos,
      month: month,
    };

    if (dataSelect.clave_oficina != "") {
      dataSend["clave_oficina"] = dataSelect.clave_oficina;
    }

    fetch(
      `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=getAvanceMensualAgentesByClaveOficina`,
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(dataSend),
      }
    )
      .then((res) => res.json())
      .then((res) => {

        console.log(res)
        setLoadDataAgentesMensual(false);
        res.list.sort((a,b)=>{
          if (a.cobranza_current > b.cobranza_current) return -1;
        });

        // res.id = dataSelect.clave_oficina;
        // const isSet = profileOficinasAgentes.find(
        //   (element) => element.id === dataSelect.clave_oficina
        // );
        // if (isSet) {
        //   const indexP = profileOficinasAgentes.findIndex(
        //     (element) => element.id === dataSelect.clave_oficina
        //   );
        //   profileOficinasAgentes[indexP] = res;
        //   updateState({ loadingData: false, profileOficinasAgentes });
        //   setArray(res.list);
        //   setLoad(false);
        //   setLoadDataAgentes(false);
        // } else {
          // updateState({
          //   loadingData: false,
          //   profileOficinasAgentes: profileOficinasAgentes.concat(res),
          // });
          setDataAgentesMensual(res.list);
          // setLoad(false);
          // setLoadDataAgentes(false);
        // }

      });
  }
}

function TablaAgentesGrupo({
  initState,
  updateState,
  loadDataAgentes,
  setLoadDataAgentes,
  dataSelect = { id_grupo: "" },
  viewGrupo = false,
}) {
  const { usuario } = useContext(AuthContext);
  const isInitialMount = useRef(true);

  const {
    profileOficinasAgentes,
    profileOficinas,
    exportFileTableAgentes,
    exportFileProdCobAgentesByIdGrupo,
  } = initState;
  const currentYear = new Date().getFullYear();
  const [yearG, setYearG] = useState(currentYear);
  const [search, setSearch] = useState("");
  const [mode, setMode] = useState(true);
  const [month, setMonth] = useState("1");
  const [load, setLoad] = useState(false);
  const [array, setArray] = useState([]);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
    } else {
      getAvancesAgentesByIdGrupo();
    }
  }, [yearG]);

  useEffect(() => {
    if (loadDataAgentes) {
      setLoad(true);
      getAvancesAgentesByIdGrupo();
    } else {
      setLoad(true);
      getAvancesAgentesByIdGrupo();
    }
  }, [loadDataAgentes]);

  if (load === true) {
    return (
      <Col xs={12} md={12} className="mb-3">
        <div
          className="ws_box"
          style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
        >
          <Container fluid>
            <div className="ws_box_header mb-3">
              <div className="d-flex justify-content-start align-items-end">
                <div>
                  <h2 className="ws_table_agente_title pb-0 mb-2">
                    Agentes <span className="ws_table_agente_number">0</span>
                  </h2>
                  <Skeleton width="200px" height={20} />
                </div>
              </div>
            </div>
            <Skeleton width="100%" height={400} />
          </Container>
        </div>
      </Col>
    );
  }

  return (
    <Col xs={12} md={12} className="mb-3">
      <div
        className="ws_box"
        style={{
          position: "relative",
          paddingTop: "1rem",
          paddingBottom: "1rem",
        }}
      >
        {!viewGrupo
          ? exportFileTableAgentes && (
              <div className="ws_backdrop_reporte d-flex justify-content-center align-items-start">
                <h1>Generando reporte, espere por favor...</h1>
              </div>
            )
          : exportFileProdCobAgentesByIdGrupo && (
              <div className="ws_backdrop_reporte d-flex justify-content-center align-items-start">
                <h1>Generando reporte, espere por favor...</h1>
              </div>
            )}

        <Container fluid>
          <div className="ws_box_header mb-3">
            <div className="d-flex justify-content-start align-items-end">
              <div>
                <h2 className="ws_table_agente_title pb-0 mb-2">
                  Agentes{" "}
                  <span className="ws_table_agente_number">{array.length}</span>
                </h2>
                <div className="d-flex justify-content-center align-items-center">
                  <DatePickerW
                    onChange={(e) => {
                      setYearG(e.target.value);
                      setLoad(true);
                    }}
                    year={currentYear}
                    selected={yearG}
                  />
                  {!mode ? (
                    <DatePickerMonthW
                      className="ms-2"
                      onChange={(e) => {
                        setMonth(e.target.value);
                      }}
                      selected={month}
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
            <div className="d-flex flex-column justify-content-between align-items-end">
              <div className="d-flex flex-row justify-content-between align-self-center align-items-center">
                <Form>
                  <Form.Control
                    type="search"
                    placeholder="Buscar"
                    className="ws_input"
                    onChange={(e) => {
                      setSearch(e.target.value);
                    }}
                  />
                </Form>
                <Dropdown className="ws_dropdown">
                  <Dropdown.Toggle id="dropdown-basic">
                    <Image
                      src={"/img/darkOpt.svg"}
                      alt="icon_opt"
                      className="ws_icon ms-2"
                    />
                  </Dropdown.Toggle>
                  <Dropdown.Menu align="end">
                    {/* <Dropdown.Item href="#">Quitar del dashboard</Dropdown.Item>
                    <Dropdown.Item href="#">Duplicar</Dropdown.Item>
                    <Dropdown.Item href="#">Ocultar en móvil</Dropdown.Item> */}
                    <Dropdown.Item
                      href="#"
                      onClick={(e) => {
                        if (!viewGrupo) {
                          updateState({
                            exportFileTableAgentes: true,
                          });
                          exportToExcelProduccionAgentes();
                        } else {
                          updateState({
                            exportFileProdCobAgentesByIdGrupo: true,
                          });
                          exportToExcelProduccionAgentesByIdGrupo();
                        }
                      }}
                    >
                      Exportar Producción
                    </Dropdown.Item>
                    <Dropdown.Item
                      href="#"
                      onClick={(e) => {
                        if (!viewGrupo) {
                          updateState({
                            exportFileTableAgentes: true,
                          });
                          exportToExcelCobranzaAgentes();
                        } else {
                          updateState({
                            exportFileProdCobAgentesByIdGrupo: true,
                          });
                          exportToExcelCobranzaAgentesByIdGrupo();
                        }
                      }}
                    >
                      Exportar Cobranza
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              {/* <Button className="mt-3 btn btn-primary ws_btn_secundary" onClick={(e) => { setMode(!mode) }}>{mode ? 'Ver Renovaciones' : 'Ver Prod / Cobr'}</Button> */}
            </div>
          </div>

          {mode ? (
            <div className="table-responsive" style={{ maxHeight: 450 }}>
              <Table
                striped
                bordered
                hover
                size="sm"
                className="ws_tabla_agentes"
              >
                <thead
                  style={{
                    backgroundColor: "#0a93af",
                    color: "#fff",
                    fontSize: ".9rem",
                  }}
                >
                  <tr>
                    <th rowSpan="2" width="30%" align="left" className="ps-3">
                      AGENTE
                    </th>
                    <th colSpan="3" className="text-center">
                      PRODUCCIÓN
                    </th>
                    <th colSpan="3" className="text-center">
                      COBRANZA
                    </th>
                    {/* <th rowSpan="2" width="5%" align="center">Opc</th> */}
                  </tr>
                  <tr>
                    <th className="text-center">{yearG - 1}</th>
                    <th className="text-center">{yearG}</th>
                    <th className="text-center">%</th>
                    <th className="text-center">{yearG - 1}</th>
                    <th className="text-center">{yearG}</th>
                    <th className="text-center">%</th>
                  </tr>
                </thead>
                <tbody style={{ fontSize: ".9rem" }}>
                  {array.length > 0 ? (
                    array.map((t, e) => {
                      let decClave = "";
                      t.claves.map((t0) => {
                        decClave += `,${t0}`;
                      });

                      if (
                        search === "" ||
                        (decClave &&
                          decClave.toString().indexOf(search) !== -1) ||
                        (t.n_completo &&
                          t.n_completo
                            .toLowerCase()
                            .indexOf(search.toLowerCase()) !== -1)
                      ) {
                        return (
                          <tr key={e}>
                            <td align="left" style={{ paddingLeft: 15 }}>
                              <span
                                className="ws_color_secundario"
                                style={{ fontWeight: "700", marginRight: 10 }}
                              >
                                {t.claves[0]}
                              </span>
                              <span>
                                <Link
                                  to={`/agentes/${t.id_usuario}`}
                                  style={{ color: "#606060" }}
                                >
                                  {t.n_completo}
                                </Link>
                              </span>
                            </td>
                            <td className="text-center">
                              ${number_format(t.produccion_before, 2)}
                            </td>
                            <td className="text-center">
                              ${number_format(t.produccion_current, 2)}
                            </td>
                            <td className="text-center">
                              {number_format(t.prodIncreaseMonth, 2)}%
                            </td>
                            <td className="text-center">
                              ${number_format(t.cobranza_before, 2)}
                            </td>
                            <td className="text-center">
                              ${number_format(t.cobranza_current, 2)}
                            </td>
                            <td className="text-center">
                              {number_format(t.cobIncreaseMonth, 2)}%
                            </td>
                            {/* <td style={{ position: 'relative' }}>
                                  <Dropdown className="ws_dropdown">
                                    <Dropdown.Toggle id="dropdown-basic">
                                      <Image src={'/img/darkOpt.svg'} alt="icon_opt" className="ws_icon ms-2" style={{ width: 25, height: 25 }} />
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu align="end">
                                      <Dropdown.Item href="#">Ver Ficha</Dropdown.Item>
                                      <Dropdown.Item href="#">Ver Pólizas</Dropdown.Item>
                                      <Dropdown.Item href="#">Asignar Ejecutivo</Dropdown.Item>
                                      <Dropdown.Item href="#">Añadir a grupo</Dropdown.Item>
                                      <Dropdown.Item href="#">Exportar Pólizas</Dropdown.Item>
                                      <Dropdown.Item href="#">Compartir Perfil</Dropdown.Item>
                                    </Dropdown.Menu>
                                  </Dropdown>
                                </td> */}
                          </tr>
                        );
                      }
                    })
                  ) : (
                    <tr className="text-center">
                      <td colSpan="8">
                        <p style={{ fontSize: "1rem" }}>No hay datos</p>
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          ) : (
            <Table striped bordered hover size="sm" responsive>
              <thead
                style={{
                  backgroundColor: "#0a93af",
                  color: "#fff",
                  fontSize: ".9rem",
                }}
              >
                <tr>
                  <th rowSpan="2" width="30%" align="left" className="ps-3">
                    AGENTE
                  </th>
                  <th colSpan="5" className="text-center">
                    Prima Neta
                  </th>
                  <th colSpan="3" className="text-center">
                    Contratos
                  </th>
                  <th rowSpan="2" width="5%" align="center">
                    Opc
                  </th>
                </tr>
                <tr>
                  <th className="text-center">mes</th>
                  <th className="text-center">x renovar</th>
                  <th className="text-center">renovada</th>
                  <th className="text-center">nueva</th>
                  <th className="text-center">anterior</th>
                  <th className="text-center">nuevos</th>
                  <th className="text-center">x renovar</th>
                  <th className="text-center">renovados</th>
                </tr>
              </thead>
              <tbody style={{ fontSize: ".9rem" }}>
                <tr>
                  <td align="left" style={{ paddingLeft: 15 }}>
                    <a
                      href="#"
                      style={{ color: "#606060", textDecoration: "none" }}
                    >
                      <span
                        className="ws_color_secundario"
                        style={{ fontWeight: "700", marginRight: 10 }}
                      >
                        69
                      </span>
                      Marcela Rocha Arredondo
                    </a>
                  </td>
                  <td>$892,727</td>
                  <td>$175,680</td>
                  <td>$357,849</td>
                  <td>$794,340</td>
                  <td>$101,219</td>
                  <td>38</td>
                  <td>13</td>
                  <td>17</td>
                  <td>
                    <Dropdown className="ws_dropdown">
                      <Dropdown.Toggle id="dropdown-basic">
                        <Image
                          src={"/img/darkOpt.svg"}
                          alt="icon_opt"
                          className="ws_icon ms-2"
                          style={{ width: 25, height: 25 }}
                        />
                      </Dropdown.Toggle>
                      <Dropdown.Menu align="end">
                        <Dropdown.Item href="#">Ver Ficha</Dropdown.Item>
                        <Dropdown.Item href="#">Ver Pólizas</Dropdown.Item>
                        <Dropdown.Item href="#">
                          Asignar Ejecutivo
                        </Dropdown.Item>
                        <Dropdown.Item href="#">Añadir a grupo</Dropdown.Item>
                        <Dropdown.Item href="#">Exportar Pólizas</Dropdown.Item>
                        <Dropdown.Item href="#">Compartir Perfil</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </td>
                </tr>
                <tr>
                  <td align="left" style={{ paddingLeft: 15 }}>
                    <a
                      href="#"
                      style={{ color: "#606060", textDecoration: "none" }}
                    >
                      <span
                        className="ws_color_secundario"
                        style={{ fontWeight: "700", marginRight: 10 }}
                      >
                        68
                      </span>
                      Julio Ernesto Silva Gomez
                    </a>
                  </td>
                  <td>$556,265</td>
                  <td>$185,739</td>
                  <td>$246,871</td>
                  <td>$324,096</td>
                  <td>$282,688</td>
                  <td>55</td>
                  <td>33</td>
                  <td>36</td>
                  <td>
                    <Dropdown className="ws_dropdown">
                      <Dropdown.Toggle id="dropdown-basic">
                        <Image
                          src={"/img/darkOpt.svg"}
                          alt="icon_opt"
                          className="ws_icon ms-2"
                          style={{ width: 25, height: 25 }}
                        />
                      </Dropdown.Toggle>
                      <Dropdown.Menu align="end">
                        <Dropdown.Item href="#">Ver Ficha</Dropdown.Item>
                        <Dropdown.Item href="#">Ver Pólizas</Dropdown.Item>
                        <Dropdown.Item href="#">
                          Asignar Ejecutivo
                        </Dropdown.Item>
                        <Dropdown.Item href="#">Añadir a grupo</Dropdown.Item>
                        <Dropdown.Item href="#">Exportar Pólizas</Dropdown.Item>
                        <Dropdown.Item href="#">Compartir Perfil</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </td>
                </tr>
                <tr>
                  <td align="left" style={{ paddingLeft: 15 }}>
                    <a
                      href="#"
                      style={{ color: "#606060", textDecoration: "none" }}
                    >
                      <span
                        className="ws_color_secundario"
                        style={{ fontWeight: "700", marginRight: 10 }}
                      >
                        67
                      </span>
                      Jose de Jesús Yañez Mar
                    </a>
                  </td>
                  <td>$814,265</td>
                  <td>$239,156</td>
                  <td>$124,604</td>
                  <td>$274,813</td>
                  <td>$644,814</td>
                  <td>52</td>
                  <td>30</td>
                  <td>15</td>
                  <td>
                    <Dropdown className="ws_dropdown">
                      <Dropdown.Toggle id="dropdown-basic">
                        <Image
                          src={"/img/darkOpt.svg"}
                          alt="icon_opt"
                          className="ws_icon ms-2"
                          style={{ width: 25, height: 25 }}
                        />
                      </Dropdown.Toggle>
                      <Dropdown.Menu align="end">
                        <Dropdown.Item href="#">Ver Ficha</Dropdown.Item>
                        <Dropdown.Item href="#">Ver Pólizas</Dropdown.Item>
                        <Dropdown.Item href="#">
                          Asignar Ejecutivo
                        </Dropdown.Item>
                        <Dropdown.Item href="#">Añadir a grupo</Dropdown.Item>
                        <Dropdown.Item href="#">Exportar Pólizas</Dropdown.Item>
                        <Dropdown.Item href="#">Compartir Perfil</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </td>
                </tr>
                <tr>
                  <td align="left" style={{ paddingLeft: 15 }}>
                    <a
                      href="#"
                      style={{ color: "#606060", textDecoration: "none" }}
                    >
                      <span
                        className="ws_color_secundario"
                        style={{ fontWeight: "700", marginRight: 10 }}
                      >
                        66
                      </span>
                      Liliana Salazar Rocha
                    </a>
                  </td>
                  <td>$426,951</td>
                  <td>$46,542</td>
                  <td>$84,627</td>
                  <td>$358,195</td>
                  <td>$74,792</td>
                  <td>8</td>
                  <td>8</td>
                  <td>17</td>
                  <td>
                    <Dropdown className="ws_dropdown">
                      <Dropdown.Toggle id="dropdown-basic">
                        <Image
                          src={"/img/darkOpt.svg"}
                          alt="icon_opt"
                          className="ws_icon ms-2"
                          style={{ width: 25, height: 25 }}
                        />
                      </Dropdown.Toggle>
                      <Dropdown.Menu align="end">
                        <Dropdown.Item href="#">Ver Ficha</Dropdown.Item>
                        <Dropdown.Item href="#">Ver Pólizas</Dropdown.Item>
                        <Dropdown.Item href="#">
                          Asignar Ejecutivo
                        </Dropdown.Item>
                        <Dropdown.Item href="#">Añadir a grupo</Dropdown.Item>
                        <Dropdown.Item href="#">Exportar Pólizas</Dropdown.Item>
                        <Dropdown.Item href="#">Compartir Perfil</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </td>
                </tr>
                <tr>
                  <td align="left" style={{ paddingLeft: 15 }}>
                    <a
                      href="#"
                      style={{ color: "#606060", textDecoration: "none" }}
                    >
                      <span
                        className="ws_color_secundario"
                        style={{ fontWeight: "700", marginRight: 10 }}
                      >
                        65
                      </span>
                      Francisco García de la Cruz
                    </a>
                  </td>
                  <td>$373,533</td>
                  <td>$91,758</td>
                  <td>$152,688</td>
                  <td>$215,148</td>
                  <td>$166,515</td>
                  <td>20</td>
                  <td>16</td>
                  <td>16</td>
                  <td>
                    <Dropdown className="ws_dropdown">
                      <Dropdown.Toggle id="dropdown-basic">
                        <Image
                          src={"/img/darkOpt.svg"}
                          alt="icon_opt"
                          className="ws_icon ms-2"
                          style={{ width: 25, height: 25 }}
                        />
                      </Dropdown.Toggle>
                      <Dropdown.Menu align="end">
                        <Dropdown.Item href="#">Ver Ficha</Dropdown.Item>
                        <Dropdown.Item href="#">Ver Pólizas</Dropdown.Item>
                        <Dropdown.Item href="#">
                          Asignar Ejecutivo
                        </Dropdown.Item>
                        <Dropdown.Item href="#">Añadir a grupo</Dropdown.Item>
                        <Dropdown.Item href="#">Exportar Pólizas</Dropdown.Item>
                        <Dropdown.Item href="#">Compartir Perfil</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </td>
                </tr>
                <tr>
                  <td align="left" style={{ paddingLeft: 15 }}>
                    <a
                      href="#"
                      style={{ color: "#606060", textDecoration: "none" }}
                    >
                      <span
                        className="ws_color_secundario"
                        style={{ fontWeight: "700", marginRight: 10 }}
                      >
                        64
                      </span>
                      Emmanuel González González
                    </a>
                  </td>
                  <td>$89,974</td>
                  <td>$44,076</td>
                  <td>$16,939</td>
                  <td>$22,274</td>
                  <td>$69,905</td>
                  <td>34</td>
                  <td>4</td>
                  <td>2</td>
                  <td>
                    <Dropdown className="ws_dropdown">
                      <Dropdown.Toggle id="dropdown-basic">
                        <Image
                          src={"/img/darkOpt.svg"}
                          alt="icon_opt"
                          className="ws_icon ms-2"
                          style={{ width: 25, height: 25 }}
                        />
                      </Dropdown.Toggle>
                      <Dropdown.Menu align="end">
                        <Dropdown.Item href="#">Ver Ficha</Dropdown.Item>
                        <Dropdown.Item href="#">Ver Pólizas</Dropdown.Item>
                        <Dropdown.Item href="#">
                          Asignar Ejecutivo
                        </Dropdown.Item>
                        <Dropdown.Item href="#">Añadir a grupo</Dropdown.Item>
                        <Dropdown.Item href="#">Exportar Pólizas</Dropdown.Item>
                        <Dropdown.Item href="#">Compartir Perfil</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </td>
                </tr>
              </tbody>
            </Table>
          )}
        </Container>
      </div>
    </Col>
  );

  function exportToExcelProduccionAgentesByIdGrupo() {
    const dataSend = {
      id_login: usuario.id_usuario,
      id_grupo: dataSelect.id_grupo,
      year: yearG,
    };
    fetch(
      `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=exportToExcelProduccionAgentesByIdGrupo`,
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(dataSend),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        updateState({
          exportFileProdCobAgentesByIdGrupo: false,
        });
        window.location.href = res.link;
      });
  }

  function exportToExcelCobranzaAgentesByIdGrupo() {
    const dataSend = {
      id_login: usuario.id_usuario,
      id_grupo: dataSelect.id_grupo,
      year: yearG,
    };
    fetch(
      `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=exportToExcelCobranzaAgentesByIdGrupo`,
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(dataSend),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        updateState({
          exportFileProdCobAgentesByIdGrupo: false,
        });
        window.location.href = res.link;
      });
  }

  function exportToExcelProduccionAgentes() {
    const dataSend = {
      id_login: usuario.id_usuario,
      year: yearG,
      oficinas: dataSelect.selectedOficinas,
      agentes: dataSelect.selectedAgentes,
      tipo_agente: dataSelect.selectedTipos,
    };

    if (dataSelect.id_grupo != "") {
      dataSend["id_grupo"] = dataSelect.id_grupo;
    }

    fetch(
      `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=exportToExcelProduccionAgentes`,
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(dataSend),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        updateState({
          exportFileTableAgentes: false,
        });
        window.location.href = res.link;
      });
  }

  function exportToExcelCobranzaAgentes() {
    const dataSend = {
      id_login: usuario.id_usuario,
      year: yearG,
      oficinas: dataSelect.selectedOficinas,
      agentes: dataSelect.selectedAgentes,
      tipo_agente: dataSelect.selectedTipos,
    };

    if (dataSelect.id_grupo != "") {
      dataSend["id_grupo"] = dataSelect.id_grupo;
    }

    fetch(
      `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=exportToExcelCobranzaAgentes`,
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(dataSend),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        updateState({
          exportFileTableAgentes: false,
        });
        window.location.href = res.link;
      });
  }

  function getAvancesAgentesByIdGrupo() {
    const dataSend = {
      id_login: usuario.id_usuario,
      year: yearG,
      oficinas: dataSelect.selectedOficinas,
      agentes: dataSelect.selectedAgentes,
      tipo_agente: dataSelect.selectedTipos,
    };

    if (dataSelect.id_grupo != "") {
      dataSend["id_grupo"] = dataSelect.id_grupo;
    }

    fetch(
      `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=getAvancesAgentesByIdGrupo`,
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(dataSend),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        res.id = dataSelect.id_grupo;
        const isSet = profileOficinasAgentes.find(
          (element) => element.id === dataSelect.id_grupo
        );
        if (isSet) {
          const indexP = profileOficinasAgentes.findIndex(
            (element) => element.id === dataSelect.id_grupo
          );
          profileOficinasAgentes[indexP] = res;
          updateState({ loadingData: false, profileOficinasAgentes });
          setArray(res.list);
          setLoad(false);
          setLoadDataAgentes(false);
        } else {
          updateState({
            loadingData: false,
            profileOficinasAgentes: profileOficinasAgentes.concat(res),
          });
          setArray(res.list);
          setLoad(false);
          setLoadDataAgentes(false);
        }
      });
  }
}

function TablaAgentesPromotoria({
  initState,
  updateState,
  loadDataAgentes,
  setLoadDataAgentes,
  dataSelect = { promotor: "" },
  viewPromotoria = false,
}) {
  const { usuario } = useContext(AuthContext);
  const isInitialMount = useRef(true);

  const {
    profileOficinasAgentes,
    profileOficinas,
    exportFileTableAgentes,
    exportFileProdCobAgentesByIdPromotoria,
  } = initState;
  const currentYear = new Date().getFullYear();
  const [yearG, setYearG] = useState(currentYear);
  const [search, setSearch] = useState("");
  const [mode, setMode] = useState(true);
  const [month, setMonth] = useState("1");
  const [load, setLoad] = useState(false);
  const [array, setArray] = useState([]);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
    } else {
      getAvancesAgentesByIdPromotoria();
    }
  }, [yearG]);

  useEffect(() => {
    if (loadDataAgentes) {
      setLoad(true);
      getAvancesAgentesByIdPromotoria();
    } else {
      setLoad(true);
      getAvancesAgentesByIdPromotoria();
    }
  }, [loadDataAgentes]);

  if (load === true) {
    return (
      <Col xs={12} md={12} className="mb-3">
        <div
          className="ws_box"
          style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
        >
          <Container fluid>
            <div className="ws_box_header mb-3">
              <div className="d-flex justify-content-start align-items-end">
                <div>
                  <h2 className="ws_table_agente_title pb-0 mb-2">
                    Agentes <span className="ws_table_agente_number">0</span>
                  </h2>
                  <Skeleton width="200px" height={20} />
                </div>
              </div>
            </div>
            <Skeleton width="100%" height={400} />
          </Container>
        </div>
      </Col>
    );
  }

  return (
    <Col xs={12} md={12} className="mb-3">
      <div
        className="ws_box"
        style={{
          position: "relative",
          paddingTop: "1rem",
          paddingBottom: "1rem",
        }}
      >
        {!viewPromotoria
          ? exportFileTableAgentes && (
              <div className="ws_backdrop_reporte d-flex justify-content-center align-items-start">
                <h1>Generando reporte, espere por favor...</h1>
              </div>
            )
          : exportFileProdCobAgentesByIdPromotoria && (
              <div className="ws_backdrop_reporte d-flex justify-content-center align-items-start">
                <h1>Generando reporte, espere por favor...</h1>
              </div>
            )}

        <Container fluid>
          <div className="ws_box_header mb-3">
            <div className="d-flex justify-content-start align-items-end">
              <div>
                <h2 className="ws_table_agente_title pb-0 mb-2">
                  Agentes{" "}
                  <span className="ws_table_agente_number">{array.length}</span>
                </h2>
                <div className="d-flex justify-content-center align-items-center">
                  <DatePickerW
                    onChange={(e) => {
                      setYearG(e.target.value);
                      setLoad(true);
                    }}
                    year={currentYear}
                    selected={yearG}
                  />
                  {!mode ? (
                    <DatePickerMonthW
                      className="ms-2"
                      onChange={(e) => {
                        setMonth(e.target.value);
                      }}
                      selected={month}
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
            <div className="d-flex flex-column justify-content-between align-items-end">
              <div className="d-flex flex-row justify-content-between align-self-center align-items-center">
                <Form>
                  <Form.Control
                    type="search"
                    placeholder="Buscar"
                    className="ws_input"
                    onChange={(e) => {
                      setSearch(e.target.value);
                    }}
                  />
                </Form>
                <Dropdown className="ws_dropdown">
                  <Dropdown.Toggle id="dropdown-basic">
                    <Image
                      src={"/img/darkOpt.svg"}
                      alt="icon_opt"
                      className="ws_icon ms-2"
                    />
                  </Dropdown.Toggle>
                  <Dropdown.Menu align="end">
                    {/* <Dropdown.Item href="#">Quitar del dashboard</Dropdown.Item>
                    <Dropdown.Item href="#">Duplicar</Dropdown.Item>
                    <Dropdown.Item href="#">Ocultar en móvil</Dropdown.Item> */}
                    <Dropdown.Item
                      href="#"
                      onClick={(e) => {
                        if (!viewPromotoria) {
                          updateState({
                            exportFileTableAgentes: true,
                          });
                          exportToExcelProduccionAgentes();
                        } else {
                          updateState({
                            exportFileProdCobAgentesByIdPromotoria: true,
                          });
                          exportToExcelProduccionAgentesByIdPromotoria();
                        }
                      }}
                    >
                      Exportar Producción
                    </Dropdown.Item>
                    <Dropdown.Item
                      href="#"
                      onClick={(e) => {
                        if (!viewPromotoria) {
                          updateState({
                            exportFileTableAgentes: true,
                          });
                          exportToExcelCobranzaAgentes();
                        } else {
                          updateState({
                            exportFileProdCobAgentesByIdPromotoria: true,
                          });
                          exportToExcelCobranzaAgentesByIdPromotoria();
                        }
                      }}
                    >
                      Exportar Cobranza
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              {/* <Button className="mt-3 btn btn-primary ws_btn_secundary" onClick={(e) => { setMode(!mode) }}>{mode ? 'Ver Renovaciones' : 'Ver Prod / Cobr'}</Button> */}
            </div>
          </div>

          {mode ? (
            <div className="table-responsive" style={{ maxHeight: 450 }}>
              <Table
                striped
                bordered
                hover
                size="sm"
                className="ws_tabla_agentes"
              >
                <thead
                  style={{
                    backgroundColor: "#0a93af",
                    color: "#fff",
                    fontSize: ".9rem",
                  }}
                >
                  <tr>
                    <th rowSpan="2" width="30%" align="left" className="ps-3">
                      AGENTE
                    </th>
                    <th colSpan="3" className="text-center">
                      PRODUCCIÓN
                    </th>
                    <th colSpan="3" className="text-center">
                      COBRANZA
                    </th>
                    {/* <th rowSpan="2" width="5%" align="center">Opc</th> */}
                  </tr>
                  <tr>
                    <th className="text-center">{yearG - 1}</th>
                    <th className="text-center">{yearG}</th>
                    <th className="text-center">%</th>
                    <th className="text-center">{yearG - 1}</th>
                    <th className="text-center">{yearG}</th>
                    <th className="text-center">%</th>
                  </tr>
                </thead>
                <tbody style={{ fontSize: ".9rem" }}>
                  {array.length > 0 ? (
                    array.map((t, e) => {
                      let decClave = "";
                      t.claves.map((t0) => {
                        decClave += `,${t0}`;
                      });

                      if (
                        search === "" ||
                        (decClave &&
                          decClave.toString().indexOf(search) !== -1) ||
                        (t.n_completo &&
                          t.n_completo
                            .toLowerCase()
                            .indexOf(search.toLowerCase()) !== -1)
                      ) {
                        return (
                          <tr key={e}>
                            <td align="left" style={{ paddingLeft: 15 }}>
                              <span
                                className="ws_color_secundario"
                                style={{ fontWeight: "700", marginRight: 10 }}
                              >
                                {t.claves[0]}
                              </span>
                              <span>
                                <Link
                                  to={`/agentes/${t.id_usuario}`}
                                  style={{ color: "#606060" }}
                                >
                                  {t.n_completo}
                                </Link>
                              </span>
                            </td>
                            <td className="text-center">
                              ${number_format(t.produccion_before, 2)}
                            </td>
                            <td className="text-center">
                              ${number_format(t.produccion_current, 2)}
                            </td>
                            <td className="text-center">
                              {number_format(t.prodIncreaseMonth, 2)}%
                            </td>
                            <td className="text-center">
                              ${number_format(t.cobranza_before, 2)}
                            </td>
                            <td className="text-center">
                              ${number_format(t.cobranza_current, 2)}
                            </td>
                            <td className="text-center">
                              {number_format(t.cobIncreaseMonth, 2)}%
                            </td>
                            {/* <td style={{ position: 'relative' }}>
                                  <Dropdown className="ws_dropdown">
                                    <Dropdown.Toggle id="dropdown-basic">
                                      <Image src={'/img/darkOpt.svg'} alt="icon_opt" className="ws_icon ms-2" style={{ width: 25, height: 25 }} />
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu align="end">
                                      <Dropdown.Item href="#">Ver Ficha</Dropdown.Item>
                                      <Dropdown.Item href="#">Ver Pólizas</Dropdown.Item>
                                      <Dropdown.Item href="#">Asignar Ejecutivo</Dropdown.Item>
                                      <Dropdown.Item href="#">Añadir a grupo</Dropdown.Item>
                                      <Dropdown.Item href="#">Exportar Pólizas</Dropdown.Item>
                                      <Dropdown.Item href="#">Compartir Perfil</Dropdown.Item>
                                    </Dropdown.Menu>
                                  </Dropdown>
                                </td> */}
                          </tr>
                        );
                      }
                    })
                  ) : (
                    <tr className="text-center">
                      <td colSpan="8">
                        <p style={{ fontSize: "1rem" }}>No hay datos</p>
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          ) : (
            <Table striped bordered hover size="sm" responsive>
              <thead
                style={{
                  backgroundColor: "#0a93af",
                  color: "#fff",
                  fontSize: ".9rem",
                }}
              >
                <tr>
                  <th rowSpan="2" width="30%" align="left" className="ps-3">
                    AGENTE
                  </th>
                  <th colSpan="5" className="text-center">
                    Prima Neta
                  </th>
                  <th colSpan="3" className="text-center">
                    Contratos
                  </th>
                  <th rowSpan="2" width="5%" align="center">
                    Opc
                  </th>
                </tr>
                <tr>
                  <th className="text-center">mes</th>
                  <th className="text-center">x renovar</th>
                  <th className="text-center">renovada</th>
                  <th className="text-center">nueva</th>
                  <th className="text-center">anterior</th>
                  <th className="text-center">nuevos</th>
                  <th className="text-center">x renovar</th>
                  <th className="text-center">renovados</th>
                </tr>
              </thead>
              <tbody style={{ fontSize: ".9rem" }}>
                <tr>
                  <td align="left" style={{ paddingLeft: 15 }}>
                    <a
                      href="#"
                      style={{ color: "#606060", textDecoration: "none" }}
                    >
                      <span
                        className="ws_color_secundario"
                        style={{ fontWeight: "700", marginRight: 10 }}
                      >
                        69
                      </span>
                      Marcela Rocha Arredondo
                    </a>
                  </td>
                  <td>$892,727</td>
                  <td>$175,680</td>
                  <td>$357,849</td>
                  <td>$794,340</td>
                  <td>$101,219</td>
                  <td>38</td>
                  <td>13</td>
                  <td>17</td>
                  <td>
                    <Dropdown className="ws_dropdown">
                      <Dropdown.Toggle id="dropdown-basic">
                        <Image
                          src={"/img/darkOpt.svg"}
                          alt="icon_opt"
                          className="ws_icon ms-2"
                          style={{ width: 25, height: 25 }}
                        />
                      </Dropdown.Toggle>
                      <Dropdown.Menu align="end">
                        <Dropdown.Item href="#">Ver Ficha</Dropdown.Item>
                        <Dropdown.Item href="#">Ver Pólizas</Dropdown.Item>
                        <Dropdown.Item href="#">
                          Asignar Ejecutivo
                        </Dropdown.Item>
                        <Dropdown.Item href="#">Añadir a grupo</Dropdown.Item>
                        <Dropdown.Item href="#">Exportar Pólizas</Dropdown.Item>
                        <Dropdown.Item href="#">Compartir Perfil</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </td>
                </tr>
                <tr>
                  <td align="left" style={{ paddingLeft: 15 }}>
                    <a
                      href="#"
                      style={{ color: "#606060", textDecoration: "none" }}
                    >
                      <span
                        className="ws_color_secundario"
                        style={{ fontWeight: "700", marginRight: 10 }}
                      >
                        68
                      </span>
                      Julio Ernesto Silva Gomez
                    </a>
                  </td>
                  <td>$556,265</td>
                  <td>$185,739</td>
                  <td>$246,871</td>
                  <td>$324,096</td>
                  <td>$282,688</td>
                  <td>55</td>
                  <td>33</td>
                  <td>36</td>
                  <td>
                    <Dropdown className="ws_dropdown">
                      <Dropdown.Toggle id="dropdown-basic">
                        <Image
                          src={"/img/darkOpt.svg"}
                          alt="icon_opt"
                          className="ws_icon ms-2"
                          style={{ width: 25, height: 25 }}
                        />
                      </Dropdown.Toggle>
                      <Dropdown.Menu align="end">
                        <Dropdown.Item href="#">Ver Ficha</Dropdown.Item>
                        <Dropdown.Item href="#">Ver Pólizas</Dropdown.Item>
                        <Dropdown.Item href="#">
                          Asignar Ejecutivo
                        </Dropdown.Item>
                        <Dropdown.Item href="#">Añadir a grupo</Dropdown.Item>
                        <Dropdown.Item href="#">Exportar Pólizas</Dropdown.Item>
                        <Dropdown.Item href="#">Compartir Perfil</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </td>
                </tr>
                <tr>
                  <td align="left" style={{ paddingLeft: 15 }}>
                    <a
                      href="#"
                      style={{ color: "#606060", textDecoration: "none" }}
                    >
                      <span
                        className="ws_color_secundario"
                        style={{ fontWeight: "700", marginRight: 10 }}
                      >
                        67
                      </span>
                      Jose de Jesús Yañez Mar
                    </a>
                  </td>
                  <td>$814,265</td>
                  <td>$239,156</td>
                  <td>$124,604</td>
                  <td>$274,813</td>
                  <td>$644,814</td>
                  <td>52</td>
                  <td>30</td>
                  <td>15</td>
                  <td>
                    <Dropdown className="ws_dropdown">
                      <Dropdown.Toggle id="dropdown-basic">
                        <Image
                          src={"/img/darkOpt.svg"}
                          alt="icon_opt"
                          className="ws_icon ms-2"
                          style={{ width: 25, height: 25 }}
                        />
                      </Dropdown.Toggle>
                      <Dropdown.Menu align="end">
                        <Dropdown.Item href="#">Ver Ficha</Dropdown.Item>
                        <Dropdown.Item href="#">Ver Pólizas</Dropdown.Item>
                        <Dropdown.Item href="#">
                          Asignar Ejecutivo
                        </Dropdown.Item>
                        <Dropdown.Item href="#">Añadir a grupo</Dropdown.Item>
                        <Dropdown.Item href="#">Exportar Pólizas</Dropdown.Item>
                        <Dropdown.Item href="#">Compartir Perfil</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </td>
                </tr>
                <tr>
                  <td align="left" style={{ paddingLeft: 15 }}>
                    <a
                      href="#"
                      style={{ color: "#606060", textDecoration: "none" }}
                    >
                      <span
                        className="ws_color_secundario"
                        style={{ fontWeight: "700", marginRight: 10 }}
                      >
                        66
                      </span>
                      Liliana Salazar Rocha
                    </a>
                  </td>
                  <td>$426,951</td>
                  <td>$46,542</td>
                  <td>$84,627</td>
                  <td>$358,195</td>
                  <td>$74,792</td>
                  <td>8</td>
                  <td>8</td>
                  <td>17</td>
                  <td>
                    <Dropdown className="ws_dropdown">
                      <Dropdown.Toggle id="dropdown-basic">
                        <Image
                          src={"/img/darkOpt.svg"}
                          alt="icon_opt"
                          className="ws_icon ms-2"
                          style={{ width: 25, height: 25 }}
                        />
                      </Dropdown.Toggle>
                      <Dropdown.Menu align="end">
                        <Dropdown.Item href="#">Ver Ficha</Dropdown.Item>
                        <Dropdown.Item href="#">Ver Pólizas</Dropdown.Item>
                        <Dropdown.Item href="#">
                          Asignar Ejecutivo
                        </Dropdown.Item>
                        <Dropdown.Item href="#">Añadir a grupo</Dropdown.Item>
                        <Dropdown.Item href="#">Exportar Pólizas</Dropdown.Item>
                        <Dropdown.Item href="#">Compartir Perfil</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </td>
                </tr>
                <tr>
                  <td align="left" style={{ paddingLeft: 15 }}>
                    <a
                      href="#"
                      style={{ color: "#606060", textDecoration: "none" }}
                    >
                      <span
                        className="ws_color_secundario"
                        style={{ fontWeight: "700", marginRight: 10 }}
                      >
                        65
                      </span>
                      Francisco García de la Cruz
                    </a>
                  </td>
                  <td>$373,533</td>
                  <td>$91,758</td>
                  <td>$152,688</td>
                  <td>$215,148</td>
                  <td>$166,515</td>
                  <td>20</td>
                  <td>16</td>
                  <td>16</td>
                  <td>
                    <Dropdown className="ws_dropdown">
                      <Dropdown.Toggle id="dropdown-basic">
                        <Image
                          src={"/img/darkOpt.svg"}
                          alt="icon_opt"
                          className="ws_icon ms-2"
                          style={{ width: 25, height: 25 }}
                        />
                      </Dropdown.Toggle>
                      <Dropdown.Menu align="end">
                        <Dropdown.Item href="#">Ver Ficha</Dropdown.Item>
                        <Dropdown.Item href="#">Ver Pólizas</Dropdown.Item>
                        <Dropdown.Item href="#">
                          Asignar Ejecutivo
                        </Dropdown.Item>
                        <Dropdown.Item href="#">Añadir a grupo</Dropdown.Item>
                        <Dropdown.Item href="#">Exportar Pólizas</Dropdown.Item>
                        <Dropdown.Item href="#">Compartir Perfil</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </td>
                </tr>
                <tr>
                  <td align="left" style={{ paddingLeft: 15 }}>
                    <a
                      href="#"
                      style={{ color: "#606060", textDecoration: "none" }}
                    >
                      <span
                        className="ws_color_secundario"
                        style={{ fontWeight: "700", marginRight: 10 }}
                      >
                        64
                      </span>
                      Emmanuel González González
                    </a>
                  </td>
                  <td>$89,974</td>
                  <td>$44,076</td>
                  <td>$16,939</td>
                  <td>$22,274</td>
                  <td>$69,905</td>
                  <td>34</td>
                  <td>4</td>
                  <td>2</td>
                  <td>
                    <Dropdown className="ws_dropdown">
                      <Dropdown.Toggle id="dropdown-basic">
                        <Image
                          src={"/img/darkOpt.svg"}
                          alt="icon_opt"
                          className="ws_icon ms-2"
                          style={{ width: 25, height: 25 }}
                        />
                      </Dropdown.Toggle>
                      <Dropdown.Menu align="end">
                        <Dropdown.Item href="#">Ver Ficha</Dropdown.Item>
                        <Dropdown.Item href="#">Ver Pólizas</Dropdown.Item>
                        <Dropdown.Item href="#">
                          Asignar Ejecutivo
                        </Dropdown.Item>
                        <Dropdown.Item href="#">Añadir a grupo</Dropdown.Item>
                        <Dropdown.Item href="#">Exportar Pólizas</Dropdown.Item>
                        <Dropdown.Item href="#">Compartir Perfil</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </td>
                </tr>
              </tbody>
            </Table>
          )}
        </Container>
      </div>
    </Col>
  );

  function exportToExcelProduccionAgentesByIdPromotoria() {
    const dataSend = {
      id_login: usuario.id_usuario,
      promotor: dataSelect.promotor,
      year: yearG,
    };
    fetch(
      `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=exportToExcelProduccionAgentesByIdPromotoria`,
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(dataSend),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        updateState({
          exportFileProdCobAgentesByIdPromotoria: false,
        });
        window.location.href = res.link;
      });
  }

  function exportToExcelCobranzaAgentesByIdPromotoria() {
    const dataSend = {
      id_login: usuario.id_usuario,
      promotor: dataSelect.promotor,
      year: yearG,
    };
    fetch(
      `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=exportToExcelCobranzaAgentesByIdPromotoria`,
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(dataSend),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        updateState({
          exportFileProdCobAgentesByIdPromotoria: false,
        });
        window.location.href = res.link;
      });
  }

  function exportToExcelProduccionAgentes() {
    const dataSend = {
      id_login: usuario.id_usuario,
      year: yearG,
      oficinas: dataSelect.selectedOficinas,
      agentes: dataSelect.selectedAgentes,
      tipo_agente: dataSelect.selectedTipos,
    };

    if (dataSelect.promotor != "") {
      dataSend["promotor"] = dataSelect.promotor;
    }

    fetch(
      `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=exportToExcelProduccionAgentes`,
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(dataSend),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        updateState({
          exportFileTableAgentes: false,
        });
        window.location.href = res.link;
      });
  }

  function exportToExcelCobranzaAgentes() {
    const dataSend = {
      id_login: usuario.id_usuario,
      year: yearG,
      oficinas: dataSelect.selectedOficinas,
      agentes: dataSelect.selectedAgentes,
      tipo_agente: dataSelect.selectedTipos,
    };

    if (dataSelect.promotor != "") {
      dataSend["promotor"] = dataSelect.promotor;
    }

    fetch(
      `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=exportToExcelCobranzaAgentes`,
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(dataSend),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        updateState({
          exportFileTableAgentes: false,
        });
        window.location.href = res.link;
      });
  }

  function getAvancesAgentesByIdPromotoria() {
    const dataSend = {
      id_login: usuario.id_usuario,
      year: yearG,
      oficinas: dataSelect.selectedOficinas,
      agentes: dataSelect.selectedAgentes,
      tipo_agente: dataSelect.selectedTipos,
    };

    if (dataSelect.promotor != "") {
      dataSend["promotor"] = dataSelect.promotor;
    }

    fetch(
      `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=getAvancesAgentesByIdPromotoria`,
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(dataSend),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        res.id = dataSelect.promotor;
        const isSet = profileOficinasAgentes.find(
          (element) => element.id === dataSelect.promotor
        );
        if (isSet) {
          const indexP = profileOficinasAgentes.findIndex(
            (element) => element.id === dataSelect.promotor
          );
          profileOficinasAgentes[indexP] = res;
          updateState({ loadingData: false, profileOficinasAgentes });
          setArray(res.list);
          setLoad(false);
          setLoadDataAgentes(false);
        } else {
          updateState({
            loadingData: false,
            profileOficinasAgentes: profileOficinasAgentes.concat(res),
          });
          setArray(res.list);
          setLoad(false);
          setLoadDataAgentes(false);
        }
      });
  }
}

function TablaAgentesByQuatrimestre({
  initState,
  updateState,
  loadAgentesQuatrimestre,
  dataAgente = { nombre: "", id_usuario: "", claves: [] },
  data = [],
  props,
  size = { xs: 12, sm: 6, md: 6, lg: 6, xl: 6, xxl: 6 },
}) {
  const { usuario } = useContext(AuthContext);

  const { profileOficinasAgentes, exportFileCierrePorCuatrimestre } = initState;

  const currentYear = new Date().getFullYear();
  const beforeYear = new Date(
    new Date().setFullYear(new Date().getFullYear() - 1)
  ).getFullYear();
  const [yearG, setYearG] = useState(currentYear);
  const [search, setSearch] = useState("");
  const [mode, setMode] = useState(true);
  const [avanceAgente, setAvanceAgente] = useState(data);
  const [load, setLoad] = useState(loadAgentesQuatrimestre);

  useEffect( () => setAvanceAgente(data) ,[data]);
  useEffect(() => setLoad(loadAgentesQuatrimestre), [loadAgentesQuatrimestre]);

  if (load) {
    return (
      <Col className="mb-3" xs={size.xs} sm={size.sm} md={size.md} lg={size.lg} xl={size.xl} xxl={size.xxl}>
        <div className="ws_box" style={{ paddingTop: "1rem", paddingBottom: "1rem" }} >
          <Container fluid>
            <Skeleton className="mb-3" width="150px" height={30} />
            <Skeleton width="100%" height={200} />
          </Container>
        </div>
      </Col>
    );
  }

  return (
    <Col
      xs={size.xs}
      sm={size.sm}
      md={size.md}
      lg={size.lg}
      xl={size.xl}
      xxl={size.xxl}
      className="mb-3"
    >
      <div
        className="ws_box"
        style={{
          position: "relative",
          paddingTop: "1rem",
          paddingBottom: "1rem",
        }}
      >

        {exportFileCierrePorCuatrimestre && (
          <div className="ws_backdrop_reporte d-flex justify-content-center align-items-start">
            <h1>Generando reporte, espere por favor...</h1>
          </div>
        )}
        
        <Container fluid>
          <div className="ws_box_header mb-3">
            <div className="d-flex justify-content-start align-items-end">
              <div>
                <h2 className="ws_table_agente_title pb-0 mb-2">
                  {dataAgente.nombre}
                </h2>
              </div>
            </div>
            <div className="d-flex flex-column justify-content-between align-items-end">
              <div className="d-flex flex-row justify-content-between align-self-center align-items-center">
                <Form>
                  <Form.Control
                    type="search"
                    placeholder="Buscar"
                    className="ws_input"
                    onChange={(e) => {
                      setSearch(e.target.value);
                    }}
                  />
                </Form>
                <Dropdown className="ws_dropdown">
                  <Dropdown.Toggle id="dropdown-basic">
                    <Image
                      src={"/img/darkOpt.svg"}
                      alt="icon_opt"
                      className="ws_icon ms-2"
                    />
                  </Dropdown.Toggle>
                  <Dropdown.Menu align="end">
                    <Dropdown.Item
                      href="#"
                      onClick={(e) => {
                        updateState({
                          exportFileCierrePorCuatrimestre: true,
                        });
                        exportToExcelAvanceAgente();
                      }}
                    >
                      Exportar a excel
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          </div>
          <Table
            striped
            bordered
            hover
            size="sm"
            responsive="md"
            className="ws_tabla_agentes"
          >
            <thead
              style={{
                backgroundColor: "#0a93af",
                color: "#fff",
                fontSize: ".9rem",
              }}
            >
              <tr>
                <th
                  rowSpan="2"
                  width="30%"
                  align="left"
                  style={{ paddingLeft: 15 }}
                >
                  Agente
                </th>
                <th colSpan="3" className="text-center">
                  PRODUCCIÓN
                </th>
                <th colSpan="3" className="text-center">
                  COBRANZA
                </th>
              </tr>
              <tr>
                <th className="text-center">{beforeYear}</th>
                <th className="text-center">{currentYear}</th>
                <th className="text-center">%</th>
                <th className="text-center">{beforeYear}</th>
                <th className="text-center">{currentYear}</th>
                <th className="text-center">%</th>
              </tr>
            </thead>
            <tbody style={{ fontSize: ".9rem" }}>
              {avanceAgente.map((t, e, array) => {
                if (
                  search === "" ||
                  (t.mes &&
                    t.mes
                      .toString()
                      .toLowerCase()
                      .indexOf(search.toLowerCase()) !== -1)
                ) {
                  const arrLength = array.length - 1;
                  if (arrLength === e) {
                    return (
                      <tr
                        key={e}
                        style={{
                          backgroundColor: "#0a93af",
                          color: "#fff",
                          fontSize: "0.9rem",
                        }}
                      >
                        <td align="left" style={{ paddingLeft: 15 }}>
                          <span>{t.mes}</span>
                        </td>
                        <td>${number_format(t.produccion_before, 2)}</td>
                        <td>${number_format(t.produccion_current, 2)}</td>
                        <td>{t.prodIncreaseMonth}%</td>
                        <td>${number_format(t.cobranza_before, 2)}</td>
                        <td>${number_format(t.cobranza_current, 2)}</td>
                        <td>{t.cobIncreaseMonth}%</td>
                      </tr>
                    );
                  } else {
                    return (
                      <tr
                        key={e}
                        style={{
                          backgroundColor:
                            e === 4 || e === 9 || e === 14 ? "#9ed9e1" : "",
                          fontWeight:
                            e === 4 || e === 9 || e === 14 ? "600" : "",
                        }}
                      >
                        <td align="left" style={{ paddingLeft: 15 }}>
                          <span>{t.mes}</span>
                        </td>
                        <td>${number_format(t.produccion_before, 2)}</td>
                        <td>${number_format(t.produccion_current, 2)}</td>
                        <td>{t.prodIncreaseMonth}%</td>
                        <td>${number_format(t.cobranza_before, 2)}</td>
                        <td>${number_format(t.cobranza_current, 2)}</td>
                        <td>{t.cobIncreaseMonth}%</td>
                      </tr>
                    );
                  }
                }
              })}
            </tbody>
          </Table>
        </Container>
      </div>
    </Col>
  );


  function exportToExcelAvanceAgente() {
    const dataSend = {
      id_login: usuario.id_usuario,
      id_usuario: dataAgente.id_usuario,
      claves: dataAgente.claves
    };
    fetch(
      `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=exportToExcelAvanceAgente`,
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(dataSend),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        updateState({
          exportFileCierrePorCuatrimestre: false,
        });
        window.location.href = res.link;
      });
  }

  
}

function TablaLoader({title="Tabla",counter="0",size = { xs: 12, sm: 12, md: 12, lg: 12, xl: 6, xxl: 6 } }){
  return(
    <Col xs={size.xs} sm={size.sm} md={size.md} lg={size.lg} xl={size.xl} xxl={size.xxl} className="mb-3">
      <div className="ws_box" style={{ paddingTop: '1rem', paddingBottom: "1rem" }}>
        <Container fluid>
          <Skeleton className="mb-3" width="150px" height={30} />
          <Skeleton width="100%" height={200} />
        </Container> 
      </div> 
    </Col>
  )
}

function TablaReservaPendientesCobertura({initState,updateState,data,loadData=false,size = { xs: 12, sm: 12, md: 12, lg: 12, xl: 6, xxl: 6 },dataSelect,type }){

  const [load,setLoad] = useState(loadData);
  const [search, setSearch] = useState("");
  const [array,setArray] = useState(data);
  const [show,setShow] = useState(false);
  const [coberturaReserva,setCoberturaReserva] = useState("");
  const [dataReservaDetalle,setDataReservaDetalle] = useState([]);
  const [dataHeaders,setDataHeaders] = useState([]);

  const { usuario } = useContext(AuthContext);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect( () => setLoad(loadData), [loadData]);
  useEffect( () => setArray(data), [data]);

  const getReservaAgenteDetalle = (cobertura) =>{
    setCoberturaReserva(cobertura);
    handleShow();
  }

  useEffect(() => {
    if(show){
      getReservaAgenteDetalleCobertura();
    }
  },[show])

  if(load) return <TablaLoader title="Reserva Pendiente por Cobertura" counter="0" size={size} />

  return(
    <Col xs={size.xs} sm={size.sm} md={size.md} lg={size.lg} xl={size.xl} xxl={size.xxl} className="mb-3">
      <div className="ws_box" style={{ paddingTop: '1rem', paddingBottom: "1rem" }}>
        <Container fluid>
          {/* Box header */}
          <div className="ws_box_header mb-3"> 
            <div className="d-flex justify-content-start align-items-end">
              <div>
                <h2 className="ws_table_agente_title pb-0 mb-2">
                  Reserva Pendiente por Cobertura MN
                  {/* <span className="ws_table_agente_number">
                    {dataClaves.length}
                  </span> */}
                </h2>
              </div>
            </div>
            <div className="d-flex flex-column justify-content-between align-items-end">
              <div className="d-flex flex-row justify-content-between align-self-center align-items-center">
                <Form>
                  <Form.Control
                    type="search"
                    placeholder="Buscar"
                    className="ws_input"
                    onChange={(e) => {
                      setSearch(e.target.value);
                    }}
                  />
                </Form>
              </div>
            </div>
          </div>
          <Table
            striped
            bordered
            hover
            size="sm"
            responsive="md"
            className="ws_tabla"
          >
            <thead style={{ backgroundColor: "#0a93af", color: "#fff", fontSize: ".9rem" }}>
              <tr>
                <th className="text-left ps-3">Cobertura</th>
                <th className="text-left ps-3">Monto</th>
                <th className="text-left ps-3">Casos</th>
                <th className="text-left ps-3">%</th>
              </tr>
            </thead>
            <tbody style={{ fontSize: ".9rem" }}>
            {array.length > 0 ? (
                array.map((t, e,array) => {
                  if (
                    search === "" ||
                    (t.cobertura &&
                      t.cobertura
                        .toString()
                        .toLowerCase()
                        .indexOf(search.toLowerCase()) !== -1)
                  ) {

                    const arrLength = array.length - 1;

                    if(arrLength === e){
                      if(array.length===1){
                        return (
                          <>
                          <tr>
                            <td className="text-center" colSpan="4">
                              No hay datos disponibles
                            </td>
                          </tr>
                          <tr key={e} style={{ backgroundColor: '#0a93af', color:'#fff' }}>
                            <td className="text-left ps-3">
                              {t.cobertura}
                            </td>
                            <td className="text-left ps-3">
                              ${number_format(t.reserva,2)}
                            </td>
                            <td className="text-left ps-3" >
                              {t.count}
                            </td>
                            <td className="text-left ps-3">
                              {t.porcentaje}%
                            </td>
                          </tr>
                          </>
                        )
                      }else{
                        return (
                          <tr key={e} style={{ backgroundColor: '#0a93af', color:'#fff' }}>
                            <td className="text-left ps-3">
                              {t.cobertura}
                            </td>
                            <td className="text-left ps-3">
                              ${number_format(t.reserva,2)}
                            </td>
                            <td className="text-left ps-3" style={{cursor: "pointer"}} onClick={ () => getReservaAgenteDetalle(t.cobertura) }>
                              {t.count}
                            </td>
                            <td className="text-left ps-3">
                              {t.porcentaje}%
                            </td>
                          </tr>
                        )
                      }
                    }else{
                      return (
                        <tr key={e}>
                          <td className="text-left ps-3">
                            {t.cobertura}
                          </td>
                          <td className="text-left ps-3">
                            ${number_format(t.reserva,2)}
                          </td>
                          <td className="text-left ps-3" style={{cursor: "pointer"}} onClick={ () => getReservaAgenteDetalle(t.cobertura) }>
                            {t.count}
                          </td>
                          <td className="text-left ps-3">
                            {t.porcentaje}%
                          </td>
                        </tr>
                      )
                    }
                    
                  }
                })
              ) : (
                <tr>
                  <td className="text-center" colSpan="4">
                    No hay datos disponibles
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </Container> 
      </div> 

      <Modal show={show} onHide={handleClose} fullscreen={true}>
        <Modal.Header closeButton>
          <Modal.Title>Casos {coberturaReserva}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table 
           striped
           bordered
           hover
           size="sm"
           responsive="md"
           className="ws_tabla"
          >
            <thead style={{ backgroundColor: "#0a93af", color: "#fff", fontSize: ".9rem" }}>
              <tr>
                {
                  (dataHeaders.length > 0) ?
                    dataHeaders.map((t,e) => (
                      <th>{t}</th>
                    ))
                  : <th>Columna 1</th>
                }
              </tr>
            </thead>
            <tbody style={{ fontSize: ".9rem" }}>
              {
                dataReservaDetalle.map((detalle,e) => (
                  <tr>
                    {
                      dataHeaders.map((header,e) => (
                        <td>{detalle[header]}</td>
                      ))
                    }
                  </tr>
                ))
              }
            </tbody>  
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </Col>
  )

  function getReservaAgenteDetalleCobertura() {
    let dataSend;
    if(type==='Oficina'){
      dataSend = {
        id_login: usuario.id_usuario,
        clave_oficina: dataSelect.id,
        cobertura: coberturaReserva
      };
    }
    if(type==='Agente'){
      dataSend = {
        id_login: usuario.id_usuario,
        id_usuario: dataSelect.id,
        cobertura: coberturaReserva,
        claves: []
      };
    }

    fetch(
      `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=getReserva${type}DetalleCobertura`,
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(dataSend),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        const data = res.detalle_reserva_cobertura;
        var headers = [];
        for(let y in data){
          headers = headers.concat(Object.keys(data[y]))
        }
        headers = headers.filter(function(item, pos) {
          return headers.indexOf(item) == pos;
        })
        setDataHeaders(headers);
        setDataReservaDetalle(res.detalle_reserva_cobertura);
      });
  }
}

function TablaReservaPendientesMarca({initState,updateState,data,loadData=false,size = { xs: 12, sm: 12, md: 12, lg: 12, xl: 6, xxl: 6 },dataSelect,type } ){

  const [load,setLoad] = useState(loadData);
  const [search, setSearch] = useState("");
  const [array,setArray] = useState(data);

  const [show, setShow] = useState(false);
  const [marcaReserva,setMarcaReserva] = useState("");
  const [dataReservaDetalle,setDataReservaDetalle] = useState([]);
  const [dataHeaders,setDataHeaders] = useState([]);

  const { usuario } = useContext(AuthContext);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const getReservaAgenteDetalle = (marca) =>{
    setMarcaReserva(marca);
    handleShow();
  }

  useEffect(() => {
    if(show){
      getReservaAgenteDetalleMarca();
    }
  },[show])

  useEffect( () => setLoad(loadData), [loadData]);
  useEffect( () => setArray(data), [data]);

  if(load) return <TablaLoader title="Reserva Pendiente por Marca" counter="0" size={size} />

  return(
    <Col xs={size.xs} sm={size.sm} md={size.md} lg={size.lg} xl={size.xl} xxl={size.xxl} className="mb-3">

      <div className="ws_box" style={{ paddingTop: '1rem', paddingBottom: "1rem" }}>
        <Container fluid>
          {/* Box header */}
          <div className="ws_box_header mb-3"> 
            <div className="d-flex justify-content-start align-items-end">
              <div>
                <h2 className="ws_table_agente_title pb-0 mb-2">
                  Reserva Pendiente por Marca MN
                  {/* <span className="ws_table_agente_number">
                    {dataClaves.length}
                  </span> */}
                </h2>
              </div>
            </div>
            <div className="d-flex flex-column justify-content-between align-items-end">
              <div className="d-flex flex-row justify-content-between align-self-center align-items-center">
                <Form>
                  <Form.Control
                    type="search"
                    placeholder="Buscar"
                    className="ws_input"
                    onChange={(e) => {
                      setSearch(e.target.value);
                    }}
                  />
                </Form>
              </div>
            </div>
          </div>
          <Table
            striped
            bordered
            hover
            size="sm"
            responsive="md"
            className="ws_tabla"
          >
            <thead style={{ backgroundColor: "#0a93af", color: "#fff", fontSize: ".9rem" }}>
              <tr>
                {/* <th className="text-center">Código Cobertura</th> */}
                <th className="text-left ps-3">Marca</th>
                <th className="text-left ps-3">Monto</th>
                <th className="text-left ps-3">Casos</th>
                <th className="text-left ps-3">Porcentaje</th>  
              </tr>
            </thead>
            <tbody style={{ fontSize: ".9rem" }}>
            {array.length > 0 ? (
                array.map((t, e) => {
                  if (
                    search === "" ||
                    (t.marca &&
                      t.marca
                        .toString()
                        .toLowerCase()
                        .indexOf(search.toLowerCase()) !== -1)
                  ) {
                    const arrLength = array.length - 1;
                    if(arrLength === e){
                      if(array.length === 1){
                        return (
                          <>
                          <tr>
                            <td className="text-center" colSpan="4">
                              No hay datos disponibles
                            </td>
                          </tr>
                          <tr key={e} style={{ backgroundColor: '#0a93af','color': '#fff' }}>
                            <td className="text-left ps-3">
                              {t.marca}
                            </td>
                            <td className="text-left ps-3">
                              ${number_format(t.reserva,2)}
                            </td>
                            <td className="text-left ps-3" >
                              {t.count}
                            </td>
                            <td className="text-left ps-3">
                              {t.porcentaje}%
                            </td>
                          </tr>
                          </>
                        );
                      }else{
                        return (
                          <tr key={e} style={{ backgroundColor: '#0a93af','color': '#fff' }}>
                            <td className="text-left ps-3">
                              {t.marca}
                            </td>
                            <td className="text-left ps-3">
                              ${number_format(t.reserva,2)}
                            </td>
                            <td className="text-left ps-3" style={{cursor: "pointer"}} onClick={ () => getReservaAgenteDetalle(t.marca) }>
                              {t.count}
                            </td>
                            <td className="text-left ps-3">
                              {t.porcentaje}%
                            </td>
                          </tr>
                        );
                      }
                    }else{
                      return (
                        <tr key={e}>
                          <td className="text-left ps-3">
                            {t.marca}
                          </td>
                          <td className="text-left ps-3">
                            ${number_format(t.reserva,2)}
                          </td>
                          <td className="text-left ps-3" style={{cursor: "pointer"}} onClick={ () => getReservaAgenteDetalle(t.marca) }>
                            {t.count}
                          </td>
                          <td className="text-left ps-3">
                            {t.porcentaje}%
                          </td>
                        </tr>
                      );
                    }
                    
                  }
                })
              ) : (
                <tr>
                  <td className="text-center" colSpan="4">
                    No hay datos disponibles
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </Container> 
      </div> 

      <Modal show={show} onHide={handleClose} fullscreen={true}>
        <Modal.Header closeButton>
          <Modal.Title>Casos {marcaReserva}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <Table 
           striped
           bordered
           hover
           size="sm"
           responsive="md"
           className="ws_tabla"
          >
            <thead style={{ backgroundColor: "#0a93af", color: "#fff", fontSize: ".9rem" }}>
              <tr>
                {
                  (dataHeaders.length > 0) ?
                    dataHeaders.map((t,e) => (
                      <th>{t}</th>
                    ))
                  : <th>Columna 1</th>
                }
              </tr>
            </thead>
            <tbody style={{ fontSize: ".9rem" }}>
              {
                dataReservaDetalle.map((detalle,e) => (
                  <tr>
                    {
                      dataHeaders.map((header,e) => (
                        <td>{detalle[header]}</td>
                      ))
                    }
                  </tr>
                ))
              }
            </tbody>  
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>

    </Col>
  )

  function getReservaAgenteDetalleMarca() {
    let dataSend;
    if(type==='Oficina'){
      dataSend = {
        id_login: usuario.id_usuario,
        clave_oficina: dataSelect.id,
        marca: marcaReserva
      };
    }
    if(type==='Agente'){
      dataSend = {
        id_login: usuario.id_usuario,
        id_usuario: dataSelect.id,
        marca: marcaReserva,
        claves: []
      };
    }

    fetch(
      `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=getReserva${type}DetalleMarca`,
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(dataSend),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        const data = res.detalle_reserva_marca;
        var headers = [];
        for(let y in data){
          headers = headers.concat(Object.keys(data[y]))
        }
        headers = headers.filter(function(item, pos) {
          return headers.indexOf(item) == pos;
        })
        setDataHeaders(headers);
        setDataReservaDetalle(res.detalle_reserva_marca);
      });
  }

  
}

function TablaAgentesClaves({
  initState,
  updateState,
  data,
  props,
  dataSelect = { id_usuario: "" },
  size = { xs: 12, sm: 12, md: 12, lg: 12, xl: 6, xxl: 6 },
}) {
  const { usuario } = useContext(AuthContext);
  const [search, setSearch] = useState("");

  const [dataClaves, setDataClaves] = useState([]);
  const [monthClaves,setMonthClaves] = useState('');
  const [load, setLoad] = useState(false);

  useEffect(() => {
    setLoad(true);
    getInfoClavesByIdAgente();
  }, []);

  if (load) {
    return (
      <Col
        xs={size.xs}
        sm={size.sm}
        md={size.md}
        lg={size.lg}
        xl={size.xl}
        xxl={size.xxl}
        className="mb-3"
      >
        <div
          className="ws_box"
          style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
        >
          <Container fluid>
            <div className="ws_box_header mb-3">
              <div className="d-flex justify-content-start align-items-end">
                <div>
                  <h2 className="ws_table_agente_title pb-0 mb-2">
                    Claves <span className="ws_table_agente_number">0</span>
                  </h2>
                </div>
              </div>
            </div>
            <Skeleton width="100%" height={400} />
          </Container>
        </div>
      </Col>
    );
  }

  return (
    <Col
      xs={size.xs}
      sm={size.sm}
      md={size.md}
      lg={size.lg}
      xl={size.xl}
      xxl={size.xxl}
      className="mb-3"
    >
      <div
        className="ws_box"
        style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
      >
        <Container fluid>
          <div className="ws_box_header mb-3">
            <div className="d-flex justify-content-start align-items-end">
              <div>
                <h2 className="ws_table_agente_title pb-0 mb-2">
                  Claves{" "}
                  <span className="ws_table_agente_number">
                    {dataClaves.length}
                  </span>
                </h2>
              </div>
            </div>
            <div className="d-flex flex-column justify-content-between align-items-end">
              <div className="d-flex flex-row justify-content-between align-self-center align-items-center">
                <Form>
                  <Form.Control
                    type="search"
                    placeholder="Buscar"
                    className="ws_input"
                    onChange={(e) => {
                      setSearch(e.target.value);
                    }}
                  />
                </Form>
                {/* <Dropdown className="ws_dropdown">
                  <Dropdown.Toggle id="dropdown-basic">
                    <Image src={'/img/darkOpt.svg'} alt="icon_opt" className="ws_icon ms-2" />
                  </Dropdown.Toggle>
                  <Dropdown.Menu align="end">
                    <Dropdown.Item href="#">Quitar del dashboard</Dropdown.Item>
                    <Dropdown.Item href="#">Duplicar</Dropdown.Item>
                    <Dropdown.Item href="#">Ocultar en móvil</Dropdown.Item>
                    <Dropdown.Item href="#">Exportar</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown> */}
              </div>
            </div>
          </div>
          <Table
            striped
            bordered
            hover
            size="sm"
            responsive="md"
            className="ws_tabla"
          >
            <thead
              style={{
                backgroundColor: "#0a93af",
                color: "#fff",
                fontSize: ".9rem",
              }}
            >
              <tr>
                <th className="text-center">Clave</th>
                <th className="text-center">Prima anual</th>
                <th className="text-center">Prima Devengada</th>
                <th className="text-center">Siniestralidad {monthClaves}</th>
                <th className="text-center">%Sin</th>
              </tr>
            </thead>
            <tbody style={{ fontSize: ".9rem" }}>
              {dataClaves.length > 0 ? (
                dataClaves.map((t, e) => {
                  if (
                    search === "" ||
                    (t.clave &&
                      t.clave
                        .toString()
                        .toLowerCase()
                        .indexOf(search.toLowerCase()) !== -1)
                  ) {
                    return (
                      <tr key={e}>
                        <td
                          align="left"
                          style={{ paddingLeft: 15 }}
                          className="text-center"
                        >
                          <span>{t.clave}</span>
                        </td>
                        <td className="text-left ps-3">
                          ${number_format(t.prima, 2)}
                        </td>
                        <td className="text-left ps-3">
                          ${number_format(t.devengada, 2)}
                        </td>
                        <td className="text-left ps-3">
                          ${number_format(t.siniestralidad, 2)}
                        </td>
                        <td className="text-left ps-3">{t.porcentaje}%</td>
                      </tr>
                    );
                  }
                })
              ) : (
                <tr>
                  <td className="text-center" colSpan="5">
                    No hay datos
                  </td>
                </tr>
              )}

              {/* <tr style={{ color: '#0ca1b4' }}>
                <td align="left" style={{ paddingLeft: 15 }} className="text-center">
                  <span>General</span>
                </td>
                <td className="text-left ps-3">$9,624,170.99</td>
                <td className="text-left ps-3">$9,358,046.34</td>
                <td className="text-left ps-3">$11,646,795.61</td>
                <td className="text-left ps-3">52.96%</td>
              </tr> */}
            </tbody>
          </Table>
        </Container>
      </div>
    </Col>
  );

  function getInfoClavesByIdAgente() {
    const dataSend = {
      id_login: usuario.id_usuario,
      id_usuario: dataSelect.id_usuario,
    };

    fetch(
      `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=getInfoClavesByIdAgente`,
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(dataSend),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        setLoad(false);
        setDataClaves(res.info_claves);
        if(res&&res.month){
          setMonthClaves(res.month);
        }
      });
  }
}

function TablaLogros({
  initState,
  updateState,
  data,
  props,
  size = { xs: 12, sm: 6, md: 6, lg: 6 },
}) {
  const [search, setSearch] = useState("");
  return (
    <Col
      xs={size.xs}
      sm={size.sm}
      md={size.md}
      lg={size.lg}
      className="mb-3"
      id="tbLogros"
    >
      <div
        className="ws_box"
        style={{
          position: "relative",
          paddingTop: "1rem",
          paddingBottom: "1rem",
        }}
      >
        {/* <div className="ws_backdrop d-flex justify-content-center align-items-center"><h1>No disponible por el momento</h1></div> */}

        <Container fluid>
          <div className="ws_box_header mb-3">
            <div className="d-flex justify-content-start align-items-end">
              <div>
                <h2 className="ws_table_agente_title pb-0 mb-2">
                  Logros <span className="ws_table_agente_number">22</span>
                </h2>
              </div>
            </div>
            <div className="d-flex flex-column justify-content-between align-items-end">
              <div className="d-flex flex-row justify-content-between align-self-center align-items-center">
                <Form>
                  <Form.Control
                    type="search"
                    placeholder="Buscar"
                    className="ws_input"
                    onChange={(e) => {
                      setSearch(e.target.value);
                    }}
                  />
                </Form>
                <Dropdown className="ws_dropdown">
                  <Dropdown.Toggle id="dropdown-basic">
                    <Image
                      src={"/img/darkOpt.svg"}
                      alt="icon_opt"
                      className="ws_icon ms-2"
                    />
                  </Dropdown.Toggle>
                  <Dropdown.Menu align="end">
                    <Dropdown.Item href="#">Quitar del dashboard</Dropdown.Item>
                    <Dropdown.Item href="#">Duplicar</Dropdown.Item>
                    <Dropdown.Item href="#">Ocultar en móvil</Dropdown.Item>
                    <Dropdown.Item href="#">Exportar</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          </div>
          <Table striped bordered hover size="sm" responsive="md">
            <thead
              style={{
                backgroundColor: "#0a93af",
                color: "#fff",
                fontSize: ".9rem",
              }}
            >
              <tr>
                <th className="text-center" width="30%">
                  Agente
                </th>
                <th width="70%"></th>
              </tr>
            </thead>
            <tbody style={{ fontSize: ".9rem" }}>
              <tr>
                <td
                  align="center"
                  style={{ paddingLeft: 15, fontSize: "1.2rem" }}
                >
                  Julio
                </td>
                <td>
                  <IconBannerDiamante width="90px" height="90px" />
                  <IconBanner24k width="90px" height="90px" />
                  <IconBannerBuenaRacha width="90px" height="90px" />
                  <IconBannerBono width="90px" height="90px" />
                </td>
              </tr>
              <tr>
                <td
                  align="center"
                  style={{ paddingLeft: 15, fontSize: "1.2rem" }}
                >
                  Junio
                </td>
                <td>
                  <IconBanner24k width="90px" height="90px" />
                  <IconBannerBuenaRacha width="90px" height="90px" />
                  <IconBannerBono width="90px" height="90px" />
                </td>
              </tr>
              <tr>
                <td
                  align="center"
                  style={{ paddingLeft: 15, fontSize: "1.2rem" }}
                >
                  Mayo
                </td>
                <td>
                  <IconBanner24k width="90px" height="90px" />
                  <IconBannerBuenaRacha width="90px" height="90px" />
                  <IconBannerBono width="90px" height="90px" />
                </td>
              </tr>
              <tr>
                <td
                  align="center"
                  style={{ paddingLeft: 15, fontSize: "1.2rem" }}
                >
                  Abril
                </td>
                <td>
                  <IconBanner24k width="90px" height="90px" />
                  <IconBannerBuenaRacha width="90px" height="90px" />
                  <IconBannerBono width="90px" height="90px" />
                </td>
              </tr>
              <tr>
                <td
                  align="center"
                  style={{ paddingLeft: 15, fontSize: "1.2rem" }}
                >
                  Marzo
                </td>
                <td>
                  <IconBanner24k width="90px" height="90px" />
                  <IconBannerBuenaRacha width="90px" height="90px" />
                  <IconBannerBono width="90px" height="90px" />
                </td>
              </tr>
              <tr>
                <td
                  align="center"
                  style={{ paddingLeft: 15, fontSize: "1.2rem" }}
                >
                  Febrero
                </td>
                <td>
                  <IconBannerBuenaRacha width="90px" height="90px" />
                  <IconBannerBono width="90px" height="90px" />
                </td>
              </tr>
              <tr>
                <td
                  align="center"
                  style={{ paddingLeft: 15, fontSize: "1.2rem" }}
                >
                  Enero
                </td>
                <td>
                  <IconBanner24k width="90px" height="90px" />
                  <IconBannerBuenaRacha width="90px" height="90px" />
                  <IconBannerEscalon width="90px" height="90px" />
                  <IconBannerBono width="90px" height="90px" />
                </td>
              </tr>
            </tbody>
          </Table>
        </Container>
      </div>
    </Col>
  );
}

function CarteraIndividual({
  initState,
  updateState,
  loadCarteraIndividual,
  setLoadCarteraIndividual,
  dataAgente = { id_usuario: "", claves: [] },
  size = { xs: 12, sm: 12, md: 12, lg: 12, xl: 6, xxl: 6 },
}) {
  const { usuario } = useContext(AuthContext);
  const currentMonth = moment().format("MMMM");
  const currentYear = new Date().getFullYear();
  const [year, setYear] = useState(currentYear);
  const [search, setSearch] = useState("");
  const [month, setMonth] = useState(
    moment().month(currentMonth).subtract(1, "month").format("M")
  );
  const [dataGrafica, setDataGrafica] = useState([]);
  const [dataTable, setDataTable] = useState([]);
  const [load, setLoad] = useState(false);

  useEffect(() => {
    setLoad(true);
    getCarteraIndividualByIdAgente();
  }, [month]);

  useEffect(() => {
    if (loadCarteraIndividual) {
      setLoad(true);
      getCarteraIndividualByIdAgente();
    }
  }, [loadCarteraIndividual]);

  if (load) {
    return (
      <Col
        xs={size.xs}
        sm={size.sm}
        md={size.md}
        lg={size.lg}
        xl={size.xl}
        xxl={size.xxl}
        className="mb-3"
      >
        <div
          className="ws_box"
          style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
        >
          <Container fluid>
            <div className="ws_box_header mb-3">
              <div className="d-flex justify-content-start align-items-end">
                <div>
                  <h2 className="ws_table_agente_title pb-0 mb-2">
                    Cartera Individual{" "}
                    <span className="ws_table_agente_number">0</span>
                  </h2>
                </div>
              </div>
            </div>
            <Skeleton width="100%" height={400} />
          </Container>
        </div>
      </Col>
    );
  }

  return (
    <Col
      xs={size.xs}
      sm={size.sm}
      md={size.md}
      lg={size.lg}
      xl={size.xl}
      xxl={size.xxl}
      className="mb-3"
      id="tbLogros"
    >
      <div
        className="ws_box"
        style={{
          position: "relative",
          paddingTop: "1rem",
          paddingBottom: "1rem",
        }}
      >
        {/* <div className="ws_backdrop d-flex justify-content-center align-items-center"><h1>No disponible por el momento</h1></div> */}

        <Container fluid>
          <div className="ws_box_header mb-3">
            <div className="d-flex flex-column justify-content-center align-items-start">
              <div>
                <h2 className="ws_table_agente_title pb-0 mb-2">
                  Cartera Individual{" "}
                  <span className="ws_table_agente_number">
                    {dataTable.length - 1}
                  </span>
                </h2>
              </div>
              <div className="d-flex justify-content-center align-items-center">
                <DatePickerW
                  onChange={(e) => {
                    setYear(e.target.value);
                    setLoadCarteraIndividual(true);
                  }}
                  year={currentYear}
                  selected={year}
                />
                <DatePickerMonthW
                  className="ms-2"
                  onChange={(e) => {
                    setMonth(e.target.value);
                  }}
                  selected={month}
                />
              </div>
            </div>
            <div className="d-flex flex-column justify-content-between align-items-end">
              <div className="d-flex flex-row justify-content-between align-self-center align-items-center">
                <Form>
                  <Form.Control
                    type="search"
                    placeholder="Buscar"
                    className="ws_input"
                    onChange={(e) => {
                      setSearch(e.target.value);
                    }}
                  />
                </Form>
                {/* <Dropdown className="ws_dropdown">
                  <Dropdown.Toggle id="dropdown-basic">
                    <Image src={'/img/darkOpt.svg'} alt="icon_opt" className="ws_icon ms-2" />
                  </Dropdown.Toggle>
                  <Dropdown.Menu align="end">
                    <Dropdown.Item href="#">Quitar del dashboard</Dropdown.Item>
                    <Dropdown.Item href="#">Duplicar</Dropdown.Item>
                    <Dropdown.Item href="#">Ocultar en móvil</Dropdown.Item>
                    <Dropdown.Item href="#">Exportar</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown> */}
              </div>
            </div>
          </div>
          <div style={{ widht: "100%", height: 400 }}>
            <ResponsivePieCanvas
              data={dataGrafica}
              margin={{ top: 40, right: 200, bottom: 40, left: 80 }}
              innerRadius={0.5}
              padAngle={0.7}
              cornerRadius={3}
              activeOuterRadiusOffset={8}
              colors={[
                "#0ca1b4",
                "#660091",
                "#6a2aac",
                "#6d47be",
                "#6f63d0",
                "#727fe2",
                "#73ffff",
                "#0cffb4",
                "#0ceab4",
                "#0cd7b4",
                "#0cb6b4",
              ]}
              borderColor={{ from: "color", modifiers: [["darker", 0.6]] }}
              arcLinkLabelsSkipAngle={10}
              arcLinkLabelsTextColor="#333333"
              arcLinkLabelsThickness={2}
              arcLinkLabelsColor={"#000"}
              arcLabelsSkipAngle={10}
              arcLabelsTextColor="#fff"
              defs={[
                {
                  id: "dots",
                  type: "patternDots",
                  background: "inherit",
                  color: "rgba(255, 255, 255, 0.3)",
                  size: 4,
                  padding: 1,
                  stagger: true,
                },
                {
                  id: "lines",
                  type: "patternLines",
                  background: "inherit",
                  color: "rgba(255, 255, 255, 0.3)",
                  rotation: -45,
                  lineWidth: 6,
                  spacing: 10,
                },
              ]}
              fill={[
                {
                  match: {
                    id: "ruby",
                  },
                  id: "dots",
                },
                {
                  match: {
                    id: "c",
                  },
                  id: "dots",
                },
                {
                  match: {
                    id: "go",
                  },
                  id: "dots",
                },
                {
                  match: {
                    id: "python",
                  },
                  id: "dots",
                },
                {
                  match: {
                    id: "scala",
                  },
                  id: "lines",
                },
                {
                  match: {
                    id: "lisp",
                  },
                  id: "lines",
                },
                {
                  match: {
                    id: "elixir",
                  },
                  id: "lines",
                },
                {
                  match: {
                    id: "javascript",
                  },
                  id: "lines",
                },
              ]}
              legends={[
                {
                  anchor: "right",
                  direction: "column",
                  justify: false,
                  translateX: 140,
                  translateY: 0,
                  itemsSpacing: 2,
                  itemWidth: 60,
                  itemHeight: 14,
                  itemTextColor: "#999",
                  itemDirection: "left-to-right",
                  itemOpacity: 1,
                  symbolSize: 14,
                  symbolShape: "circle",
                },
              ]}
            />
          </div>
          <Table
            striped
            bordered
            hover
            size="sm"
            responsive
            className="ws_tabla mt-4"
          >
            <thead
              style={{
                backgroundColor: "#0a93af",
                color: "#fff",
                fontSize: ".9rem",
              }}
            >
              <tr>
                <th className="ps-3 text-left">Grupo</th>
                <th className="ps-3 text-left">Prima Neta</th>
                <th className="ps-3 text-left">Prima Devengada</th>
                <th className="ps-3 text-left">Siniestralidad</th>
                <th className="ps-3 text-left">%Sin</th>
              </tr>
            </thead>
            <tbody style={{ fontSize: ".9rem" }}>
              {dataTable.map((t, e, array) => {
                if (
                  search === "" ||
                  (t.grupo &&
                    t.grupo
                      .toString()
                      .toLowerCase()
                      .indexOf(search.toLowerCase()) !== -1)
                ) {
                  const arrLenght = array.length - 1;
                  if (arrLenght === e) {
                    return (
                      <tr style={{ color: "#0ca1b4" }} key={e}>
                        <td className="ps-3 text-left">{t.cartera}</td>
                        <td className="ps-3 text-left">
                          ${number_format(t.prima_neta, 2)}
                        </td>
                        <td className="ps-3 text-left">
                          ${number_format(t.devengada, 2)}
                        </td>
                        <td className="ps-3 text-left">
                          ${number_format(t.siniestralidad, 2)}
                        </td>
                        <td className="ps-3 text-left">{t.porcentaje_sin}%</td>
                      </tr>
                    );
                  } else {
                    return (
                      <tr key={e}>
                        <td className="ps-3 text-left">{t.grupo}</td>
                        <td className="ps-3 text-left">
                          ${number_format(t.prima_neta, 2)}
                        </td>
                        <td className="ps-3 text-left">
                          ${number_format(t.devengada, 2)}
                        </td>
                        <td className="ps-3 text-left">
                          ${number_format(t.siniestralidad, 2)}
                        </td>
                        <td className="ps-3 text-left">{t.porcentaje_sin}%</td>
                      </tr>
                    );
                  }
                }
              })}
            </tbody>
          </Table>
        </Container>
      </div>
    </Col>
  );

  function getCarteraIndividualByIdAgente() {
    const dataSend = {
      id_login: usuario.id_usuario,
      id_usuario: dataAgente.id_usuario,
      month: month,
      year,
      claves: dataAgente.claves,
    };
    fetch(
      `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=getCarteraIndividualByIdAgente`,
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(dataSend),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        if (loadCarteraIndividual != undefined) {
          setLoadCarteraIndividual(false);
        }
        setLoad(false);
        setDataTable(res.list);
        setDataGrafica(res.graph);
      });
  }
}

function CarteraIndividualOficina({
  initState,
  updateState,
  loadCarteraIndividual,
  setLoadCarteraIndividual,
  dataOficina = { clave_oficina: "" },
  size = { xs: 12, sm: 12, md: 12, lg: 12, xl: 6, xxl: 6 },
}) {
  const { usuario } = useContext(AuthContext);
  const currentMonth = moment().format("MMMM");
  const currentYear = new Date().getFullYear();
  const [year, setYear] = useState(currentYear);
  const [search, setSearch] = useState("");
  const [month, setMonth] = useState(
    moment().month(currentMonth).subtract(1, "month").format("M")
  );
  const [dataGrafica, setDataGrafica] = useState([]);
  const [dataTable, setDataTable] = useState([]);
  const [load, setLoad] = useState(false);

  useEffect(() => {
    setLoad(true);
    getCarteraIndividualByClaveOficina();
  }, [month]);

  useEffect(() => {
    if (loadCarteraIndividual) {
      setLoad(true);
      getCarteraIndividualByClaveOficina();
    }
  }, [loadCarteraIndividual]);

  if (load) {
    return (
      <Col
        xs={size.xs}
        sm={size.sm}
        md={size.md}
        lg={size.lg}
        xl={size.xl}
        xxl={size.xxl}
        className="mb-3"
      >
        <div
          className="ws_box"
          style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
        >
          <Container fluid>
            <div className="ws_box_header mb-3">
              <div className="d-flex justify-content-start align-items-end">
                <div>
                  <h2 className="ws_table_agente_title pb-0 mb-2">
                    Cartera Individual{" "}
                    <span className="ws_table_agente_number">0</span>
                  </h2>
                </div>
              </div>
            </div>
            <Skeleton width="100%" height={400} />
          </Container>
        </div>
      </Col>
    );
  }

  return (
    <Col
      xs={size.xs}
      sm={size.sm}
      md={size.md}
      lg={size.lg}
      xl={size.xl}
      xxl={size.xxl}
      className="mb-3"
      id="tbLogros"
    >
      <div
        className="ws_box"
        style={{
          position: "relative",
          paddingTop: "1rem",
          paddingBottom: "1rem",
        }}
      >
        {/* <div className="ws_backdrop d-flex justify-content-center align-items-center"><h1>No disponible por el momento</h1></div> */}

        <Container fluid>
          <div className="ws_box_header mb-3">
            <div className="d-flex flex-column justify-content-center align-items-start">
              <div>
                <h2 className="ws_table_agente_title pb-0 mb-2">
                  Cartera Individual{" "}
                  <span className="ws_table_agente_number">
                    {dataTable.length - 1}
                  </span>
                </h2>
              </div>
              <div className="d-flex justify-content-center align-items-center">
                <DatePickerW
                  onChange={(e) => {
                    setYear(e.target.value);
                    setLoadCarteraIndividual(true);
                  }}
                  year={currentYear}
                  selected={year}
                />
                <DatePickerMonthW
                  className="ms-2"
                  onChange={(e) => {
                    setMonth(e.target.value);
                  }}
                  selected={month}
                />
              </div>
            </div>
            <div className="d-flex flex-column justify-content-between align-items-end">
              <div className="d-flex flex-row justify-content-between align-self-center align-items-center">
                <Form>
                  <Form.Control
                    type="search"
                    placeholder="Buscar"
                    className="ws_input"
                    onChange={(e) => {
                      setSearch(e.target.value);
                    }}
                  />
                </Form>
                {/* <Dropdown className="ws_dropdown">
                  <Dropdown.Toggle id="dropdown-basic">
                    <Image src={'/img/darkOpt.svg'} alt="icon_opt" className="ws_icon ms-2" />
                  </Dropdown.Toggle>
                  <Dropdown.Menu align="end">
                    <Dropdown.Item href="#">Quitar del dashboard</Dropdown.Item>
                    <Dropdown.Item href="#">Duplicar</Dropdown.Item>
                    <Dropdown.Item href="#">Ocultar en móvil</Dropdown.Item>
                    <Dropdown.Item href="#">Exportar</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown> */}
              </div>
            </div>
          </div>
          <div style={{ widht: "100%", height: 400 }}>
            <ResponsivePieCanvas
              data={dataGrafica}
              margin={{ top: 40, right: 200, bottom: 40, left: 80 }}
              innerRadius={0.5}
              padAngle={0.7}
              cornerRadius={3}
              activeOuterRadiusOffset={8}
              colors={[
                "#0ca1b4",
                "#660091",
                "#6a2aac",
                "#6d47be",
                "#6f63d0",
                "#727fe2",
                "#73ffff",
                "#0cffb4",
                "#0ceab4",
                "#0cd7b4",
                "#0cb6b4",
              ]}
              borderColor={{ from: "color", modifiers: [["darker", 0.6]] }}
              arcLinkLabelsSkipAngle={10}
              arcLinkLabelsTextColor="#333333"
              arcLinkLabelsThickness={2}
              arcLinkLabelsColor={"#000"}
              arcLabelsSkipAngle={10}
              arcLabelsTextColor="#fff"
              defs={[
                {
                  id: "dots",
                  type: "patternDots",
                  background: "inherit",
                  color: "rgba(255, 255, 255, 0.3)",
                  size: 4,
                  padding: 1,
                  stagger: true,
                },
                {
                  id: "lines",
                  type: "patternLines",
                  background: "inherit",
                  color: "rgba(255, 255, 255, 0.3)",
                  rotation: -45,
                  lineWidth: 6,
                  spacing: 10,
                },
              ]}
              fill={[
                {
                  match: {
                    id: "ruby",
                  },
                  id: "dots",
                },
                {
                  match: {
                    id: "c",
                  },
                  id: "dots",
                },
                {
                  match: {
                    id: "go",
                  },
                  id: "dots",
                },
                {
                  match: {
                    id: "python",
                  },
                  id: "dots",
                },
                {
                  match: {
                    id: "scala",
                  },
                  id: "lines",
                },
                {
                  match: {
                    id: "lisp",
                  },
                  id: "lines",
                },
                {
                  match: {
                    id: "elixir",
                  },
                  id: "lines",
                },
                {
                  match: {
                    id: "javascript",
                  },
                  id: "lines",
                },
              ]}
              legends={[
                {
                  anchor: "right",
                  direction: "column",
                  justify: false,
                  translateX: 140,
                  translateY: 0,
                  itemsSpacing: 2,
                  itemWidth: 60,
                  itemHeight: 14,
                  itemTextColor: "#999",
                  itemDirection: "left-to-right",
                  itemOpacity: 1,
                  symbolSize: 14,
                  symbolShape: "circle",
                },
              ]}
            />
          </div>
          <Table
            striped
            bordered
            hover
            size="sm"
            responsive
            className="ws_tabla mt-4"
          >
            <thead
              style={{
                backgroundColor: "#0a93af",
                color: "#fff",
                fontSize: ".9rem",
              }}
            >
              <tr>
                <th className="ps-3 text-left">Grupo</th>
                <th className="ps-3 text-left">Prima Neta</th>
                <th className="ps-3 text-left">Prima Devengada</th>
                <th className="ps-3 text-left">Siniestralidad</th>
                <th className="ps-3 text-left">%Sin</th>
              </tr>
            </thead>
            <tbody style={{ fontSize: ".9rem" }}>
              {dataTable.map((t, e, array) => {
                if (
                  search === "" ||
                  (t.grupo &&
                    t.grupo
                      .toString()
                      .toLowerCase()
                      .indexOf(search.toLowerCase()) !== -1)
                ) {
                  const arrLenght = array.length - 1;
                  if (arrLenght === e) {
                    return (
                      <tr style={{ color: "#0ca1b4" }} key={e}>
                        <td className="ps-3 text-left">{t.cartera}</td>
                        <td className="ps-3 text-left">
                          ${number_format(t.prima_neta, 2)}
                        </td>
                        <td className="ps-3 text-left">
                          ${number_format(t.devengada, 2)}
                        </td>
                        <td className="ps-3 text-left">
                          ${number_format(t.siniestralidad, 2)}
                        </td>
                        <td className="ps-3 text-left">{t.porcentaje_sin}%</td>
                      </tr>
                    );
                  } else {
                    return (
                      <tr key={e}>
                        <td className="ps-3 text-left">{t.grupo}</td>
                        <td className="ps-3 text-left">
                          ${number_format(t.prima_neta, 2)}
                        </td>
                        <td className="ps-3 text-left">
                          ${number_format(t.devengada, 2)}
                        </td>
                        <td className="ps-3 text-left">
                          ${number_format(t.siniestralidad, 2)}
                        </td>
                        <td className="ps-3 text-left">{t.porcentaje_sin}%</td>
                      </tr>
                    );
                  }
                }
              })}
            </tbody>
          </Table>
        </Container>
      </div>
    </Col>
  );

  function getCarteraIndividualByClaveOficina() {
    const dataSend = {
      id_login: usuario.id_usuario,
      clave_oficina: dataOficina.clave_oficina,
      month: month,
      year,
      // claves: dataOficina.claves
    };
    fetch(
      `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=getCarteraIndividualByClaveOficina`,
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(dataSend),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        if (loadCarteraIndividual != undefined) {
          setLoadCarteraIndividual(false);
        }
        setLoad(false);
        setDataTable(res.list);
        setDataGrafica(res.graph);
      });
  }
}

function CarteraFlotillas({
  initState,
  updateState,
  loadCarteraFlotillas,
  setLoadCarteraFlotillas,
  dataAgente = { id_usuario: "", claves: [] },
  size = { xs: 12, sm: 12, md: 12, lg: 12, xl: 6, xxl: 6 },
}) {
  const { usuario } = useContext(AuthContext);
  const currentMonth = moment().format("MMMM");
  const currentYear = new Date().getFullYear();
  const [year, setYear] = useState(currentYear);
  const [search, setSearch] = useState("");
  const [month, setMonth] = useState(
    moment().month(currentMonth).subtract(1, "month").format("M")
  );
  const [dataGrafica, setDataGrafica] = useState([]);
  const [dataTable, setDataTable] = useState([]);
  const [load, setLoad] = useState(false);

  useEffect(() => {
    setLoad(true);
    getCarteraFlotillasByIdAgente();
  }, [month]);

  useEffect(() => {
    if (loadCarteraFlotillas) {
      setLoad(true);
      getCarteraFlotillasByIdAgente();
    }
  }, [loadCarteraFlotillas]);

  if (load) {
    return (
      <Col
        xs={size.xs}
        sm={size.sm}
        md={size.md}
        lg={size.lg}
        xl={size.xl}
        xxl={size.xxl}
        className="mb-3"
      >
        <div
          className="ws_box"
          style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
        >
          <Container fluid>
            <div className="ws_box_header mb-3">
              <div className="d-flex justify-content-start align-items-end">
                <div>
                  <h2 className="ws_table_agente_title pb-0 mb-2">
                    Cartera Flotillas{" "}
                    <span className="ws_table_agente_number">0</span>
                  </h2>
                </div>
              </div>
            </div>
            <Skeleton width="100%" height={400} />
          </Container>
        </div>
      </Col>
    );
  }

  return (
    <Col
      xs={size.xs}
      sm={size.sm}
      md={size.md}
      lg={size.lg}
      xl={size.xl}
      xxl={size.xxl}
      className="mb-3"
    >
      <div
        className="ws_box"
        style={{
          position: "relative",
          paddingTop: "1rem",
          paddingBottom: "1rem",
        }}
      >
        {/* <div className="ws_backdrop d-flex justify-content-center align-items-center"><h1>No disponible por el momento</h1></div> */}

        <Container fluid>
          <div className="ws_box_header mb-3">
            <div className="d-flex flex-column justify-content-center align-items-start">
              <div>
                <h2 className="ws_table_agente_title pb-0 mb-2">
                  Cartera Flotillas{" "}
                  <span className="ws_table_agente_number">
                    {dataTable.length - 1}
                  </span>
                </h2>
              </div>
              <div className="d-flex justify-content-center align-items-center">
                <DatePickerW
                  onChange={(e) => {
                    setYear(e.target.value);
                    setLoadCarteraFlotillas(true);
                  }}
                  year={currentYear}
                  selected={year}
                />
                <DatePickerMonthW
                  className="ms-2"
                  onChange={(e) => {
                    setMonth(e.target.value);
                  }}
                  selected={month}
                />
              </div>
            </div>
            <div className="d-flex flex-column justify-content-between align-items-end">
              <div className="d-flex flex-row justify-content-between align-self-center align-items-center">
                <Form>
                  <Form.Control
                    type="search"
                    placeholder="Buscar"
                    className="ws_input"
                    onChange={(e) => {
                      setSearch(e.target.value);
                    }}
                  />
                </Form>
                {/* <Dropdown className="ws_dropdown">
                  <Dropdown.Toggle id="dropdown-basic">
                    <Image src={'/img/darkOpt.svg'} alt="icon_opt" className="ws_icon ms-2" />
                  </Dropdown.Toggle>
                  <Dropdown.Menu align="end">
                    <Dropdown.Item href="#">Quitar del dashboard</Dropdown.Item>
                    <Dropdown.Item href="#">Duplicar</Dropdown.Item>
                    <Dropdown.Item href="#">Ocultar en móvil</Dropdown.Item>
                    <Dropdown.Item href="#">Exportar</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown> */}
              </div>
            </div>
          </div>
          <div style={{ widht: "100%", height: 400 }}>
            <ResponsivePieCanvas
              data={dataGrafica}
              margin={{ top: 40, right: 200, bottom: 40, left: 80 }}
              innerRadius={0.5}
              padAngle={0.7}
              cornerRadius={3}
              activeOuterRadiusOffset={8}
              colors={[
                "#0ca1b4",
                "#660091",
                "#6a2aac",
                "#6d47be",
                "#6f63d0",
                "#727fe2",
                "#73ffff",
                "#0cffb4",
                "#0ceab4",
                "#0cd7b4",
                "#0cb6b4",
              ]}
              borderColor={{ from: "color", modifiers: [["darker", 0.6]] }}
              arcLinkLabelsSkipAngle={10}
              arcLinkLabelsTextColor="#333333"
              arcLinkLabelsThickness={2}
              arcLinkLabelsColor={"#000"}
              arcLabelsSkipAngle={10}
              arcLabelsTextColor="#fff"
              defs={[
                {
                  id: "dots",
                  type: "patternDots",
                  background: "inherit",
                  color: "rgba(255, 255, 255, 0.3)",
                  size: 4,
                  padding: 1,
                  stagger: true,
                },
                {
                  id: "lines",
                  type: "patternLines",
                  background: "inherit",
                  color: "rgba(255, 255, 255, 0.3)",
                  rotation: -45,
                  lineWidth: 6,
                  spacing: 10,
                },
              ]}
              fill={[
                {
                  match: {
                    id: "ruby",
                  },
                  id: "dots",
                },
                {
                  match: {
                    id: "c",
                  },
                  id: "dots",
                },
                {
                  match: {
                    id: "go",
                  },
                  id: "dots",
                },
                {
                  match: {
                    id: "python",
                  },
                  id: "dots",
                },
                {
                  match: {
                    id: "scala",
                  },
                  id: "lines",
                },
                {
                  match: {
                    id: "lisp",
                  },
                  id: "lines",
                },
                {
                  match: {
                    id: "elixir",
                  },
                  id: "lines",
                },
                {
                  match: {
                    id: "javascript",
                  },
                  id: "lines",
                },
              ]}
              legends={[
                {
                  anchor: "right",
                  direction: "column",
                  justify: false,
                  translateX: 140,
                  translateY: 0,
                  itemsSpacing: 2,
                  itemWidth: 60,
                  itemHeight: 14,
                  itemTextColor: "#999",
                  itemDirection: "left-to-right",
                  itemOpacity: 1,
                  symbolSize: 14,
                  symbolShape: "circle",
                },
              ]}
            />
          </div>
          <Table
            striped
            bordered
            hover
            size="sm"
            responsive
            className="ws_tabla mt-4"
          >
            <thead
              style={{
                backgroundColor: "#0a93af",
                color: "#fff",
                fontSize: ".9rem",
              }}
            >
              <tr>
                <th className="ps-3 text-left">Grupo</th>
                <th className="ps-3 text-left">Prima Neta</th>
                <th className="ps-3 text-left">Prima Devengada</th>
                <th className="ps-3 text-left">Siniestralidad</th>
                <th className="ps-3 text-left">%Sin</th>
              </tr>
            </thead>
            <tbody style={{ fontSize: ".9rem" }}>
              {dataTable.map((t, e, array) => {
                if (
                  search === "" ||
                  (t.grupo &&
                    t.grupo
                      .toString()
                      .toLowerCase()
                      .indexOf(search.toLowerCase()) !== -1)
                ) {
                  const arrLenght = array.length - 1;
                  if (arrLenght === e) {
                    return (
                      <tr style={{ color: "#0ca1b4" }} key={e}>
                        <td className="ps-3 text-left">{t.cartera}</td>
                        <td className="ps-3 text-left">
                          ${number_format(t.prima_neta, 2)}
                        </td>
                        <td className="ps-3 text-left">
                          ${number_format(t.devengada, 2)}
                        </td>
                        <td className="ps-3 text-left">
                          ${number_format(t.siniestralidad, 2)}
                        </td>
                        <td className="ps-3 text-left">{t.porcentaje_sin}%</td>
                      </tr>
                    );
                  } else {
                    return (
                      <tr key={e}>
                        <td className="ps-3 text-left">{t.grupo}</td>
                        <td className="ps-3 text-left">
                          ${number_format(t.prima_neta, 2)}
                        </td>
                        <td className="ps-3 text-left">
                          ${number_format(t.devengada, 2)}
                        </td>
                        <td className="ps-3 text-left">
                          ${number_format(t.siniestralidad, 2)}
                        </td>
                        <td className="ps-3 text-left">{t.porcentaje_sin}%</td>
                      </tr>
                    );
                  }
                }
              })}
            </tbody>
          </Table>
        </Container>
      </div>
    </Col>
  );

  function getCarteraFlotillasByIdAgente() {
    const dataSend = {
      id_login: usuario.id_usuario,
      id_usuario: dataAgente.id_usuario,
      month: month,
      year,
      claves: dataAgente.claves,
    };
    fetch(
      `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=getCarteraFlotillasByIdAgente`,
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(dataSend),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        if (loadCarteraFlotillas != undefined) {
          setLoadCarteraFlotillas(false);
        }
        setLoad(false);
        setDataTable(res.list);
        setDataGrafica(res.graph);
      });
  }
}

function CarteraFlotillasOficina({
  initState,
  updateState,
  loadCarteraFlotillas,
  setLoadCarteraFlotillas,
  dataOficina = { clave_oficina: "" },
  size = { xs: 12, sm: 12, md: 12, lg: 12, xl: 6, xxl: 6 },
}) {
  const { usuario } = useContext(AuthContext);
  const currentMonth = moment().format("MMMM");
  const currentYear = new Date().getFullYear();
  const [year, setYear] = useState(currentYear);
  const [search, setSearch] = useState("");
  const [month, setMonth] = useState(
    moment().month(currentMonth).subtract(1, "month").format("M")
  );
  const [dataGrafica, setDataGrafica] = useState([]);
  const [dataTable, setDataTable] = useState([]);
  const [load, setLoad] = useState(false);

  useEffect(() => {
    setLoad(true);
    getCarteraFlotillasByClaveOficina();
  }, [month]);

  useEffect(() => {
    if (loadCarteraFlotillas) {
      setLoad(true);
      getCarteraFlotillasByClaveOficina();
    }
  }, [loadCarteraFlotillas]);

  if (load) {
    return (
      <Col
        xs={size.xs}
        sm={size.sm}
        md={size.md}
        lg={size.lg}
        xl={size.xl}
        xxl={size.xxl}
        className="mb-3"
      >
        <div
          className="ws_box"
          style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
        >
          <Container fluid>
            <div className="ws_box_header mb-3">
              <div className="d-flex justify-content-start align-items-end">
                <div>
                  <h2 className="ws_table_agente_title pb-0 mb-2">
                    Cartera Flotillas{" "}
                    <span className="ws_table_agente_number">0</span>
                  </h2>
                </div>
              </div>
            </div>
            <Skeleton width="100%" height={400} />
          </Container>
        </div>
      </Col>
    );
  }

  return (
    <Col
      xs={size.xs}
      sm={size.sm}
      md={size.md}
      lg={size.lg}
      xl={size.xl}
      xxl={size.xxl}
      className="mb-3"
    >
      <div
        className="ws_box"
        style={{
          position: "relative",
          paddingTop: "1rem",
          paddingBottom: "1rem",
        }}
      >
        {/* <div className="ws_backdrop d-flex justify-content-center align-items-center"><h1>No disponible por el momento</h1></div> */}

        <Container fluid>
          <div className="ws_box_header mb-3">
            <div className="d-flex flex-column justify-content-center align-items-start">
              <div>
                <h2 className="ws_table_agente_title pb-0 mb-2">
                  Cartera Flotillas{" "}
                  <span className="ws_table_agente_number">
                    {dataTable.length - 1}
                  </span>
                </h2>
              </div>
              <div className="d-flex justify-content-center align-items-center">
                <DatePickerW
                  onChange={(e) => {
                    setYear(e.target.value);
                    setLoadCarteraFlotillas(true);
                  }}
                  year={currentYear}
                  selected={year}
                />
                <DatePickerMonthW
                  className="ms-2"
                  onChange={(e) => {
                    setMonth(e.target.value);
                  }}
                  selected={month}
                />
              </div>
            </div>
            <div className="d-flex flex-column justify-content-between align-items-end">
              <div className="d-flex flex-row justify-content-between align-self-center align-items-center">
                <Form>
                  <Form.Control
                    type="search"
                    placeholder="Buscar"
                    className="ws_input"
                    onChange={(e) => {
                      setSearch(e.target.value);
                    }}
                  />
                </Form>
                {/* <Dropdown className="ws_dropdown">
                  <Dropdown.Toggle id="dropdown-basic">
                    <Image src={'/img/darkOpt.svg'} alt="icon_opt" className="ws_icon ms-2" />
                  </Dropdown.Toggle>
                  <Dropdown.Menu align="end">
                    <Dropdown.Item href="#">Quitar del dashboard</Dropdown.Item>
                    <Dropdown.Item href="#">Duplicar</Dropdown.Item>
                    <Dropdown.Item href="#">Ocultar en móvil</Dropdown.Item>
                    <Dropdown.Item href="#">Exportar</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown> */}
              </div>
            </div>
          </div>
          <div style={{ widht: "100%", height: 400 }}>
            <ResponsivePieCanvas
              data={dataGrafica}
              margin={{ top: 40, right: 200, bottom: 40, left: 80 }}
              innerRadius={0.5}
              padAngle={0.7}
              cornerRadius={3}
              activeOuterRadiusOffset={8}
              colors={[
                "#0ca1b4",
                "#660091",
                "#6a2aac",
                "#6d47be",
                "#6f63d0",
                "#727fe2",
                "#73ffff",
                "#0cffb4",
                "#0ceab4",
                "#0cd7b4",
                "#0cb6b4",
              ]}
              borderColor={{ from: "color", modifiers: [["darker", 0.6]] }}
              arcLinkLabelsSkipAngle={10}
              arcLinkLabelsTextColor="#333333"
              arcLinkLabelsThickness={2}
              arcLinkLabelsColor={"#000"}
              arcLabelsSkipAngle={10}
              arcLabelsTextColor="#fff"
              defs={[
                {
                  id: "dots",
                  type: "patternDots",
                  background: "inherit",
                  color: "rgba(255, 255, 255, 0.3)",
                  size: 4,
                  padding: 1,
                  stagger: true,
                },
                {
                  id: "lines",
                  type: "patternLines",
                  background: "inherit",
                  color: "rgba(255, 255, 255, 0.3)",
                  rotation: -45,
                  lineWidth: 6,
                  spacing: 10,
                },
              ]}
              fill={[
                {
                  match: {
                    id: "ruby",
                  },
                  id: "dots",
                },
                {
                  match: {
                    id: "c",
                  },
                  id: "dots",
                },
                {
                  match: {
                    id: "go",
                  },
                  id: "dots",
                },
                {
                  match: {
                    id: "python",
                  },
                  id: "dots",
                },
                {
                  match: {
                    id: "scala",
                  },
                  id: "lines",
                },
                {
                  match: {
                    id: "lisp",
                  },
                  id: "lines",
                },
                {
                  match: {
                    id: "elixir",
                  },
                  id: "lines",
                },
                {
                  match: {
                    id: "javascript",
                  },
                  id: "lines",
                },
              ]}
              legends={[
                {
                  anchor: "right",
                  direction: "column",
                  justify: false,
                  translateX: 140,
                  translateY: 0,
                  itemsSpacing: 2,
                  itemWidth: 60,
                  itemHeight: 14,
                  itemTextColor: "#999",
                  itemDirection: "left-to-right",
                  itemOpacity: 1,
                  symbolSize: 14,
                  symbolShape: "circle",
                },
              ]}
            />
          </div>
          <Table
            striped
            bordered
            hover
            size="sm"
            responsive
            className="ws_tabla mt-4"
          >
            <thead
              style={{
                backgroundColor: "#0a93af",
                color: "#fff",
                fontSize: ".9rem",
              }}
            >
              <tr>
                <th className="ps-3 text-left">Grupo</th>
                <th className="ps-3 text-left">Prima Neta</th>
                <th className="ps-3 text-left">Prima Devengada</th>
                <th className="ps-3 text-left">Siniestralidad</th>
                <th className="ps-3 text-left">%Sin</th>
              </tr>
            </thead>
            <tbody style={{ fontSize: ".9rem" }}>
              {dataTable.map((t, e, array) => {
                if (
                  search === "" ||
                  (t.grupo &&
                    t.grupo
                      .toString()
                      .toLowerCase()
                      .indexOf(search.toLowerCase()) !== -1)
                ) {
                  const arrLenght = array.length - 1;
                  if (arrLenght === e) {
                    return (
                      <tr style={{ color: "#0ca1b4" }} key={e}>
                        <td className="ps-3 text-left">{t.cartera}</td>
                        <td className="ps-3 text-left">
                          ${number_format(t.prima_neta, 2)}
                        </td>
                        <td className="ps-3 text-left">
                          ${number_format(t.devengada, 2)}
                        </td>
                        <td className="ps-3 text-left">
                          ${number_format(t.siniestralidad, 2)}
                        </td>
                        <td className="ps-3 text-left">{t.porcentaje_sin}%</td>
                      </tr>
                    );
                  } else {
                    return (
                      <tr key={e}>
                        <td className="ps-3 text-left">{t.grupo}</td>
                        <td className="ps-3 text-left">
                          ${number_format(t.prima_neta, 2)}
                        </td>
                        <td className="ps-3 text-left">
                          ${number_format(t.devengada, 2)}
                        </td>
                        <td className="ps-3 text-left">
                          ${number_format(t.siniestralidad, 2)}
                        </td>
                        <td className="ps-3 text-left">{t.porcentaje_sin}%</td>
                      </tr>
                    );
                  }
                }
              })}
            </tbody>
          </Table>
        </Container>
      </div>
    </Col>
  );

  function getCarteraFlotillasByClaveOficina() {
    const dataSend = {
      id_login: usuario.id_usuario,
      clave_oficina: dataOficina.clave_oficina,
      month: month,
      year,
      // claves: dataOficina.claves
    };
    fetch(
      `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=getCarteraFlotillasByClaveOficina`,
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(dataSend),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        if (loadCarteraFlotillas != undefined) {
          setLoadCarteraFlotillas(false);
        }
        setLoad(false);
        setDataTable(res.list);
        setDataGrafica(res.graph);
      });
  }
}

function SegmentacionCartera({
  initState,
  updateState,
  loadSegmentacionCartera,
  setLoadSegmentacionCartera,
  dataAgente = { id_usuario: "", claves: [] },
  size = { xs: 12, sm: 12, md: 12, lg: 12, xl: 6, xxl: 6 },
}) {
  const { usuario } = useContext(AuthContext);
  const currentMonth = moment().format("MMMM");
  const currentYear = new Date().getFullYear();
  const [year, setYear] = useState(currentYear);
  const [search, setSearch] = useState("");
  const [month, setMonth] = useState(
    moment().month(currentMonth).subtract(1, "month").format("M")
  );
  const [dataGrafica, setDataGrafica] = useState([]);
  const [dataTable, setDataTable] = useState([]);
  const [load, setLoad] = useState(false);

  useEffect(() => {
    setLoad(true);
    getSegmentacionCarteraByIdAgente();
  }, [month]);

  useEffect(() => {
    if (loadSegmentacionCartera) {
      setLoad(true);
      getSegmentacionCarteraByIdAgente();
    }
  }, [loadSegmentacionCartera]);

  if (load) {
    return (
      <Col
        xs={size.xs}
        sm={size.sm}
        md={size.md}
        lg={size.lg}
        xl={size.xl}
        xxl={size.xxl}
        className="mb-3"
      >
        <div
          className="ws_box"
          style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
        >
          <Container fluid>
            <div className="ws_box_header mb-3">
              <div className="d-flex justify-content-start align-items-end">
                <div>
                  <h2 className="ws_table_agente_title pb-0 mb-2">
                    Segmentación Cartera
                  </h2>
                </div>
              </div>
            </div>
            <Skeleton width="100%" height={400} />
          </Container>
        </div>
      </Col>
    );
  }
  return (
    <Col
      xs={size.xs}
      sm={size.sm}
      md={size.md}
      lg={size.lg}
      xl={size.xl}
      xxl={size.xxl}
      className="mb-3"
      id="tbLogros"
    >
      <div
        className="ws_box"
        style={{
          position: "relative",
          paddingTop: "1rem",
          paddingBottom: "1rem",
        }}
      >
        {/* <div className="ws_backdrop d-flex justify-content-center align-items-center"><h1>No disponible por el momento</h1></div> */}

        <Container fluid>
          <div className="ws_box_header mb-3">
            <div className="d-flex flex-column justify-content-center align-items-start">
              <div>
                <h2 className="ws_table_agente_title pb-0 mb-2">
                  Segmentación Cartera
                </h2>
              </div>
              <div className="d-flex justify-content-center align-items-center">
                <DatePickerW
                  onChange={(e) => {
                    setYear(e.target.value);
                    setLoadSegmentacionCartera(true);
                  }}
                  year={currentYear}
                  selected={year}
                />
                <DatePickerMonthW
                  className="ms-2"
                  onChange={(e) => {
                    setMonth(e.target.value);
                  }}
                  selected={month}
                />
              </div>
            </div>
            <div className="d-flex flex-column justify-content-between align-items-end">
              <div className="d-flex flex-row justify-content-between align-self-center align-items-center">
                <Form>
                  <Form.Control
                    type="search"
                    placeholder="Buscar"
                    className="ws_input"
                    onChange={(e) => {
                      setSearch(e.target.value);
                    }}
                  />
                </Form>
                {/* <Dropdown className="ws_dropdown">
                  <Dropdown.Toggle id="dropdown-basic">
                    <Image src={'/img/darkOpt.svg'} alt="icon_opt" className="ws_icon ms-2" />
                  </Dropdown.Toggle>
                  <Dropdown.Menu align="end">
                    <Dropdown.Item href="#">Quitar del dashboard</Dropdown.Item>
                    <Dropdown.Item href="#">Duplicar</Dropdown.Item>
                    <Dropdown.Item href="#">Ocultar en móvil</Dropdown.Item>
                    <Dropdown.Item href="#">Exportar</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown> */}
              </div>
            </div>
          </div>
          <div style={{ widht: "100%", height: 400 }}>
            <ResponsivePieCanvas
              data={dataGrafica}
              margin={{ top: 40, right: 200, bottom: 40, left: 80 }}
              innerRadius={0.5}
              padAngle={0.7}
              cornerRadius={3}
              activeOuterRadiusOffset={8}
              colors={[
                "#0ca1b4",
                "#660091",
                "#6a2aac",
                "#6d47be",
                "#6f63d0",
                "#727fe2",
                "#73ffff",
                "#0cffb4",
                "#0ceab4",
                "#0cd7b4",
                "#0cb6b4",
              ]}
              borderColor={{ from: "color", modifiers: [["darker", 0.6]] }}
              arcLinkLabelsSkipAngle={10}
              arcLinkLabelsTextColor="#333333"
              arcLinkLabelsThickness={2}
              arcLinkLabelsColor={"#000"}
              arcLabelsSkipAngle={10}
              arcLabelsTextColor="#fff"
              defs={[
                {
                  id: "dots",
                  type: "patternDots",
                  background: "inherit",
                  color: "rgba(255, 255, 255, 0.3)",
                  size: 4,
                  padding: 1,
                  stagger: true,
                },
                {
                  id: "lines",
                  type: "patternLines",
                  background: "inherit",
                  color: "rgba(255, 255, 255, 0.3)",
                  rotation: -45,
                  lineWidth: 6,
                  spacing: 10,
                },
              ]}
              fill={[
                {
                  match: {
                    id: "ruby",
                  },
                  id: "dots",
                },
                {
                  match: {
                    id: "c",
                  },
                  id: "dots",
                },
                {
                  match: {
                    id: "go",
                  },
                  id: "dots",
                },
                {
                  match: {
                    id: "python",
                  },
                  id: "dots",
                },
                {
                  match: {
                    id: "scala",
                  },
                  id: "lines",
                },
                {
                  match: {
                    id: "lisp",
                  },
                  id: "lines",
                },
                {
                  match: {
                    id: "elixir",
                  },
                  id: "lines",
                },
                {
                  match: {
                    id: "javascript",
                  },
                  id: "lines",
                },
              ]}
              legends={[
                {
                  anchor: "right",
                  direction: "column",
                  justify: false,
                  translateX: 140,
                  translateY: 0,
                  itemsSpacing: 2,
                  itemWidth: 60,
                  itemHeight: 14,
                  itemTextColor: "#999",
                  itemDirection: "left-to-right",
                  itemOpacity: 1,
                  symbolSize: 14,
                  symbolShape: "circle",
                },
              ]}
            />
          </div>
          <Table
            striped
            bordered
            hover
            size="sm"
            responsive
            className="ws_tabla mt-4"
          >
            <thead
              style={{
                backgroundColor: "#0a93af",
                color: "#fff",
                fontSize: ".9rem",
              }}
            >
              <tr>
                <th className="ps-3 text-left">Cartera</th>
                <th className="ps-3 text-left">Prima Neta</th>
                <th className="ps-3 text-left">Prima Devengada</th>
                <th className="ps-3 text-left">Siniestralidad</th>
                <th className="ps-3 text-left">%Sin</th>
              </tr>
            </thead>
            <tbody style={{ fontSize: ".9rem" }}>
              {dataTable.map((t, e, array) => {
                let arrayLenght = array.length - 1;
                if (arrayLenght === e) {
                  return (
                    <tr style={{ color: "#0ca1b4" }} key={e}>
                      <td className="ps-3 text-left">{t.cartera}</td>
                      <td className="ps-3 text-left">
                        ${number_format(t.prima_neta, 2)}
                      </td>
                      <td className="ps-3 text-left">
                        ${number_format(t.devengada, 2)}
                      </td>
                      <td className="ps-3 text-left">
                        ${number_format(t.siniestralidad, 2)}
                      </td>
                      <td className="ps-3 text-left">{t.porcentaje_sin}%</td>
                    </tr>
                  );
                } else {
                  return (
                    <tr key={e}>
                      <td className="ps-3 text-left">{t.cartera}</td>
                      <td className="ps-3 text-left">
                        ${number_format(t.prima_neta, 2)}
                      </td>
                      <td className="ps-3 text-left">
                        ${number_format(t.devengada, 2)}
                      </td>
                      <td className="ps-3 text-left">
                        ${number_format(t.siniestralidad, 2)}
                      </td>
                      <td className="ps-3 text-left">{t.porcentaje_sin}%</td>
                    </tr>
                  );
                }
              })}
            </tbody>
          </Table>
        </Container>
      </div>
    </Col>
  );

  function getSegmentacionCarteraByIdAgente() {
    const dataSend = {
      id_login: usuario.id_usuario,
      id_usuario: dataAgente.id_usuario,
      month: month,
      year,
      claves: dataAgente.claves,
    };
    fetch(
      `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=getSegmentacionCarteraByIdAgente`,
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(dataSend),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        if (loadSegmentacionCartera != undefined) {
          setLoadSegmentacionCartera(false);
        }
        setLoad(false);
        setDataTable(res.list);
        setDataGrafica(res.graph);
      });
  }
}
function SegmentacionCarteraOficina({
  initState,
  updateState,
  loadSegmentacionCartera,
  setLoadSegmentacionCartera,
  dataOficina = { clave_oficina: "" },
  size = { xs: 12, sm: 12, md: 12, lg: 12, xl: 6, xxl: 6 },
}) {
  const { usuario } = useContext(AuthContext);
  const currentMonth = moment().format("MMMM");
  const currentYear = new Date().getFullYear();

  const [search, setSearch] = useState("");
  const [month, setMonth] = useState(
    moment().month(currentMonth).subtract(1, "month").format("M")
  );
  const [dataGrafica, setDataGrafica] = useState([]);
  const [dataTable, setDataTable] = useState([]);
  const [load, setLoad] = useState(false);
  const [year, setYear] = useState(currentYear);

  useEffect(() => {
    setLoad(true);
    getSegmentacionCarteraByClaveOficina();
  }, [month]);

  useEffect(() => {
    if (loadSegmentacionCartera) {
      setLoad(true);
      getSegmentacionCarteraByClaveOficina();
    }
  }, [loadSegmentacionCartera]);

  if (load) {
    return (
      <Col
        xs={size.xs}
        sm={size.sm}
        md={size.md}
        lg={size.lg}
        xl={size.xl}
        xxl={size.xxl}
        className="mb-3"
      >
        <div
          className="ws_box"
          style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
        >
          <Container fluid>
            <div className="ws_box_header mb-3">
              <div className="d-flex justify-content-start align-items-end">
                <div>
                  <h2 className="ws_table_agente_title pb-0 mb-2">
                    Segmentación Cartera
                  </h2>
                </div>
              </div>
            </div>
            <Skeleton width="100%" height={400} />
          </Container>
        </div>
      </Col>
    );
  }
  return (
    <Col
      xs={size.xs}
      sm={size.sm}
      md={size.md}
      lg={size.lg}
      xl={size.xl}
      xxl={size.xxl}
      className="mb-3"
      id="tbLogros"
    >
      <div
        className="ws_box"
        style={{
          position: "relative",
          paddingTop: "1rem",
          paddingBottom: "1rem",
        }}
      >
        {/* <div className="ws_backdrop d-flex justify-content-center align-items-center"><h1>No disponible por el momento</h1></div> */}

        <Container fluid>
          <div className="ws_box_header mb-3">
            <div className="d-flex flex-column justify-content-center align-items-start">
              <div>
                <h2 className="ws_table_agente_title pb-0 mb-2">
                  Segmentación Cartera
                </h2>
              </div>
              <div className="d-flex justify-content-center align-items-center">
                <DatePickerW
                  onChange={(e) => {
                    setYear(e.target.value);
                    setLoadSegmentacionCartera(true);
                  }}
                  year={currentYear}
                  selected={year}
                />
                <DatePickerMonthW
                  className="ms-2"
                  onChange={(e) => {
                    setMonth(e.target.value);
                  }}
                  selected={month}
                />
              </div>
              {/* <DatePickerMonthW className="ms-2" onChange={(e) => { setMonth(e.target.value); }} selected={month} /> */}
            </div>
            <div className="d-flex flex-column justify-content-between align-items-end">
              <div className="d-flex flex-row justify-content-between align-self-center align-items-center">
                <Form>
                  <Form.Control
                    type="search"
                    placeholder="Buscar"
                    className="ws_input"
                    onChange={(e) => {
                      setSearch(e.target.value);
                    }}
                  />
                </Form>
                {/* <Dropdown className="ws_dropdown">
                  <Dropdown.Toggle id="dropdown-basic">
                    <Image src={'/img/darkOpt.svg'} alt="icon_opt" className="ws_icon ms-2" />
                  </Dropdown.Toggle>
                  <Dropdown.Menu align="end">
                    <Dropdown.Item href="#">Quitar del dashboard</Dropdown.Item>
                    <Dropdown.Item href="#">Duplicar</Dropdown.Item>
                    <Dropdown.Item href="#">Ocultar en móvil</Dropdown.Item>
                    <Dropdown.Item href="#">Exportar</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown> */}
              </div>
            </div>
          </div>
          <div style={{ widht: "100%", height: 400 }}>
            <ResponsivePieCanvas
              data={dataGrafica}
              margin={{ top: 40, right: 200, bottom: 40, left: 80 }}
              innerRadius={0.5}
              padAngle={0.7}
              cornerRadius={3}
              activeOuterRadiusOffset={8}
              colors={[
                "#0ca1b4",
                "#660091",
                "#6a2aac",
                "#6d47be",
                "#6f63d0",
                "#727fe2",
                "#73ffff",
                "#0cffb4",
                "#0ceab4",
                "#0cd7b4",
                "#0cb6b4",
              ]}
              borderColor={{ from: "color", modifiers: [["darker", 0.6]] }}
              arcLinkLabelsSkipAngle={10}
              arcLinkLabelsTextColor="#333333"
              arcLinkLabelsThickness={2}
              arcLinkLabelsColor={"#000"}
              arcLabelsSkipAngle={10}
              arcLabelsTextColor="#fff"
              defs={[
                {
                  id: "dots",
                  type: "patternDots",
                  background: "inherit",
                  color: "rgba(255, 255, 255, 0.3)",
                  size: 4,
                  padding: 1,
                  stagger: true,
                },
                {
                  id: "lines",
                  type: "patternLines",
                  background: "inherit",
                  color: "rgba(255, 255, 255, 0.3)",
                  rotation: -45,
                  lineWidth: 6,
                  spacing: 10,
                },
              ]}
              fill={[
                {
                  match: {
                    id: "ruby",
                  },
                  id: "dots",
                },
                {
                  match: {
                    id: "c",
                  },
                  id: "dots",
                },
                {
                  match: {
                    id: "go",
                  },
                  id: "dots",
                },
                {
                  match: {
                    id: "python",
                  },
                  id: "dots",
                },
                {
                  match: {
                    id: "scala",
                  },
                  id: "lines",
                },
                {
                  match: {
                    id: "lisp",
                  },
                  id: "lines",
                },
                {
                  match: {
                    id: "elixir",
                  },
                  id: "lines",
                },
                {
                  match: {
                    id: "javascript",
                  },
                  id: "lines",
                },
              ]}
              legends={[
                {
                  anchor: "right",
                  direction: "column",
                  justify: false,
                  translateX: 140,
                  translateY: 0,
                  itemsSpacing: 2,
                  itemWidth: 60,
                  itemHeight: 14,
                  itemTextColor: "#999",
                  itemDirection: "left-to-right",
                  itemOpacity: 1,
                  symbolSize: 14,
                  symbolShape: "circle",
                },
              ]}
            />
          </div>
          <Table
            striped
            bordered
            hover
            size="sm"
            responsive
            className="ws_tabla mt-4"
          >
            <thead
              style={{
                backgroundColor: "#0a93af",
                color: "#fff",
                fontSize: ".9rem",
              }}
            >
              <tr>
                <th className="ps-3 text-left">Cartera</th>
                <th className="ps-3 text-left">Prima Neta</th>
                <th className="ps-3 text-left">Prima Devengada</th>
                <th className="ps-3 text-left">Siniestralidad</th>
                <th className="ps-3 text-left">%Sin</th>
              </tr>
            </thead>
            <tbody style={{ fontSize: ".9rem" }}>
              {dataTable.map((t, e, array) => {
                let arrayLenght = array.length - 1;
                if (arrayLenght === e) {
                  return (
                    <tr style={{ color: "#0ca1b4" }} key={e}>
                      <td className="ps-3 text-left">{t.cartera}</td>
                      <td className="ps-3 text-left">
                        ${number_format(t.prima_neta, 2)}
                      </td>
                      <td className="ps-3 text-left">
                        ${number_format(t.devengada, 2)}
                      </td>
                      <td className="ps-3 text-left">
                        ${number_format(t.siniestralidad, 2)}
                      </td>
                      <td className="ps-3 text-left">{t.porcentaje_sin}%</td>
                    </tr>
                  );
                } else {
                  return (
                    <tr key={e}>
                      <td className="ps-3 text-left">{t.cartera}</td>
                      <td className="ps-3 text-left">
                        ${number_format(t.prima_neta, 2)}
                      </td>
                      <td className="ps-3 text-left">
                        ${number_format(t.devengada, 2)}
                      </td>
                      <td className="ps-3 text-left">
                        ${number_format(t.siniestralidad, 2)}
                      </td>
                      <td className="ps-3 text-left">{t.porcentaje_sin}%</td>
                    </tr>
                  );
                }
              })}
            </tbody>
          </Table>
        </Container>
      </div>
    </Col>
  );

  function getSegmentacionCarteraByClaveOficina() {
    const dataSend = {
      id_login: usuario.id_usuario,
      clave_oficina: dataOficina.clave_oficina,
      month: month,
      year: year,
      // claves: dataOficina.claves
    };
    fetch(
      `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=getSegmentacionCarteraByClaveOficina`,
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(dataSend),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        if (loadSegmentacionCartera != undefined) {
          setLoadSegmentacionCartera(false);
        }
        setLoad(false);
        setDataTable(res.list);
        setDataGrafica(res.graph);
      });
  }
}

function TablaHistorico({ initState, updateState, opt }) {
  const { data, loadingData } = initState;

  let { years_historial = [], historial = [] } = data[opt];

  let dataHistorico = [];
  if (years_historial.length > 0) {
    historial.map((element, index) => {
      dataHistorico.push({ mes: element.mes, datos: element.years });
    });
  }

  const currentYear = new Date().getFullYear();
  const [valueSwitch, setValueSwitch] = useState(true);
  const [search, setSearch] = useState("");
  const [mode, setMode] = useState(true);

  return (
    <Col xs={12} md={12} className="mb-3">
      <div
        className="ws_box"
        style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
      >
        <Container fluid>
          <div className="ws_box_header mb-3">
            <div className="d-flex justify-content-start align-items-end">
              <div>
                <h2 className="ws_table_agente_title pb-0 mb-2">
                  Histórico <span className="ws_table_agente_number"></span>
                </h2>
              </div>
              {mode ? (
                <SwitchComponentProd
                  className="ms-3 mb-2"
                  isOn={valueSwitch}
                  handleToggle={(e) => {
                    setValueSwitch(!valueSwitch);
                  }}
                />
              ) : (
                ""
              )}
            </div>
            <div className="d-flex flex-column justify-content-between align-items-end">
              <div className="d-flex flex-row justify-content-between align-self-center align-items-center">
                {/* <Form>
                  <Form.Control type="search" placeholder="Buscar" className="ws_input" onChange={(e) => { setSearch(e.target.value) }} />
                </Form> */}
                {/* <Dropdown className="ws_dropdown">
                  <Dropdown.Toggle id="dropdown-basic">
                    <Image src={'img/darkOpt.svg'} alt="icon_opt" className="ws_icon ms-2" />
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item href="#">Quitar del dashboard</Dropdown.Item>
                    <Dropdown.Item href="#">Duplicar</Dropdown.Item>
                    <Dropdown.Item href="#">Ocultar en móvil</Dropdown.Item>
                    <Dropdown.Item href="#">Exportar</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown> */}
              </div>
            </div>
          </div>
          {!loadingData ? (
            <Table
              striped
              bordered
              hover
              size="sm"
              responsive
              className="ws_tabla"
            >
              <thead
                style={{
                  backgroundColor: "#0a93af",
                  color: "#fff",
                  fontSize: ".9rem",
                }}
              >
                <tr>
                  <th align="left">
                    {valueSwitch ? "COBRANZA" : "PRODUCCIÓN"}
                  </th>
                  {years_historial.map((element, index, arr) => (
                    <th className="text-center" key={index}>
                      {element.value}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody style={{ fontSize: ".9rem" }}>
                {dataHistorico.map((element, index) => (
                  <tr key={`tr_historico_${index}`}>
                    <td align="left">{element.mes}</td>
                    {element.datos.map((element1, index1, array) => {
                      let arrLength = array.length - 1;
                      if (arrLength === index1) {
                        return (
                          <td key={`td_historico_${index1}`} align="center">
                            {valueSwitch
                              ? number_format(element1.inc_cobranza, 2)
                              : number_format(element1.inc_produccion, 2)}
                            %
                          </td>
                        );
                      } else {
                        return (
                          <td key={`td_historico_${index1}`} align="center">
                            $
                            {valueSwitch
                              ? number_format(element1.cobranza, 2)
                              : number_format(element1.produccion, 2)}
                          </td>
                        );
                      }
                    })}
                  </tr>
                ))}
              </tbody>
            </Table>
          ) : (
            <Skeleton width="100%" height={400} />
          )}
        </Container>
      </div>
    </Col>
  );
}

function TablaBonosDiamante({
  bonos = [],
  state,
  updateState,
  dataSelected,
  year,
  setYear,
  load,
  setLoad,
  data,
  setData,
  selectOficina,
  sendReport,
  setSendReport,
}) {
  const { usuario } = useContext(AuthContext);
  const currentYear = new Date().getFullYear();
  const [search, setSearch] = useState("");
  const [dataBonos, setDataBonos] = useState(bonos);
  const [dataToSend, setDataToSend] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleChangeInput = (index, value) => {
    let newData = [...data];
    newData[index].checked = value;
    setData(newData);
    if (value) {
      let newDataSend = [
        ...dataToSend,
        data.find((element) => element.idObj === newData[index].idObj),
      ];
      setDataToSend(newDataSend);
    } else {
      let newDataSend = dataToSend.filter(
        (element) => element.idObj != newData[index].idObj
      );
      setDataToSend(newDataSend);
    }
  };

  const handleChangeInputAll = () => {
    setSelectAll(!selectAll);
    let newData = data.map((obj) => ({ ...obj, checked: !selectAll }));
    setData(newData);
  };

  useEffect(() => {
    if (selectAll === false) {
      setDataToSend([]);
    } else {
      let newDataSend = data.filter(
        (element) => element.email != "" && element.subscribe === 1
      );
      setDataToSend(newDataSend);
    }
  }, [selectAll]);

  useEffect(() => {
    setDataToSend([]);
    setSelectAll(false);
  }, [selectOficina]);

  if (load) {
    return (
      <Col xs={12} md={12} className="mb-3">
        <div
          className="ws_box"
          style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
        >
          <Container fluid>
            <div className="ws_box_header mb-3">
              <div className="d-flex justify-content-start align-items-end">
                <div>
                  <h2 className="ws_table_agente_title pb-0 mb-2">
                    Diamante{" "}
                    <span className="ws_table_agente_number">
                      <a href="#" style={{ color: "#0ca1b4" }}>
                        0
                      </a>
                    </span>
                  </h2>
                </div>
              </div>
            </div>
            <Skeleton width="100%" height={400} />
          </Container>
        </div>
      </Col>
    );
  }

  return (
    <Col xs={12} md={12} className="mb-3">
      <div
        className="ws_box"
        style={{
          paddingTop: "1rem",
          paddingBottom: "1rem",
          position: "relative",
        }}
      >
        <div
          style={{
            borderRadius: "6px",
            position: "absolute",
            backgroundColor: "rgba(0,0,0,0.6)",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            color: "#fff",
            display: sendReport ? "flex" : "none",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <h3>Enviando correo(s)...</h3>
        </div>
        <Container fluid>
          <div className="ws_box_header mb-3">
            <div className="d-flex justify-content-start ali align-items-start">
              <div>
                <h2 className="ws_table_agente_title pb-0 mb-2">
                  Diamante{" "}
                  <span className="ws_table_agente_number">
                    <a href="#" style={{ color: "#0ca1b4" }}>
                      {data ? data.length : "0"}
                    </a>
                  </span>
                </h2>
                <div className="d-flex justify-content-center align-items-center">
                  <DatePickerW
                    onChange={(e) => {
                      setYear(e.target.value);
                      setLoad(true);
                      setDataToSend([]);
                    }}
                    year={currentYear}
                    selected={year}
                  />
                </div>
              </div>
            </div>
            <div className="d-flex flex-column justify-content-between align-items-end">
              <div className="d-flex flex-row justify-content-between align-self-center align-items-center">
                <Form>
                  <Form.Control
                    type="search"
                    placeholder="Buscar"
                    className="ws_input"
                    onChange={(e) => {
                      setSearch(e.target.value);
                    }}
                  />
                </Form>
                {/* <Dropdown className="ws_dropdown">
                  <Dropdown.Toggle id="dropdown-basic">
                    <Image src={'img/darkOpt.svg'} alt="icon_opt" className="ws_icon ms-2" />
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item href="#">Quitar del dashboard</Dropdown.Item>
                    <Dropdown.Item href="#">Duplicar</Dropdown.Item>
                    <Dropdown.Item href="#">Ocultar en móvil</Dropdown.Item>
                    <Dropdown.Item href="#">Exportar</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown> */}
              </div>
            </div>
          </div>
          <Button
            className="mb-3 ws_btn_secundary"
            style={{ borderRadius: "5px" }}
            onClick={() => {
              sendEmailsInsigniaAnual();
            }}
          >
            Enviar
          </Button>

          <Button
            className="mb-3 ws_btn_primary ms-3"
            style={{ borderRadius: "5px" }}
            onClick={() => {
              setShow(true);
            }}
          >
            Ver plantilla
          </Button>
          <div className="table-responsive" style={{ maxHeight: 450 }}>
            <Table striped bordered hover size="sm" className="ws_tabla">
              <thead
                style={{
                  backgroundColor: "#0a93af",
                  color: "#fff",
                  fontSize: ".9rem",
                }}
              >
                <tr>
                  <th className="text-center align-content-center">
                    <Form.Group controlId="frmcheckEmailAll">
                      <Form.Check
                        type="checkbox"
                        label=""
                        onChange={() => {
                          handleChangeInputAll();
                        }}
                      />
                    </Form.Group>
                  </th>
                  <th align="left" className="ps-3" style={{ width: "25%" }}>
                    AGENTE
                  </th>
                  <th
                    align="left"
                    className="ps-3 text-center"
                    style={{ width: "15%" }}
                  >
                    CLAVE
                  </th>
                  <th align="left" className="ps-3 text-center">
                    ANTERIOR
                  </th>
                  <th align="left" className="ps-3 text-center">
                    LOGRADO
                  </th>
                  <th
                    align="left"
                    className="ps-3 text-center"
                    style={{ width: "15%" }}
                  >
                    FECHA LOGRO
                  </th>
                  <th className="text-center" style={{ width: "15%" }}>
                    STATUS
                  </th>
                  {/* <th className="text-center">EMAIL</th> */}
                  {/* <th className="text-center">TIPO</th>
                  <th className="text-center">OFICINA</th> */}
                  {/* <th className="text-center" style={{ width: '10%' }}>ENVIAR</th> */}
                </tr>
              </thead>
              <tbody style={{ fontSize: ".9rem" }}>
                {data && data.length > 0 ? (
                  data.map((t, e) => {
                    if (
                      search === "" ||
                      (t.nombre &&
                        t.nombre.toLowerCase().indexOf(search.toLowerCase()) !==
                          -1) ||
                      (t.correo &&
                        t.correo.toLowerCase().indexOf(search.toLowerCase()) !==
                          -1) ||
                      (t.clave &&
                        t.clave.toLowerCase().indexOf(search.toLowerCase()) !==
                          -1)
                    ) {
                      return (
                        <tr key={e}>
                          <td className="text-center">
                            {t.email != "" && t.suscribe != 0 ? (
                              <Form.Group
                                className="mb-3"
                                controlId="frmcheckEmail"
                              >
                                <Form.Check
                                  type="checkbox"
                                  label=""
                                  onChange={() => {
                                    handleChangeInput(e, !t.checked);
                                  }}
                                  checked={t.checked}
                                />
                              </Form.Group>
                            ) : null}
                          </td>
                          <td className="ps-3">
                            <a
                              href="#"
                              style={{
                                color: "#606060",
                                display: "block",
                                textTransform: "uppercase",
                                textDecoration: "none",
                              }}
                            >
                              {t.nombre}
                            </a>
                            <a
                              href={`mailto:${t.email}`}
                              style={{
                                color: "#606060",
                                textDecoration: "none",
                                fontSize: ".85rem",
                                fontWeight: "600",
                              }}
                            >
                              {t.email}
                            </a>
                          </td>
                          <td className="text-center">
                            <p className="mb-0">{t.clave}</p>
                          </td>
                          <td className="ps-3">
                            <p className="mb-0">
                              ${number_format(t.cantidad_before, 2)}
                            </p>
                          </td>
                          <td className="ps-3">
                            <p className="mb-0">
                              ${number_format(t.cantidad_current, 2)}
                            </p>
                          </td>
                          <td className="text-center">
                            <p className="mb-0">
                              {moment(t.fecha_logro).format("DD/MM/YYYY")}
                            </p>
                          </td>
                          <td align="center">
                            <div
                              className={
                                t.status == "2"
                                  ? "ws_tag_primary"
                                  : "ws_tag_secundary"
                              }
                            >
                              {t.status == "2" ? "NOTIFICADO" : "SIN NOTIFICAR"}
                            </div>
                          </td>
                          {/* <td align="center"><IconEmailActive width={'35px'} height={'35px'} /></td> */}
                        </tr>
                      );
                    }
                  })
                ) : (
                  <tr>
                    <td colSpan={7} className="text-center">
                      <p className="mb-0">No hay datos disponibles</p>
                    </td>
                  </tr>
                )}
                {/* <tr>
                  <td className='ps-3'>
                    <a href="#" style={{ color: "#606060", display: 'block', textTransform: 'uppercase' }}>BEATRIZ PALOS MENDEZ</a>
                    <a href="mailto:beatrizpalos@hotmail.com" style={{ color: '#606060', textDecoration: 'none', fontSize: '.85rem', fontWeight: '600' }}>beatrizpalos@hotmail.com</a>
                  </td>
                  <td align="center"><p className="mb-0">63994</p></td>
                  <td align="center"><p className="mb-0">$40,042.39</p></td>
                  <td align="center"><p className="mb-0">$40,042.39</p></td> */}
                {/* <td align="left"><IconStar width={'30px'} height={'30px'} /><IconStar width={'30px'} height={'30px'} /><IconStar width={'30px'} height={'30px'} /></td> */}
                {/* <td align="center"><p className="mb-0">01/12/2021</p></td>
                  <td align="center"><div className="ws_tag_primary">NOTFICADO</div></td>
                  <td align="center"><IconEmailActive width={'35px'} height={'35px'} /></td>
                </tr> */}
              </tbody>
            </Table>
          </div>
        </Container>
        <Modal show={show} onHide={handleClose} backdrop="static" size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Vista previa de plantilla</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Container>
              <Row>
                <Col
                  xs={12}
                  className="d-flex flex-column text-center justify-content-center align-items-center"
                >
                  <Image
                    src={"img/diamante/preview_1_diamante.png"}
                    style={{ width: "300px" }}
                  />
                  <Image
                    src={"img/diamante/preview_2_diamante.png"}
                    style={{ width: "300px" }}
                  />
                  <Image
                    src={"img/diamante/preview_3_diamante.png"}
                    style={{ width: "300px" }}
                  />
                  <Image
                    src={"img/diamante/preview_4_diamante.png"}
                    style={{ width: "300px" }}
                  />
                </Col>
              </Row>
            </Container>
          </Modal.Body>
          {/* <Modal.Footer>
              <Button variant="primary" className="ws_btn_secundary" onClick={handleClose}>
                Crear Grupo
              </Button>
            </Modal.Footer> */}
        </Modal>
      </div>
    </Col>
  );

  function sendEmailsInsigniaAnual() {
    // setLoad(true);
    if (dataToSend.length > 0) {
      setSendReport(true);
      fetch(
        `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=sendEmailsInsigniaAnual`,
        {
          method: "POST",
          mode: "cors",
          body: JSON.stringify({
            id_login: usuario.id_usuario,
            array_insignias: dataToSend,
          }),
        }
      )
        .then((res) => res.json())
        .then((res) => {
          if (res.status == "ok") {
            alert(
              `Se han enviado correctamente ${dataToSend.length} correo(s)`
            );
          }
          setSendReport(false);
        });
    } else {
      alert("Selecciona un usuario para enviar el reporte");
    }
  }

  function tabla24k() {
    return (
      <Table striped bordered hover size="sm" responsive className="ws_tabla">
        <thead
          style={{
            backgroundColor: "#0a93af",
            color: "#fff",
            fontSize: ".9rem",
          }}
        >
          <tr>
            <th align="left" className="ps-3" style={{ width: "25%" }}>
              AGENTE
            </th>
            <th
              align="left"
              className="ps-3 text-center"
              style={{ width: "15%" }}
            >
              CLAVE
            </th>
            <th align="left" className="ps-3 text-center">
              CANTIDAD
            </th>
            <th
              align="left"
              className="ps-3 text-center"
              style={{ width: "15%" }}
            >
              FECHA LOGRO
            </th>
            <th className="text-center" style={{ width: "15%" }}>
              STATUS
            </th>
            {/* <th className="text-center">EMAIL</th> */}
            {/* <th className="text-center">TIPO</th>
            <th className="text-center">OFICINA</th> */}
            <th className="text-center" style={{ width: "10%" }}>
              ENVIAR
            </th>
          </tr>
        </thead>
        <tbody style={{ fontSize: ".9rem" }}>
          <tr>
            <td className="ps-3">
              <a
                href="#"
                style={{
                  color: "#606060",
                  display: "block",
                  textTransform: "uppercase",
                }}
              >
                ELOY FELIX RAMOS
              </a>
              <a
                href="mailto:eloyferam@gmail.com"
                style={{
                  color: "#606060",
                  textDecoration: "none",
                  fontSize: ".85rem",
                  fontWeight: "600",
                }}
              >
                eloyferam@gmail.com
              </a>
            </td>
            <td align="center">
              <p className="mb-0">63151</p>
            </td>
            <td align="center">
              <p className="mb-0">$5,584.63</p>
            </td>
            {/* <td align="left"><IconStar width={'30px'} height={'30px'} /><IconStar width={'30px'} height={'30px'} /><IconStar width={'30px'} height={'30px'} /></td> */}
            <td align="center">
              <p className="mb-0">01/12/2021</p>
            </td>
            <td align="center">
              <div className="ws_tag_primary">NOTFICADO</div>
            </td>
            <td align="center">
              <IconEmailActive width={"35px"} height={"35px"} />
            </td>
          </tr>
          <tr>
            <td className="ps-3">
              <a
                href="#"
                style={{
                  color: "#606060",
                  display: "block",
                  textTransform: "uppercase",
                }}
              >
                SAMIRPINEDAPEREZ
              </a>
              <a
                href="mailto:spp292@hotmail.com"
                style={{
                  color: "#606060",
                  textDecoration: "none",
                  fontSize: ".85rem",
                  fontWeight: "600",
                }}
              >
                spp292@hotmail.com
              </a>
            </td>
            <td align="center">
              <p className="mb-0">63838</p>
            </td>
            <td align="center">
              <p className="mb-0">$1,629.16</p>
            </td>
            {/* <td align="left"><IconStar width={'30px'} height={'30px'} /><IconStar width={'30px'} height={'30px'} /><IconStar width={'30px'} height={'30px'} /></td> */}
            <td align="center">
              <p className="mb-0">07/12/2021</p>
            </td>
            <td align="center">
              <div className="ws_tag_primary">NOTFICADO</div>
            </td>
            <td align="center">
              <IconEmailActive width={"35px"} height={"35px"} />
            </td>
          </tr>
          <tr>
            <td className="ps-3">
              <a
                href="#"
                style={{
                  color: "#606060",
                  display: "block",
                  textTransform: "uppercase",
                }}
              >
                BEATRIZ PALOS MENDEZ
              </a>
              <a
                href="mailto:beatrizpalos@hotmail.com"
                style={{
                  color: "#606060",
                  textDecoration: "none",
                  fontSize: ".85rem",
                  fontWeight: "600",
                }}
              >
                beatrizpalos@hotmail.com
              </a>
            </td>
            <td align="center">
              <p className="mb-0">63994</p>
            </td>
            <td align="center">
              <p className="mb-0">$13,037.88</p>
            </td>
            {/* <td align="left"><IconStar width={'30px'} height={'30px'} /><IconStar width={'30px'} height={'30px'} /><IconStar width={'30px'} height={'30px'} /></td> */}
            <td align="center">
              <p className="mb-0">01/12/2021</p>
            </td>
            <td align="center">
              <div className="ws_tag_secundary">SIN NOTIFICAR</div>
            </td>
            <td align="center">
              <IconEmailActive width={"35px"} height={"35px"} />
            </td>
          </tr>
        </tbody>
      </Table>
    );
  }

  function tablaBuenaRacha() {
    return (
      <Table striped bordered hover size="sm" responsive className="ws_tabla">
        <thead
          style={{
            backgroundColor: "#0a93af",
            color: "#fff",
            fontSize: ".9rem",
          }}
        >
          <tr>
            <th align="left" className="ps-3" style={{ width: "25%" }}>
              AGENTE
            </th>
            <th
              align="left"
              className="ps-3 text-center"
              style={{ width: "15%" }}
            >
              CLAVE
            </th>
            <th align="left" className="ps-3 text-center">
              CANTIDAD
            </th>
            <th
              align="left"
              className="ps-3 text-center"
              style={{ width: "15%" }}
            >
              FECHA LOGRO
            </th>
            <th className="text-center" style={{ width: "15%" }}>
              STATUS
            </th>
            {/* <th className="text-center">EMAIL</th> */}
            {/* <th className="text-center">TIPO</th>
            <th className="text-center">OFICINA</th> */}
            <th className="text-center" style={{ width: "10%" }}>
              ENVIAR
            </th>
          </tr>
        </thead>
        <tbody style={{ fontSize: ".9rem" }}>
          <tr>
            <td className="ps-3">
              <a
                href="#"
                style={{
                  color: "#606060",
                  display: "block",
                  textTransform: "uppercase",
                }}
              >
                SERGIO BRAVO
              </a>
              <a
                href="mailto:sanfrancisco@qualitas.com.mx"
                style={{
                  color: "#606060",
                  textDecoration: "none",
                  fontSize: ".85rem",
                  fontWeight: "600",
                }}
              >
                sanfrancisco@qualitas.com.mx
              </a>
            </td>
            <td align="center">
              <p className="mb-0">9460</p>
            </td>
            <td align="left" className="ps-3">
              <p className="mb-0">$459,364.11</p>
              <p className="mb-0">Pólizas: 279.00</p>
              <p className="mb-0">Días: 34.00</p>
            </td>
            {/* <td align="left"><IconStar width={'30px'} height={'30px'} /><IconStar width={'30px'} height={'30px'} /><IconStar width={'30px'} height={'30px'} /></td> */}
            <td align="center">
              <p className="mb-0">01/12/2021</p>
              <p className="mb-0">12/12/2021</p>
            </td>
            <td align="center">
              <div className="ws_tag_primary">NOTFICADO</div>
            </td>
            <td align="center">
              <IconEmailActive width={"35px"} height={"35px"} />
            </td>
          </tr>
          <tr>
            <td className="ps-3">
              <a
                href="#"
                style={{
                  color: "#606060",
                  display: "block",
                  textTransform: "uppercase",
                }}
              >
                YADIRA GABRIELA CAPETILLO CABRERA
              </a>
              <a
                href="mailto:gabriela.capetillo@fortaseguros.com.mx"
                style={{
                  color: "#606060",
                  textDecoration: "none",
                  fontSize: ".85rem",
                  fontWeight: "600",
                }}
              >
                gabriela.capetillo@fortaseguros.com.mx
              </a>
            </td>
            <td align="center">
              <p className="mb-0">60861</p>
            </td>
            <td align="left" className="ps-3">
              <p className="mb-0">$105,336.06</p>
              <p className="mb-0">Pólizas: 25.00</p>
              <p className="mb-0">Días: 8.00</p>
            </td>
            {/* <td align="left"><IconStar width={'30px'} height={'30px'} /><IconStar width={'30px'} height={'30px'} /><IconStar width={'30px'} height={'30px'} /></td> */}
            <td align="center">
              <p className="mb-0">03/12/2021</p>
              <p className="mb-0">12/12/2021</p>
            </td>
            <td align="center">
              <div className="ws_tag_primary">NOTFICADO</div>
            </td>
            <td align="center">
              <IconEmailActive width={"35px"} height={"35px"} />
            </td>
          </tr>
          <tr>
            <td className="ps-3">
              <a
                href="#"
                style={{
                  color: "#606060",
                  display: "block",
                  textTransform: "uppercase",
                }}
              >
                GREGORIO ALBERTO RIVERA ACOSTA
              </a>
              <a
                href="mailto:gregorio.alberto@gryasociados.mx"
                style={{
                  color: "#606060",
                  textDecoration: "none",
                  fontSize: ".85rem",
                  fontWeight: "600",
                }}
              >
                gregorio.alberto@gryasociados.mx
              </a>
            </td>
            <td align="center">
              <p className="mb-0">17773</p>
            </td>
            <td align="left" className="ps-3">
              <p className="mb-0">$76,271.14</p>
              <p className="mb-0">Pólizas: 25.00</p>
              <p className="mb-0">Días: 8.00</p>
            </td>
            {/* <td align="left"><IconStar width={'30px'} height={'30px'} /><IconStar width={'30px'} height={'30px'} /><IconStar width={'30px'} height={'30px'} /></td> */}
            <td align="center">
              <p className="mb-0">02/12/2021</p>
              <p className="mb-0">11/12/2021</p>
            </td>
            <td align="center">
              <div className="ws_tag_secundary">SIN NOTIFICAR</div>
            </td>
            <td align="center">
              <IconEmailActive width={"35px"} height={"35px"} />
            </td>
          </tr>
        </tbody>
      </Table>
    );
  }
}

function TablaBonos24k({
  bonos = [],
  state,
  updateState,
  dataSelected,
  year,
  setYear,
  load,
  setLoad,
  data,
  setData,
  selectOficina,
  sendReport,
  setSendReport,
}) {
  const { usuario } = useContext(AuthContext);

  const currentYear = new Date().getFullYear();
  const [search, setSearch] = useState("");
  const [dataBonos, setDataBonos] = useState(bonos);
  const [dataToSend, setDataToSend] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleChangeInput = (index, value) => {
    let newData = [...data];
    newData[index].checked = value;
    setData(newData);
    if (value) {
      let newDataSend = [
        ...dataToSend,
        data.find((element) => element.idObj === newData[index].idObj),
      ];
      setDataToSend(newDataSend);
    } else {
      let newDataSend = dataToSend.filter(
        (element) => element.idObj != newData[index].idObj
      );
      setDataToSend(newDataSend);
    }
  };

  const handleChangeInputAll = () => {
    setSelectAll(!selectAll);
    let newData = data.map((obj) => ({ ...obj, checked: !selectAll }));
    setData(newData);
  };

  useEffect(() => {
    if (selectAll === false) {
      setDataToSend([]);
    } else {
      let newDataSend = data.filter(
        (element) => element.email != "" && element.subscribe === 1
      );
      setDataToSend(newDataSend);
    }
  }, [selectAll]);

  useEffect(() => {
    setDataToSend([]);
    setSelectAll(false);
  }, [selectOficina]);

  if (load) {
    return (
      <Col xs={12} md={12} className="mb-3">
        <div
          className="ws_box"
          style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
        >
          <Container fluid>
            <div className="ws_box_header mb-3">
              <div className="d-flex justify-content-start align-items-end">
                <div>
                  <h2 className="ws_table_agente_title pb-0 mb-2">
                    24k{" "}
                    <span className="ws_table_agente_number">
                      <a href="#" style={{ color: "#0ca1b4" }}>
                        0
                      </a>
                    </span>
                  </h2>
                </div>
              </div>
            </div>
            <Skeleton width="100%" height={400} />
          </Container>
        </div>
      </Col>
    );
  }

  return (
    <Col xs={12} md={12} className="mb-3">
      <div
        className="ws_box"
        style={{
          paddingTop: "1rem",
          paddingBottom: "1rem",
          position: "relative",
        }}
      >
        <div
          style={{
            borderRadius: "6px",
            position: "absolute",
            backgroundColor: "rgba(0,0,0,0.6)",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            color: "#fff",
            display: sendReport ? "flex" : "none",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <h3>Enviando correo(s)...</h3>
        </div>
        <Container fluid>
          <div className="ws_box_header mb-3">
            <div className="d-flex justify-content-start ali align-items-start">
              <div>
                <h2 className="ws_table_agente_title pb-0 mb-2">
                  24K{" "}
                  <span className="ws_table_agente_number">
                    <a href="#" style={{ color: "#0ca1b4" }}>
                      {data ? data.length : "0"}
                    </a>
                  </span>
                </h2>
                <div className="d-flex justify-content-center align-items-center">
                  <DatePickerW
                    onChange={(e) => {
                      setYear(e.target.value);
                      setLoad(true);
                      setDataToSend([]);
                    }}
                    year={currentYear}
                    selected={year}
                  />
                </div>
              </div>
            </div>
            <div className="d-flex flex-column justify-content-between align-items-end">
              <div className="d-flex flex-row justify-content-between align-self-center align-items-center">
                <Form>
                  <Form.Control
                    type="search"
                    placeholder="Buscar"
                    className="ws_input"
                    onChange={(e) => {
                      setSearch(e.target.value);
                    }}
                  />
                </Form>
                {/* <Dropdown className="ws_dropdown">
                  <Dropdown.Toggle id="dropdown-basic">
                    <Image src={'img/darkOpt.svg'} alt="icon_opt" className="ws_icon ms-2" />
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item href="#">Quitar del dashboard</Dropdown.Item>
                    <Dropdown.Item href="#">Duplicar</Dropdown.Item>
                    <Dropdown.Item href="#">Ocultar en móvil</Dropdown.Item>
                    <Dropdown.Item href="#">Exportar</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown> */}
              </div>
            </div>
          </div>
          <Button
            className="mb-3 ws_btn_secundary"
            style={{ borderRadius: "5px" }}
            onClick={() => {
              sendEmailsInsigniaMensual();
            }}
          >
            Enviar
          </Button>
          <Button
            className="mb-3 ws_btn_primary ms-3"
            style={{ borderRadius: "5px" }}
            onClick={() => {
              setShow(true);
            }}
          >
            Ver plantilla
          </Button>
          <div className="table-responsive" style={{ maxHeight: 450 }}>
            <Table striped bordered hover size="sm" className="ws_tabla">
              <thead
                style={{
                  backgroundColor: "#0a93af",
                  color: "#fff",
                  fontSize: ".9rem",
                }}
              >
                <tr>
                  <th className="text-center align-content-center">
                    <Form.Group controlId="frmcheckEmailAll">
                      <Form.Check
                        type="checkbox"
                        label=""
                        onChange={() => {
                          handleChangeInputAll();
                        }}
                      />
                    </Form.Group>
                  </th>
                  <th align="left" className="ps-3" style={{ width: "25%" }}>
                    AGENTE
                  </th>
                  <th
                    align="left"
                    className="ps-3 text-center"
                    style={{ width: "15%" }}
                  >
                    CLAVE
                  </th>
                  <th align="left" className="ps-3 text-center">
                    ANTERIOR
                  </th>
                  <th align="left" className="ps-3 text-center">
                    LOGRADO
                  </th>
                  <th
                    align="left"
                    className="ps-3 text-center"
                    style={{ width: "15%" }}
                  >
                    FECHA LOGRO
                  </th>
                  <th className="text-center" style={{ width: "15%" }}>
                    STATUS
                  </th>
                  {/* <th className="text-center">EMAIL</th> */}
                  {/* <th className="text-center">TIPO</th>
                  <th className="text-center">OFICINA</th> */}
                  {/* <th className="text-center" style={{ width: '10%' }}>ENVIAR</th> */}
                </tr>
              </thead>
              <tbody style={{ fontSize: ".9rem" }}>
                {data && data.length > 0 ? (
                  data.map((t, e) => {
                    if (
                      search === "" ||
                      (t.nombre &&
                        t.nombre.toLowerCase().indexOf(search.toLowerCase()) !==
                          -1) ||
                      (t.correo &&
                        t.correo.toLowerCase().indexOf(search.toLowerCase()) !==
                          -1) ||
                      (t.clave &&
                        t.clave.toLowerCase().indexOf(search.toLowerCase()) !==
                          -1)
                    ) {
                      return (
                        <tr key={e}>
                          <td className="text-center">
                            {t.email != "" && t.subscribe != 0 ? (
                              <Form.Group
                                className="mb-3"
                                controlId="frmcheckEmail"
                              >
                                <Form.Check
                                  type="checkbox"
                                  label=""
                                  onChange={() => {
                                    handleChangeInput(e, !t.checked);
                                  }}
                                  checked={t.checked}
                                />
                              </Form.Group>
                            ) : null}
                          </td>
                          <td className="ps-3">
                            <a
                              href="#"
                              style={{
                                color: "#606060",
                                display: "block",
                                textTransform: "uppercase",
                                textDecoration: "none",
                              }}
                            >
                              {t.nombre}
                            </a>
                            <a
                              href={`mailto:${t.email}`}
                              style={{
                                color: "#606060",
                                textDecoration: "none",
                                fontSize: ".85rem",
                                fontWeight: "600",
                              }}
                            >
                              {t.email}
                            </a>
                          </td>
                          <td className="text-center">
                            <p className="mb-0">{t.clave}</p>
                          </td>
                          <td className="ps-3">
                            <p className="mb-0">
                              ${number_format(t.cantidad_before, 2)}
                            </p>
                          </td>
                          <td className="ps-3">
                            <p className="mb-0">
                              ${number_format(t.cantidad_current, 2)}
                            </p>
                          </td>
                          <td className="text-center">
                            <p className="mb-0">
                              {moment(t.fecha_logro).format("DD/MM/YYYY")}
                            </p>
                          </td>
                          <td align="center">
                            <div
                              className={
                                t.status == "2"
                                  ? "ws_tag_primary"
                                  : "ws_tag_secundary"
                              }
                            >
                              {t.status == "2" ? "NOTIFICADO" : "SIN NOTIFICAR"}
                            </div>
                          </td>
                          {/* <td align="center"><IconEmailActive width={'35px'} height={'35px'} /></td> */}
                        </tr>
                      );
                    }
                  })
                ) : (
                  <tr>
                    <td colSpan={7} className="text-center">
                      <p className="mb-0">No hay datos disponibles</p>
                    </td>
                  </tr>
                )}

                {/* <tr>
                  <td className='ps-3'>
                    <a href="#" style={{ color: "#606060", display: 'block', textTransform: 'uppercase' }}>ELOY FELIX RAMOS</a>
                    <a href="mailto:eloyferam@gmail.com" style={{ color: '#606060', textDecoration: 'none', fontSize: '.85rem', fontWeight: '600' }}>eloyferam@gmail.com</a>
                  </td>
                  <td align="center"><p className="mb-0">63151</p></td>
                  <td align="center"><p className="mb-0">$5,584.63</p></td>
                  <td align="center"><p className="mb-0">$5,584.63</p></td>
                  <td align="left"><IconStar width={'30px'} height={'30px'} /><IconStar width={'30px'} height={'30px'} /><IconStar width={'30px'} height={'30px'} /></td>
                  <td align="center"><p className="mb-0">01/12/2021</p></td>
                  <td align="center"><div className="ws_tag_primary">NOTFICADO</div></td>
                  <td align="center"><IconEmailActive width={'35px'} height={'35px'} /></td>
                </tr> */}

                {/* <tr>
                  <td className='ps-3'>
                    <a href="#" style={{ color: "#606060", display: 'block', textTransform: 'uppercase' }}>SAMIRPINEDAPEREZ</a>
                    <a href="mailto:spp292@hotmail.com" style={{ color: '#606060', textDecoration: 'none', fontSize: '.85rem', fontWeight: '600' }}>spp292@hotmail.com</a>
                  </td>
                  <td align="center"><p className="mb-0">63838</p></td>
                  <td align="center"><p className="mb-0">$1,629.16</p></td>
                  <td align="center"><p className="mb-0">$1,629.16</p></td>
                  <td align="left"><IconStar width={'30px'} height={'30px'} /><IconStar width={'30px'} height={'30px'} /><IconStar width={'30px'} height={'30px'} /></td>
                  <td align="center"><p className="mb-0">07/12/2021</p></td>
                  <td align="center"><div className="ws_tag_primary">NOTFICADO</div></td>
                  <td align="center"><IconEmailActive width={'35px'} height={'35px'} /></td>
                </tr>
                <tr>
                  <td className='ps-3'>
                    <a href="#" style={{ color: "#606060", display: 'block', textTransform: 'uppercase' }}>BEATRIZ PALOS MENDEZ</a>
                    <a href="mailto:beatrizpalos@hotmail.com" style={{ color: '#606060', textDecoration: 'none', fontSize: '.85rem', fontWeight: '600' }}>beatrizpalos@hotmail.com</a>
                  </td>
                  <td align="center"><p className="mb-0">63994</p></td>
                  <td align="center"><p className="mb-0">$13,037.88</p></td>
                  <td align="center"><p className="mb-0">$13,037.88</p></td>
                  <td align="left"><IconStar width={'30px'} height={'30px'} /><IconStar width={'30px'} height={'30px'} /><IconStar width={'30px'} height={'30px'} /></td>
                  <td align="center"><p className="mb-0">01/12/2021</p></td>
                  <td align="center"><div className="ws_tag_secundary">SIN NOTIFICAR</div></td>
                  <td align="center"><IconEmailActive width={'35px'} height={'35px'} /></td>
                </tr> */}
              </tbody>
            </Table>
          </div>
        </Container>
        <Modal show={show} onHide={handleClose} backdrop="static" size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Vista previa de plantilla</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Container>
              <Row>
                <Col
                  xs={12}
                  className="d-flex flex-column text-center justify-content-center align-items-center"
                >
                  <Image
                    src={"img/24k/preview_1_24k.png"}
                    style={{ width: "300px" }}
                  />
                  <Image
                    src={"img/24k/preview_2_24k.png"}
                    style={{ width: "300px" }}
                  />
                  <Image
                    src={"img/24k/preview_3_24k.png"}
                    style={{ width: "300px" }}
                  />
                  <Image
                    src={"img/24k/preview_4_24k.png"}
                    style={{ width: "300px" }}
                  />
                </Col>
              </Row>
            </Container>
          </Modal.Body>
          {/* <Modal.Footer>
              <Button variant="primary" className="ws_btn_secundary" onClick={handleClose}>
                Crear Grupo
              </Button>
            </Modal.Footer> */}
        </Modal>
      </div>
    </Col>
  );

  function sendEmailsInsigniaMensual() {
    // setLoad(true);
    if (dataToSend.length > 0) {
      setSendReport(true);
      fetch(
        `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=sendEmailsInsigniaMensual`,
        {
          method: "POST",
          mode: "cors",
          body: JSON.stringify({
            id_login: usuario.id_usuario,
            array_insignias: dataToSend,
          }),
        }
      )
        .then((res) => res.json())
        .then((res) => {
          if (res.status == "ok") {
            alert(
              `Se han enviado correctamente ${dataToSend.length} correo(s)`
            );
          }
          setSendReport(false);
        });
    } else {
      alert("Selecciona un usuario para enviar el reporte");
    }
  }

  function tablaBuenaRacha() {
    return (
      <Table striped bordered hover size="sm" responsive className="ws_tabla">
        <thead
          style={{
            backgroundColor: "#0a93af",
            color: "#fff",
            fontSize: ".9rem",
          }}
        >
          <tr>
            <th align="left" className="ps-3" style={{ width: "25%" }}>
              AGENTE
            </th>
            <th
              align="left"
              className="ps-3 text-center"
              style={{ width: "15%" }}
            >
              CLAVE
            </th>
            <th align="left" className="ps-3 text-center">
              CANTIDAD
            </th>
            <th
              align="left"
              className="ps-3 text-center"
              style={{ width: "15%" }}
            >
              FECHA LOGRO
            </th>
            <th className="text-center" style={{ width: "15%" }}>
              STATUS
            </th>
            {/* <th className="text-center">EMAIL</th> */}
            {/* <th className="text-center">TIPO</th>
            <th className="text-center">OFICINA</th> */}
            <th className="text-center" style={{ width: "10%" }}>
              ENVIAR
            </th>
          </tr>
        </thead>
        <tbody style={{ fontSize: ".9rem" }}>
          <tr>
            <td className="ps-3">
              <a
                href="#"
                style={{
                  color: "#606060",
                  display: "block",
                  textTransform: "uppercase",
                }}
              >
                SERGIO BRAVO
              </a>
              <a
                href="mailto:sanfrancisco@qualitas.com.mx"
                style={{
                  color: "#606060",
                  textDecoration: "none",
                  fontSize: ".85rem",
                  fontWeight: "600",
                }}
              >
                sanfrancisco@qualitas.com.mx
              </a>
            </td>
            <td align="center">
              <p className="mb-0">9460</p>
            </td>
            <td align="left" className="ps-3">
              <p className="mb-0">$459,364.11</p>
              <p className="mb-0">Pólizas: 279.00</p>
              <p className="mb-0">Días: 34.00</p>
            </td>
            {/* <td align="left"><IconStar width={'30px'} height={'30px'} /><IconStar width={'30px'} height={'30px'} /><IconStar width={'30px'} height={'30px'} /></td> */}
            <td align="center">
              <p className="mb-0">01/12/2021</p>
              <p className="mb-0">12/12/2021</p>
            </td>
            <td align="center">
              <div className="ws_tag_primary">NOTFICADO</div>
            </td>
            <td align="center">
              <IconEmailActive width={"35px"} height={"35px"} />
            </td>
          </tr>
          <tr>
            <td className="ps-3">
              <a
                href="#"
                style={{
                  color: "#606060",
                  display: "block",
                  textTransform: "uppercase",
                }}
              >
                YADIRA GABRIELA CAPETILLO CABRERA
              </a>
              <a
                href="mailto:gabriela.capetillo@fortaseguros.com.mx"
                style={{
                  color: "#606060",
                  textDecoration: "none",
                  fontSize: ".85rem",
                  fontWeight: "600",
                }}
              >
                gabriela.capetillo@fortaseguros.com.mx
              </a>
            </td>
            <td align="center">
              <p className="mb-0">60861</p>
            </td>
            <td align="left" className="ps-3">
              <p className="mb-0">$105,336.06</p>
              <p className="mb-0">Pólizas: 25.00</p>
              <p className="mb-0">Días: 8.00</p>
            </td>
            {/* <td align="left"><IconStar width={'30px'} height={'30px'} /><IconStar width={'30px'} height={'30px'} /><IconStar width={'30px'} height={'30px'} /></td> */}
            <td align="center">
              <p className="mb-0">03/12/2021</p>
              <p className="mb-0">12/12/2021</p>
            </td>
            <td align="center">
              <div className="ws_tag_primary">NOTFICADO</div>
            </td>
            <td align="center">
              <IconEmailActive width={"35px"} height={"35px"} />
            </td>
          </tr>
          <tr>
            <td className="ps-3">
              <a
                href="#"
                style={{
                  color: "#606060",
                  display: "block",
                  textTransform: "uppercase",
                }}
              >
                GREGORIO ALBERTO RIVERA ACOSTA
              </a>
              <a
                href="mailto:gregorio.alberto@gryasociados.mx"
                style={{
                  color: "#606060",
                  textDecoration: "none",
                  fontSize: ".85rem",
                  fontWeight: "600",
                }}
              >
                gregorio.alberto@gryasociados.mx
              </a>
            </td>
            <td align="center">
              <p className="mb-0">17773</p>
            </td>
            <td align="left" className="ps-3">
              <p className="mb-0">$76,271.14</p>
              <p className="mb-0">Pólizas: 25.00</p>
              <p className="mb-0">Días: 8.00</p>
            </td>
            {/* <td align="left"><IconStar width={'30px'} height={'30px'} /><IconStar width={'30px'} height={'30px'} /><IconStar width={'30px'} height={'30px'} /></td> */}
            <td align="center">
              <p className="mb-0">02/12/2021</p>
              <p className="mb-0">11/12/2021</p>
            </td>
            <td align="center">
              <div className="ws_tag_secundary">SIN NOTIFICAR</div>
            </td>
            <td align="center">
              <IconEmailActive width={"35px"} height={"35px"} />
            </td>
          </tr>
        </tbody>
      </Table>
    );
  }
}

function TablaBonosBuenaRacha({
  bonos = [],
  state,
  updateState,
  dataSelected,
  year,
  setYear,
  month,
  setMonth,
  load,
  setLoad,
  data,
  setData,
  selectOficina,
  sendReport,
  setSendReport,
}) {
  const { usuario } = useContext(AuthContext);

  const currentYear = new Date().getFullYear();
  const [search, setSearch] = useState("");
  const [dataBonos, setDataBonos] = useState(bonos);
  const [dataToSend, setDataToSend] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleChangeInput = (index, value) => {
    let newData = [...data];
    newData[index].checked = value;
    setData(newData);
    if (value) {
      let newDataSend = [
        ...dataToSend,
        data.find((element) => element.idObj === newData[index].idObj),
      ];
      setDataToSend(newDataSend);
    } else {
      let newDataSend = dataToSend.filter(
        (element) => element.idObj != newData[index].idObj
      );
      setDataToSend(newDataSend);
    }
  };

  const handleChangeInputAll = () => {
    setSelectAll(!selectAll);
    let newData = data.map((obj) => ({ ...obj, checked: !selectAll }));
    setData(newData);
  };

  useEffect(() => {
    if (selectAll === false) {
      setDataToSend([]);
    } else {
      let newDataSend = data.filter(
        (element) => element.email != "" && element.subscribe === 1
      );
      setDataToSend(newDataSend);
    }
  }, [selectAll]);

  useEffect(() => {
    setDataToSend([]);
    setSelectAll(false);
  }, [selectOficina]);

  if (load) {
    return (
      <Col xs={12} md={12} className="mb-3">
        <div
          className="ws_box"
          style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
        >
          <Container fluid>
            <div className="ws_box_header mb-3">
              <div className="d-flex justify-content-start align-items-end">
                <div>
                  <h2 className="ws_table_agente_title pb-0 mb-2">
                    Buena Racha{" "}
                    <span className="ws_table_agente_number">
                      <a href="#" style={{ color: "#0ca1b4" }}>
                        0
                      </a>
                    </span>
                  </h2>
                </div>
              </div>
            </div>
            <Skeleton width="100%" height={400} />
          </Container>
        </div>
      </Col>
    );
  }

  return (
    <Col xs={12} md={12} className="mb-3">
      <div
        className="ws_box"
        style={{
          paddingTop: "1rem",
          paddingBottom: "1rem",
          position: "relative",
        }}
      >
        <div
          style={{
            borderRadius: "6px",
            position: "absolute",
            backgroundColor: "rgba(0,0,0,0.6)",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            color: "#fff",
            display: sendReport ? "flex" : "none",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <h3>Enviando correo(s)...</h3>
        </div>
        <Container fluid>
          <div className="ws_box_header mb-3">
            <div className="d-flex justify-content-start ali align-items-start">
              <div>
                <h2 className="ws_table_agente_title pb-0 mb-2">
                  Buena Racha{" "}
                  <span className="ws_table_agente_number">
                    <a href="#" style={{ color: "#0ca1b4" }}>
                      {data && data.length > 0 ? data.length : "0"}
                    </a>
                  </span>
                </h2>
                <div className="d-flex justify-content-center align-items-center">
                  <DatePickerW
                    onChange={(e) => {
                      setYear(e.target.value);
                      setLoad(true);
                      setDataToSend([]);
                    }}
                    year={currentYear}
                    selected={year}
                  />
                  <DatePickerMonthW
                    className="ms-2"
                    onChange={(e) => {
                      setMonth(e.target.value);
                      setDataToSend([]);
                    }}
                    selected={month}
                  />
                </div>
              </div>
            </div>
            <div className="d-flex flex-column justify-content-between align-items-end">
              <div className="d-flex flex-row justify-content-between align-self-center align-items-center">
                <Form>
                  <Form.Control
                    type="search"
                    placeholder="Buscar"
                    className="ws_input"
                    onChange={(e) => {
                      setSearch(e.target.value);
                    }}
                  />
                </Form>
                {/* <Dropdown className="ws_dropdown">
                  <Dropdown.Toggle id="dropdown-basic">
                    <Image src={'img/darkOpt.svg'} alt="icon_opt" className="ws_icon ms-2" />
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item href="#">Quitar del dashboard</Dropdown.Item>
                    <Dropdown.Item href="#">Duplicar</Dropdown.Item>
                    <Dropdown.Item href="#">Ocultar en móvil</Dropdown.Item>
                    <Dropdown.Item href="#">Exportar</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown> */}
              </div>
            </div>
          </div>
          <Button
            className="mb-3 ws_btn_secundary"
            style={{ borderRadius: "5px" }}
            onClick={() => {
              sendEmailsInsigniaDiaria();
            }}
          >
            Enviar
          </Button>
          <Button
            className="mb-3 ws_btn_primary ms-3"
            style={{ borderRadius: "5px" }}
            onClick={() => {
              setShow(true);
            }}
          >
            Ver plantilla
          </Button>
          <div className="table-responsive" style={{ maxHeight: 450 }}>
            <Table
              striped
              bordered
              hover
              size="sm"
              responsive
              className="ws_tabla"
            >
              <thead
                style={{
                  backgroundColor: "#0a93af",
                  color: "#fff",
                  fontSize: ".9rem",
                }}
              >
                <tr>
                  <th className="text-center align-content-center">
                    <Form.Group controlId="frmcheckEmailAll">
                      <Form.Check
                        type="checkbox"
                        label=""
                        onChange={() => {
                          handleChangeInputAll();
                        }}
                      />
                    </Form.Group>
                  </th>
                  <th align="left" className="ps-3" style={{ width: "25%" }}>
                    AGENTE
                  </th>
                  <th
                    align="left"
                    className="ps-3 text-center"
                    style={{ width: "15%" }}
                  >
                    CLAVE
                  </th>
                  <th align="left" className="ps-3 text-center">
                    CANTIDAD
                  </th>
                  <th
                    align="left"
                    className="ps-3 text-center"
                    style={{ width: "15%" }}
                  >
                    FECHA LOGRO
                  </th>
                  <th className="text-center" style={{ width: "15%" }}>
                    STATUS
                  </th>
                  {/* <th className="text-center">EMAIL</th> */}
                  {/* <th className="text-center">TIPO</th>
                  <th className="text-center">OFICINA</th> */}
                  {/* <th className="text-center" style={{ width: '10%' }}>ENVIAR</th> */}
                </tr>
              </thead>
              <tbody style={{ fontSize: ".9rem" }}>
                {data && data.length > 0 ? (
                  data.map((t, e) => {
                    if (
                      search === "" ||
                      (t.nombre &&
                        t.nombre.toLowerCase().indexOf(search.toLowerCase()) !==
                          -1) ||
                      (t.email &&
                        t.email.toLowerCase().indexOf(search.toLowerCase()) !==
                          -1) ||
                      (t.clave &&
                        t.clave.toLowerCase().indexOf(search.toLowerCase()) !==
                          -1)
                    ) {
                      return (
                        <tr key={e}>
                          <td className="text-center">
                            {t.email != "" && t.suscribe != 0 ? (
                              <Form.Group
                                className="mb-3"
                                controlId="frmcheckEmail"
                              >
                                <Form.Check
                                  type="checkbox"
                                  label=""
                                  onChange={() => {
                                    handleChangeInput(e, !t.checked);
                                  }}
                                  checked={t.checked}
                                />
                              </Form.Group>
                            ) : null}
                          </td>
                          <td className="ps-3">
                            <a
                              href="#"
                              style={{
                                color: "#606060",
                                display: "block",
                                textTransform: "uppercase",
                                textDecoration: "none",
                              }}
                            >
                              {t.nombre}
                            </a>
                            <a
                              href={`mailto:${t.email}`}
                              style={{
                                color: "#606060",
                                textDecoration: "none",
                                fontSize: ".85rem",
                                fontWeight: "600",
                              }}
                            >
                              {t.email}
                            </a>
                          </td>
                          <td className="text-center">
                            <p className="mb-0">{t.clave}</p>
                          </td>
                          <td align="left" className="ps-3">
                            <p className="mb-0">
                              ${number_format(t.total_lana, 2)}
                            </p>
                            <p className="mb-0">Pólizas: {t.total_polizas}</p>
                            <p className="mb-0">Días: {t.total_dias}</p>
                          </td>
                          <td className="text-center">
                            <p className="mb-0">
                              {moment(t.fecha_inicio).format("DD/MM/YYYY")}
                            </p>
                            <p className="mb-0">
                              {moment(t.fecha_fin).format("DD/MM/YYYY")}
                            </p>
                          </td>
                          <td align="center">
                            <div
                              className={
                                t.status == "2"
                                  ? "ws_tag_primary"
                                  : "ws_tag_secundary"
                              }
                            >
                              {t.status == "2" ? "NOTIFICADO" : "SIN NOTIFICAR"}
                            </div>
                          </td>
                          {/* <td align="center"><IconEmailActive width={'35px'} height={'35px'} /></td> */}
                        </tr>
                      );
                    }
                  })
                ) : (
                  <tr>
                    <td colSpan={6} className="text-center">
                      <p className="mb-0">No hay datos disponibles</p>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </Container>
        <Modal show={show} onHide={handleClose} backdrop="static" size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Vista previa de plantilla</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Container>
              <Row>
                <Col
                  xs={12}
                  className="d-flex flex-column text-center justify-content-center align-items-center"
                >
                  <Image
                    src={"img/buena_racha/preview_1_buenaracha.png"}
                    style={{ width: "300px" }}
                  />
                  <Image
                    src={"img/buena_racha/preview_2_buenaracha.png"}
                    style={{ width: "300px" }}
                  />
                  <Image
                    src={"img/buena_racha/preview_3_buenaracha.png"}
                    style={{ width: "300px" }}
                  />
                  <Image
                    src={"img/buena_racha/preview_4_buenaracha.png"}
                    style={{ width: "300px" }}
                  />
                </Col>
              </Row>
            </Container>
          </Modal.Body>
          {/* <Modal.Footer>
              <Button variant="primary" className="ws_btn_secundary" onClick={handleClose}>
                Crear Grupo
              </Button>
            </Modal.Footer> */}
        </Modal>
      </div>
    </Col>
  );

  function sendEmailsInsigniaDiaria() {
    // setLoad(true);
    if (dataToSend.length > 0) {
      setSendReport(true);
      fetch(
        `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=sendEmailsInsigniaDiaria`,
        {
          method: "POST",
          mode: "cors",
          body: JSON.stringify({
            id_login: usuario.id_usuario,
            array_insignias: dataToSend,
          }),
        }
      )
        .then((res) => res.json())
        .then((res) => {
          if (res.status == "ok") {
            alert(
              `Se han enviado correctamente ${dataToSend.length} correo(s)`
            );
          }
          setSendReport(false);
        });
    } else {
      alert("Selecciona un usuario para enviar el reporte");
    }
  }
}

function TablaBonosMalaRacha({
  bonos = [],
  state,
  updateState,
  dataSelected,
  load,
  setLoad,
  data,
  setData,
  selectOficina,
  sendReport,
  setSendReport,
}) {
  const { usuario } = useContext(AuthContext);

  const currentYear = new Date().getFullYear();
  const [search, setSearch] = useState("");
  const [dataBonos, setDataBonos] = useState(bonos);
  const [dataToSend, setDataToSend] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleChangeInput = (index, value) => {
    let newData = [...data];
    newData[index].checked = value;
    setData(newData);
    if (value) {
      let newDataSend = [
        ...dataToSend,
        data.find((element) => element.idObj === newData[index].idObj),
      ];
      setDataToSend(newDataSend);
    } else {
      let newDataSend = dataToSend.filter(
        (element) => element.idObj != newData[index].idObj
      );
      setDataToSend(newDataSend);
    }
  };

  const handleChangeInputAll = () => {
    setSelectAll(!selectAll);
    let newData = data.map((obj) => ({ ...obj, checked: !selectAll }));
    setData(newData);
  };

  useEffect(() => {
    if (selectAll === false) {
      setDataToSend([]);
    } else {
      let newDataSend = data.filter(
        (element) => element.email != "" && element.subscribe === 1
      );
      setDataToSend(newDataSend);
    }
  }, [selectAll]);

  useEffect(() => {
    setDataToSend([]);
    setSelectAll(false);
  }, [selectOficina]);

  if (load) {
    return (
      <Col xs={12} md={12} className="mb-3">
        <div
          className="ws_box"
          style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
        >
          <Container fluid>
            <div className="ws_box_header mb-3">
              <div className="d-flex justify-content-start align-items-end">
                <div>
                  <h2 className="ws_table_agente_title pb-0 mb-2">
                    Mala Racha{" "}
                    <span className="ws_table_agente_number">
                      <a href="#" style={{ color: "#0ca1b4" }}>
                        0
                      </a>
                    </span>
                  </h2>
                </div>
              </div>
            </div>
            <Skeleton width="100%" height={400} />
          </Container>
        </div>
      </Col>
    );
  }

  return (
    <Col xs={12} md={12} className="mb-3">
      <div
        className="ws_box"
        style={{
          paddingTop: "1rem",
          paddingBottom: "1rem",
          position: "relative",
        }}
      >
        <div
          style={{
            borderRadius: "6px",
            position: "absolute",
            backgroundColor: "rgba(0,0,0,0.6)",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            color: "#fff",
            display: sendReport ? "flex" : "none",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <h3>Enviando correo(s)...</h3>
        </div>
        <Container fluid>
          <div className="ws_box_header mb-3">
            <div className="d-flex justify-content-start ali align-items-start">
              <div>
                <h2 className="ws_table_agente_title pb-0 mb-2">
                  Mala Racha{" "}
                  <span className="ws_table_agente_number">
                    <a href="#" style={{ color: "#0ca1b4" }}>
                      {data && data.length > 0 ? data.length : "0"}
                    </a>
                  </span>
                </h2>
              </div>
            </div>
            <div className="d-flex flex-column justify-content-between align-items-end">
              <div className="d-flex flex-row justify-content-between align-self-center align-items-center">
                <Form>
                  <Form.Control
                    type="search"
                    placeholder="Buscar"
                    className="ws_input"
                    onChange={(e) => {
                      setSearch(e.target.value);
                    }}
                  />
                </Form>
                {/* <Dropdown className="ws_dropdown">
                  <Dropdown.Toggle id="dropdown-basic">
                    <Image src={'img/darkOpt.svg'} alt="icon_opt" className="ws_icon ms-2" />
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item href="#">Quitar del dashboard</Dropdown.Item>
                    <Dropdown.Item href="#">Duplicar</Dropdown.Item>
                    <Dropdown.Item href="#">Ocultar en móvil</Dropdown.Item>
                    <Dropdown.Item href="#">Exportar</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown> */}
              </div>
            </div>
          </div>
          <Button
            className="mb-3 ws_btn_secundary"
            style={{ borderRadius: "5px" }}
            onClick={() => {
              sendEmailsInsigniaInactividadDecena();
            }}
          >
            Enviar
          </Button>
          <Button
            className="mb-3 ws_btn_primary ms-3"
            style={{ borderRadius: "5px" }}
            onClick={() => {
              setShow(true);
            }}
          >
            Ver plantilla
          </Button>
          <div className="table-responsive" style={{ maxHeight: 450 }}>
            <Table striped bordered hover size="sm" className="ws_tabla">
              <thead
                style={{
                  backgroundColor: "#0a93af",
                  color: "#fff",
                  fontSize: ".9rem",
                }}
              >
                <tr>
                  <th
                    style={{ width: "5%" }}
                    className="text-center align-content-center"
                  >
                    <Form.Group controlId="frmcheckEmailAll">
                      <Form.Check
                        type="checkbox"
                        label=""
                        onChange={() => {
                          handleChangeInputAll();
                        }}
                      />
                    </Form.Group>
                  </th>
                  <th align="left" className="ps-3" style={{ width: "25%" }}>
                    AGENTE
                  </th>
                  {/* <th align="left" className='ps-3 text-center' style={{ width: '15%' }}>CLAVE</th> */}
                  <th
                    align="left"
                    className="ps-3 text-center"
                    style={{ width: "15%" }}
                  >
                    FECHAS
                  </th>
                  <th className="text-center" style={{ width: "15%" }}>
                    STATUS
                  </th>
                  {/* <th className="text-center">EMAIL</th> */}
                  {/* <th className="text-center">TIPO</th>
                  <th className="text-center">OFICINA</th> */}
                  {/* <th className="text-center" style={{ width: '10%' }}>ENVIAR</th> */}
                </tr>
              </thead>
              <tbody style={{ fontSize: ".9rem" }}>
                {data && data.length > 0 ? (
                  data.map((t, e) => {
                    if (
                      search === "" ||
                      (t.nombre &&
                        t.nombre.toLowerCase().indexOf(search.toLowerCase()) !==
                          -1) ||
                      (t.email &&
                        t.email.toLowerCase().indexOf(search.toLowerCase()) !==
                          -1)
                    ) {
                      return (
                        <tr key={e}>
                          <td className="text-center">
                            {t.email != "" && t.suscribe != 0 ? (
                              <Form.Group
                                className="mb-3"
                                controlId="frmcheckEmail"
                              >
                                <Form.Check
                                  type="checkbox"
                                  label=""
                                  onChange={() => {
                                    handleChangeInput(e, !t.checked);
                                  }}
                                  checked={t.checked}
                                />
                              </Form.Group>
                            ) : null}
                          </td>
                          <td className="ps-3">
                            <a
                              href="#"
                              style={{
                                color: "#606060",
                                display: "block",
                                textTransform: "uppercase",
                                textDecoration: "none",
                              }}
                            >
                              {t.nombre}
                            </a>
                            <a
                              href={`mailto:${t.email}`}
                              style={{
                                color: "#606060",
                                textDecoration: "none",
                                fontSize: ".85rem",
                                fontWeight: "600",
                              }}
                            >
                              {t.email}
                            </a>
                          </td>
                          {/* <td className="text-center"><p className="mb-0">{t.clave}</p></td> */}
                          <td align="left" className="ps-3">
                            <p className="mb-0">Del 21 al 31.</p>
                          </td>
                          <td align="center">
                            <div
                              className={
                                t.status == "2"
                                  ? "ws_tag_primary"
                                  : "ws_tag_secundary"
                              }
                            >
                              {t.status == "2" ? "NOTIFICADO" : "SIN NOTIFICAR"}
                            </div>
                          </td>
                          {/* <td align="center"><IconEmailActive width={'35px'} height={'35px'} /></td> */}
                        </tr>
                      );
                    }
                  })
                ) : (
                  <tr>
                    <td colSpan={4} className="text-center">
                      <p className="mb-0">No hay datos disponibles</p>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </Container>
        <Modal show={show} onHide={handleClose} backdrop="static" size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Vista previa de plantilla</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Container>
              <Row>
                <Col
                  xs={12}
                  className="d-flex flex-column text-center justify-content-center align-items-center"
                >
                  <Image
                    src={"img/mala_racha/preview_1_malaracha.png"}
                    style={{ width: "300px" }}
                  />
                  <Image
                    src={"img/mala_racha/preview_2_malaracha.png"}
                    style={{ width: "300px" }}
                  />
                  <Image
                    src={"img/mala_racha/preview_3_malaracha.png"}
                    style={{ width: "300px" }}
                  />
                  <Image
                    src={"img/mala_racha/preview_4_malaracha.png"}
                    style={{ width: "300px" }}
                  />
                </Col>
              </Row>
            </Container>
          </Modal.Body>
          {/* <Modal.Footer>
              <Button variant="primary" className="ws_btn_secundary" onClick={handleClose}>
                Crear Grupo
              </Button>
            </Modal.Footer> */}
        </Modal>
      </div>
    </Col>
  );

  function sendEmailsInsigniaInactividadDecena() {
    // setLoad(true);
    if (dataToSend.length > 0) {
      setSendReport(true);
      fetch(
        `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=sendEmailsInsigniaInactividadDecena`,
        {
          method: "POST",
          mode: "cors",
          body: JSON.stringify({
            id_login: usuario.id_usuario,
            array_insignias: dataToSend,
          }),
        }
      )
        .then((res) => res.json())
        .then((res) => {
          if (res.status == "ok") {
            alert(
              `Se han enviado correctamente ${dataToSend.length} correo(s)`
            );
          }
          setSendReport(false);
        });
    } else {
      alert("Selecciona un usuario para enviar el reporte");
    }
  }
}

function TablaBonosTeExtranamos({
  bonos = [],
  state,
  updateState,
  dataSelected,
  year,
  setYear,
  month,
  setMonth,
  load,
  setLoad,
  data,
  setData,
  selectOficina,
  sendReport,
  setSendReport,
}) {
  const { usuario } = useContext(AuthContext);

  const currentYear = new Date().getFullYear();
  const [search, setSearch] = useState("");
  const [dataBonos, setDataBonos] = useState(bonos);
  const [dataToSend, setDataToSend] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleChangeInput = (index, value) => {
    let newData = [...data];
    newData[index].checked = value;
    setData(newData);
    if (value) {
      let newDataSend = [
        ...dataToSend,
        data.find((element) => element.idObj === newData[index].idObj),
      ];
      setDataToSend(newDataSend);
    } else {
      let newDataSend = dataToSend.filter(
        (element) => element.idObj != newData[index].idObj
      );
      setDataToSend(newDataSend);
    }
  };

  const handleChangeInputAll = () => {
    setSelectAll(!selectAll);
    let newData = data.map((obj) => ({ ...obj, checked: !selectAll }));
    setData(newData);
  };

  useEffect(() => {
    if (selectAll === false) {
      setDataToSend([]);
    } else {
      let newDataSend = data.filter(
        (element) => element.email != "" && element.subscribe === 1
      );
      setDataToSend(newDataSend);
    }
  }, [selectAll]);

  useEffect(() => {
    setDataToSend([]);
    setSelectAll(false);
  }, [selectOficina]);

  if (load) {
    return (
      <Col xs={12} md={12} className="mb-3">
        <div
          className="ws_box"
          style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
        >
          <Container fluid>
            <div className="ws_box_header mb-3">
              <div className="d-flex justify-content-start align-items-end">
                <div>
                  <h2 className="ws_table_agente_title pb-0 mb-2">
                    Te extrañamos{" "}
                    <span className="ws_table_agente_number">
                      <a href="#" style={{ color: "#0ca1b4" }}>
                        0
                      </a>
                    </span>
                  </h2>
                </div>
              </div>
            </div>
            <Skeleton width="100%" height={400} />
          </Container>
        </div>
      </Col>
    );
  }

  return (
    <Col xs={12} md={12} className="mb-3">
      <div
        className="ws_box"
        style={{
          paddingTop: "1rem",
          paddingBottom: "1rem",
          position: "relative",
        }}
      >
        <div
          style={{
            borderRadius: "6px",
            position: "absolute",
            backgroundColor: "rgba(0,0,0,0.6)",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            color: "#fff",
            display: sendReport ? "flex" : "none",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <h3>Enviando correo(s)...</h3>
        </div>
        <Container fluid>
          <div className="ws_box_header mb-3">
            <div className="d-flex justify-content-start ali align-items-start">
              <div>
                <h2 className="ws_table_agente_title pb-0 mb-2">
                  Te extrañamos{" "}
                  <span className="ws_table_agente_number">
                    <a href="#" style={{ color: "#0ca1b4" }}>
                      {data && data.length > 0 ? data.length : "0"}
                    </a>
                  </span>
                </h2>
                <div className="d-flex justify-content-center align-items-center">
                  <DatePickerW
                    onChange={(e) => {
                      setYear(e.target.value);
                      setLoad(true);
                      setDataToSend([]);
                    }}
                    year={currentYear}
                    selected={year}
                  />
                  <DatePickerMonthW
                    className="ms-2"
                    onChange={(e) => {
                      setMonth(e.target.value);
                      setDataToSend([]);
                    }}
                    selected={month}
                  />
                </div>
              </div>
            </div>
            <div className="d-flex flex-column justify-content-between align-items-end">
              <div className="d-flex flex-row justify-content-between align-self-center align-items-center">
                <Form>
                  <Form.Control
                    type="search"
                    placeholder="Buscar"
                    className="ws_input"
                    onChange={(e) => {
                      setSearch(e.target.value);
                    }}
                  />
                </Form>
                {/* <Dropdown className="ws_dropdown">
                  <Dropdown.Toggle id="dropdown-basic">
                    <Image src={'img/darkOpt.svg'} alt="icon_opt" className="ws_icon ms-2" />
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item href="#">Quitar del dashboard</Dropdown.Item>
                    <Dropdown.Item href="#">Duplicar</Dropdown.Item>
                    <Dropdown.Item href="#">Ocultar en móvil</Dropdown.Item>
                    <Dropdown.Item href="#">Exportar</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown> */}
              </div>
            </div>
          </div>
          <Button
            className="mb-3 ws_btn_secundary"
            style={{ borderRadius: "5px" }}
            onClick={() => {
              sendEmailsInsigniaInactividadMensual();
            }}
          >
            Enviar
          </Button>
          <Button
            className="mb-3 ws_btn_primary ms-3"
            style={{ borderRadius: "5px" }}
            onClick={() => {
              setShow(true);
            }}
          >
            Ver plantilla
          </Button>
          <div className="table-responsive" style={{ maxHeight: 450 }}>
            <Table striped bordered hover size="sm" className="ws_tabla">
              <thead
                style={{
                  backgroundColor: "#0a93af",
                  color: "#fff",
                  fontSize: ".9rem",
                }}
              >
                <tr>
                  <th
                    style={{ width: "5%" }}
                    className="text-center align-content-center"
                  >
                    <Form.Group controlId="frmcheckEmailAll">
                      <Form.Check
                        type="checkbox"
                        label=""
                        onChange={() => {
                          handleChangeInputAll();
                        }}
                      />
                    </Form.Group>
                  </th>
                  <th align="left" className="ps-3" style={{ width: "25%" }}>
                    AGENTE
                  </th>
                  {/* <th align="left" className='ps-3 text-center' style={{ width: '15%' }}>CLAVE</th> */}
                  <th className="text-center" style={{ width: "15%" }}>
                    STATUS
                  </th>
                  {/* <th className="text-center">EMAIL</th> */}
                  {/* <th className="text-center">TIPO</th>
                  <th className="text-center">OFICINA</th> */}
                  {/* <th className="text-center" style={{ width: '10%' }}>ENVIAR</th> */}
                </tr>
              </thead>
              <tbody style={{ fontSize: ".9rem" }}>
                {data && data.length > 0 ? (
                  data.map((t, e) => {
                    if (
                      search === "" ||
                      (t.nombre &&
                        t.nombre.toLowerCase().indexOf(search.toLowerCase()) !==
                          -1) ||
                      (t.email &&
                        t.email.toLowerCase().indexOf(search.toLowerCase()) !==
                          -1)
                    ) {
                      return (
                        <tr key={e}>
                          <td className="text-center">
                            {t.email != "" && t.suscribe != 0 ? (
                              <Form.Group
                                className="mb-3"
                                controlId="frmcheckEmail"
                              >
                                <Form.Check
                                  type="checkbox"
                                  label=""
                                  onChange={() => {
                                    handleChangeInput(e, !t.checked);
                                  }}
                                  checked={t.checked}
                                />
                              </Form.Group>
                            ) : null}
                          </td>
                          <td className="ps-3">
                            <a
                              href="#"
                              style={{
                                color: "#606060",
                                display: "block",
                                textTransform: "uppercase",
                                textDecoration: "none",
                              }}
                            >
                              {t.nombre}
                            </a>
                            <a
                              href={`mailto:${t.email}`}
                              style={{
                                color: "#606060",
                                textDecoration: "none",
                                fontSize: ".85rem",
                                fontWeight: "600",
                              }}
                            >
                              {t.email}
                            </a>
                          </td>
                          <td align="center">
                            <div
                              className={
                                t.status == "2"
                                  ? "ws_tag_primary"
                                  : "ws_tag_secundary"
                              }
                            >
                              {t.status == "2" ? "NOTIFICADO" : "SIN NOTIFICAR"}
                            </div>
                          </td>
                          {/* <td align="center"><IconEmailActive width={'35px'} height={'35px'} /></td> */}
                        </tr>
                      );
                    }
                  })
                ) : (
                  <tr>
                    <td colSpan={3} className="text-center">
                      <p className="mb-0">No hay datos disponibles</p>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </Container>
        <Modal show={show} onHide={handleClose} backdrop="static" size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Vista previa de plantilla</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Container>
              <Row>
                <Col
                  xs={12}
                  className="d-flex flex-column text-center justify-content-center align-items-center"
                >
                  <Image
                    src={"img/te_extranamos/preview_1_teextranamos.png"}
                    style={{ width: "300px" }}
                  />
                  <Image
                    src={"img/te_extranamos/preview_2_teextranamos.png"}
                    style={{ width: "300px" }}
                  />
                  <Image
                    src={"img/te_extranamos/preview_3_teextranamos.png"}
                    style={{ width: "300px" }}
                  />
                  <Image
                    src={"img/te_extranamos/preview_4_teextranamos.png"}
                    style={{ width: "300px" }}
                  />
                </Col>
              </Row>
            </Container>
          </Modal.Body>
          {/* <Modal.Footer>
              <Button variant="primary" className="ws_btn_secundary" onClick={handleClose}>
                Crear Grupo
              </Button>
            </Modal.Footer> */}
        </Modal>
      </div>
    </Col>
  );

  function sendEmailsInsigniaInactividadMensual() {
    // setLoad(true);
    if (dataToSend.length > 0) {
      setSendReport(true);
      fetch(
        `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=sendEmailsInsigniaInactividadMensual`,
        {
          method: "POST",
          mode: "cors",
          body: JSON.stringify({
            id_login: usuario.id_usuario,
            array_insignias: dataToSend,
          }),
        }
      )
        .then((res) => res.json())
        .then((res) => {
          if (res.status == "ok") {
            alert(
              `Se han enviado correctamente ${dataToSend.length} correo(s)`
            );
          }
          setSendReport(false);
        });
    } else {
      alert("Selecciona un usuario para enviar el reporte");
    }
  }
}

function TablaBonosEscalones({
  bonos = [],
  state,
  updateState,
  dataSelected,
  year,
  setYear,
  month,
  setMonth,
  load,
  setLoad,
  data,
  setData,
  selectOficina,
  sendReport,
  setSendReport,
}) {
  const { usuario } = useContext(AuthContext);

  const currentYear = new Date().getFullYear();
  const [search, setSearch] = useState("");
  const [dataBonos, setDataBonos] = useState(bonos);
  const [dataToSend, setDataToSend] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleChangeInput = (index, value) => {
    let newData = [...data];
    newData[index].checked = value;
    setData(newData);
    if (value) {
      let newDataSend = [
        ...dataToSend,
        data.find((element) => element.idObj === newData[index].idObj),
      ];
      setDataToSend(newDataSend);
    } else {
      let newDataSend = dataToSend.filter(
        (element) => element.idObj != newData[index].idObj
      );
      setDataToSend(newDataSend);
    }
  };

  const handleChangeInputAll = () => {
    setSelectAll(!selectAll);
    let newData = data.map((obj) => ({ ...obj, checked: !selectAll }));
    setData(newData);
  };

  useEffect(() => {
    if (selectAll === false) {
      setDataToSend([]);
    } else {
      let newDataSend = data.filter(
        (element) => element.email != "" && element.subscribe === 1
      );
      setDataToSend(newDataSend);
    }
  }, [selectAll]);

  useEffect(() => {
    setDataToSend([]);
    setSelectAll(false);
  }, [selectOficina]);

  if (load) {
    return (
      <Col xs={12} md={12} className="mb-3">
        <div
          className="ws_box"
          style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
        >
          <Container fluid>
            <div className="ws_box_header mb-3">
              <div className="d-flex justify-content-start align-items-end">
                <div>
                  <h2 className="ws_table_agente_title pb-0 mb-2">
                    Escalones de bono{" "}
                    <span className="ws_table_agente_number">
                      <a href="#" style={{ color: "#0ca1b4" }}>
                        0
                      </a>
                    </span>
                  </h2>
                </div>
              </div>
            </div>
            <Skeleton width="100%" height={400} />
          </Container>
        </div>
      </Col>
    );
  }

  return (
    <Col xs={12} md={12} className="mb-3">
      <div
        className="ws_box"
        style={{
          paddingTop: "1rem",
          paddingBottom: "1rem",
          position: "relative",
        }}
      >
        <div
          style={{
            borderRadius: "6px",
            position: "absolute",
            backgroundColor: "rgba(0,0,0,0.6)",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            color: "#fff",
            display: sendReport ? "flex" : "none",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <h3>Enviando correo(s)...</h3>
        </div>
        <Container fluid>
          <div className="ws_box_header mb-3">
            <div className="d-flex justify-content-start ali align-items-start">
              <div>
                <h2 className="ws_table_agente_title pb-0 mb-2">
                  Escalones de bono{" "}
                  <span className="ws_table_agente_number">
                    <a href="#" style={{ color: "#0ca1b4" }}>
                      {data && data.length > 0 ? data.length : "0"}
                    </a>
                  </span>
                </h2>
                <div className="d-flex justify-content-center align-items-center">
                  <DatePickerW
                    onChange={(e) => {
                      setYear(e.target.value);
                      setLoad(true);
                      setDataToSend([]);
                    }}
                    year={currentYear}
                    selected={year}
                  />
                  <DatePickerMonthW
                    className="ms-2"
                    onChange={(e) => {
                      setMonth(e.target.value);
                      setDataToSend([]);
                    }}
                    selected={month}
                  />
                </div>
              </div>
            </div>
            <div className="d-flex flex-column justify-content-between align-items-end">
              <div className="d-flex flex-row justify-content-between align-self-center align-items-center">
                <Form>
                  <Form.Control
                    type="search"
                    placeholder="Buscar"
                    className="ws_input"
                    onChange={(e) => {
                      setSearch(e.target.value);
                    }}
                  />
                </Form>
                {/* <Dropdown className="ws_dropdown">
                  <Dropdown.Toggle id="dropdown-basic">
                    <Image src={'img/darkOpt.svg'} alt="icon_opt" className="ws_icon ms-2" />
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item href="#">Quitar del dashboard</Dropdown.Item>
                    <Dropdown.Item href="#">Duplicar</Dropdown.Item>
                    <Dropdown.Item href="#">Ocultar en móvil</Dropdown.Item>
                    <Dropdown.Item href="#">Exportar</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown> */}
              </div>
            </div>
          </div>
          <Button
            className="mb-3 ws_btn_secundary"
            style={{ borderRadius: "5px" }}
            onClick={() => {
              sendEmailsEscalonBonos();
            }}
          >
            Enviar
          </Button>
          <Button
            className="mb-3 ws_btn_primary ms-3"
            style={{ borderRadius: "5px" }}
            onClick={() => {
              setShow(true);
            }}
          >
            Ver plantilla
          </Button>
          <div className="table-responsive" style={{ maxHeight: 450 }}>
            <Table
              striped
              bordered
              hover
              size="sm"
              responsive
              className="ws_tabla"
            >
              <thead
                style={{
                  backgroundColor: "#0a93af",
                  color: "#fff",
                  fontSize: ".9rem",
                }}
              >
                <tr>
                  <th
                    style={{ width: "5%" }}
                    className="text-center align-content-center"
                  >
                    <Form.Group controlId="frmcheckEmailAll">
                      <Form.Check
                        type="checkbox"
                        label=""
                        onChange={() => {
                          handleChangeInputAll();
                        }}
                      />
                    </Form.Group>
                  </th>
                  <th align="left" className="ps-3" style={{ width: "25%" }}>
                    AGENTE
                  </th>
                  <th
                    align="left"
                    className="ps-3 text-center"
                    style={{ width: "15%" }}
                  >
                    ESCALON ACTUAL
                  </th>
                  <th className="text-center" style={{ width: "15%" }}>
                    PRIMA SIG. ESCALON
                  </th>
                  {/* <th className="text-center">EMAIL</th> */}
                  {/* <th className="text-center">TIPO</th>
                  <th className="text-center">OFICINA</th> */}
                  <th className="text-center" style={{ width: "10%" }}>
                    ESTADO
                  </th>
                  {/* <th className="text-center" style={{ width: '10%' }}>ENVIAR</th> */}
                </tr>
              </thead>
              <tbody style={{ fontSize: ".9rem" }}>
                {data && data.length > 0 ? (
                  data.map((t, e) => {
                    if (
                      search === "" ||
                      (t.nombre &&
                        t.nombre.toLowerCase().indexOf(search.toLowerCase()) !==
                          -1) ||
                      (t.email &&
                        t.email.toLowerCase().indexOf(search.toLowerCase()) !==
                          -1)
                    ) {
                      return (
                        <tr key={e}>
                          <td className="text-center">
                            {t.email != "" && t.suscribe != 0 ? (
                              <Form.Group
                                className="mb-3"
                                controlId="frmcheckEmail"
                              >
                                <Form.Check
                                  type="checkbox"
                                  label=""
                                  onChange={() => {
                                    handleChangeInput(e, !t.checked);
                                  }}
                                  checked={t.checked}
                                />
                              </Form.Group>
                            ) : null}
                          </td>
                          <td className="ps-3">
                            <a
                              href="#"
                              style={{
                                color: "#606060",
                                display: "block",
                                textTransform: "uppercase",
                                textDecoration: "none",
                              }}
                            >
                              {t.nombre}
                            </a>
                            <a
                              href={`mailto:${t.email}`}
                              style={{
                                color: "#606060",
                                textDecoration: "none",
                                fontSize: ".85rem",
                                fontWeight: "600",
                              }}
                            >
                              {t.email}
                            </a>
                          </td>
                          <td className="text-center">
                            <p className="mb-0">{t.escalon}</p>
                          </td>
                          <td className="ps-3">
                            <p className="mb-0">
                              ${number_format(t.siguiente, 2)}
                            </p>
                            <p className="mb-0">*cálculo aproximado</p>
                          </td>
                          <td align="center">
                            <div
                              className={
                                t.status == "2"
                                  ? "ws_tag_primary"
                                  : "ws_tag_secundary"
                              }
                            >
                              {t.status == "2" ? "NOTIFICADO" : "SIN NOTIFICAR"}
                            </div>
                          </td>
                          {/* <td align="center"><IconEmailActive width={'35px'} height={'35px'} /></td> */}
                        </tr>
                      );
                    }
                  })
                ) : (
                  <tr>
                    <td colSpan={5} className="text-center">
                      <p className="mb-0">No hay datos disponibles</p>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </Container>
        <Modal show={show} onHide={handleClose} backdrop="static" size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Vista previa de plantilla</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Container>
              <Row>
                <Col
                  xs={12}
                  className="d-flex flex-column text-center justify-content-center align-items-center"
                >
                  <Image
                    src={"img/escalones/preview_1_escalon.png"}
                    style={{ width: "300px" }}
                  />
                  <Image
                    src={"img/escalones/preview_2_escalon.png"}
                    style={{ width: "300px" }}
                  />
                  <Image
                    src={"img/escalones/preview_3_escalon.png"}
                    style={{ width: "300px" }}
                  />
                  <Image
                    src={"img/escalones/preview_4_escalon.png"}
                    style={{ width: "300px" }}
                  />
                </Col>
              </Row>
            </Container>
          </Modal.Body>
          {/* <Modal.Footer>
              <Button variant="primary" className="ws_btn_secundary" onClick={handleClose}>
                Crear Grupo
              </Button>
            </Modal.Footer> */}
        </Modal>
      </div>
    </Col>
  );

  function sendEmailsEscalonBonos() {
    // setLoad(true);
    if (dataToSend.length > 0) {
      setSendReport(true);
      fetch(
        `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=sendEmailsEscalonBonos`,
        {
          method: "POST",
          mode: "cors",
          body: JSON.stringify({
            id_login: usuario.id_usuario,
            array_insignias: dataToSend,
          }),
        }
      )
        .then((res) => res.json())
        .then((res) => {
          if (res.status == "ok") {
            alert(
              `Se han enviado correctamente ${dataToSend.length} correo(s)`
            );
          }
          setSendReport(false);
        });
    } else {
      alert("Selecciona un usuario para enviar el reporte");
    }
  }
}

function TablaBonosPago({
  bonos = [],
  state,
  updateState,
  dataSelected,
  year,
  setYear,
  month,
  setMonth,
  load,
  setLoad,
  data,
  setData,
  selectOficina,
  sendReport,
  setSendReport,
}) {
  const { usuario } = useContext(AuthContext);

  const currentYear = new Date().getFullYear();
  const [search, setSearch] = useState("");
  const [dataBonos, setDataBonos] = useState(bonos);
  const [dataToSend, setDataToSend] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleChangeInput = (index, value) => {
    let newData = [...data];
    newData[index].checked = value;
    setData(newData);
    if (value) {
      let newDataSend = [
        ...dataToSend,
        data.find((element) => element.idObj === newData[index].idObj),
      ];
      setDataToSend(newDataSend);
    } else {
      let newDataSend = dataToSend.filter(
        (element) => element.idObj != newData[index].idObj
      );
      setDataToSend(newDataSend);
    }
  };

  const handleChangeInputAll = () => {
    setSelectAll(!selectAll);
    let newData = data.map((obj) => ({ ...obj, checked: !selectAll }));
    setData(newData);
  };

  useEffect(() => {
    if (selectAll === false) {
      setDataToSend([]);
    } else {
      let newDataSend = data.filter(
        (element) => element.email != "" && element.subscribe === 1
      );
      setDataToSend(newDataSend);
    }
  }, [selectAll]);

  useEffect(() => {
    setDataToSend([]);
    setSelectAll(false);
  }, [selectOficina]);

  if (load) {
    return (
      <Col xs={12} md={12} className="mb-3">
        <div
          className="ws_box"
          style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
        >
          <Container fluid>
            <div className="ws_box_header mb-3">
              <div className="d-flex justify-content-start align-items-end">
                <div>
                  <h2 className="ws_table_agente_title pb-0 mb-2">
                    Pago de bonos{" "}
                    <span className="ws_table_agente_number">
                      <a href="#" style={{ color: "#0ca1b4" }}>
                        0
                      </a>
                    </span>
                  </h2>
                </div>
              </div>
            </div>
            <Skeleton width="100%" height={400} />
          </Container>
        </div>
      </Col>
    );
  }

  return (
    <Col xs={12} md={12} className="mb-3">
      <div
        className="ws_box"
        style={{
          paddingTop: "1rem",
          paddingBottom: "1rem",
          position: "relative",
        }}
      >
        <div
          style={{
            borderRadius: "6px",
            position: "absolute",
            backgroundColor: "rgba(0,0,0,0.6)",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            color: "#fff",
            display: sendReport ? "flex" : "none",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <h3>Enviando correo(s)...</h3>
        </div>
        <Container fluid>
          <div className="ws_box_header mb-3">
            <div className="d-flex justify-content-start ali align-items-start">
              <div>
                <h2 className="ws_table_agente_title pb-0 mb-2">
                  Pago de bonos{" "}
                  <span className="ws_table_agente_number">
                    <a href="#" style={{ color: "#0ca1b4" }}>
                      {data && data.length > 0 ? data.length : "0"}
                    </a>
                  </span>
                </h2>
                <div className="d-flex justify-content-center align-items-center">
                  <DatePickerW
                    onChange={(e) => {
                      setYear(e.target.value);
                      setLoad(true);
                      setDataToSend([]);
                    }}
                    year={currentYear}
                    selected={year}
                  />
                  <DatePickerMonthW
                    className="ms-2"
                    onChange={(e) => {
                      setMonth(e.target.value);
                      setDataToSend([]);
                    }}
                    selected={month}
                  />
                </div>
              </div>
            </div>
            <div className="d-flex flex-column justify-content-between align-items-end">
              <div className="d-flex flex-row justify-content-between align-self-center align-items-center">
                <Form>
                  <Form.Control
                    type="search"
                    placeholder="Buscar"
                    className="ws_input"
                    onChange={(e) => {
                      setSearch(e.target.value);
                    }}
                  />
                </Form>
                {/* <Dropdown className="ws_dropdown">
                  <Dropdown.Toggle id="dropdown-basic">
                    <Image src={'img/darkOpt.svg'} alt="icon_opt" className="ws_icon ms-2" />
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item href="#">Quitar del dashboard</Dropdown.Item>
                    <Dropdown.Item href="#">Duplicar</Dropdown.Item>
                    <Dropdown.Item href="#">Ocultar en móvil</Dropdown.Item>
                    <Dropdown.Item href="#">Exportar</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown> */}
              </div>
            </div>
          </div>
          <Button
            className="mb-3 ws_btn_secundary"
            style={{ borderRadius: "5px" }}
            onClick={() => {
              sendEmailsPagoBonos();
            }}
          >
            Enviar
          </Button>
          <Button
            className="mb-3 ws_btn_primary ms-3"
            style={{ borderRadius: "5px" }}
            onClick={() => {
              setShow(true);
            }}
          >
            Ver plantilla
          </Button>
          <div className="table-responsive" style={{ maxHeight: 450 }}>
            <Table striped bordered hover size="sm" className="ws_tabla">
              <thead
                style={{
                  backgroundColor: "#0a93af",
                  color: "#fff",
                  fontSize: ".9rem",
                }}
              >
                <tr>
                  <th
                    style={{ width: "5%" }}
                    className="text-center align-content-center"
                  >
                    <Form.Group controlId="frmcheckEmailAll">
                      <Form.Check
                        type="checkbox"
                        label=""
                        onChange={() => {
                          handleChangeInputAll();
                        }}
                      />
                    </Form.Group>
                  </th>
                  <th align="left" className="ps-3" style={{ width: "25%" }}>
                    AGENTE
                  </th>
                  <th
                    align="left"
                    className="ps-3 text-center"
                    style={{ width: "15%" }}
                  >
                    CLAVE
                  </th>
                  <th className="text-center" style={{ width: "15%" }}>
                    % BONO
                  </th>
                  {/* <th className="text-center">EMAIL</th> */}
                  {/* <th className="text-center">TIPO</th>
                  <th className="text-center">OFICINA</th> */}
                  <th className="text-center" style={{ width: "10%" }}>
                    IMPORTE A PAGAR
                  </th>
                  <th className="text-center" style={{ width: "10%" }}>
                    ESTADO
                  </th>
                  {/* <th className="text-center" style={{ width: '10%' }}>ENVIAR</th> */}
                </tr>
              </thead>
              <tbody style={{ fontSize: ".9rem" }}>
                {data && data.length > 0 ? (
                  data.map((t, e) => {
                    if (
                      search === "" ||
                      (t.nombre &&
                        t.nombre.toLowerCase().indexOf(search.toLowerCase()) !==
                          -1) ||
                      (t.email &&
                        t.email.toLowerCase().indexOf(search.toLowerCase()) !==
                          -1)
                    ) {
                      return (
                        <tr key={e}>
                          <td className="text-center">
                            {t.email != "" && t.suscribe != 0 ? (
                              <Form.Group
                                className="mb-3"
                                controlId="frmcheckEmail"
                              >
                                <Form.Check
                                  type="checkbox"
                                  label=""
                                  onChange={() => {
                                    handleChangeInput(e, !t.checked);
                                  }}
                                  checked={t.checked}
                                />
                              </Form.Group>
                            ) : null}
                          </td>
                          <td className="ps-3">
                            <a
                              href="#"
                              style={{
                                color: "#606060",
                                display: "block",
                                textTransform: "uppercase",
                                textDecoration: "none",
                              }}
                            >
                              {t.nombre}
                            </a>
                            <a
                              href={`mailto:${t.email}`}
                              style={{
                                color: "#606060",
                                textDecoration: "none",
                                fontSize: ".85rem",
                                fontWeight: "600",
                              }}
                            >
                              {t.email}
                            </a>
                          </td>
                          <td align="center">
                            <p className="mb-0">{t.clave}</p>
                          </td>
                          <td className="ps-3">
                            <p className="mb-0">{t.bono}%</p>
                          </td>
                          <td className="ps-3">
                            <p className="mb-0">
                              ${number_format(t.neto_a_pagar, 2)}
                            </p>
                          </td>
                          <td align="center">
                            <div
                              className={
                                t.status == "2"
                                  ? "ws_tag_primary"
                                  : "ws_tag_secundary"
                              }
                            >
                              {t.status == "2" ? "NOTIFICADO" : "SIN NOTIFICAR"}
                            </div>
                          </td>
                          {/* <td align="center"><IconEmailActive width={'35px'} height={'35px'} /></td> */}
                        </tr>
                      );
                    }
                  })
                ) : (
                  <tr>
                    <td colSpan={6} className="text-center">
                      <p className="mb-0">No hay datos disponibles</p>
                    </td>
                  </tr>
                )}

                {/* <tr>
                  <td className='ps-3'>
                    <a href="#" style={{ color: "#606060", display: 'block', textTransform: 'uppercase' }}>DANIEL ENRIQUEZ AGUILAR</a>
                    <a href="mailto:denriqua1@hotmail.com" style={{ color: '#606060', textDecoration: 'none', fontSize: '.85rem', fontWeight: '600' }}>denriqua1@hotmail.com</a>
                  </td>
                  <td align="center"><p className="mb-0">5654</p></td>
                  <td align="center"><p className="mb-0">18569.36%</p></td>
                  <td align="center"><p className="mb-0">$7,837.69</p></td>
                  <td align="left"><IconStar width={'30px'} height={'30px'} /><IconStar width={'30px'} height={'30px'} /><IconStar width={'30px'} height={'30px'} /></td>
                  <td align="center"><div className="ws_tag_primary">NOTFICADO</div></td>
                  <td align="center"><IconEmailActive width={'35px'} height={'35px'} /></td>
                </tr> */}
              </tbody>
            </Table>
          </div>
        </Container>
        <Modal show={show} onHide={handleClose} backdrop="static" size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Vista previa de plantilla</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Container>
              <Row>
                <Col
                  xs={12}
                  className="d-flex flex-column text-center justify-content-center align-items-center"
                >
                  <Image
                    src={"img/bonos/preview_1_pagobonos.png"}
                    style={{ width: "300px" }}
                  />
                  <Image
                    src={"img/bonos/preview_2_pagobonos.png"}
                    style={{ width: "300px" }}
                  />
                  <Image
                    src={"img/bonos/preview_3_pagobonos.png"}
                    style={{ width: "300px" }}
                  />
                  <Image
                    src={"img/bonos/preview_4_pagobonos.png"}
                    style={{ width: "300px" }}
                  />
                </Col>
              </Row>
            </Container>
          </Modal.Body>
          {/* <Modal.Footer>
              <Button variant="primary" className="ws_btn_secundary" onClick={handleClose}>
                Crear Grupo
              </Button>
            </Modal.Footer> */}
        </Modal>
      </div>
    </Col>
  );

  function sendEmailsPagoBonos() {
    // setLoad(true);
    if (dataToSend.length > 0) {
      setSendReport(true);
      fetch(
        `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=sendEmailsPagoBonos`,
        {
          method: "POST",
          mode: "cors",
          body: JSON.stringify({
            id_login: usuario.id_usuario,
            array_insignias: dataToSend,
          }),
        }
      )
        .then((res) => res.json())
        .then((res) => {
          if (res.status == "ok") {
            alert(
              `Se han enviado correctamente ${dataToSend.length} correo(s)`
            );
          }
          setSendReport(false);
        });
    } else {
      alert("Selecciona un usuario para enviar el reporte");
    }
  }
}

function TablaBonosReporteMensual({
  bonos = [],
  state,
  updateState,
  dataSelected,
  year,
  setYear,
  month,
  setMonth,
  load,
  setLoad,
  data,
  claveOficina,
  nombreOficina,
  setData,
  selectOficina,
  sendReport,
  setSendReport,
}) {
  const { usuario } = useContext(AuthContext);

  const currentYear = new Date().getFullYear();
  const [search, setSearch] = useState("");
  const [dataBonos, setDataBonos] = useState(bonos);
  const [dataToSend, setDataToSend] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleChangeInput = (index, value) => {
    let newData = [...data];
    newData[index].checked = value;
    setData(newData);
    if (value) {
      let newDataSend = [
        ...dataToSend,
        data.find((element) => element.idObj === newData[index].idObj),
      ];
      setDataToSend(newDataSend);
    } else {
      let newDataSend = dataToSend.filter(
        (element) => element.idObj != newData[index].idObj
      );
      setDataToSend(newDataSend);
    }
  };

  const handleChangeInputAll = () => {
    setSelectAll(!selectAll);
    let newData = data.map((obj) => ({ ...obj, checked: !selectAll }));
    setData(newData);
  };

  useEffect(() => {
    if (selectAll === false) {
      setDataToSend([]);
    } else {
      let newDataSend = data.filter(
        (element) => element.email != "" && element.subscribe === 1
      );
      setDataToSend(newDataSend);
    }
  }, [selectAll]);

  useEffect(() => {
    setDataToSend([]);
    setSelectAll(false);
  }, [selectOficina]);

  if (load) {
    return (
      <Col xs={12} md={12} className="mb-3">
        <div
          className="ws_box"
          style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
        >
          <Container fluid>
            <div className="ws_box_header mb-3">
              <div className="d-flex justify-content-start align-items-end">
                <div>
                  <h2 className="ws_table_agente_title pb-0 mb-2">
                    Reporte mensual{" "}
                    <span className="ws_table_agente_number">
                      <a href="#" style={{ color: "#0ca1b4" }}>
                        0
                      </a>
                    </span>
                  </h2>
                </div>
              </div>
            </div>
            <Skeleton width="100%" height={400} />
          </Container>
        </div>
      </Col>
    );
  }

  return (
    <Col xs={12} md={12} className="mb-3">
      <div
        className="ws_box"
        style={{
          paddingTop: "1rem",
          paddingBottom: "1rem",
          position: "relative",
        }}
      >
        <div
          style={{
            borderRadius: "6px",
            position: "absolute",
            backgroundColor: "rgba(0,0,0,0.6)",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            color: "#fff",
            display: sendReport ? "flex" : "none",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <h3>Enviando correo(s)...</h3>
        </div>
        <Container fluid>
          <div className="ws_box_header mb-3">
            <div className="d-flex justify-content-start ali align-items-start">
              <div>
                <h2 className="ws_table_agente_title pb-0 mb-2">
                  Reporte mensual{" "}
                  <span className="ws_table_agente_number">
                    <a href="#" style={{ color: "#0ca1b4" }}>
                      {data && data.length > 0 ? data.length : "0"}
                    </a>
                  </span>
                </h2>
                <div className="d-flex justify-content-center align-items-center">
                  <DatePickerW
                    onChange={(e) => {
                      setYear(e.target.value);
                      setLoad(true);
                      setDataToSend([]);
                    }}
                    year={currentYear}
                    selected={year}
                  />
                  <DatePickerMonthW
                    className="ms-2"
                    onChange={(e) => {
                      setMonth(e.target.value);
                      setDataToSend([]);
                    }}
                    selected={month}
                  />
                </div>
              </div>
            </div>
            <div className="d-flex flex-column justify-content-between align-items-end">
              <div className="d-flex flex-row justify-content-between align-self-center align-items-center">
                <Form>
                  <Form.Control
                    type="search"
                    placeholder="Buscar"
                    className="ws_input"
                    onChange={(e) => {
                      setSearch(e.target.value);
                    }}
                  />
                </Form>
                {/* <Dropdown className="ws_dropdown">
                  <Dropdown.Toggle id="dropdown-basic">
                    <Image src={'img/darkOpt.svg'} alt="icon_opt" className="ws_icon ms-2" />
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item href="#">Quitar del dashboard</Dropdown.Item>
                    <Dropdown.Item href="#">Duplicar</Dropdown.Item>
                    <Dropdown.Item href="#">Ocultar en móvil</Dropdown.Item>
                    <Dropdown.Item href="#">Exportar</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown> */}
              </div>
            </div>
          </div>
          <Button
            className="mb-3 ws_btn_secundary"
            style={{ borderRadius: "5px" }}
            onClick={() => {
              sendEmailsCierreMensual();
            }}
          >
            Enviar
          </Button>
          <Button
            className="mb-3 ws_btn_primary ms-3"
            style={{ borderRadius: "5px" }}
            onClick={() => {
              setShow(true);
            }}
          >
            Ver plantilla
          </Button>
          <div className="table-responsive" style={{ maxHeight: 450 }}>
            <Table striped bordered hover size="sm" className="ws_tabla">
              <thead
                style={{
                  backgroundColor: "#0a93af",
                  color: "#fff",
                  fontSize: ".9rem",
                }}
              >
                <tr>
                  <th
                    style={{ width: "5%" }}
                    className="text-center align-content-center"
                  >
                    <Form.Group controlId="frmcheckEmailAll">
                      <Form.Check
                        type="checkbox"
                        label=""
                        onChange={() => {
                          handleChangeInputAll();
                        }}
                      />
                    </Form.Group>
                  </th>
                  <th align="left" className="ps-3">
                    AGENTE
                  </th>
                  <th align="left" className="ps-3 text-center">
                    OFICINA
                  </th>
                  <th className="text-center">TIPO DE AGENTE</th>
                </tr>
              </thead>
              <tbody style={{ fontSize: ".9rem" }}>
                {data && data.length > 0 ? (
                  data.map((t, e) => {
                    if (
                      search === "" ||
                      (t.nombre &&
                        t.nombre.toLowerCase().indexOf(search.toLowerCase()) !==
                          -1) ||
                      (t.email &&
                        t.email.toLowerCase().indexOf(search.toLowerCase()) !==
                          -1)
                    ) {
                      return (
                        <tr key={e}>
                          <td className="text-center">
                            {t.email != "" && t.suscribe != 0 ? (
                              <Form.Group
                                className="mb-3"
                                controlId="frmcheckEmail"
                              >
                                <Form.Check
                                  type="checkbox"
                                  label=""
                                  onChange={() => {
                                    handleChangeInput(e, !t.checked);
                                  }}
                                  checked={t.checked}
                                />
                              </Form.Group>
                            ) : null}
                          </td>
                          <td className="ps-3">
                            <a
                              href="#"
                              style={{
                                color: "#606060",
                                display: "block",
                                textTransform: "uppercase",
                                textDecoration: "none",
                              }}
                            >
                              {t.nombre}
                            </a>
                            <a
                              href={`mailto:${t.email}`}
                              style={{
                                color: "#606060",
                                textDecoration: "none",
                                fontSize: ".85rem",
                                fontWeight: "600",
                              }}
                            >
                              {t.email}
                            </a>
                          </td>
                          <td className="text-center">
                            <p className="mb-0">{`${nombreOficina}(${claveOficina})`}</p>
                          </td>
                          <td className="ps-3">
                            <p
                              className="mb-0"
                              style={{ textTransform: "uppercase" }}
                            >
                              {t.tipo_agente_text}
                            </p>
                          </td>
                        </tr>
                      );
                    }
                  })
                ) : (
                  <tr>
                    <td colSpan={7} className="text-center">
                      <p className="mb-0">No hay datos disponibles</p>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </Container>
        <Modal show={show} onHide={handleClose} backdrop="static" size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Vista previa de plantilla</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Container>
              <Row>
                <Col
                  xs={12}
                  className="d-flex flex-column text-center justify-content-center align-items-center"
                >
                  <Image
                    src={"img/resumen_mensual/preview_1_cierremensual.png"}
                    style={{ width: "300px" }}
                  />
                  <Image
                    src={"img/resumen_mensual/preview_2_cierremensual.png"}
                    style={{ width: "300px" }}
                  />
                  <Image
                    src={"img/resumen_mensual/preview_3_cierremensual.png"}
                    style={{ width: "300px" }}
                  />
                  <Image
                    src={"img/resumen_mensual/preview_4_cierremensual.png"}
                    style={{ width: "300px" }}
                  />
                </Col>
              </Row>
            </Container>
          </Modal.Body>
          {/* <Modal.Footer>
              <Button variant="primary" className="ws_btn_secundary" onClick={handleClose}>
                Crear Grupo
              </Button>
            </Modal.Footer> */}
        </Modal>
      </div>
    </Col>
  );

  function sendEmailsCierreMensual() {
    // setLoad(true);
    if (dataToSend.length > 0) {
      setSendReport(true);
      fetch(
        `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=sendEmailsCierreMensual`,
        {
          method: "POST",
          mode: "cors",
          body: JSON.stringify({
            id_login: usuario.id_usuario,
            array_insignias: dataToSend,
          }),
        }
      )
        .then((res) => res.json())
        .then((res) => {
          if (res.status == "ok") {
            alert(
              `Se han enviado correctamente ${dataToSend.length} correo(s)`
            );
          }
          setSendReport(false);
        });
    } else {
      alert("Selecciona un usuario para enviar el reporte");
    }
  }
}

function TablaPromotorias({
  state,
  updateState,
  data,
  load,
  setLoad,
  year,
  setYear,
}) {
  const currentYear = new Date().getFullYear();
  const currentMonth = moment().format("MMMM");

  const [valueSwitch, setValueSwitch] = useState(true);
  const [search, setSearch] = useState("");
  const [mode, setMode] = useState(false);
  const [month, setMonth] = useState(moment().month(currentMonth).format("M"));
  const [searchModal, setSearchModal] = useState("");
  const [nombre, setNombre] = useState("");
  const [dataGrupos, setDataGrupos] = useState([]);
  const beforeYearBySelect = new Date(
    new Date().setFullYear(year - 1)
  ).getFullYear();

  const { list = [] } = dataGrupos;

  const [select, setSelect] = useState({
    oficinas: "0",
    agentes: "0",
    tipos: "0",
  });

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    setDataGrupos(data);
  }, [data]);

  if (load) {
    return (
      <Col xs={12} md={12} className="mb-3">
        <div
          className="ws_box"
          style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
        >
          <Container fluid>
            <div className="ws_box_header mb-3">
              <div className="d-flex justify-content-start align-items-end">
                <div>
                  <h2 className="ws_table_agente_title pb-0 mb-2">
                    Promotorías{" "}
                    <span className="ws_table_agente_number">
                      {list.length}
                    </span>
                  </h2>
                </div>
              </div>
            </div>
            <Skeleton width="100%" height={400} />
          </Container>
        </div>
      </Col>
    );
  }

  return (
    <Col xs={12} md={12} className="mb-3">
      <div
        className="ws_box"
        style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
      >
        <Container fluid>
          <div className="ws_box_header mb-3">
            <div className="d-flex justify-content-start align-items-end">
              <div>
                <h2 className="ws_table_agente_title pb-0 mb-2">
                  Promotorías{" "}
                  <span className="ws_table_agente_number">{list.length}</span>
                </h2>
                <div className="d-flex justify-content-center align-items-center">
                  <DatePickerW
                    onChange={(e) => {
                      setYear(e.target.value);
                    }}
                    year={currentYear}
                    selected={year}
                  />
                  {!mode ? (
                    <DatePickerMonthW
                      className="ms-2"
                      onChange={(e) => {
                        setMonth(e.target.value);
                      }}
                      selected={month}
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
              {mode ? (
                <SwitchComponentProd
                  className="ms-3 mb-2"
                  isOn={valueSwitch}
                  handleToggle={(e) => {
                    setValueSwitch(!valueSwitch);
                  }}
                />
              ) : (
                ""
              )}
            </div>
            <div className="d-flex flex-column justify-content-between align-items-end">
              <div className="d-flex flex-row justify-content-between align-self-center align-items-center">
                <Form>
                  <Form.Control
                    type="search"
                    placeholder="Buscar"
                    className="ws_input"
                    onChange={(e) => {
                      setSearch(e.target.value);
                    }}
                  />
                </Form>
                {/* <Dropdown className="ws_dropdown">
                  <Dropdown.Toggle id="dropdown-basic">
                    <Image src={'img/darkOpt.svg'} alt="icon_opt" className="ws_icon ms-2" />
                  </Dropdown.Toggle>
                  <Dropdown.Menu align="end">
                    <Dropdown.Item href="#">Quitar del dashboard</Dropdown.Item>
                    <Dropdown.Item href="#">Duplicar</Dropdown.Item>
                    <Dropdown.Item href="#">Ocultar en móvil</Dropdown.Item>
                    <Dropdown.Item href="#">Exportar</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown> */}
              </div>
              <div className="align-items-center">
                {/* <Button className="mt-3 me-2 ws_btn_secundary_transparent btn-sm" onClick={handleShow}><IconPlus width="30px" height="30px" /> Agregar Promotoría</Button> */}
                <Button
                  className="mt-3 btn btn-primary ws_btn_secundary"
                  onClick={(e) => {
                    setMode(!mode);
                  }}
                >
                  {mode ? "Ver Prod / Cobr" : "Ver Crecimiento"}
                </Button>
              </div>
            </div>
          </div>

          {mode ? (
            <Table
              striped
              bordered
              hover
              size="sm"
              responsive
              className="ws_tabla"
            >
              <thead
                style={{
                  backgroundColor: "#0a93af",
                  color: "#fff",
                  fontSize: ".9rem",
                }}
              >
                <tr>
                  <th align="left" className="ps-3">
                    GRUPO
                  </th>
                  <th className="text-center">
                    {dataGrupos.tituloCobAcumYearBefore}
                  </th>
                  <th className="text-center">
                    {dataGrupos.tituloPorcentajeSiniYearBefore}
                  </th>
                  <th className="text-center">
                    {dataGrupos.tituloCobAcumYearMonthBefore}
                  </th>
                  <th className="text-center">
                    {dataGrupos.tituloCobAcumYearMonthCurrent}
                  </th>
                  <th className="text-center">
                    {dataGrupos.tituloCobIncreaseMonth}
                  </th>
                  <th className="text-center">
                    {dataGrupos.tituloCobLast12Months}
                  </th>
                  <th className="text-center">
                    {dataGrupos.tituloCobIncreaseYear}
                  </th>
                  <th className="text-center">
                    {dataGrupos.tituloPorcentajeSiniMonthCurrent}
                  </th>
                  <th className="text-center">
                    {dataGrupos.tituloPorcentajeSinVS1}
                  </th>
                  <th className="text-center">
                    {dataGrupos.tituloPorcentajeSinVS2}
                  </th>
                </tr>
              </thead>
              <tbody style={{ fontSize: ".9rem" }}>
                {list.length > 0 ? (
                  list.map((t, e) => {
                    if (
                      search === "" ||
                      (t.nombre &&
                        t.nombre.toLowerCase().indexOf(search.toLowerCase()) !==
                          -1)
                    ) {
                      return (
                        <tr key={e}>
                          {/* <td align="left" className="ps-3" width="25%">
                                <span className="ws_color_secundario" style={{ fontWeight: '700', marginRight: 10 }}>{oficina.clave_oficina}</span>
                                <span><Link to={`/oficinas/${oficina.clave_oficina}`} style={{ color: "#606060" }}>{oficina.nombre_oficina}</Link></span>
                              </td> */}

                          <td align="left" className="ps-3">
                            <span>
                              <Link
                                to={`/promotorias/${t.promotor}`}
                                style={{ color: "#606060" }}
                              >
                                {t.nombre}
                              </Link>
                            </span>
                          </td>
                          <td className="text-center">
                            $
                            {valueSwitch
                              ? number_format(t.cobAcumYearBefore, 2)
                              : number_format(t.prodAcumYearBefore, 2)}
                          </td>
                          <td className="text-center">
                            {t.porcentajeSiniYearBefore}%
                          </td>
                          <td className="text-center">
                            $
                            {valueSwitch
                              ? number_format(t.cobAcumYearMonthBefore, 2)
                              : number_format(t.prodAcumYearMonthBefore, 2)}
                          </td>
                          <td className="text-center">
                            $
                            {valueSwitch
                              ? number_format(t.cobAcumYearMonthCurrent, 2)
                              : number_format(t.prodAcumYearMonthCurrent, 2)}
                          </td>
                          <td className="text-center">
                            {valueSwitch
                              ? t.cobIncreaseMonth
                              : t.prodIncreaseMonth}
                            %
                          </td>
                          <td className="text-center">
                            $
                            {valueSwitch
                              ? number_format(t.cobLast12Months, 2)
                              : number_format(t.prodLast12Months, 2)}
                          </td>
                          <td className="text-center">
                            {valueSwitch
                              ? t.cobIncreaseYear
                              : t.prodIncreaseYear}
                            %
                          </td>
                          <td className="text-center">
                            {t.porcentajeSiniMonthCurrent}%
                          </td>
                          <td className="text-center">{t.porcentajeSinVS1}%</td>
                          <td className="text-center">{t.porcentajeSinVS2}%</td>
                        </tr>
                      );
                    }
                  })
                ) : (
                  <tr>
                    <td colSpan="11" className="text-center">
                      <p className="mb-0">No hay datos disponibles</p>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          ) : (
            <Table
              striped
              bordered
              hover
              size="sm"
              responsive
              className="ws_tabla"
            >
              <thead
                style={{
                  backgroundColor: "#0a93af",
                  color: "#fff",
                  fontSize: ".9rem",
                }}
              >
                <tr>
                  <th className="text-left ps-3">GRUPO</th>
                  <th className="text-center">Acum Anual {year}</th>
                  <th className="text-center">
                    Prima{" "}
                    {moment()
                      .month(month - 1)
                      .format("MMM")}{" "}
                    {year}
                  </th>
                  <th className="text-center">
                    Prima{" "}
                    {moment()
                      .month(month - 1)
                      .format("MMM")}{" "}
                    {beforeYearBySelect}
                  </th>
                </tr>
              </thead>
              <tbody style={{ fontSize: ".9rem" }}>
                {list.map((t, e) => {
                  if (
                    search === "" ||
                    (t.nombre &&
                      t.nombre.toLowerCase().indexOf(search.toLowerCase()) !==
                        -1)
                  ) {
                    return (
                      <tr key={e}>
                        <td align="left" className="ps-3">
                          <span>
                            <Link
                              to={`/promotorias/${t.promotor}`}
                              style={{ color: "#606060" }}
                            >
                              {t.nombre}
                            </Link>
                          </span>
                        </td>
                        <td className="text-center">
                          ${number_format(t.cobAcumYearCurrent, 2)}
                        </td>
                        <td className="text-center">
                          $
                          {t.months_current.length &&
                            number_format(
                              t.months_current.find(
                                (element) => element.mes == month
                              ).cobranza,
                              2
                            )}
                        </td>
                        <td className="text-center">
                          $
                          {t.months_before.length &&
                            number_format(
                              t.months_before.find(
                                (element) => element.mes == month
                              ).cobranza,
                              2
                            )}
                        </td>
                      </tr>
                    );
                  }
                })}
              </tbody>
            </Table>
          )}

          {/* <Button className="ws_btn_secundary_transparent btn-sm" onClick={handleShow}><IconPlus width="30px" height="30px" /> Agregar Promotoría</Button> */}

          <Modal show={show} onHide={handleClose} backdrop="static" size="lg">
            <Modal.Header closeButton>
              <Modal.Title>Crear Promotoría</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
                <Form.Group className="mb-3">
                  <Form.Label>Nombre</Form.Label>
                  <Form.Control
                    type="text"
                    id="nombre_grupo"
                    name="nombre_grupo"
                    value={nombre}
                    onChange={(e) => setNombre(e.target.value)}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Agregar agentes{" "}
                    <span className="ws_color_primario">13</span>
                  </Form.Label>
                  <div style={{ position: "relative" }}>
                    <Form.Control
                      type="search"
                      id="buscar_agente"
                      name="buscar_agente"
                      value={searchModal}
                      onChange={(e) => setSearchModal(e.target.value)}
                      style={{ paddingLeft: 50 }}
                    />
                    <IconMinSearch
                      width="30px"
                      height="30px"
                      className="ws_icon_search_input"
                    />
                  </div>
                </Form.Group>
                <Form.Group>
                  <Row>
                    <Col xs={4}>
                      <Form.Label className="text-center ws_color_primario d-block">
                        <p style={{ fontSize: "1.2rem" }} className="mb-0">
                          Oficinas
                        </p>
                      </Form.Label>
                      <Form.Select
                        aria-label="Default select example"
                        value={select.oficina}
                        id="oficinas"
                        name="oficinas"
                        onChange={(e) => {
                          setSelect({
                            ...select,
                            [e.target.name]: e.target.value,
                          });
                        }}
                      >
                        {state.data[0].oficinas
                          ? state.data[0].oficinas.map((oficina, index) => (
                              <option value={oficina.clave_oficina} key={index}>
                                {oficina.nombre_oficina}
                              </option>
                            ))
                          : null}
                      </Form.Select>
                    </Col>
                    <Col xs={4}>
                      <Form.Label className="text-center ws_color_primario d-block">
                        <p style={{ fontSize: "1.2rem" }} className="mb-0">
                          Agentes
                        </p>
                      </Form.Label>
                      <Form.Select
                        aria-label="Default select example"
                        value={select.agentes}
                        id="agentes"
                        name="agentes"
                        onChange={(e) => {
                          setSelect({
                            ...select,
                            [e.target.name]: e.target.value,
                          });
                        }}
                      >
                        {state.data[0].agentes
                          ? state.data[0].agentes.map((agente, index) => (
                              <option value={agente.value} key={index}>
                                {agente.name}
                              </option>
                            ))
                          : null}
                      </Form.Select>
                    </Col>
                    <Col xs={4}>
                      <Form.Label className="text-center ws_color_primario d-block">
                        <p style={{ fontSize: "1.2rem" }} className="mb-0">
                          Tipos
                        </p>
                      </Form.Label>
                      <Form.Select
                        aria-label="Default select example"
                        value={select.tipos}
                        id="tipos"
                        name="tipos"
                        onChange={(e) => {
                          setSelect({
                            ...select,
                            [e.target.name]: e.target.value,
                          });
                        }}
                      >
                        {state.data[0].tipos
                          ? state.data[0].tipos.map((tipos, index) => (
                              <option value={tipos.value} key={index}>
                                {tipos.name}
                              </option>
                            ))
                          : null}
                      </Form.Select>
                    </Col>
                  </Row>
                </Form.Group>
              </Form>
              <Table
                striped
                bordered
                hover
                size="sm"
                responsive
                style={{ marginTop: 40 }}
              >
                <thead
                  style={{
                    backgroundColor: "#0a93af",
                    color: "#fff",
                    fontSize: ".9rem",
                  }}
                >
                  <tr>
                    <th
                      width="50%"
                      className="text-center"
                      style={{ padding: 7, fontSize: "1.1rem" }}
                    >
                      Agente
                    </th>
                    <th
                      width="50%"
                      className="text-center"
                      style={{ padding: 7 }}
                    ></th>
                  </tr>
                </thead>
                <tbody style={{ fontSize: ".9rem" }}>
                  <tr>
                    <td align="left">
                      <span
                        className="ws_color_secundario"
                        style={{ fontWeight: "700", marginRight: 10 }}
                      >
                        69
                      </span>
                      <span>
                        <a href="#" style={{ color: "#606060" }}>
                          Marcela Rocha Arredondo
                        </a>
                      </span>
                    </td>
                    <td>
                      <SingleSwitch isOn={true} id={"69"} />
                    </td>
                  </tr>
                  <tr>
                    <td align="left">
                      <span
                        className="ws_color_secundario"
                        style={{ fontWeight: "700", marginRight: 10 }}
                      >
                        68
                      </span>
                      <span>
                        <a href="#" style={{ color: "#606060" }}>
                          Julio Ernesto Silva Gomez
                        </a>
                      </span>
                    </td>
                    <td>
                      <SingleSwitch isOn={true} id={"68"} />
                    </td>
                  </tr>
                  <tr>
                    <td align="left">
                      <span
                        className="ws_color_secundario"
                        style={{ fontWeight: "700", marginRight: 10 }}
                      >
                        67
                      </span>
                      <span>
                        <a href="#" style={{ color: "#606060" }}>
                          Julio Jose de Jesús Yañez Mar
                        </a>
                      </span>
                    </td>
                    <td>
                      <SingleSwitch isOn={false} id={"67"} />
                    </td>
                  </tr>
                  <tr>
                    <td align="left">
                      <span
                        className="ws_color_secundario"
                        style={{ fontWeight: "700", marginRight: 10 }}
                      >
                        66
                      </span>
                      <span>
                        <a href="#" style={{ color: "#606060" }}>
                          Julio Liliana Salazar Rocha
                        </a>
                      </span>
                    </td>
                    <td>
                      <SingleSwitch isOn={true} id={"66"} />
                    </td>
                  </tr>
                  <tr>
                    <td align="left">
                      <span
                        className="ws_color_secundario"
                        style={{ fontWeight: "700", marginRight: 10 }}
                      >
                        65
                      </span>
                      <span>
                        <a href="#" style={{ color: "#606060" }}>
                          Julio Francisco García de la Cruz
                        </a>
                      </span>
                    </td>
                    <td>
                      <SingleSwitch isOn={false} id={"65"} />
                    </td>
                  </tr>
                  <tr>
                    <td align="left">
                      <span
                        className="ws_color_secundario"
                        style={{ fontWeight: "700", marginRight: 10 }}
                      >
                        64
                      </span>
                      <span>
                        <a href="#" style={{ color: "#606060" }}>
                          Julio Emmanuel González González
                        </a>
                      </span>
                    </td>
                    <td>
                      <SingleSwitch isOn={true} id={"64"} />
                    </td>
                  </tr>
                  <tr>
                    <td align="left">
                      <span
                        className="ws_color_secundario"
                        style={{ fontWeight: "700", marginRight: 10 }}
                      >
                        63
                      </span>
                      <span>
                        <a href="#" style={{ color: "#606060" }}>
                          Julio Xochitl Remedios Guerra
                        </a>
                      </span>
                    </td>
                    <td>
                      <SingleSwitch isOn={true} id={"63"} />
                    </td>
                  </tr>
                  <tr>
                    <td align="left">
                      <span
                        className="ws_color_secundario"
                        style={{ fontWeight: "700", marginRight: 10 }}
                      >
                        62
                      </span>
                      <span>
                        <a href="#" style={{ color: "#606060" }}>
                          Julio Marcela Huacuja Rodríguez
                        </a>
                      </span>
                    </td>
                    <td>
                      <SingleSwitch isOn={false} id={"62"} />
                    </td>
                  </tr>
                </tbody>
              </Table>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="primary"
                className="ws_btn_secundary"
                onClick={handleClose}
              >
                Crear Promotoría
              </Button>
            </Modal.Footer>
          </Modal>
        </Container>
      </div>
    </Col>
  );
}

function TablaGrupos({
  state,
  updateState,
  data,
  load,
  setLoad,
  year,
  setYear,
}) {
  const currentYear = new Date().getFullYear();
  const currentMonth = moment().format("MMMM");

  const [valueSwitch, setValueSwitch] = useState(true);
  const [search, setSearch] = useState("");
  const [mode, setMode] = useState(false);
  const [month, setMonth] = useState(moment().month(currentMonth).format("M"));
  const [searchModal, setSearchModal] = useState("");
  const [nombre, setNombre] = useState("");
  const [dataGrupos, setDataGrupos] = useState([]);
  const beforeYearBySelect = new Date(
    new Date().setFullYear(year - 1)
  ).getFullYear();

  const { info_grupos = [] } = dataGrupos;

  const [select, setSelect] = useState({
    oficinas: "0",
    agentes: "0",
    tipos: "0",
  });

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    setDataGrupos(data);
  }, [data]);

  if (load) {
    return (
      <Col xs={12} md={12} className="mb-3">
        <div
          className="ws_box"
          style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
        >
          <Container fluid>
            <div className="ws_box_header mb-3">
              <div className="d-flex justify-content-start align-items-end">
                <div>
                  <h2 className="ws_table_agente_title pb-0 mb-2">
                    Grupos{" "}
                    <span className="ws_table_agente_number">
                      {info_grupos.length}
                    </span>
                  </h2>
                </div>
              </div>
            </div>
            <Skeleton width="100%" height={400} />
          </Container>
        </div>
      </Col>
    );
  }

  return (
    <Col xs={12} md={12} className="mb-3">
      <div
        className="ws_box"
        style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
      >
        <Container fluid>
          <div className="ws_box_header mb-3">
            <div className="d-flex justify-content-start align-items-end">
              <div>
                <h2 className="ws_table_agente_title pb-0 mb-2">
                  Grupos{" "}
                  <span className="ws_table_agente_number">
                    {info_grupos.length}
                  </span>
                </h2>
                <div className="d-flex justify-content-center align-items-center">
                  <DatePickerW
                    onChange={(e) => {
                      setYear(e.target.value);
                    }}
                    year={currentYear}
                    selected={year}
                  />
                  {!mode ? (
                    <DatePickerMonthW
                      className="ms-2"
                      onChange={(e) => {
                        setMonth(e.target.value);
                      }}
                      selected={month}
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
              {mode ? (
                <SwitchComponentProd
                  className="ms-3 mb-2"
                  isOn={valueSwitch}
                  handleToggle={(e) => {
                    setValueSwitch(!valueSwitch);
                  }}
                />
              ) : (
                ""
              )}
            </div>
            <div className="d-flex flex-column justify-content-between align-items-end">
              <div className="d-flex flex-row justify-content-between align-self-center align-items-center">
                <Form>
                  <Form.Control
                    type="search"
                    placeholder="Buscar"
                    className="ws_input"
                    onChange={(e) => {
                      setSearch(e.target.value);
                    }}
                  />
                </Form>
                {/* <Dropdown className="ws_dropdown">
                  <Dropdown.Toggle id="dropdown-basic">
                    <Image src={'img/darkOpt.svg'} alt="icon_opt" className="ws_icon ms-2" />
                  </Dropdown.Toggle>
                  <Dropdown.Menu align="end">
                    <Dropdown.Item href="#">Quitar del dashboard</Dropdown.Item>
                    <Dropdown.Item href="#">Duplicar</Dropdown.Item>
                    <Dropdown.Item href="#">Ocultar en móvil</Dropdown.Item>
                    <Dropdown.Item href="#">Exportar</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown> */}
              </div>
              <div className="align-items-center">
                {/* <Button className="mt-3 me-2 ws_btn_secundary_transparent btn-sm" onClick={handleShow}><IconPlus width="30px" height="30px" /> Agregar Grupo</Button> */}
                <Button
                  className="mt-3 btn btn-primary ws_btn_secundary"
                  onClick={(e) => {
                    setMode(!mode);
                  }}
                >
                  {mode ? "Ver Prod / Cobr" : "Ver Crecimiento"}
                </Button>
              </div>
            </div>
          </div>

          {mode ? (
            <div className="table-responsive" style={{ maxHeight: 450 }}>
              <Table striped bordered hover size="sm" className="ws_tabla">
                <thead
                  style={{
                    backgroundColor: "#0a93af",
                    color: "#fff",
                    fontSize: ".9rem",
                  }}
                >
                  <tr>
                    <th align="left" className="ps-3">
                      GRUPO
                    </th>
                    <th className="text-center">
                      {dataGrupos.tituloCobAcumYearBefore}
                    </th>
                    <th className="text-center">
                      {dataGrupos.tituloPorcentajeSiniYearBefore}
                    </th>
                    <th className="text-center">
                      {dataGrupos.tituloCobAcumYearMonthBefore}
                    </th>
                    <th className="text-center">
                      {dataGrupos.tituloCobAcumYearMonthCurrent}
                    </th>
                    <th className="text-center">
                      {dataGrupos.tituloCobIncreaseMonth}
                    </th>
                    <th className="text-center">
                      {dataGrupos.tituloCobLast12Months}
                    </th>
                    <th className="text-center">
                      {dataGrupos.tituloCobIncreaseYear}
                    </th>
                    <th className="text-center">
                      {dataGrupos.tituloPorcentajeSiniMonthCurrent}
                    </th>
                    <th className="text-center">
                      {dataGrupos.tituloPorcentajeSinVS1}
                    </th>
                    <th className="text-center">
                      {dataGrupos.tituloPorcentajeSinVS2}
                    </th>
                  </tr>
                </thead>
                <tbody style={{ fontSize: ".9rem" }}>
                  {info_grupos.length > 0 ? (
                    info_grupos.map((t, e) => {
                      if (
                        search === "" ||
                        (t.nombre &&
                          t.nombre
                            .toLowerCase()
                            .indexOf(search.toLowerCase()) !== -1)
                      ) {
                        return (
                          <tr key={e}>
                            {/* <td align="left" className="ps-3" width="25%">
                                  <span className="ws_color_secundario" style={{ fontWeight: '700', marginRight: 10 }}>{oficina.clave_oficina}</span>
                                  <span><Link to={`/oficinas/${oficina.clave_oficina}`} style={{ color: "#606060" }}>{oficina.nombre_oficina}</Link></span>
                                </td> */}

                            <td align="left" className="ps-3">
                              <span>
                                <Link
                                  to={`/grupos/${t.id_grupo}`}
                                  style={{ color: "#606060" }}
                                >
                                  {t.nombre}
                                </Link>
                              </span>
                            </td>
                            <td className="text-center">
                              $
                              {valueSwitch
                                ? number_format(t.cobAcumYearBefore, 2)
                                : number_format(t.prodAcumYearBefore, 2)}
                            </td>
                            <td className="text-center">
                              {t.porcentajeSiniYearBefore}%
                            </td>
                            <td className="text-center">
                              $
                              {valueSwitch
                                ? number_format(t.cobAcumYearMonthBefore, 2)
                                : number_format(t.prodAcumYearMonthBefore, 2)}
                            </td>
                            <td className="text-center">
                              $
                              {valueSwitch
                                ? number_format(t.cobAcumYearMonthCurrent, 2)
                                : number_format(t.prodAcumYearMonthCurrent, 2)}
                            </td>
                            <td className="text-center">
                              {valueSwitch
                                ? t.cobIncreaseMonth
                                : t.prodIncreaseMonth}
                              %
                            </td>
                            <td className="text-center">
                              $
                              {valueSwitch
                                ? number_format(t.cobLast12Months, 2)
                                : number_format(t.prodLast12Months, 2)}
                            </td>
                            <td className="text-center">
                              {valueSwitch
                                ? t.cobIncreaseYear
                                : t.prodIncreaseYear}
                              %
                            </td>
                            <td className="text-center">
                              {t.porcentajeSiniMonthCurrent}%
                            </td>
                            <td className="text-center">
                              {t.porcentajeSinVS1}%
                            </td>
                            <td className="text-center">
                              {t.porcentajeSinVS2}%
                            </td>
                          </tr>
                        );
                      }
                    })
                  ) : (
                    <tr>
                      <td colSpan="11" className="text-center">
                        <p className="mb-0">No hay datos disponibles</p>
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          ) : (
            <div className="table-responsive" style={{ maxHeight: 450 }}>
              <Table striped bordered hover size="sm" className="ws_tabla">
                <thead
                  style={{
                    backgroundColor: "#0a93af",
                    color: "#fff",
                    fontSize: ".9rem",
                  }}
                >
                  <tr>
                    <th className="text-left ps-3">GRUPO</th>
                    <th className="text-center">Acum Anual {year}</th>
                    <th className="text-center">
                      Prima{" "}
                      {moment()
                        .month(month - 1)
                        .format("MMM")}{" "}
                      {year}
                    </th>
                    <th className="text-center">
                      Prima{" "}
                      {moment()
                        .month(month - 1)
                        .format("MMM")}{" "}
                      {beforeYearBySelect}
                    </th>
                  </tr>
                </thead>
                <tbody style={{ fontSize: ".9rem" }}>
                  {info_grupos.map((t, e) => {
                    if (
                      search === "" ||
                      (t.nombre && t.nombre.toLowerCase().indexOf(search.toLowerCase()) !== -1) ) {
                      return (
                        <tr key={e}>
                          <td align="left" className="ps-3">
                            <span>
                              <Link
                                to={`/grupos/${t.id_grupo}`}
                                style={{ color: "#606060" }}
                              >
                                {t.nombre}
                              </Link>
                            </span>
                          </td>
                          <td className="text-center">
                            ${number_format(t.cobAcumYearCurrent, 2)}
                          </td>
                          <td className="text-center">
                            $
                            {t.months_current.length &&
                              number_format(
                                t.months_current.find(
                                  (element) => element.mes == month
                                ).cobranza,
                                2
                              )}
                          </td>
                          <td className="text-center">
                            $
                            {t.months_before.length &&
                              number_format(
                                t.months_before.find(
                                  (element) => element.mes == month
                                ).cobranza,
                                2
                              )}
                          </td>
                        </tr>
                      );
                    }
                  })}
                </tbody>
              </Table>
            </div>
          )}

          {/* <Button className="ws_btn_secundary_transparent btn-sm" onClick={handleShow}><IconPlus width="30px" height="30px" /> Agregar Grupo</Button> */}

          <Modal show={show} onHide={handleClose} backdrop="static" size="lg">
            <Modal.Header closeButton>
              <Modal.Title>Crear Grupo</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
                <Form.Group className="mb-3">
                  <Form.Label>Nombre</Form.Label>
                  <Form.Control
                    type="text"
                    id="nombre_grupo"
                    name="nombre_grupo"
                    value={nombre}
                    onChange={(e) => setNombre(e.target.value)}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Agregar agentes{" "}
                    <span className="ws_color_primario">13</span>
                  </Form.Label>
                  <div style={{ position: "relative" }}>
                    <Form.Control
                      type="search"
                      id="buscar_agente"
                      name="buscar_agente"
                      value={searchModal}
                      onChange={(e) => setSearchModal(e.target.value)}
                      style={{ paddingLeft: 50 }}
                    />
                    <IconMinSearch
                      width="30px"
                      height="30px"
                      className="ws_icon_search_input"
                    />
                  </div>
                </Form.Group>
                <Form.Group>
                  <Row>
                    <Col xs={4}>
                      <Form.Label className="text-center ws_color_primario d-block">
                        <p style={{ fontSize: "1.2rem" }} className="mb-0">
                          Oficinas
                        </p>
                      </Form.Label>
                      <Form.Select
                        aria-label="Default select example"
                        value={select.oficina}
                        id="oficinas"
                        name="oficinas"
                        onChange={(e) => {
                          setSelect({
                            ...select,
                            [e.target.name]: e.target.value,
                          });
                        }}
                      >
                        {state.data[0].oficinas
                          ? state.data[0].oficinas.map((oficina, index) => (
                              <option value={oficina.clave_oficina} key={index}>
                                {oficina.nombre_oficina}
                              </option>
                            ))
                          : null}
                      </Form.Select>
                    </Col>
                    <Col xs={4}>
                      <Form.Label className="text-center ws_color_primario d-block">
                        <p style={{ fontSize: "1.2rem" }} className="mb-0">
                          Agentes
                        </p>
                      </Form.Label>
                      <Form.Select
                        aria-label="Default select example"
                        value={select.agentes}
                        id="agentes"
                        name="agentes"
                        onChange={(e) => {
                          setSelect({
                            ...select,
                            [e.target.name]: e.target.value,
                          });
                        }}
                      >
                        {state.data[0].agentes
                          ? state.data[0].agentes.map((agente, index) => (
                              <option value={agente.value} key={index}>
                                {agente.name}
                              </option>
                            ))
                          : null}
                      </Form.Select>
                    </Col>
                    <Col xs={4}>
                      <Form.Label className="text-center ws_color_primario d-block">
                        <p style={{ fontSize: "1.2rem" }} className="mb-0">
                          Tipos
                        </p>
                      </Form.Label>
                      <Form.Select
                        aria-label="Default select example"
                        value={select.tipos}
                        id="tipos"
                        name="tipos"
                        onChange={(e) => {
                          setSelect({
                            ...select,
                            [e.target.name]: e.target.value,
                          });
                        }}
                      >
                        {state.data[0].tipos
                          ? state.data[0].tipos.map((tipos, index) => (
                              <option value={tipos.value} key={index}>
                                {tipos.name}
                              </option>
                            ))
                          : null}
                      </Form.Select>
                    </Col>
                  </Row>
                </Form.Group>
              </Form>
              <Table
                striped
                bordered
                hover
                size="sm"
                responsive
                style={{ marginTop: 40 }}
              >
                <thead
                  style={{
                    backgroundColor: "#0a93af",
                    color: "#fff",
                    fontSize: ".9rem",
                  }}
                >
                  <tr>
                    <th
                      width="50%"
                      className="text-center"
                      style={{ padding: 7, fontSize: "1.1rem" }}
                    >
                      Agente
                    </th>
                    <th
                      width="50%"
                      className="text-center"
                      style={{ padding: 7 }}
                    ></th>
                  </tr>
                </thead>
                <tbody style={{ fontSize: ".9rem" }}>
                  <tr>
                    <td align="left">
                      <span
                        className="ws_color_secundario"
                        style={{ fontWeight: "700", marginRight: 10 }}
                      >
                        69
                      </span>
                      <span>
                        <a href="#" style={{ color: "#606060" }}>
                          Marcela Rocha Arredondo
                        </a>
                      </span>
                    </td>
                    <td>
                      <SingleSwitch isOn={true} id={"69"} />
                    </td>
                  </tr>
                  <tr>
                    <td align="left">
                      <span
                        className="ws_color_secundario"
                        style={{ fontWeight: "700", marginRight: 10 }}
                      >
                        68
                      </span>
                      <span>
                        <a href="#" style={{ color: "#606060" }}>
                          Julio Ernesto Silva Gomez
                        </a>
                      </span>
                    </td>
                    <td>
                      <SingleSwitch isOn={true} id={"68"} />
                    </td>
                  </tr>
                  <tr>
                    <td align="left">
                      <span
                        className="ws_color_secundario"
                        style={{ fontWeight: "700", marginRight: 10 }}
                      >
                        67
                      </span>
                      <span>
                        <a href="#" style={{ color: "#606060" }}>
                          Julio Jose de Jesús Yañez Mar
                        </a>
                      </span>
                    </td>
                    <td>
                      <SingleSwitch isOn={false} id={"67"} />
                    </td>
                  </tr>
                  <tr>
                    <td align="left">
                      <span
                        className="ws_color_secundario"
                        style={{ fontWeight: "700", marginRight: 10 }}
                      >
                        66
                      </span>
                      <span>
                        <a href="#" style={{ color: "#606060" }}>
                          Julio Liliana Salazar Rocha
                        </a>
                      </span>
                    </td>
                    <td>
                      <SingleSwitch isOn={true} id={"66"} />
                    </td>
                  </tr>
                  <tr>
                    <td align="left">
                      <span
                        className="ws_color_secundario"
                        style={{ fontWeight: "700", marginRight: 10 }}
                      >
                        65
                      </span>
                      <span>
                        <a href="#" style={{ color: "#606060" }}>
                          Julio Francisco García de la Cruz
                        </a>
                      </span>
                    </td>
                    <td>
                      <SingleSwitch isOn={false} id={"65"} />
                    </td>
                  </tr>
                  <tr>
                    <td align="left">
                      <span
                        className="ws_color_secundario"
                        style={{ fontWeight: "700", marginRight: 10 }}
                      >
                        64
                      </span>
                      <span>
                        <a href="#" style={{ color: "#606060" }}>
                          Julio Emmanuel González González
                        </a>
                      </span>
                    </td>
                    <td>
                      <SingleSwitch isOn={true} id={"64"} />
                    </td>
                  </tr>
                  <tr>
                    <td align="left">
                      <span
                        className="ws_color_secundario"
                        style={{ fontWeight: "700", marginRight: 10 }}
                      >
                        63
                      </span>
                      <span>
                        <a href="#" style={{ color: "#606060" }}>
                          Julio Xochitl Remedios Guerra
                        </a>
                      </span>
                    </td>
                    <td>
                      <SingleSwitch isOn={true} id={"63"} />
                    </td>
                  </tr>
                  <tr>
                    <td align="left">
                      <span
                        className="ws_color_secundario"
                        style={{ fontWeight: "700", marginRight: 10 }}
                      >
                        62
                      </span>
                      <span>
                        <a href="#" style={{ color: "#606060" }}>
                          Julio Marcela Huacuja Rodríguez
                        </a>
                      </span>
                    </td>
                    <td>
                      <SingleSwitch isOn={false} id={"62"} />
                    </td>
                  </tr>
                </tbody>
              </Table>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="primary"
                className="ws_btn_secundary"
                onClick={handleClose}
              >
                Crear Grupo
              </Button>
            </Modal.Footer>
          </Modal>
        </Container>
      </div>
    </Col>
  );
}

function TablaReportes({ initState, updateState, data }) {
  const { usuario } = useContext(AuthContext);

  const currentYear = new Date().getFullYear();
  const oneyearBefore = new Date(
    new Date().setFullYear(new Date().getFullYear() - 1)
  ).getFullYear();
  const twoyearBefore = new Date(
    new Date().setFullYear(new Date().getFullYear() - 2)
  ).getFullYear();
  const threeyearBefore = new Date(
    new Date().setFullYear(new Date().getFullYear() - 3)
  ).getFullYear();

  const [yearG, setYearG] = useState(currentYear);
  const [array, setArray] = useState([]);
  const [uploadsSiniestralidad, setUploadsSiniestralidad] = useState([]);
  const [search, setSearch] = useState("");
  const [mode, setMode] = useState(true);

  const [mesReporte, setMesReporte] = useState(
    moment().subtract(1, "months").format("MM")
  );
  const [yearReporte, setYearReporte] = useState(currentYear);

  const [mesReporteDevengada, setMesReporteDevengada] = useState(
    moment().subtract(1, "months").format("MM")
  );
  const [yearReporteDevengada, setYearReporteDevengada] = useState(currentYear);

  const [file, setFile] = useState("");
  const [fileDevengada, setFileDevengada] = useState("");

  const [uploadStatus, setUploadStatus] = useState(false);
  const [uploadDevengadaStatus, setUploadDevengadaStatus] = useState(false);

  const [showSiniestralidad, setShowSiniestralidad] = useState(false);
  const [showDevengada, setShowDevengada] = useState(false);

  const handleCloseSiniestralidad = () => setShowSiniestralidad(false);
  const handleShowSiniestralidad = () => setShowSiniestralidad(true);

  const handleCloseDevengada = () => setShowDevengada(false);
  const handleShowDevengada = () => setShowDevengada(true);

  const { list = [] } = uploadsSiniestralidad;

  useEffect(() => {
    getHistoryUploadsSiniestralidad();
  }, [yearG]);

  useEffect(() => {
    if (file && file != "") {
      uploadExcelContable12M();
    }
  }, [file]);

  useEffect(() => {
    if (fileDevengada && fileDevengada != "") {
      uploadExcelDesgloseDevengada();
    }
  }, [fileDevengada]);

  if (list.length === 0) {
    return (
      <Col xs={12} md={12} className="mb-3">
        <div
          className="ws_box"
          style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
        >
          <Container fluid>
            <div className="ws_box_header mb-3">
              <div className="d-flex justify-content-start align-items-end">
                <div>
                  <h2 className="ws_table_agente_title pb-0 mb-2">
                    Prima Devengada y Siniestralidad
                  </h2>
                </div>
              </div>
            </div>
            <Skeleton width="100%" height={400} />
          </Container>
        </div>
      </Col>
    );
  }

  return (
    <Col xs={12} md={12} className="mb-3">
      <div
        className="ws_box"
        style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
      >
        <Container fluid>
          <div className="ws_box_header mb-3">
            <div className="d-flex justify-content-start align-items-end">
              <div>
                <h2 className="ws_table_agente_title pb-0 mb-2">
                  Prima Devengada y Siniestralidad
                </h2>
                <div className="d-flex justify-content-start align-items-start">
                  <DatePickerW
                    onChange={(e) => {
                      setYearG(e.target.value);
                    }}
                    year={currentYear}
                    selected={yearG}
                  />
                </div>
              </div>
            </div>
            <div className="d-flex flex-column justify-content-between align-items-end">
              <div className="d-flex flex-row justify-content-between align-self-center align-items-center">
                <Form>
                  <Form.Control
                    type="search"
                    placeholder="Buscar"
                    className="ws_input"
                    onChange={(e) => {
                      setSearch(e.target.value);
                    }}
                  />
                </Form>
                {/* <Dropdown className="ws_dropdown">
                  <Dropdown.Toggle id="dropdown-basic">
                    <Image src={'img/darkOpt.svg'} alt="icon_opt" className="ws_icon ms-2" />
                  </Dropdown.Toggle>
                  <Dropdown.Menu align="end">
                    <Dropdown.Item href="#">Quitar del dashboard</Dropdown.Item>
                    <Dropdown.Item href="#">Duplicar</Dropdown.Item>
                    <Dropdown.Item href="#">Ocultar en móvil</Dropdown.Item>
                    <Dropdown.Item href="#">Exportar</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown> */}
              </div>
              <Button
                className="mt-3 btn btn-primary ws_btn_secundary"
                onClick={handleShowDevengada}
              >
                Subir Reporte Prima Devengada
              </Button>
              <Button
                className="mt-3 btn btn-primary ws_btn_secundary"
                onClick={handleShowSiniestralidad}
              >
                Subir Reporte Siniestralidad
              </Button>
            </div>
          </div>
          <Table striped bordered hover responsive className="ws_tabla">
            <thead
              style={{
                backgroundColor: "#0a93af",
                color: "#fff",
                fontSize: ".9rem",
              }}
            >
              <tr>
                <th align="left" width="25%" className="ps-3">
                  OFICINA
                </th>
                <th className="text-center">ENE</th>
                <th className="text-center">FEB</th>
                <th className="text-center">MAR</th>
                <th className="text-center">ABR</th>
                <th className="text-center">MAY</th>
                <th className="text-center">JUN</th>
                <th className="text-center">JUL</th>
                <th className="text-center">AGO</th>
                <th className="text-center">SEP</th>
                <th className="text-center">OCT</th>
                <th className="text-center">NOV</th>
                <th className="text-center">DIC</th>
              </tr>
            </thead>
            <tbody style={{ fontSize: ".9rem" }}>
              {list.map((t, e) => {
                if (
                  search === "" ||
                  (t.nombre_oficina &&
                    t.nombre_oficina
                      .toLowerCase()
                      .indexOf(search.toLowerCase()) !== -1)
                ) {
                  return (
                    <tr key={e}>
                      <td align="left" className="ps-3">
                        <a href="#" style={{ color: "#606060" }}>
                          {t.nombre_oficina}
                        </a>
                        <div className="ws_tag_noti ms-2 text-center">
                          {t.faltantes}
                        </div>
                      </td>
                      {t.history.map((t, e) => (
                        <td align="center" key={e}>
                          {t.devengada ? (
                            <IconCheckActive
                              widht="24px"
                              height="24px"
                              title="Reporte Prima Devengada"
                            />
                          ) : (
                            <IconCheckInactive
                              widht="24px"
                              height="24px"
                              title="Reporte Prima Devengada"
                            />
                          )}
                          {t.siniestralidad ? (
                            <IconCheckActive
                              widht="24px"
                              height="24px"
                              title="Reporte Siniestralidad"
                            />
                          ) : (
                            <IconCheckInactive
                              widht="24px"
                              height="24px"
                              title="Reporte Siniestralidad"
                            />
                          )}
                        </td>
                      ))}
                    </tr>
                  );
                }
              })}
            </tbody>
          </Table>

          <Modal
            show={showSiniestralidad}
            onHide={handleCloseSiniestralidad}
            backdrop="static"
            size="lg"
          >
            <Modal.Header closeButton>
              <Modal.Title>Subir Siniestralidad 12 meses contable</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ position: "relative" }}>
              <div
                style={{
                  position: "absolute",
                  backgroundColor: "rgba(0,0,0,0.6)",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  color: "#fff",
                  display: uploadStatus ? "flex" : "none",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <h3>Subiendo reporte...</h3>
              </div>
              <Form>
                <Row>
                  <Col xs={6}>
                    <Form.Group>
                      <Form.Label className="text-center ws_color_primario d-block">
                        <p style={{ fontSize: "1.2rem" }} className="mb-0">
                          Elige el mes
                        </p>
                      </Form.Label>
                      <Form.Select
                        aria-label="Default select example"
                        id="mes_siniestralidad"
                        name="mes_siniestralidad"
                        onChange={(e) => {
                          setMesReporte(e.currentTarget.value);
                        }}
                        style={{ textTransform: "uppercase" }}
                        value={mesReporte}
                      >
                        <option value="01">Enero</option>
                        <option value="02">Febrero</option>
                        <option value="03">Marzo</option>
                        <option value="04">Abril</option>
                        <option value="05">Mayo</option>
                        <option value="06">Junio</option>
                        <option value="07">Julio</option>
                        <option value="08">Agosto</option>
                        <option value="09">Septiembre</option>
                        <option value="10">Octubre</option>
                        <option value="11">Noviembre</option>
                        <option value="12">Diciembre</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col xs={6}>
                    <Form.Group>
                      <Form.Label className="text-center ws_color_primario d-block">
                        <p style={{ fontSize: "1.2rem" }} className="mb-0">
                          Elige el año
                        </p>
                      </Form.Label>
                      <Form.Select
                        aria-label="Default select example"
                        id="year_siniestralidad"
                        name="year_siniestralidad"
                        onChange={(e) => {
                          setYearReporte(e.currentTarget.value);
                        }}
                        value={yearReporte}
                      >
                        <option value={currentYear}>{currentYear}</option>
                        <option value={oneyearBefore}>{oneyearBefore}</option>
                        <option value={twoyearBefore}>{twoyearBefore}</option>
                        <option value={threeyearBefore}>
                          {threeyearBefore}
                        </option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col xs={12}>
                    <Form.Group className="mt-5">
                      <Form.Label className="w-100">
                        <div className="d-grid gap-2">
                          <p
                            className="btn btn-primary btn-file text-left d-flex justify-content-between align-items-center"
                            htmlFor={"curp_file"}
                          >
                            <p className="mb-0">
                              {file ? file.name : "SUBIR DOCUMENTO"}
                            </p>
                            <div>
                              <IconAttachment width="40px" height="40px" />
                              {/* {(file) ? <IconClose style={{width:'40px',height:'40px'}} onClick={ (e) => { e.preventDefault(); alert('delete file') } } /> : null} */}
                            </div>
                          </p>
                          <Form.Control
                            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                            className="ws-control"
                            name="file_siniestralidad"
                            id="file_siniestralidad"
                            type="file"
                            style={{ display: "none" }}
                            onChange={(file) => {
                              const name = file.target.name;
                              onFileChange(file, name, 1);
                            }}
                          />
                        </div>
                      </Form.Label>
                    </Form.Group>
                    <p className="text-center" style={{ fontWeight: "600" }}>
                      NOTA: ANTES DE SUBIR TU REPORTE DEBES SELECCIONAR EL MES Y
                      AÑO AL QUE PERTENECE
                    </p>
                  </Col>
                </Row>
              </Form>
            </Modal.Body>
          </Modal>

          <Modal
            show={showDevengada}
            onHide={handleCloseDevengada}
            backdrop="static"
            size="lg"
          >
            <Modal.Header closeButton>
              <Modal.Title>Subir prima devengada</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ position: "relative" }}>
              <div
                style={{
                  position: "absolute",
                  backgroundColor: "rgba(0,0,0,0.6)",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  color: "#fff",
                  display: uploadDevengadaStatus ? "flex" : "none",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <h3>Subiendo reporte...</h3>
              </div>
              <Form>
                <Row>
                  <Col xs={6}>
                    <Form.Group>
                      <Form.Label className="text-center ws_color_primario d-block">
                        <p style={{ fontSize: "1.2rem" }} className="mb-0">
                          Elige el mes
                        </p>
                      </Form.Label>
                      <Form.Select
                        aria-label="Default select example"
                        id="mes_siniestralidad"
                        name="mes_siniestralidad"
                        onChange={(e) => {
                          setMesReporteDevengada(e.currentTarget.value);
                        }}
                        style={{ textTransform: "uppercase" }}
                        value={mesReporteDevengada}
                      >
                        <option value="01">Enero</option>
                        <option value="02">Febrero</option>
                        <option value="03">Marzo</option>
                        <option value="04">Abril</option>
                        <option value="05">Mayo</option>
                        <option value="06">Junio</option>
                        <option value="07">Julio</option>
                        <option value="08">Agosto</option>
                        <option value="09">Septiembre</option>
                        <option value="10">Octubre</option>
                        <option value="11">Noviembre</option>
                        <option value="12">Diciembre</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col xs={6}>
                    <Form.Group>
                      <Form.Label className="text-center ws_color_primario d-block">
                        <p style={{ fontSize: "1.2rem" }} className="mb-0">
                          Elige el año
                        </p>
                      </Form.Label>
                      <Form.Select
                        aria-label="Default select example"
                        id="year_siniestralidad"
                        name="year_siniestralidad"
                        onChange={(e) => {
                          setYearReporteDevengada(e.currentTarget.value);
                        }}
                        value={yearReporteDevengada}
                      >
                        <option value={currentYear}>{currentYear}</option>
                        <option value={oneyearBefore}>{oneyearBefore}</option>
                        <option value={twoyearBefore}>{twoyearBefore}</option>
                        <option value={threeyearBefore}>
                          {threeyearBefore}
                        </option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col xs={12}>
                    <Form.Group className="mt-5">
                      <Form.Label className="w-100">
                        <div className="d-grid gap-2">
                          <p
                            className="btn btn-primary btn-file text-left d-flex justify-content-between align-items-center"
                            htmlFor={"curp_file"}
                          >
                            <p className="mb-0">
                              {fileDevengada
                                ? fileDevengada.name
                                : "SUBIR DOCUMENTO"}
                            </p>
                            <div>
                              <IconAttachment width="40px" height="40px" />
                              {/* {(file) ? <IconClose style={{width:'40px',height:'40px'}} onClick={ (e) => { e.preventDefault(); alert('delete file') } } /> : null} */}
                            </div>
                          </p>
                          <Form.Control
                            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                            className="ws-control"
                            name="file_devengada"
                            id="file_devengada"
                            type="file"
                            style={{ display: "none" }}
                            onChange={(file) => {
                              const name = file.target.name;
                              onFileChange(file, name, 2);
                            }}
                          />
                        </div>
                      </Form.Label>
                    </Form.Group>
                    <p className="text-center" style={{ fontWeight: "600" }}>
                      NOTA: ANTES DE SUBIR TU REPORTE DEBES SELECCIONAR EL MES Y
                      AÑO AL QUE PERTENECE
                    </p>
                  </Col>
                </Row>
              </Form>
            </Modal.Body>
          </Modal>
        </Container>
      </div>
    </Col>
  );

  function onFileChange(file, name, type) {
    if (type === 1) setFile(file.target.files[0]);

    if (type === 2) setFileDevengada(file.target.files[0]);
  }

  function uploadExcelContable12M() {
    setUploadStatus(true);
    const fecha = `${yearReporte}-${mesReporte}-${moment().format("DD")}`;
    const formData = new FormData();
    formData.append("id_login", usuario.id_usuario);
    formData.append("file", file);
    formData.append("fecha", fecha);

    fetch(
      `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=uploadExcelContable12M`,
      {
        method: "POST",
        mode: "cors",
        body: formData,
      }
    )
      .then((res) => res.json())
      .then((res) => {
        setUploadStatus(false);
        setFile("");
        if (res.status == "ok") {
          alert("Archivo subido con éxito");
          setShowSiniestralidad(false);
          console.log(res);
        }
        if (res.status == "error") {
          alert(
            "Lo sentimos ha ocurrido un error al intentar subir el archivo, por favor inténtalo de nuevo"
          );
        }
      });
  }

  function uploadExcelDesgloseDevengada() {
    setUploadDevengadaStatus(true);
    const fecha = `${yearReporteDevengada}-${mesReporteDevengada}-${moment().format(
      "DD"
    )}`;
    const formData = new FormData();
    formData.append("id_login", usuario.id_usuario);
    formData.append("file", fileDevengada);
    formData.append("fecha", fecha);

    fetch(
      `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=uploadExcelDesgloseDevengada`,
      {
        method: "POST",
        mode: "cors",
        body: formData,
      }
    )
      .then((res) => res.json())
      .then((res) => {
        setUploadDevengadaStatus(false);
        setFileDevengada("");
        if (res.status == "ok") {
          alert("Archivo subido con éxito");
          setShowDevengada(false);
          console.log(res);
        }
        if (res.status == "error") {
          alert(
            "Lo sentimos ha ocurrido un error al intentar subir el archivo, por favor inténtalo de nuevo"
          );
        }
      });
  }

  function getHistoryUploadsSiniestralidad() {
    fetch(
      `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=getHistoryUploadsSiniestralidad`,
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify({ id_login: usuario.id_usuario, year: yearG }),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        setUploadsSiniestralidad(res);
        setArray(res);
      });
  }
}

function TablaPagoBonos({ initState, updateState, data }) {
  const { usuario } = useContext(AuthContext);
  const currentYear = new Date().getFullYear();
  const oneyearBefore = new Date(
    new Date().setFullYear(new Date().getFullYear() - 1)
  ).getFullYear();
  const twoyearBefore = new Date(
    new Date().setFullYear(new Date().getFullYear() - 2)
  ).getFullYear();
  const threeyearBefore = new Date(
    new Date().setFullYear(new Date().getFullYear() - 3)
  ).getFullYear();

  const [mesReporteBonos, setMesReporteBonos] = useState(
    moment().subtract(1, "months").format("MM")
  );
  const [yearReporteBonos, setYearReporteBonos] = useState(currentYear);
  const [fileBonos, setFileBonos] = useState("");
  const [uploadBonosStatus, setUploadBonosStatus] = useState(false);
  const [showBonos, setShowBonos] = useState(false);

  const handleCloseBonos = () => setShowBonos(false);
  const handleShowBonos = () => setShowBonos(true);

  const [yearG, setYearG] = useState(currentYear);
  const [uploadsBonos, setUploadsBonos] = useState([]);
  const [search, setSearch] = useState("");
  const [mode, setMode] = useState(true);

  const { list = [] } = uploadsBonos;

  useEffect(() => {
    getHistoryUploadsPagosBonos();
  }, [yearG]);

  useEffect(() => {
    if (fileBonos && fileBonos != "") {
      pagoBonosAgentes();
    }
  }, [fileBonos]);

  if (list.length === 0) {
    return (
      <Col xs={12} md={12} className="mb-3">
        <div
          className="ws_box"
          style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
        >
          <Container fluid>
            <div className="ws_box_header mb-3">
              <div className="d-flex justify-content-start align-items-end">
                <div>
                  <h2 className="ws_table_agente_title pb-0 mb-2">
                    Pagos de Bonos
                  </h2>
                </div>
              </div>
            </div>
            <Skeleton width="100%" height={400} />
          </Container>
        </div>
      </Col>
    );
  }

  return (
    <Col xs={12} md={12} className="mb-3">
      <div
        className="ws_box"
        style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
      >
        <Container fluid>
          <div className="ws_box_header mb-3">
            <div className="d-flex justify-content-start align-items-end">
              <div>
                <h2 className="ws_table_agente_title pb-0 mb-2">
                  Pagos de Bonos
                </h2>
                <div className="d-flex justify-content-start align-items-start">
                  <DatePickerW
                    onChange={(e) => {
                      setYearG(e.target.value);
                    }}
                    year={currentYear}
                    selected={yearG}
                  />
                </div>
              </div>
            </div>
            <div className="d-flex flex-column justify-content-between align-items-end">
              <div className="d-flex flex-row justify-content-between align-self-center align-items-center">
                <Form>
                  <Form.Control
                    type="search"
                    placeholder="Buscar"
                    className="ws_input"
                    onChange={(e) => {
                      setSearch(e.target.value);
                    }}
                  />
                </Form>
                {/* <Dropdown className="ws_dropdown">
                  <Dropdown.Toggle id="dropdown-basic">
                    <Image src={'img/darkOpt.svg'} alt="icon_opt" className="ws_icon ms-2" />
                  </Dropdown.Toggle>
                  <Dropdown.Menu align="end">
                    <Dropdown.Item href="#">Quitar del dashboard</Dropdown.Item>
                    <Dropdown.Item href="#">Duplicar</Dropdown.Item>
                    <Dropdown.Item href="#">Ocultar en móvil</Dropdown.Item>
                    <Dropdown.Item href="#">Exportar</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown> */}
              </div>
              <Button
                className="mt-3 btn btn-primary ws_btn_secundary"
                onClick={handleShowBonos}
              >
                Subir Reporte Pagos/bonos
              </Button>
            </div>
          </div>
          <Table striped bordered hover responsive className="ws_tabla">
            <thead
              style={{
                backgroundColor: "#0a93af",
                color: "#fff",
                fontSize: ".9rem",
              }}
            >
              <tr>
                <th align="left" className="ps-3">
                  OFICINA
                </th>
                <th className="text-center">ENE - ABR</th>
                <th className="text-center">MAY - AGO</th>
                <th className="text-center">SEP - DIC</th>
              </tr>
            </thead>
            <tbody style={{ fontSize: ".9rem" }}>
              {list.map((t, e) => {
                if (
                  search === "" ||
                  (t.nombre_oficina &&
                    t.nombre_oficina
                      .toLowerCase()
                      .indexOf(search.toLowerCase()) !== -1)
                ) {
                  return (
                    <tr key={e}>
                      <td align="left" className="ps-3">
                        <a href="#" style={{ color: "#606060" }}>
                          {t.nombre_oficina}
                        </a>
                        <div className="ws_tag_noti ms-2 text-center">
                          {t.faltantes}
                        </div>
                      </td>
                      {t.history.map((t, e) => (
                        <td align="center" key={e}>
                          {t.bonos ? (
                            <IconCheckActive
                              widht="24px"
                              height="24px"
                              title="Reporte Bonos"
                            />
                          ) : (
                            <IconCheckInactive
                              widht="24px"
                              height="24px"
                              title="Reporte Btonos"
                            />
                          )}
                        </td>
                      ))}
                    </tr>
                  );
                }
              })}
            </tbody>
          </Table>

          <Modal
            show={showBonos}
            onHide={handleCloseBonos}
            backdrop="static"
            size="lg"
          >
            <Modal.Header closeButton>
              <Modal.Title>Subir pago de bonos</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ position: "relative" }}>
              <div
                style={{
                  position: "absolute",
                  backgroundColor: "rgba(0,0,0,0.6)",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  color: "#fff",
                  display: uploadBonosStatus ? "flex" : "none",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <h3>Subiendo reporte...</h3>
              </div>
              <Form>
                <Row>
                  <Col xs={6}>
                    <Form.Group>
                      <Form.Label className="text-center ws_color_primario d-block">
                        <p style={{ fontSize: "1.2rem" }} className="mb-0">
                          Elige el mes
                        </p>
                      </Form.Label>
                      <Form.Select
                        aria-label="Default select example"
                        id="mes_siniestralidad"
                        name="mes_siniestralidad"
                        onChange={(e) => {
                          setMesReporteBonos(e.currentTarget.value);
                        }}
                        style={{ textTransform: "uppercase" }}
                        value={mesReporteBonos}
                      >
                        <option value="01">Enero</option>
                        <option value="02">Febrero</option>
                        <option value="03">Marzo</option>
                        <option value="04">Abril</option>
                        <option value="05">Mayo</option>
                        <option value="06">Junio</option>
                        <option value="07">Julio</option>
                        <option value="08">Agosto</option>
                        <option value="09">Septiembre</option>
                        <option value="10">Octubre</option>
                        <option value="11">Noviembre</option>
                        <option value="12">Diciembre</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col xs={6}>
                    <Form.Group>
                      <Form.Label className="text-center ws_color_primario d-block">
                        <p style={{ fontSize: "1.2rem" }} className="mb-0">
                          Elige el año
                        </p>
                      </Form.Label>
                      <Form.Select
                        aria-label="Default select example"
                        id="year_siniestralidad"
                        name="year_siniestralidad"
                        onChange={(e) => {
                          setYearReporteBonos(e.currentTarget.value);
                        }}
                        value={yearReporteBonos}
                      >
                        <option value={currentYear}>{currentYear}</option>
                        <option value={oneyearBefore}>{oneyearBefore}</option>
                        <option value={twoyearBefore}>{twoyearBefore}</option>
                        <option value={threeyearBefore}>
                          {threeyearBefore}
                        </option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col xs={12}>
                    <Form.Group className="mt-5">
                      <Form.Label className="w-100">
                        <div className="d-grid gap-2">
                          <p
                            className="btn btn-primary btn-file text-left d-flex justify-content-between align-items-center"
                            htmlFor={"curp_file"}
                          >
                            <p className="mb-0">
                              {fileBonos ? fileBonos.name : "SUBIR DOCUMENTO"}
                            </p>
                            <div>
                              <IconAttachment width="40px" height="40px" />
                              {/* {(file) ? <IconClose style={{width:'40px',height:'40px'}} onClick={ (e) => { e.preventDefault(); alert('delete file') } } /> : null} */}
                            </div>
                          </p>
                          <Form.Control
                            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                            className="ws-control"
                            name="file_devengada"
                            id="file_devengada"
                            type="file"
                            style={{ display: "none" }}
                            onChange={(file) => {
                              const name = file.target.name;
                              onFileChange(file, name, 3);
                            }}
                          />
                        </div>
                      </Form.Label>
                    </Form.Group>
                    <p className="text-center" style={{ fontWeight: "600" }}>
                      NOTA: ANTES DE SUBIR TU REPORTE DEBES SELECCIONAR EL MES Y
                      AÑO AL QUE PERTENECE
                    </p>
                  </Col>
                </Row>
              </Form>
            </Modal.Body>
          </Modal>
        </Container>
      </div>
    </Col>
  );

  function onFileChange(file, name, type) {
    if (type === 3) setFileBonos(file.target.files[0]);
  }

  function pagoBonosAgentes() {
    setUploadBonosStatus(true);
    const fecha = `${yearReporteBonos}-${mesReporteBonos}-${moment().format(
      "DD"
    )}`;
    const formData = new FormData();
    formData.append("id_login", usuario.id_usuario);
    formData.append("file", fileBonos);
    formData.append("fecha", fecha);

    fetch(
      `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=pagoBonosAgentes`,
      {
        method: "POST",
        mode: "cors",
        body: formData,
      }
    )
      .then((res) => res.json())
      .then((res) => {
        setUploadBonosStatus(false);
        setFileBonos("");
        if (res.status == "ok") {
          console.log("Archivo subido con éxito");
          setShowBonos(false);
          console.log(res);
        }
        if (res.status == "error") {
          alert(
            "Lo sentimos ha ocurrido un error al intentar subir el archivo, por favor inténtalo de nuevo"
          );
        }
      });
  }

  function getHistoryUploadsPagosBonos() {
    fetch(
      `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=getHistoryUploadsPagosBonos`,
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify({ id_login: usuario.id_usuario, year: yearG }),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        setUploadsBonos(res);
      });
  }
}

const ControlledInput = forwardRef(({...props }, ref) => {
  return(
    <Form.Control ref={ref} type="text" />
  )
});

function TablaEditarGrupos({ initState, updateState, data = [], reload, idGrupo="" }) {

  const { usuario } = useContext(AuthContext);
  let inputNombreGrupo = useRef();
  
  const currentYear = new Date().getFullYear();
  const [valueSwitch, setValueSwitch] = useState(true);
  const [search, setSearch] = useState("");
  const [mode, setMode] = useState(true);
  const [searchModal, setSearchModal] = useState("");
  const [nombre, setNombre] = useState("");
  const [select, setSelect] = useState({
    oficinas: "0",
    agentes: "0",
    tipos: "0",
  });

  const [state,setState] = useState({
    arrListaAgentes: [],
    dataGrupos: [],
    nombreGrupo: '',
    agentesSeleccionados:[],
    buttonAddGrupo: false,
    buttonEditarNombre: false,
    modalEditarGrupo: false,
    idGrupo: '',
    loadingModalEditarGrupo: false
  });

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => {
    setState( (prevState) => ({ 
      ...prevState, 
      agentesSeleccionados: [],
      arrListaAgentes: prevState.arrListaAgentes.map( (t,e) => { if(t.es_miembro) { t.es_miembro = 0 } return t; } )
    }), setShow(true) )
  };

  const handleCloseModalEditarGrupo = () => setState( (prevState) => ( { ...prevState, modalEditarGrupo: false }) );
  const handleShowModalEditarGrupo = (idGrupo,nombre) => {
    setState( (prevState) => ( { ...prevState, modalEditarGrupo: true, loadingModalEditarGrupo: true, idGrupo, nombreGrupo: nombre }) )
    getAgentesForGroup(idGrupo)
  }

  useEffect(() => {
    getAgentesForGroup();
  },[])

  useEffect(() => {
    if(state.modalEditarGrupo)
      inputNombreGrupo.current.value = state.nombreGrupo
  },[state.modalEditarGrupo])

  useEffect(() => {
    if(data.length > 0){
      setState((prevState) => ({
        ...prevState,
        dataGrupos: data
      }))
    }
  },[data])

  const handleSubmitCrearGrupo = () => {
    if(inputNombreGrupo.current.value == ''){
      alert('Agrega un nombre de grupo')
      return false;
    }
    setState( (prevState) => ({
      ...prevState,
      buttonAddGrupo: true
    }))
    addGrupo();
  }

  const handleSwitchAgentes = (id,value,t) => {
    let status = (value) ? 1 : 0;
    setState({
      ...state,
      arrListaAgentes: arrListaAgentes.map((agente,index) => {
        if(agente.id_usuario == t.id_usuario){
          agente.es_miembro = status;
        }
        return agente;
      }),
      agentesSeleccionados: (!value) ? agentesSeleccionados.filter( element => element.id_agente !== id ) : agentesSeleccionados.concat({ id_agente: id}),
    })
  }

  const handleSwitchAgentesEditar = (id,value,t) => {
    let status = (value) ? 1 : 0;
    setState({
      ...state,
      arrListaAgentes: arrListaAgentes.map((agente,index) => {
        if(agente.id_usuario == t.id_usuario){
          agente.es_miembro = status;
        }
        return agente;
      })
    })
    if(!value) deleteAgenteGrupo(state.idGrupo,id)
    if(value) addAgenteToGrupo(state.idGrupo,id)
  }

  const handleSwitchGrupo = (id,nombre,value,t) => {
    setState({
      ...state,
      dataGrupos: dataGrupos.map((element,index) => {
        if(element.id_grupo == t.id_grupo){
          element.status = (element.status==1) ? 0 : 1;
        }
        return element;
      })
    })
    if(!value) deleteGrupo(id,nombre)
    if(value) activateGrupo(id,nombre)
  }

  const handleSaveNombreGrupo = (nombre) => {
    updateNombreGrupo(state.idGrupo,nombre)
  }

  const {arrListaAgentes,dataGrupos,agentesSeleccionados} = state;
  let filteredDataListaAgentes = [];

  //Filtro de búsqueda de agentes
  filteredDataListaAgentes = useMemo(()=>{
    if (searchModal == "") {
      filteredDataListaAgentes = arrListaAgentes;
    } else {
      filteredDataListaAgentes = arrListaAgentes.filter((el) => {
          const { clave_oficina, n_completo } = el;
          return (
              clave_oficina.toString().includes(searchModal) ||
              n_completo.toLowerCase().includes(searchModal.toLowerCase())   
          );
      });
    }
    return filteredDataListaAgentes;
  },[searchModal,arrListaAgentes])

  //Filtro de búsqueda de grupos
  let filteredDataListaGrupos = [];
  filteredDataListaGrupos = useMemo(()=>{
    if (search == "") {
      filteredDataListaGrupos = dataGrupos;
    } else {
      filteredDataListaGrupos = dataGrupos.filter((el) => {
          const { nombre } = el;
          return (
              nombre.toLowerCase().includes(search.toLowerCase())   
          );
      });
    }
    return filteredDataListaGrupos;
  },[search,dataGrupos])

  return (
    <Col xs={12} md={12} className="mb-3">
      <div className="ws_box" style={{ paddingTop: "1rem", paddingBottom: "1rem" }}>
        <Container fluid>
          <div className="ws_box_header mb-3">
            <div className="d-flex justify-content-start align-items-end">
              <div>
                <h2 className="ws_table_agente_title pb-0 mb-2">
                  Editar Grupos
                </h2>
              </div>
            </div>
            <div className="d-flex flex-column justify-content-between align-items-end">
              <div className="d-flex flex-row justify-content-between align-self-center align-items-center">
                <Button className="ws_btn_secundary_transparent btn-sm me-2" onClick={handleShow}><IconPlus width="30px" height="30px" /> Agregar Grupo</Button>
                <Form>
                  <Form.Control
                    type="search"
                    placeholder="Buscar"
                    className="ws_input"
                    onChange={(e) => {
                      setSearch(e.target.value);
                    }}
                  />
                </Form>
              </div>
            </div>
          </div>
          <Table
            striped
            bordered
            hover
            size="sm"
            responsive
            className="ws_tabla"
          >
            <thead
              style={{
                backgroundColor: "#0a93af",
                color: "#fff",
                fontSize: ".9rem",
              }}
            >
              <tr>
                <th className="text-left">GRUPO</th>
                <th className="text-center">MIEMBROS</th>
                <th className="text-center">ESTADO</th>
                <th className="text-center">EDITAR</th>
              </tr>
            </thead>
            <tbody style={{ fontSize: ".9rem" }}>
              {
                (filteredDataListaGrupos.length < 1) && (
                  <tr>
                    <td colSpan={5} className="mt-2 mb-2 text-center">No hay resultados</td>
                  </tr>
                )
              }

              {
                (filteredDataListaGrupos.length > 0) && (
                  filteredDataListaGrupos.map((t,e) => {
                    return(
                      <tr key={e}>
                        <td className="text-left ps-3">{t.nombre}</td>
                        <td align="center">{t.total_miembros}</td>
                        <td align="center">
                          <SingleSwitch2 
                          isOn={t.status == 1 ? true : false}
                          id={t.id_grupo}
                          handleSwitch={ 
                            (id,valueSwitch) => {
                              handleSwitchGrupo(id,t.nombre,valueSwitch,t)
                            }
                          }
                          // handleSwitch={ 
                          //   () => {
                          //     setState({
                          //       ...state,
                          //       dataGrupos: dataGrupos.map((element,index) => {
                          //         if(element.id_grupo == t.id_grupo){
                          //           element.status = (element.status==1) ? 0 : 1;
                          //         }
                          //         return element;
                          //       })
                          //     })
                          //   }
                          // }
                          type="gerente"
                          />
                        </td>
                        <td align="center">
                          <IconEditar 
                          width="45px" 
                          height="45px" 
                          style={{cursor:'pointer'}} 
                          onClick={ () => handleShowModalEditarGrupo(t.id_grupo,t.nombre) }
                          />
                        </td>
                      </tr>
                    )
                  })
                )
              }

            </tbody>
          </Table>
          {/* <Button className="ws_btn_secundary_transparent btn-sm" onClick={handleShow}><IconPlus width="30px" height="30px" /> Agregar Grupo</Button> */}
          <Modal show={show} onHide={handleClose} backdrop="static" size="lg">
            <Modal.Header closeButton>
              <Modal.Title>Crear Grupo</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
                <Form.Group className="mb-3">
                  <Form.Label>Nombre</Form.Label>
                  <ControlledInput
                  ref={inputNombreGrupo}
                  />
                </Form.Group>
                <hr />
                <Form.Group className="mb-3">
                  <Form.Label>
                    Buscar agentes{" "}
                    <span className="ws_color_primario">{arrListaAgentes.length}</span>
                  </Form.Label>
                  <div style={{ position: "relative" }}>
                    <Form.Control
                      type="search"
                      id="buscar_agente"
                      name="buscar_agente"
                      value={searchModal}
                      onChange={(e) => setSearchModal(e.target.value)}
                      placeholder="Buscar agente por nombre o clave de oficina"
                      style={{ paddingLeft: 50 }}
                    />
                    <IconMinSearch
                      width="30px"
                      height="30px"
                      className="ws_icon_search_input"
                    />
                  </div>
                </Form.Group>
                {/* <Form.Group>
                  <Row>
                    <Col xs={4}>
                      <Form.Label className="text-center ws_color_primario d-block">
                        <p style={{ fontSize: "1.2rem" }} className="mb-0">
                          Oficinas
                        </p>
                      </Form.Label>
                      <Form.Select
                        aria-label="Default select example"
                        value={select.oficina}
                        id="oficinas"
                        name="oficinas"
                        onChange={(e) => {
                          setSelect({
                            ...select,
                            [e.target.name]: e.target.value,
                          });
                        }}
                      >
                        {initState.data[0].oficinas
                          ? initState.data[0].oficinas.map((oficina, index) => (
                              <option value={oficina.clave_oficina} key={index}>
                                {oficina.nombre_oficina}
                              </option>
                            ))
                          : null}
                      </Form.Select>
                    </Col>
                    <Col xs={4}>
                      <Form.Label className="text-center ws_color_primario d-block">
                        <p style={{ fontSize: "1.2rem" }} className="mb-0">
                          Agentes
                        </p>
                      </Form.Label>
                      <Form.Select
                        aria-label="Default select example"
                        value={select.agentes}
                        id="agentes"
                        name="agentes"
                        onChange={(e) => {
                          setSelect({
                            ...select,
                            [e.target.name]: e.target.value,
                          });
                        }}
                      >
                        {initState.data[0].agentes
                          ? initState.data[0].agentes.map((agente, index) => (
                              <option value={agente.value} key={index}>
                                {agente.name}
                              </option>
                            ))
                          : null}
                      </Form.Select>
                    </Col>
                    <Col xs={4}>
                      <Form.Label className="text-center ws_color_primario d-block">
                        <p style={{ fontSize: "1.2rem" }} className="mb-0">
                          Tipos
                        </p>
                      </Form.Label>
                      <Form.Select
                        aria-label="Default select example"
                        value={select.tipos}
                        id="tipos"
                        name="tipos"
                        onChange={(e) => {
                          setSelect({
                            ...select,
                            [e.target.name]: e.target.value,
                          });
                        }}
                      >
                        {initState.data[0].tipos
                          ? initState.data[0].tipos.map((tipos, index) => (
                              <option value={tipos.value} key={index}>
                                {tipos.name}
                              </option>
                            ))
                          : null}
                      </Form.Select>
                    </Col>
                  </Row>
                </Form.Group> */}
              </Form>

              <div style={{maxHeight:'350px',overflow:'hidden',overflowY:'scroll'}}>
                <Table
                  striped
                  bordered
                  hover
                  size="sm"
                  responsive
                  style={{ marginTop: 10 }}
                >
                  <thead style={{ backgroundColor: "#0a93af", color: "#fff", fontSize: ".9rem" }} >
                    <tr>
                      <th width="50%" className="text-center" style={{ padding: 7, fontSize: "1.1rem" }} >
                        Agente
                      </th>
                      <th width="50%" className="text-center" style={{ padding: 7 }} ></th>
                    </tr>
                  </thead>
                  <tbody style={{ fontSize: ".9rem" }}>
                    {
                      (filteredDataListaAgentes.length < 1) && (
                        <tr>
                          <td colSpan={2} className="mt-2 mb-2 text-center">No hay resultados</td>
                        </tr>
                      )
                    }

                    {
                      (filteredDataListaAgentes.length > 0) && (
                        filteredDataListaAgentes.map((t,e) => {
                          return(
                            <tr key={e}>
                              <td align="left">
                                <span
                                  className="ws_color_secundario"
                                  style={{ fontWeight: "700", marginRight: 10 }}
                                >
                                  {t.clave_oficina}
                                </span>
                                <span>
                                  <a href="#" style={{ color: "#606060",textTransform:'uppercase' }}>
                                    {t.n_completo}
                                  </a>
                                </span>
                              </td>
                              <td>
                                <SingleSwitch2 
                                isOn={t.es_miembro == 1 ? true : false}
                                id={t.id_usuario}
                                handleSwitch={ 
                                  (id,valueSwitch) => {
                                    handleSwitchAgentes(id,valueSwitch,t)
                                  }
                                }
                                type="gerente"
                                />
                              </td>
                            </tr>
                          )
                        })
                      )
                    }
                    
                  </tbody>
                </Table>
              </div>

            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="primary"
                className="ws_btn_secundary"
                onClick={handleSubmitCrearGrupo}
                disabled={ state.buttonAddGrupo }
              >
                { (state.buttonAddGrupo) ? 'Creando grupo...' : 'Crear Grupo' }
              </Button>
            </Modal.Footer>
          </Modal>
          {/* MODAL EDITAR GRUPO */}
          <Modal show={state.modalEditarGrupo} onHide={handleCloseModalEditarGrupo} backdrop="static" size="lg">
            <Modal.Header closeButton>  
              <Modal.Title>Editar Grupo</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
                <Form.Group className="mb-3">
                  <Form.Label>Nombre</Form.Label>
                  <ControlledInput
                  ref={inputNombreGrupo}
                  />
                </Form.Group>
                <Form.Group>
                  <Button
                    variant="primary"
                    className="ws_btn_secundary"
                    onClick={ () => handleSaveNombreGrupo(inputNombreGrupo.current.value) }
                    disabled={ state.buttonEditarNombre }
                  >
                    { (state.buttonEditarNombre) ? 'Guardando cambios...' : 'Modificar nombre' }
                  </Button>
                </Form.Group>
                <hr />
                <Form.Group className="mb-3">
                  <Form.Label>
                    Buscar agentes{" "}
                    <span className="ws_color_primario">{arrListaAgentes.length}</span>
                  </Form.Label>
                  <div style={{ position: "relative" }}>
                    <Form.Control
                      type="search"
                      id="buscar_agente"
                      name="buscar_agente"
                      value={searchModal}
                      onChange={(e) => setSearchModal(e.target.value)}
                      placeholder="Buscar agente por nombre o clave de oficina"
                      style={{ paddingLeft: 50 }}
                    />
                    <IconMinSearch
                      width="30px"
                      height="30px"
                      className="ws_icon_search_input"
                    />
                  </div>
                </Form.Group>
              </Form>
              <div style={{maxHeight:'350px',overflow:'hidden', overflowY: (!state.loadingModalEditarGrupo) ? 'scroll' : 'hidden', position:'relative'}}>
                {
                  (state.loadingModalEditarGrupo) && (
                    <div style={{display:'flex',justifyContent:'center',alignItems:'center',position:'absolute',top:0,left:0,bottom:0,right:0,backgroundColor:'rgba(255,255,255,0.8)',zIndex:'2'}}>Cargando...</div>
                  )
                }
                <Table
                  striped
                  bordered
                  hover
                  size="sm"
                  responsive
                  style={{ marginTop: 10 }}
                >
                  <thead style={{ backgroundColor: "#0a93af", color: "#fff", fontSize: ".9rem" }} >
                    <tr>
                      <th width="50%" className="text-center" style={{ padding: 7, fontSize: "1.1rem" }} >
                        Agente
                      </th>
                      <th width="50%" className="text-center" style={{ padding: 7 }} ></th>
                    </tr>
                  </thead>
                  <tbody style={{ fontSize: ".9rem" }}>
                    {
                      (filteredDataListaAgentes.length < 1) && (
                        <tr>
                          <td colSpan={2} className="mt-2 mb-2 text-center">No hay resultados</td>
                        </tr>
                      )
                    }

                    {
                      (filteredDataListaAgentes.length > 0) && (
                        filteredDataListaAgentes.map((t,e) => {
                          return(
                            <tr key={e}>
                              <td align="left">
                                <span
                                  className="ws_color_secundario"
                                  style={{ fontWeight: "700", marginRight: 10 }}
                                >
                                  {t.clave_oficina}
                                </span>
                                <span>
                                  <a href="#" style={{ color: "#606060",textTransform:'uppercase' }}>
                                    {t.n_completo}
                                  </a>
                                </span>
                              </td>
                              <td>
                                <SingleSwitch2 
                                isOn={t.es_miembro == 1 ? true : false}
                                id={t.id_miembro}
                                handleSwitch={ 
                                  (id,valueSwitch) => {
                                    let idUser = (valueSwitch) ? t.id_usuario : t.id_miembro;
                                    // console.log(idUser)
                                    if(idUser!=''){
                                      handleSwitchAgentesEditar(idUser,valueSwitch,t)
                                    }
                                    else{
                                      alert('Id vacio')
                                    }
                                  }
                                }
                                type="gerente"
                                />
                              </td>
                            </tr>
                          )
                        })
                      )
                    }
                    
                  </tbody>
                </Table>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="primary"
                className="ws_btn_secundary"
                onClick={handleCloseModalEditarGrupo}
              >
                Cerrar
              </Button>
            </Modal.Footer>
          </Modal>
        </Container>
      </div>
    </Col>
  );
  //Obtener lista de agentes 
  function getAgentesForGroup(idGrupo=""){
    const dataSend = {
      id_login: usuario.id_usuario,
      id_grupo: idGrupo
    }
    fetch('https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=getAgentesForGroup',{
      method: "post",
      mode: 'cors',
      body: JSON.stringify(dataSend)
    })
    .then( response => response.json() )
    .then( response => {
      setState( (prevState) => ({
        ...prevState,
        arrListaAgentes: response.list,
        loadingModalEditarGrupo: false
      }))
    })
  }
  //Agregar nuevo grupo
  function addGrupo(){
    const dataSend = {
      id_login : usuario.id_usuario,
      nombre: inputNombreGrupo.current.value,
      agentes: agentesSeleccionados
    }
    fetch('https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=addGrupo', {
      method: "post",
      mode: 'cors',
      body: JSON.stringify(dataSend)
    })
    .then( response => response.json() )
    .then( response => {
      alert(`Se ha creado el grupo ${inputNombreGrupo.current.value}`)
      setState((prevState) => ({
        ...prevState,
        arrListaAgentes: prevState.arrListaAgentes.map( (t,e) => {
          if(t.es_miembro=='1'){
            t.es_miembro = 0
          }
          return t;
        }),
        buttonAddGrupo: false,
        agentesSeleccionados: []
      }));
      inputNombreGrupo.current.value = '';
      handleClose();
      reload();
    })
  }
  //Eliminar grupo
  function deleteGrupo(id,nombre){
    const dataSend = {
      id_login : usuario.id_usuario,
      id_grupo : id
    }
    fetch('https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=deleteGrupo',{
      method: "post",
      mode: 'cors',
      body: JSON.stringify(dataSend)
    })
    .then( response => response.json() )
    .then( response => {
      if(response.status=='ok'){
        console.log(`Se ha desactivado el grupo ${nombre}`);
      }
    })
  }
  //Activar Grupo
  function activateGrupo(id,nombre){
    const dataSend = {
      id_login : usuario.id_usuario,
      id_grupo : id
    }
    fetch('https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=activateGrupo',{
      method: "post",
      mode: 'cors',
      body: JSON.stringify(dataSend)
    })
    .then( response => response.json() )
    .then( response => {
      if(response.status=='ok'){
        console.log(`Se ha activado el grupo ${nombre}`);
      }
    })
  }
  //Modificar nombre del grupo
  function updateNombreGrupo(id,nombre){
    setState((prevState) => ({ ...prevState, buttonEditarNombre: true }))
    const dataSend = {
      id_login : usuario.id_usuario,
      id_grupo : id,
      nombre
    }
    fetch('https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=updateNombreGrupo',{
      method: 'post',
      mode: 'cors',
      body: JSON.stringify(dataSend)
    })
    .then( response => response.json() )
    .then ( response => {
      setState((prevState) => ({ ...prevState, buttonEditarNombre: false }))
      reload();
      alert('Se ha actualizado el nombre del grupo')
    })
  }
  //Agregar agente a un grupo
  function addAgenteToGrupo(id_grupo,id_usuario){
    const dataSend = {
      id_login : usuario.id_usuario,
      id_grupo,
      id_usuario
    }
    fetch('https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=addAgenteToGrupo',{
      method: 'post',
      mode: 'cors',
      body: JSON.stringify(dataSend)
    })
    .then( response => response.json() )
    .then( response => {
      reload();
      console.log(response)
    });
  }
  //Eliminar agente de un grupo
  function deleteAgenteGrupo(id_grupo,id_miembro){
    const dataSend = {
      id_login : usuario.id_usuario,
      id_grupo,
      id_miembro
    }
    fetch('https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=deleteAgenteGrupo',{
      method: 'post',
      mode: 'cors',
      body: JSON.stringify(dataSend)
    })
    .then( response => response.json() )
    .then( response => {
      reload();
      console.log(response)
    });
  }
}

function TablaEditarPromotorias({ initState, updateState, data }) {
  const currentYear = new Date().getFullYear();
  const [valueSwitch, setValueSwitch] = useState(true);
  const [search, setSearch] = useState("");
  const [mode, setMode] = useState(true);

  const [searchModal, setSearchModal] = useState("");
  const [nombre, setNombre] = useState("");

  const [select, setSelect] = useState({
    oficinas: "0",
    agentes: "0",
    tipos: "0",
  });

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <Col xs={12} md={12} className="mb-3">
      <div
        className="ws_box"
        style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
      >
        <Container fluid>
          <div className="ws_box_header mb-3">
            <div className="d-flex justify-content-start align-items-end">
              <div>
                <h2 className="ws_table_agente_title pb-0 mb-2">
                  Editar Promotorías
                </h2>
              </div>
            </div>
            <div className="d-flex flex-column justify-content-between align-items-end">
              <div className="d-flex flex-row justify-content-between align-self-center align-items-center">
                <Button
                  className="ws_btn_secundary_transparent btn-sm me-2"
                  onClick={handleShow}
                >
                  <IconPlus width="30px" height="30px" /> Agregar Promotoría
                </Button>
                <Form>
                  <Form.Control
                    type="search"
                    placeholder="Buscar"
                    className="ws_input"
                    onChange={(e) => {
                      setSearch(e.target.value);
                    }}
                  />
                </Form>
                <Dropdown className="ws_dropdown">
                  <Dropdown.Toggle id="dropdown-basic">
                    <Image
                      src={"img/darkOpt.svg"}
                      alt="icon_opt"
                      className="ws_icon ms-2"
                    />
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item href="#">Quitar del dashboard</Dropdown.Item>
                    <Dropdown.Item href="#">Duplicar</Dropdown.Item>
                    <Dropdown.Item href="#">Ocultar en móvil</Dropdown.Item>
                    <Dropdown.Item href="#">Exportar</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          </div>
          <Table
            striped
            bordered
            hover
            size="sm"
            responsive
            className="ws_tabla"
          >
            <thead
              style={{
                backgroundColor: "#0a93af",
                color: "#fff",
                fontSize: ".9rem",
              }}
            >
              <tr>
                <th className="text-left ps-3">CLAVE</th>
                <th className="text-left">GRUPO</th>
                <th className="text-center">MIEMBROS</th>
                <th className="text-center">ESTADO</th>
                <th className="text-center">EDITAR</th>
              </tr>
            </thead>
            <tbody style={{ fontSize: ".9rem" }}>
              <tr>
                <td className="text-left ps-3">15529</td>
                <td className="text-left">Trad Consultores SA de CV</td>
                <td align="center">11</td>
                <td align="center">
                  <SingleSwitch isOn={true} id={"63"} />
                </td>
                <td align="center">
                  <IconEditar width="45px" height="45px" />
                </td>
              </tr>
              <tr>
                <td className="text-left ps-3">90121</td>
                <td className="text-left">Quálitas Compañia de Seguros</td>
                <td align="center">11</td>
                <td align="center">
                  <SingleSwitch isOn={true} id={"63"} />
                </td>
                <td align="center">
                  <Button className="btn btn-primary ws_btn_secundary">
                    Aplicar Cambios
                  </Button>
                </td>
              </tr>
            </tbody>
          </Table>
          <Button
            className="ws_btn_secundary_transparent btn-sm"
            onClick={handleShow}
          >
            <IconPlus width="30px" height="30px" /> Agregar Promotoría
          </Button>
          <Modal show={show} onHide={handleClose} backdrop="static" size="lg">
            <Modal.Header closeButton>
              <Modal.Title>Crear Promotoría</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
                <Form.Group className="mb-3">
                  <Form.Label>Nombre</Form.Label>
                  <Form.Control
                    type="text"
                    id="nombre_grupo"
                    name="nombre_grupo"
                    value={nombre}
                    onChange={(e) => setNombre(e.target.value)}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Agregar agentes{" "}
                    <span className="ws_color_primario">13</span>
                  </Form.Label>
                  <div style={{ position: "relative" }}>
                    <Form.Control
                      type="search"
                      id="buscar_agente"
                      name="buscar_agente"
                      value={searchModal}
                      onChange={(e) => setSearchModal(e.target.value)}
                      style={{ paddingLeft: 50 }}
                    />
                    <IconMinSearch
                      width="30px"
                      height="30px"
                      className="ws_icon_search_input"
                    />
                  </div>
                </Form.Group>
                <Form.Group>
                  <Row>
                    <Col xs={4}>
                      <Form.Label className="text-center ws_color_primario d-block">
                        <p style={{ fontSize: "1.2rem" }} className="mb-0">
                          Oficinas
                        </p>
                      </Form.Label>
                      <Form.Select
                        aria-label="Default select example"
                        value={select.oficina}
                        id="oficinas"
                        name="oficinas"
                        onChange={(e) => {
                          setSelect({
                            ...select,
                            [e.target.name]: e.target.value,
                          });
                        }}
                      >
                        {initState.data[0].oficinas
                          ? initState.data[0].oficinas.map((oficina, index) => (
                              <option value={oficina.clave_oficina} key={index}>
                                {oficina.nombre_oficina}
                              </option>
                            ))
                          : null}
                      </Form.Select>
                    </Col>
                    <Col xs={4}>
                      <Form.Label className="text-center ws_color_primario d-block">
                        <p style={{ fontSize: "1.2rem" }} className="mb-0">
                          Agentes
                        </p>
                      </Form.Label>
                      <Form.Select
                        aria-label="Default select example"
                        value={select.agentes}
                        id="agentes"
                        name="agentes"
                        onChange={(e) => {
                          setSelect({
                            ...select,
                            [e.target.name]: e.target.value,
                          });
                        }}
                      >
                        {initState.data[0].agentes
                          ? initState.data[0].agentes.map((agente, index) => (
                              <option value={agente.value} key={index}>
                                {agente.name}
                              </option>
                            ))
                          : null}
                      </Form.Select>
                    </Col>
                    <Col xs={4}>
                      <Form.Label className="text-center ws_color_primario d-block">
                        <p style={{ fontSize: "1.2rem" }} className="mb-0">
                          Tipos
                        </p>
                      </Form.Label>
                      <Form.Select
                        aria-label="Default select example"
                        value={select.tipos}
                        id="tipos"
                        name="tipos"
                        onChange={(e) => {
                          setSelect({
                            ...select,
                            [e.target.name]: e.target.value,
                          });
                        }}
                      >
                        {initState.data[0].tipos
                          ? initState.data[0].tipos.map((tipos, index) => (
                              <option value={tipos.value} key={index}>
                                {tipos.name}
                              </option>
                            ))
                          : null}
                      </Form.Select>
                    </Col>
                  </Row>
                </Form.Group>
              </Form>
              <Table
                striped
                bordered
                hover
                size="sm"
                responsive
                style={{ marginTop: 40 }}
              >
                <thead
                  style={{
                    backgroundColor: "#0a93af",
                    color: "#fff",
                    fontSize: ".9rem",
                  }}
                >
                  <tr>
                    <th
                      width="50%"
                      className="text-center"
                      style={{ padding: 7, fontSize: "1.1rem" }}
                    >
                      Agente
                    </th>
                    <th
                      width="50%"
                      className="text-center"
                      style={{ padding: 7 }}
                    ></th>
                  </tr>
                </thead>
                <tbody style={{ fontSize: ".9rem" }}>
                  <tr>
                    <td align="left">
                      <span
                        className="ws_color_secundario"
                        style={{ fontWeight: "700", marginRight: 10 }}
                      >
                        69
                      </span>
                      <span>
                        <a href="#" style={{ color: "#606060" }}>
                          Marcela Rocha Arredondo
                        </a>
                      </span>
                    </td>
                    <td>
                      <SingleSwitch isOn={true} id={"69"} />
                    </td>
                  </tr>
                  <tr>
                    <td align="left">
                      <span
                        className="ws_color_secundario"
                        style={{ fontWeight: "700", marginRight: 10 }}
                      >
                        68
                      </span>
                      <span>
                        <a href="#" style={{ color: "#606060" }}>
                          Julio Ernesto Silva Gomez
                        </a>
                      </span>
                    </td>
                    <td>
                      <SingleSwitch isOn={true} id={"68"} />
                    </td>
                  </tr>
                  <tr>
                    <td align="left">
                      <span
                        className="ws_color_secundario"
                        style={{ fontWeight: "700", marginRight: 10 }}
                      >
                        67
                      </span>
                      <span>
                        <a href="#" style={{ color: "#606060" }}>
                          Julio Jose de Jesús Yañez Mar
                        </a>
                      </span>
                    </td>
                    <td>
                      <SingleSwitch isOn={false} id={"67"} />
                    </td>
                  </tr>
                  <tr>
                    <td align="left">
                      <span
                        className="ws_color_secundario"
                        style={{ fontWeight: "700", marginRight: 10 }}
                      >
                        66
                      </span>
                      <span>
                        <a href="#" style={{ color: "#606060" }}>
                          Julio Liliana Salazar Rocha
                        </a>
                      </span>
                    </td>
                    <td>
                      <SingleSwitch isOn={true} id={"66"} />
                    </td>
                  </tr>
                  <tr>
                    <td align="left">
                      <span
                        className="ws_color_secundario"
                        style={{ fontWeight: "700", marginRight: 10 }}
                      >
                        65
                      </span>
                      <span>
                        <a href="#" style={{ color: "#606060" }}>
                          Julio Francisco García de la Cruz
                        </a>
                      </span>
                    </td>
                    <td>
                      <SingleSwitch isOn={false} id={"65"} />
                    </td>
                  </tr>
                  <tr>
                    <td align="left">
                      <span
                        className="ws_color_secundario"
                        style={{ fontWeight: "700", marginRight: 10 }}
                      >
                        64
                      </span>
                      <span>
                        <a href="#" style={{ color: "#606060" }}>
                          Julio Emmanuel González González
                        </a>
                      </span>
                    </td>
                    <td>
                      <SingleSwitch isOn={true} id={"64"} />
                    </td>
                  </tr>
                  <tr>
                    <td align="left">
                      <span
                        className="ws_color_secundario"
                        style={{ fontWeight: "700", marginRight: 10 }}
                      >
                        63
                      </span>
                      <span>
                        <a href="#" style={{ color: "#606060" }}>
                          Julio Xochitl Remedios Guerra
                        </a>
                      </span>
                    </td>
                    <td>
                      <SingleSwitch isOn={true} id={"63"} />
                    </td>
                  </tr>
                  <tr>
                    <td align="left">
                      <span
                        className="ws_color_secundario"
                        style={{ fontWeight: "700", marginRight: 10 }}
                      >
                        62
                      </span>
                      <span>
                        <a href="#" style={{ color: "#606060" }}>
                          Julio Marcela Huacuja Rodríguez
                        </a>
                      </span>
                    </td>
                    <td>
                      <SingleSwitch isOn={false} id={"62"} />
                    </td>
                  </tr>
                </tbody>
              </Table>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="primary"
                className="ws_btn_secundary"
                onClick={handleClose}
              >
                Crear Grupo
              </Button>
            </Modal.Footer>
          </Modal>
        </Container>
      </div>
    </Col>
  );
}

function TablaMisOficinas({ initState, updateState, data, load, reload }) {
  const { usuario } = useContext(AuthContext);
  const form = useRef(null);

  const currentYear = new Date().getFullYear();
  const [valueSwitch, setValueSwitch] = useState(true);
  const [search, setSearch] = useState("");

  const [nombre, setNombre] = useState("");
  const [clave, setClave] = useState("");
  const [tipo, setTipo] = useState("");
  const [submitForm, setSubmitForm] = useState(false);
  const [editOficina, setEditOficina] = useState(false);
  const [indexInput, setIndexInput] = useState(0);

  const [dataForm, setDataForm] = useState({
    id_login: usuario.id_usuario,
    nombre_oficina: "",
    clave_oficina: "",
    tipo_oficina: "",
  });
  const [dataOficinas, setDataOficinas] = useState([]);

  const [show, setShow] = useState(false);

  const handleClose = () => {
    setShow(false);
  };
  const handleShow = () => {
    setEditOficina(false);
    setDataForm({
      id_login: usuario.id_usuario,
      nombre_oficina: "",
      clave_oficina: "",
      tipo_oficina: "",
    });
    setShow(true);
  };

  useEffect(() => {
    setDataOficinas(data);
  }, [data]);

  function onEditPhone(index, data) {
    setDataForm({
      id_login: usuario.id_usuario,
      id_oficina: data.id_oficina,
      nombre_oficina: data.nombre_oficina,
      clave_oficina: data.clave_oficina,
      tipo_oficina: data.tipo_oficina,
    });
    if (editOficina == false) {
      setIndexInput(index);
      setEditOficina(true);
    } else {
      setEditOficina(false);
    }
  }

  if (load) {
    return (
      <Col xs={12} md={12} className="mb-3">
        <div
          className="ws_box"
          style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
        >
          <Container fluid>
            <div className="ws_box_header mb-3">
              <div className="d-flex justify-content-start align-items-end">
                <div>
                  <h2 className="ws_table_agente_title pb-0 mb-2">
                    Editar Oficinas
                  </h2>
                </div>
              </div>
            </div>
            <Skeleton width="100%" height={400} />
          </Container>
        </div>
      </Col>
    );
  }

  return (
    <Col xs={12} md={12} className="mb-3">
      <div
        className="ws_box"
        style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
      >
        <Container fluid>
          <div className="ws_box_header mb-3">
            <div className="d-flex justify-content-start align-items-end">
              <div>
                <h2 className="ws_table_agente_title pb-0 mb-2">
                  Editar Oficinas
                </h2>
              </div>
            </div>
            <div className="d-flex flex-column justify-content-between align-items-end">
              <div className="d-flex flex-row justify-content-between align-self-center align-items-center">
                <Button
                  className="ws_btn_secundary_transparent btn-sm me-2"
                  onClick={handleShow}
                >
                  <IconPlus width="30px" height="30px" /> Agregar Ofcina
                </Button>
                <Form>
                  <Form.Control
                    type="search"
                    placeholder="Buscar"
                    className="ws_input"
                    onChange={(e) => {
                      setSearch(e.target.value);
                    }}
                  />
                </Form>
              </div>
            </div>
          </div>
          <div className="table-responsive" style={{ maxHeight: 450 }}>
            <Table striped bordered hover size="sm" className="ws_tabla">
              <thead
                style={{
                  backgroundColor: "#0a93af",
                  color: "#fff",
                  fontSize: ".9rem",
                }}
              >
                <tr>
                  <th className="text-left ps-3" width="5%">
                    CLAVE
                  </th>
                  <th className="text-left ps-3" width="60%">
                    OFICINA
                  </th>
                  <th className="text-center" width="10%">
                    TIPO
                  </th>
                  <th className="text-center" widht="10%">
                    ESTADO
                  </th>
                  <th className="text-center" width="15%">
                    EDITAR
                  </th>
                </tr>
              </thead>
              <tbody style={{ fontSize: ".9rem" }}>
                {dataOficinas.length > 0 ? (
                  dataOficinas.map((t, e) => {
                    if (
                      search === "" ||
                      (t.clave_oficina &&
                        t.clave_oficina.toString().indexOf(search) !== -1) ||
                      (t.nombre_oficina &&
                        t.nombre_oficina
                          .toLowerCase()
                          .indexOf(search.toLowerCase()) !== -1)
                    ) {
                      return (
                        <tr key={e}>
                          <td className="text-left ps-3 text-center">
                            {editOficina && indexInput == e ? (
                              <Form.Control
                                type="text"
                                name="clave_oficina"
                                id="clave_oficina"
                                value={dataForm.clave_oficina}
                                onChange={(e) => {
                                  let newArr = { ...dataForm };
                                  newArr[e.target.name] = e.target.value;
                                  setDataForm(newArr);
                                }}
                              />
                            ) : (
                              <p className="mb-0">{t.clave_oficina}</p>
                            )}
                          </td>
                          <td className="text-left ps-3">
                            {editOficina && indexInput == e ? (
                              <Form.Control
                                type="text"
                                name="nombre_oficina"
                                id="nombre_oficina"
                                value={dataForm.nombre_oficina}
                                onChange={(e) => {
                                  let newArr = { ...dataForm };
                                  newArr[e.target.name] = e.target.value;
                                  setDataForm(newArr);
                                }}
                              />
                            ) : (
                              <p className="mb-0 ws_name_table">
                                {t.nombre_oficina}
                              </p>
                            )}
                          </td>
                          <td align="center">
                            {editOficina && indexInput == e ? (
                              <Form.Select
                                id="tipo_oficina"
                                name="tipo_oficina"
                                aria-label="tipo_oficina"
                                key={uuidv4()}
                                value={dataForm.tipo_oficina}
                                required
                                onChange={(e) => {
                                  let newArr = { ...dataForm };
                                  newArr[e.target.name] = e.target.value;
                                  setDataForm(newArr);
                                }}
                              >
                                <option value="" disabled>
                                  Tipo de oficina
                                </option>
                                <option value="1">Servicio</option>
                                <option value="2">ODQ</option>
                              </Form.Select>
                            ) : t.tipo_oficina === 1 ? (
                              "Servicio"
                            ) : t.tipo_oficina === 2 ? (
                              "ODQ"
                            ) : (
                              ""
                            )}
                          </td>
                          <td align="center">
                            <SingleSwitch
                              isOn={t.status == 1 ? true : false}
                              handleSwitch={() => {
                                updateStatusOficina(
                                  e,
                                  !t.status,
                                  t.clave_oficina
                                );
                              }}
                            />
                          </td>
                          <td align="center">
                            {editOficina && indexInput == e ? (
                              <Button
                                className="btn btn-primary ws_btn_secundary"
                                onClick={() => {
                                  updateOficina();
                                }}
                              >
                                Aplicar Cambios
                              </Button>
                            ) : (
                              <IconEditar
                                style={{
                                  width: "45px",
                                  height: "45px",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  onEditPhone(
                                    e,
                                    (data = {
                                      nombre_oficina: t.nombre_oficina,
                                      clave_oficina: t.clave_oficina,
                                      tipo_oficina: t.tipo_oficina,
                                      id_oficina: t.id_oficina,
                                    })
                                  );
                                }}
                              />
                            )}
                          </td>
                        </tr>
                      );
                    }
                  })
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center">
                      <p className="mb-0">No hay datos disponibles</p>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
          <Button
            className="ws_btn_secundary_transparent btn-sm"
            onClick={handleShow}
          >
            <IconPlus width="30px" height="30px" /> Agregar Oficina
          </Button>
          <Modal show={show} onHide={handleClose} backdrop="static" size="lg">
            <Form
              onSubmit={(e) => {
                addNewOficina(e);
              }}
              ref={form}
            >
              <Modal.Header closeButton>
                <Modal.Title>Crear Oficina</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form.Group className="mb-3">
                  <Form.Label>Nombre</Form.Label>
                  <Form.Control
                    type="text"
                    id="nombre_oficina"
                    name="nombre_oficina"
                    value={dataForm.nombre_oficina}
                    required
                    onChange={(e) => {
                      let newArr = { ...dataForm };
                      newArr[e.target.name] = e.target.value;
                      setDataForm(newArr);
                    }}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Clave</Form.Label>
                  <Form.Control
                    type="text"
                    id="clave_oficina"
                    name="clave_oficina"
                    value={dataForm.clave_oficina}
                    required
                    onChange={(e) => {
                      let newArr = { ...dataForm };
                      validateNumber(e.target.value, (response) => {
                        newArr[e.target.name] = response;
                        setDataForm(newArr);
                      });
                    }}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Tipo</Form.Label>
                  <Form.Select
                    value={tipo}
                    id="tipo_oficina"
                    name="tipo_oficina"
                    aria-label="tipo_oficina"
                    key={uuidv4()}
                    value={dataForm.tipo_oficina}
                    required
                    onChange={(e) => {
                      let newArr = { ...dataForm };
                      newArr[e.target.name] = e.target.value;
                      setDataForm(newArr);
                    }}
                  >
                    <option value="" disabled>
                      Tipo de oficina
                    </option>
                    <option value="1">Servicio</option>
                    <option value="2">ODQ</option>
                  </Form.Select>
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  type="submit"
                  variant="primary"
                  className="ws_btn_secundary"
                  disabled={submitForm ? true : false}
                >
                  Crear Oficina
                </Button>
              </Modal.Footer>
            </Form>
          </Modal>
        </Container>
      </div>
    </Col>
  );

  function updateStatusOficina(index, status, id) {
    const dataSend = {
      id_login: usuario.id_usuario,
      status: status ? "1" : "0",
      id_oficina: id,
    };
    fetch(
      `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=updateStatusOficina`,
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(dataSend),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        if (res.status == "ok") {
          let newArr = [...dataOficinas];
          newArr[index].status = status ? 1 : 0;
          setDataOficinas(newArr);
        } else {
          console.log(res);
        }
      });
  }

  function addNewOficina(e) {
    setSubmitForm(true);
    e.preventDefault();
    fetch(
      `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=addNewOficina`,
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(dataForm),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        setSubmitForm(false);
        if (res.status == "ok") {
          alert("Oficina agregada correctamente");
          reload();
        } else {
          alert("Ha ocurrido un error intenta de nuevo");
        }
      });
  }

  function updateOficina() {
    fetch(
      `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=updateOficina`,
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(dataForm),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        setSubmitForm(false);
        setEditOficina(false);
        setDataForm({
          id_login: usuario.id_usuario,
          nombre_oficina: "",
          clave_oficina: "",
          tipo_oficina: "",
        });
        if (res.status == "ok") {
          reload();
          alert("Oficina actualizada correctamente");
        } else {
          alert("Ha ocurrido un error intenta de nuevo");
        }
      });
  }

  function validateNumber(value, callback) {
    var inputValue = value.trim();
    // var span = $this.target.nextSibling;
    if (/\D/g.test(inputValue)) inputValue = inputValue.replace(/\D/g, "");

    // if(inputValue.length == 0){
    // 	$this.target.classList.add('ws-control-error')
    // 	span.innerHTML = '<img className="icon-fail" src="https://tarjeta.id/qualitas/imgs/iconfail.png">';
    // }else{
    // 	$this.target.classList.remove('ws-control-error')
    // 	span.innerHTML = '<img className="icon-fail" src="https://tarjeta.id/qualitas/imgs/iconcheck.png">';
    // }
    callback(inputValue);
  }
}

function TablaMisAgentes({ initState, updateState, data, setData, load, reload }) {
  const { usuario } = useContext(AuthContext);

  const refTable = useRef(null);
  const refTable2 = useRef(null);
  const divRes = useRef(null);
  const divRes2 = useRef(null);

  const [search, setSearch] = useState("");
  const [step, setStep] = useState(1);
  const [dataAgentes, setDataAgentes] = useState([]);
  const [submitForm, setSubmitForm] = useState(false);
  const [editAgente, setEditAgente] = useState(false);
  const [indexInput, setIndexInput] = useState(0);

  const [dataForm, setDataForm] = useState({
    id_login: usuario.id_usuario,
    nombre_agente: "",
    correo_agente: "",
    oficina_agente: "",
    tipo_agente: "",
    correo_asistente_agente: "",
    bono_produccion_file: "",
    cvex_file: "",
    rfc_homoclave: "",
    curp_agente: "",
    escolaridad_agente: "",
    telefono_agente: "",
  });

  let totalPasos = 2;
  let percentStep = (step * 100) / 2;

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => {
    setEditAgente(false);
    setDataForm({
      id_login: usuario.id_usuario,
      nombre_agente: "",
      correo_agente: "",
      oficina_agente: "",
      tipo_agente: "",
      correo_asistente_agente: "",
      bono_produccion_file: "",
      cvex_file: "",
      rfc_homoclave: "",
      curp_agente: "",
      escolaridad_agente: "",
      telefono_agente: "",
    });
    setShow(true);
  };

  useEffect(() => {
    setDataAgentes(data);
  }, [data]);

  function onEditAgente(index, data) {
    setDataForm({
      id_login: usuario.id_usuario,
      id_usuario: data.id_usuario,
      nombre: data.nombre,
      apellidos: data.apellidos,
      apellido_paterno: data.paterno,
      apellido_materno: data.materno,
      email: data.email,
      telefono: data.telefono,
      tipo_agente: data.ejecutivo,
    });
    if (editAgente == false) {
      setIndexInput(index);
      setEditAgente(true);
    } else {
      setEditAgente(false);
    }
  }

  const nextStep = () => {
    if (step > 0 && step < 2) {
      setStep(step + 1);
    }
  };
  const backStep = () => {
    if (step > 0 && step < 3) {
      setStep(step - 1);
    }
  };

  if (load) {
    return (
      <Col xs={12} md={12} className="mb-3">
        <div
          className="ws_box"
          style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
        >
          <Container fluid>
            <div className="ws_box_header mb-3">
              <div className="d-flex justify-content-start align-items-end">
                <div>
                  <h2 className="ws_table_agente_title pb-0 mb-2">
                    Editar Agentes
                  </h2>
                </div>
              </div>
            </div>
            <Skeleton width="100%" height={400} />
          </Container>
        </div>
      </Col>
    );
  }

  return (
    <Col xs={12} md={12} className="mb-3">
      <div
        className="ws_box"
        style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
      >
        <Container fluid>
          <div className="ws_box_header mb-3">
            <div className="d-flex justify-content-start align-items-end">
              <div>
                <h2 className="ws_table_agente_title pb-0 mb-2">
                  Editar Agentes
                </h2>
              </div>
            </div>
            <div className="d-flex flex-column justify-content-between align-items-end">
              <div className="d-flex flex-row justify-content-between align-self-center align-items-center">
                {/* <Button className="ws_btn_secundary_transparent btn-sm me-2" onClick={handleShow}><IconPlus width="30px" height="30px" /> Agregar Agente</Button> */}
                <Form>
                  <Form.Control
                    type="search"
                    placeholder="Buscar"
                    className="ws_input"
                    onChange={(e) => {
                      setSearch(e.target.value);
                    }}
                  />
                </Form>
              </div>
            </div>
          </div>
          <div
            className="table-responsive"
            ref={divRes2}
            style={{ maxHeight: 450 }}
          >
            <Table
              striped
              bordered
              hover
              size="sm"
              className="ws_tabla"
              ref={refTable}
            >
              <thead
                style={{
                  backgroundColor: "#0a93af",
                  color: "#fff",
                  fontSize: ".9rem",
                }}
              >
                <tr>
                  <th className="text-left ps-3" width="10%">
                    CLAVE OFICINA
                  </th>
                  <th className="text-left ps-3" width="25%">
                    AGENTE
                  </th>
                  <th className="text-left ps-3" width="25%">
                    EMAIL
                  </th>
                  <th className="text-center" width="10%">
                    TELÉFONO
                  </th>
                  <th className="text-center" width="10%">
                    TIPO
                  </th>
                  <th className="text-center" width="10%">
                    ESTADO
                  </th>
                  <th className="text-center" width="10%">
                    EDITAR
                  </th>
                </tr>
              </thead>
              <tbody style={{ fontSize: ".9rem" }}>
                {dataAgentes.map((t, e) => {
                  if (
                    search === "" ||
                    (t.clave_oficina &&
                      t.clave_oficina.toString().indexOf(search) !== -1) ||
                    (t.nombre &&
                      t.nombre.toLowerCase().indexOf(search.toLowerCase()) !==
                        -1) ||
                    (t.paterno &&
                      t.paterno.toLowerCase().indexOf(search.toLowerCase()) !==
                        -1) ||
                    (t.materno &&
                      t.materno.toLowerCase().indexOf(search.toLowerCase()) !==
                        -1)
                  ) {
                    return (
                      <tr key={e}>
                        <td className="text-center">
                          <p className="mb-0">{t.clave_oficina}</p>
                        </td>
                        <td className="text-left ps-3 ws_name_table">
                          {editAgente && indexInput == e ? (
                            <React.Fragment>
                              <Form.Control
                                className="mb-2"
                                type="text"
                                name="nombre"
                                id="nombre"
                                value={dataForm.nombre}
                                placeholder="Nombre"
                                onChange={(e) => {
                                  let newArr = { ...dataForm };
                                  newArr[e.target.name] = e.target.value;
                                  setDataForm(newArr);
                                }}
                              />
                              <Form.Control
                                className="mb-2"
                                type="text"
                                name="apellido_paterno"
                                id="apellido_paterno"
                                value={dataForm.apellido_paterno}
                                placeholder="Apellido paterno"
                                onChange={(e) => {
                                  let newArr = { ...dataForm };
                                  newArr[e.target.name] = e.target.value;
                                  setDataForm(newArr);
                                }}
                              />
                              <Form.Control
                                className="mb-2"
                                type="text"
                                name="apellido_materno"
                                id="apellido_materno"
                                value={dataForm.apellido_materno}
                                placeholder="Apellido materno"
                                onChange={(e) => {
                                  let newArr = { ...dataForm };
                                  newArr[e.target.name] = e.target.value;
                                  setDataForm(newArr);
                                }}
                              />
                            </React.Fragment>
                          ) : (
                            <p className="mb-0">
                              {t.nombre} {t.paterno} {t.materno}
                            </p>
                          )}
                        </td>
                        <td className="text-left ps-3">
                          {editAgente && indexInput == e ? (
                            <Form.Control
                              type="text"
                              name="email"
                              id="email"
                              value={dataForm.email}
                              onChange={(e) => {
                                let newArr = { ...dataForm };
                                newArr[e.target.name] = e.target.value;
                                setDataForm(newArr);
                              }}
                            />
                          ) : (
                            <p className="mb-0">{t.email}</p>
                          )}
                        </td>
                        <td className="text-center">
                          {editAgente && indexInput == e ? (
                            <Form.Control
                              type="text"
                              name="telefono"
                              id="telefono"
                              value={dataForm.telefono}
                              onChange={(e) => {
                                let newArr = { ...dataForm };
                                newArr[e.target.name] = e.target.value;
                                setDataForm(newArr);
                              }}
                            />
                          ) : (
                            <p className="mb-0">{t.telefono}</p>
                          )}
                        </td>
                        <td align="center">
                          {editAgente && indexInput == e ? (
                            <Form.Select
                              id="tipo_agente"
                              name="tipo_agente"
                              aria-label="tipo_agente"
                              key={uuidv4()}
                              value={dataForm.tipo_agente}
                              required
                              onChange={(e) => {
                                let newArr = { ...dataForm };
                                newArr[e.target.name] = e.target.value;
                                setDataForm(newArr);
                              }}
                            >
                              <option value="" disabled>
                                Tipo
                              </option>
                              <option value="1">FA</option>
                              <option value="2">CONSOLIDADO</option>
                              <option value="3">ESPECIAL</option>
                            </Form.Select>
                          ) : (
                            <p className="mb-0 ws_name_table">
                              {t.tipo_agente_text}
                            </p>
                          )}
                        </td>
                        <td align="center">
                          {/* <SingleSwitch isOn={true} id={"63"} /> */}
                          <SingleSwitchConfirm
                            isOn={t.status == 2 ? true : false}
                            text="Si desactivas un agente ya no podrás volver a activarlo. ¿Deseas continuar?"
                            handleSwitch={() => {
                              updateStatusAgente(
                                e,
                                !(t.status == 2) ? true : false,
                                t.id_usuario
                              )
                            }}
                          />
                        </td>
                        <td align="center">
                          {editAgente && indexInput == e ? (
                            <Button
                              className="btn btn-primary ws_btn_secundary"
                              onClick={() => {
                                updateInfoAgente();
                              }}
                            >
                              Aplicar Cambios
                            </Button>
                          ) : (
                            <IconEditar
                              style={{
                                width: "45px",
                                height: "45px",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                onEditAgente(
                                  e,
                                  (data = {
                                    nombre: t.nombre,
                                    apellidos: `${t.paterno} ${t.materno}`,
                                    email: t.email,
                                    telefono: t.telefono,
                                    ejecutivo: t.tipo_agente,
                                    id_usuario: t.id_usuario,
                                    paterno: t.paterno,
                                    materno: t.materno,
                                  })
                                );
                              }}
                            />
                          )}
                        </td>
                      </tr>
                    );
                  }
                })}
              </tbody>
            </Table>
          </div>
          {/* <Button className="ws_btn_secundary_transparent btn-sm" onClick={handleShow}><IconPlus width="30px" height="30px" /> Agregar Agente</Button> */}
          <Modal show={show} onHide={handleClose} backdrop="static" size="lg">
            <Modal.Header closeButton>
              <Modal.Title>
                {step === 1 ? "Crear Agente" : "Ficha de Agente"}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
                {step === 1 ? (
                  <React.Fragment>
                    <Form.Group className="mb-3">
                      <Form.Label>Nombre</Form.Label>
                      <Form.Control
                        type="text"
                        id="nombre_agente"
                        name="nombre_agente"
                        value={dataForm.nombre_agente}
                        onChange={(e) => {
                          let newArr = { ...dataForm };
                          newArr[e.target.name] = e.target.value;
                          setDataForm(newArr);
                        }}
                      />
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label>Correo</Form.Label>
                      <Form.Control
                        type="text"
                        id="correo_agente"
                        name="correo_agente"
                        value={dataForm.correo_agente}
                        onChange={(e) => {
                          let newArr = { ...dataForm };
                          newArr[e.target.name] = e.target.value;
                          setDataForm(newArr);
                        }}
                      />
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label>Oficina</Form.Label>
                      <Form.Select
                        value={dataForm.oficina_agente}
                        id="oficina_agente"
                        name="oficina_agente"
                        aria-label="oficina_agente"
                        key={uuidv4()}
                        onChange={(e) => {
                          let newArr = { ...dataForm };
                          newArr[e.target.name] = e.target.value;
                          setDataForm(newArr);
                        }}
                      >
                        <option value="" disabled>
                          Oficina
                        </option>
                        <option value="1">Cd Valles</option>
                      </Form.Select>
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label>Tipo</Form.Label>
                      <Form.Select
                        value={dataForm.tipo_agente}
                        id="tipo_agente"
                        name="tipo_agente"
                        aria-label="tipo_agente"
                        key={uuidv4()}
                        onChange={(e) => {
                          let newArr = { ...dataForm };
                          newArr[e.target.name] = e.target.value;
                          setDataForm(newArr);
                        }}
                      >
                        <option value="" disabled>
                          Tipo
                        </option>
                        <option value="1">FA</option>
                      </Form.Select>
                    </Form.Group>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <Form.Group className="mb-3">
                      <Form.Label>Correo del asistente</Form.Label>
                      <Form.Control
                        type="text"
                        id="correo_asistente_agente"
                        name="correo_asistente_agente"
                        value={dataForm.correo_asistente_agente}
                        onChange={(e) => {
                          let newArr = { ...dataForm };
                          newArr[e.target.name] = e.target.value;
                          setDataForm(newArr);
                        }}
                      />
                    </Form.Group>
                    <Form.Group className="mb-2">
                      <Form.Label>Convenio bonos 2019</Form.Label>
                      <Form.Label
                        htmlFor={"bono_produccion_file"}
                        className="w-100"
                      >
                        <div className="d-grid gap-2">
                          <p
                            className="btn btn-primary btn-file text-left d-flex justify-content-between align-items-center mb-0"
                            htmlFor={"bono_produccion_file"}
                          >
                            <p className="mb-0">
                              {dataForm.bono_produccion_file != ""
                                ? dataForm.bono_produccion_file.name
                                : "Subir Archivo"}
                            </p>
                            <div>
                              <IconAttachment width="40px" height="40px" />
                              {dataForm.bono_produccion_file != "" ? (
                                <IconClose
                                  width="40px"
                                  height="40px"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    alert("delete file");
                                  }}
                                />
                              ) : null}
                            </div>
                          </p>
                          <Form.Control
                            className="ws-control"
                            name="bono_produccion_file"
                            id="bono_produccion_file"
                            type="file"
                            style={{ display: "none" }}
                            onChange={(file) => {
                              const name = file.target.name;
                              onFileChange(file, name);
                            }}
                          />
                        </div>
                      </Form.Label>
                    </Form.Group>
                    <Form.Group className="mb-2">
                      <Form.Label>Convenio excedentes</Form.Label>
                      <Form.Label htmlFor={"cvex_file"} className="w-100">
                        <div className="d-grid gap-2">
                          <p
                            className="btn btn-primary btn-file text-left d-flex justify-content-between align-items-center mb-0"
                            htmlFor={"cvex_file"}
                          >
                            <p className="mb-0">
                              {dataForm.cvex_file != ""
                                ? dataForm.cvex_file.name
                                : "Subir Archivo"}
                            </p>
                            <div>
                              <IconAttachment width="40px" height="40px" />
                              {dataForm.cvex_file != "" ? (
                                <IconClose
                                  width="40px"
                                  height="40px"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    alert("delete file");
                                  }}
                                />
                              ) : null}
                            </div>
                          </p>
                          <Form.Control
                            className="ws-control"
                            name="cvex_file"
                            id="cvex_file"
                            type="file"
                            style={{ display: "none" }}
                            onChange={(file) => {
                              const name = file.target.name;
                              onFileChange(file, name);
                            }}
                          />
                        </div>
                      </Form.Label>
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label>RFC con homoclave</Form.Label>
                      <Form.Control
                        type="text"
                        id="rfc_homoclave"
                        name="rfc_homoclave"
                        value={dataForm.rfc_homoclave}
                        onChange={(e) => {
                          let newArr = { ...dataForm };
                          newArr[e.target.name] = e.target.value;
                          setDataForm(newArr);
                        }}
                      />
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label>CURP</Form.Label>
                      <Form.Control
                        type="text"
                        id="curp_agente"
                        name="curp_agente"
                        value={dataForm.curp_agente}
                        onChange={(e) => {
                          let newArr = { ...dataForm };
                          newArr[e.target.name] = e.target.value;
                          setDataForm(newArr);
                        }}
                      />
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label>Escolaridad</Form.Label>
                      <Form.Select
                        value={dataForm.escolaridad_agente}
                        id="escolaridad_agente"
                        name="escolaridad_agente"
                        aria-label="escolaridad_agente"
                        key={uuidv4()}
                        onChange={(e) => {
                          let newArr = { ...dataForm };
                          newArr[e.target.name] = e.target.value;
                          setDataForm(newArr);
                        }}
                      >
                        {/* <option value="" disabled>Tipo</option> */}
                        <option value="1">Primaria</option>
                        <option value="2">Secundaria</option>
                        <option value="3">Bachillerato</option>
                        <option value="4">Universidad</option>
                      </Form.Select>
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label>Teléfono</Form.Label>
                      <Form.Control
                        type="text"
                        id="telefono_agente"
                        name="telefono_agente"
                        value={dataForm.telefono_agente}
                        onChange={(e) => {
                          let newArr = { ...dataForm };
                          newArr[e.target.name] = e.target.value;
                          setDataForm(newArr);
                        }}
                      />
                    </Form.Group>
                  </React.Fragment>
                )}

                {/* <Form.Group controlId="frmButtonCrearId" className="mb-3 text-center">
                  <Button variant="primary btn-qualitas"
                  disabled={(submitForm) ? true : false }
                  onClick={
                    (e) => {
                      this.submitHandler()
                    }
                  }
                  >{(submitForm) ? 'Guardando datos...' : 'Siguiente Paso' }</Button>
                </Form.Group> */}

                <div
                  style={{
                    border: "1px solid #606060",
                    padding: "5px",
                    borderRadius: "15px",
                    marginTop: "10px",
                  }}
                >
                  <div
                    style={{
                      backgroundColor: "#0A93AF",
                      width: percentStep + "%",
                      height: "15px",
                      borderRadius: "15px",
                    }}
                  ></div>
                </div>
                <p className="text-center" style={{ color: "#0ca1b4" }}>
                  Paso {step} de {totalPasos}
                </p>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              {step === 2 && (
                <Button
                  variant="primary"
                  className="ws_btn_secundary"
                  onClick={backStep}
                >
                  Atrás
                </Button>
              )}
              <Button
                variant="primary"
                className="ws_btn_secundary"
                onClick={nextStep}
              >
                {step === 1 ? "Siguiente" : "Crear agente"}
              </Button>
            </Modal.Footer>
          </Modal>
        </Container>
      </div>
    </Col>
  );

  function onFileChange(file, name) {
    let newObj = { ...dataForm };
    newObj[name] = file.target.files[0];
    setDataForm(newObj);
  }

  function updateStatusAgente(index, status, id) {
    const dataSend = {
      id_login: usuario.id_usuario,
      status: status ? "2" : "1",
      id_usuario: id,
    };
    fetch(
      `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=updateStatusAgente`,
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(dataSend),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        if (res.status == "ok") {
          let newArr = [...dataAgentes];
          // newArr[index].status = status ? 2 : 1;

          const newData = newArr.filter( element => element.id_usuario != id)
          // console.log(newArr)
          setData(newData);
        } else {
          console.log(res);
        }
      });
  }

  function updateInfoAgente(e) {
    fetch(
      `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=updateInfoAgente`,
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(dataForm),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        setSubmitForm(false);
        setEditAgente(false);
        setDataForm({
          id_login: usuario.id_usuario,
          nombre_agente: "",
          correo_agente: "",
          oficina_agente: "",
          tipo_agente: "",
          correo_asistente_agente: "",
          bono_produccion_file: "",
          cvex_file: "",
          rfc_homoclave: "",
          curp_agente: "",
          escolaridad_agente: "",
          telefono_agente: "",
        });
        if (res.status == "ok") {
          alert("Agente actualizado correctamente");
          reload();
        } else {
          alert("Ha ocurrido un error intenta de nuevo");
        }
      });
  }
}

function TablaMiFormularioAgentes({ initState, updateState, data,setData,updateStatusFichaAgente}) {

  const { usuario } = useContext(AuthContext);
  const [search, setSearch] = useState("");

  const [dataForm,setDataForm] = useState([]);
  const [nombre,setNombre] = useState("");
  const [type,setType] = useState("1");
  const [btnStatus,setBtnStatus] = useState(false);

  const [idPadre,setIdPadre] = useState("");
  const [nombre2,setNombre2] = useState("");
  const [type2,setType2] = useState("1");
  const [btnStatus2,setBtnStatus2] = useState(false);

  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true)
  };
  const handleClose2 = () => setShow2(false);
  const handleShow2 = (id_padre,nombre,type) => {
    setShow2(true)
    setIdPadre(id_padre)
    setNombre2(nombre)
    setType2(type)
  };

  useEffect(() => {
    setDataForm(data);
  }, [data]);

  const handleSubmitForm = (e) => {
    e.preventDefault();
    setBtnStatus(true)
    addConfigFichaAgentes(nombre,type)
  }

  const handleSubmitForm2 = (e) => {
    e.preventDefault();
    setBtnStatus2(true)
    updateValueFichaAgente(idPadre,nombre2,type2)
  }

  return (
    <Col xs={12} md={12} className="mb-3">
      <div
        className="ws_box"
        style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
      >
        <Container fluid>
          <div className="ws_box_header mb-3">
            <div className="d-flex justify-content-start align-items-end">
              <div>
                <h2 className="ws_table_agente_title pb-0 mb-2">
                Administrar ficha de agentes
                </h2>
              </div>
            </div>
            <div className="d-flex flex-column justify-content-between align-items-end">
              <div className="d-flex flex-row justify-content-between align-self-center align-items-center">
                <Button
                  className="ws_btn_secundary_transparent btn-sm me-2"
                  onClick={handleShow}
                >
                  <IconPlus width="30px" height="30px" /> Agregar nuevo valor
                </Button>
                <Form>
                  <Form.Control
                    type="search"
                    placeholder="Buscar"
                    className="ws_input"
                    onChange={(e) => {
                      setSearch(e.target.value);
                    }}
                  />
                </Form>
              </div>
            </div>
          </div>
          <div
            className="table-responsive"
            style={{ maxHeight: 450 }}
          >
            <Table
              striped
              bordered
              hover
              size="sm"
              className="ws_tabla"
            >
              <thead
                style={{
                  backgroundColor: "#0a93af",
                  color: "#fff",
                  fontSize: ".9rem",
                }}
              >
                <tr>
                  <th className="text-left ps-3" >
                    NOMBRE
                  </th>
                  <th className="text-left ps-3 text-center" >
                    TIPO
                  </th>
                  <th className="text-left ps-3 text-center" >
                    ESTADO
                  </th>
                  <th className="text-left ps-3 text-center" width="20%">
                    EDITAR
                  </th>
                </tr>
              </thead>
              <tbody style={{ fontSize: ".9rem" }}>
              {dataForm.map((t, e) => {
                  if (
                    search === "" ||
                    (t.nombre &&
                      t.nombre.toString().toLowerCase().indexOf(search.toLowerCase()) !== -1)
                  ) {
                    return (
                      <tr key={e}>
                        <td className="text-left ps-3">
                          <p className="mb-0">{t.nombre}</p>
                        </td>
                        <td className="text-center ps-3">
                          <p className="mb-0">{(t.type=="1") ? 'Texto' : 'Archivo' }</p>
                        </td>
                        <td className="text-center">
                          {/* <p className="mb-0">{(t.status) ? 'Activo' : 'Inactivo' }</p> */}
                          <SingleSwitch3
                            isOn={ (t.status) ? true : false }
                            id={t.id_padre}
                            handleSwitch={ updateStatusFichaAgente }
                          />
                        </td>
                        <td className="text-center">
                          {
                            (t.token!=0)
                            ? <IconEditar
                              style={{
                                width: "45px",
                                height: "45px",
                                cursor: "pointer",
                              }}
                              onClick={ () => { handleShow2(t.id_padre,t.nombre,t.type) }}
                            /> 
                            : null
                          }
                        </td>
                      </tr>
                    );
                  }
                })}
              </tbody>
            </Table>
          </div>
          
          <Modal show={show} onHide={handleClose} backdrop="static" size="lg">
            <Modal.Header closeButton>
              <Modal.Title>
                Agregar nuevo valor a la ficha del usuario
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmitForm}>
                  <Row>
                    <Col xs={12} md={6} className="mb-3">
                      <Form.Group>
                        <Form.Label>Nombre del Campo</Form.Label>
                        <Form.Control type="text" onChange={ (e) => { setNombre(e.target.value) } } required />
                      </Form.Group>
                    </Col>
                    <Col xs={12} md={6} className="mb-3">
                      <Form.Group>
                        <Form.Label>Tipo</Form.Label>
                        <Form.Select aria-label="Default select example" onChange={ (e) => { setType(e.target.value) } } required>
                          <option value="1">Texto</option>
                          <option value="2">Archivo</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col xs={12}>
                      <Button type="submit" className="ws_btn_secundary btn btn-primary" disabled={(btnStatus) ? true : false }>Guardar</Button>
                    </Col>
                  </Row>
                </Form>
            </Modal.Body>
          </Modal>

          <Modal show={show2} onHide={handleClose2} backdrop="static" size="lg">
            <Modal.Header closeButton>
              <Modal.Title>
                Editar el valor de la ficha del usuario
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmitForm2}>
                  <Row>
                    <Col xs={12} md={6} className="mb-3">
                      <Form.Group>
                        <Form.Label>Nombre del Campo</Form.Label>
                        <Form.Control type="text" value={nombre2} onChange={ (e) => { setNombre2(e.target.value) } } required />
                      </Form.Group>
                    </Col>
                    <Col xs={12} md={6} className="mb-3">
                      <Form.Group>
                        <Form.Label>Tipo</Form.Label>
                        <Form.Select aria-label="Default select example" value={type2} onChange={ (e) => { setType2(e.target.value) } } required>
                          <option value="1">Texto</option>
                          <option value="2">Archivo</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col xs={12}>
                      <Button type="submit" className="ws_btn_secundary btn btn-primary" disabled={(btnStatus2) ? true : false }>Guardar</Button>
                    </Col>
                  </Row>
                </Form>
            </Modal.Body>
          </Modal>

        </Container>
      </div>
    </Col>
  );

  function addConfigFichaAgentes(nombre,type) {
    const dataSend = {
      id_login: usuario.id_usuario,
      nombre,
      type
    }

    console.log(dataSend);
    fetch(`https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=addConfigFichaAgentes`, {
      method: "POST",
      mode: "cors",
      body: JSON.stringify(dataSend),
    })
    .then(res => res.json())
    .then((res) => {
      const newArr = [...dataForm];
      const newData = [...newArr, res.configuracion]
      // console.log(newData)
      setDataForm(newData)
      setBtnStatus(false)
      setShow(false)
      console.log(res)
    })
  }

  function updateValueFichaAgente(id_padre,nombre,type) {
    const dataSend = {
      id_login: usuario.id_usuario,
      id_padre,
      nombre,
      type
    }
    console.log(dataSend)
    fetch(`https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=updateValueFichaAgente`, {
      method: "POST",
      mode: "cors",
      body: JSON.stringify(dataSend),
    })
    .then(res => res.json())
    .then((res) => {
      const newArray = [...dataForm];
      const newData = newArray.map( element => {
        if(element.id_padre===id_padre){
          element.nombre = nombre
          element.type = type
        }
        return element
      })
      console.log(newData)
      setBtnStatus2(false)
      setShow2(false)
    })
  }

}

function TablaMisFormularios({ initState, updateState, data }) {
  return (
    <Col xs={12} md={12} className="mb-3">
      <h1 style={{ color: "#000", marginBottom: 20 }}>Mis Formularios</h1>
      <div
        className="ws_box"
        style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
      >
        <Container fluid></Container>
      </div>
    </Col>
  );
}

function TablaMisUsuarios({ initState, updateState, data, load, reload }) {
  const { usuario } = useContext(AuthContext);
  const form = useRef(null);

  const [search, setSearch] = useState("");
  const [submitForm, setSubmitForm] = useState(false);
  const [editUsuario, setEditUsuario] = useState(false);
  const [indexInput, setIndexInput] = useState(0);

  const [dataForm, setDataForm] = useState({
    id_login: usuario.id_usuario,
    nombre: "",
    apellidos: "",
    usuario: "",
    email: "",
    telefono: "",
    tipo: "",
  });

  const [dataUsuarios, setDataUsuarios] = useState([]);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => {
    setEditUsuario(false);
    setDataForm({
      id_login: usuario.id_usuario,
      nombre: "",
      apellidos: "",
      usuario: "",
      email: "",
      telefono: "",
      tipo: "",
    });
    setShow(true);
  };

  useEffect(() => {
    setDataUsuarios(data);
  }, [data]);

  function onEditUsuario(index, data) {
    setDataForm({
      id_login: usuario.id_usuario,
      id_usuario: data.id_usuario,
      nombre: data.nombre,
      apellidos: data.apellidos,
      usuario: data.usuario,
      email: data.email,
      telefono: data.telefono,
      tipo: data.tipo,
    });
    if (editUsuario == false) {
      setIndexInput(index);
      setEditUsuario(true);
    } else {
      setEditUsuario(false);
    }
  }

  if (load) {
    return (
      <Col xs={12} md={12} className="mb-3">
        <div
          className="ws_box"
          style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
        >
          <Container fluid>
            <div className="ws_box_header mb-3">
              <div className="d-flex justify-content-start align-items-end">
                <div>
                  <h2 className="ws_table_agente_title pb-0 mb-2">
                    Editar Usuarios
                  </h2>
                </div>
              </div>
            </div>
            <Skeleton width="100%" height={400} />
          </Container>
        </div>
      </Col>
    );
  }

  return (
    <Col xs={12} md={12} className="mb-3">
      <div
        className="ws_box"
        style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
      >
        <Container fluid>
          <div className="ws_box_header mb-3">
            <div className="d-flex justify-content-start align-items-end">
              <div>
                <h2 className="ws_table_agente_title pb-0 mb-2">
                  Editar Usuarios
                </h2>
              </div>
            </div>
            <div className="d-flex flex-column justify-content-between align-items-end">
              <div className="d-flex flex-row justify-content-between align-self-center align-items-center">
                <Button
                  className="ws_btn_secundary_transparent btn-sm me-2"
                  onClick={handleShow}
                >
                  <IconPlus width="30px" height="30px" /> Agregar Usuario
                </Button>
                <Form>
                  <Form.Control
                    type="search"
                    placeholder="Buscar"
                    className="ws_input"
                    onChange={(e) => {
                      setSearch(e.target.value);
                    }}
                  />
                </Form>
              </div>
            </div>
          </div>
          <div className="table-responsive" style={{ maxHeight: 450 }}>
            <Table striped bordered hover size="sm" className="ws_tabla">
              <thead
                style={{
                  backgroundColor: "#0a93af",
                  color: "#fff",
                  fontSize: ".9rem",
                }}
              >
                <tr>
                  <th className="text-left ps-3" width="25%">
                    NOMBRES
                  </th>
                  <th className="text-left ps-3" width="10%">
                    USUARIO
                  </th>
                  <th className="text-left ps-3" width="25%">
                    EMAIL
                  </th>
                  <th className="text-center" width="10%">
                    TELÉFONO
                  </th>
                  <th className="text-center" width="10%">
                    TIPO
                  </th>
                  <th className="text-center" width="10%">
                    ESTADO
                  </th>
                  <th className="text-center" width="10%">
                    EDITAR
                  </th>
                </tr>
              </thead>
              <tbody style={{ fontSize: ".9rem" }}>
                {dataUsuarios.length > 0 ? (
                  dataUsuarios.map((t, e) => {
                    if (
                      search === "" ||
                      (t.nombre &&
                        t.nombre.toString().indexOf(search) !== -1) ||
                      (t.usuario &&
                        t.usuario
                          .toLowerCase()
                          .indexOf(search.toLowerCase()) !== -1)
                    ) {
                      return (
                        <tr key={e}>
                          <td className="text-left ps-3 ws_name_table">
                            {editUsuario && indexInput == e ? (
                              <React.Fragment>
                                <Form.Control
                                  className="mb-2"
                                  type="text"
                                  name="nombre"
                                  id="nombre"
                                  value={dataForm.nombre}
                                  placeholder="Nombre"
                                  onChange={(e) => {
                                    let newArr = { ...dataForm };
                                    newArr[e.target.name] = e.target.value;
                                    setDataForm(newArr);
                                  }}
                                />
                                <Form.Control
                                  className="mb-2"
                                  type="text"
                                  name="apellidos"
                                  id="apellidos"
                                  value={dataForm.apellidos}
                                  placeholder="Apellidos"
                                  onChange={(e) => {
                                    let newArr = { ...dataForm };
                                    newArr[e.target.name] = e.target.value;
                                    setDataForm(newArr);
                                  }}
                                />
                              </React.Fragment>
                            ) : (
                              <p className="mb-0">{t.completo}</p>
                            )}
                          </td>
                          <td className="text-left ps-3 ws_name_table">
                            {editUsuario && indexInput == e ? (
                              <Form.Control
                                type="text"
                                name="usuario"
                                id="usuario"
                                value={dataForm.usuario}
                                onChange={(e) => {
                                  let newArr = { ...dataForm };
                                  newArr[e.target.name] = e.target.value;
                                  setDataForm(newArr);
                                }}
                              />
                            ) : (
                              <p className="mb-0">{t.usuario}</p>
                            )}
                          </td>
                          <td align="center">
                            {editUsuario && indexInput == e ? (
                              <Form.Control
                                type="text"
                                name="email"
                                id="email"
                                value={dataForm.email}
                                onChange={(e) => {
                                  let newArr = { ...dataForm };
                                  newArr[e.target.name] = e.target.value;
                                  setDataForm(newArr);
                                }}
                              />
                            ) : (
                              <p className="mb-0">{t.email}</p>
                            )}
                          </td>
                          <td align="center">
                            {editUsuario && indexInput == e ? (
                              <Form.Control
                                type="text"
                                name="telefono"
                                id="telefono"
                                value={dataForm.telefono}
                                onChange={(e) => {
                                  let newArr = { ...dataForm };
                                  newArr[e.target.name] = e.target.value;
                                  setDataForm(newArr);
                                }}
                              />
                            ) : (
                              <p className="mb-0">{t.telefono}</p>
                            )}
                          </td>
                          <td align="center">{t.tipo_text}</td>
                          <td align="center">
                            {/* <SingleSwitch isOn={true} id={"63"} /> */}
                            <SingleSwitch
                              isOn={t.status == 1 ? true : false}
                              handleSwitch={() => {
                                updateStatusUsuario(e, !t.status, t.id_usuario);
                              }}
                            />
                          </td>
                          <td align="center">
                            {editUsuario && indexInput == e ? (
                              <Button
                                className="btn btn-primary ws_btn_secundary"
                                onClick={() => {
                                  updateInfoUsuario();
                                }}
                              >
                                Aplicar Cambios
                              </Button>
                            ) : (
                              <IconEditar
                                style={{
                                  width: "45px",
                                  height: "45px",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  onEditUsuario(
                                    e,
                                    (data = {
                                      nombre: t.nombre,
                                      apellidos: t.apellidos,
                                      usuario: t.usuario,
                                      email: t.email,
                                      telefono: t.telefono,
                                      tipo: t.tipo,
                                      id_usuario: t.id_usuario,
                                    })
                                  );
                                }}
                              />
                            )}
                          </td>
                        </tr>
                      );
                    }
                  })
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center">
                      <p className="mb-0">No hay datos disponibles</p>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
          <Button
            className="ws_btn_secundary_transparent btn-sm"
            onClick={handleShow}
          >
            <IconPlus width="30px" height="30px" /> Agregar Usuario
          </Button>
          <Modal show={show} onHide={handleClose} backdrop="static" size="lg">
            <Form
              onSubmit={(e) => {
                addNewUsuario(e);
              }}
              ref={form}
            >
              <Modal.Header closeButton>
                <Modal.Title>Crear Usuario</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <React.Fragment>
                  <Form.Group className="mb-3">
                    <Form.Label>Nombre</Form.Label>
                    <Form.Control
                      type="text"
                      id="nombre"
                      name="nombre"
                      value={dataForm.nombre}
                      required
                      onChange={(e) => {
                        let newArr = { ...dataForm };
                        newArr[e.target.name] = e.target.value;
                        setDataForm(newArr);
                      }}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Apellidos</Form.Label>
                    <Form.Control
                      type="text"
                      id="apellidos"
                      name="apellidos"
                      value={dataForm.apellidos}
                      required
                      onChange={(e) => {
                        let newArr = { ...dataForm };
                        newArr[e.target.name] = e.target.value;
                        setDataForm(newArr);
                      }}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Usuario</Form.Label>
                    <Form.Control
                      type="text"
                      id="usuario"
                      name="usuario"
                      value={dataForm.usuario}
                      required
                      onChange={(e) => {
                        let newArr = { ...dataForm };
                        newArr[e.target.name] = e.target.value;
                        setDataForm(newArr);
                      }}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Correo</Form.Label>
                    <Form.Control
                      type="text"
                      id="email"
                      name="email"
                      value={dataForm.email}
                      required
                      onChange={(e) => {
                        let newArr = { ...dataForm };
                        newArr[e.target.name] = e.target.value;
                        setDataForm(newArr);
                      }}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Teléfono</Form.Label>
                    <Form.Control
                      type="text"
                      id="telefono"
                      name="telefono"
                      value={dataForm.telefono}
                      required
                      onChange={(e) => {
                        let newArr = { ...dataForm };
                        newArr[e.target.name] = e.target.value;
                        setDataForm(newArr);
                      }}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Permisos de la cuenta</Form.Label>
                    <Form.Select
                      value={dataForm.tipo}
                      id="tipo"
                      name="tipo"
                      aria-label="tipo"
                      key={uuidv4()}
                      required
                      onChange={(e) => {
                        let newArr = { ...dataForm };
                        newArr[e.target.name] = e.target.value;
                        setDataForm(newArr);
                      }}
                    >
                      <option value="" disabled>
                        Tipo
                      </option>
                      <option value="1">Director</option>
                      <option value="2">Gerente</option>
                      <option value="3">Ejecutivo</option>
                      <option value="4">Siniestros</option>
                    </Form.Select>
                  </Form.Group>
                </React.Fragment>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  type="submit"
                  variant="primary"
                  className="ws_btn_secundary"
                  disabled={submitForm ? true : false}
                >
                  Crear
                </Button>
              </Modal.Footer>
            </Form>
          </Modal>
        </Container>
      </div>
    </Col>
  );

  function addNewUsuario(e) {
    setSubmitForm(true);
    e.preventDefault();
    // console.log('add new usuario')
    fetch(
      `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=addNewUsuario`,
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(dataForm),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        setSubmitForm(false);
        if (res.status == "ok") {
          alert("Usuario agregado correctamente");
          reload();
        } else {
          alert("Ha ocurrido un error intenta de nuevo");
        }
      });
  }

  function updateStatusUsuario(index, status, id) {
    const dataSend = {
      id_login: usuario.id_usuario,
      status: status ? "1" : "0",
      id_usuario: id,
    };
    fetch(
      `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=updateStatusUsuario`,
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(dataSend),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        if (res.status == "ok") {
          let newArr = [...dataUsuarios];
          newArr[index].status = status ? 1 : 0;
          setDataUsuarios(newArr);
        } else {
          console.log(res);
        }
      });
  }

  function updateInfoUsuario(e) {
    fetch(
      `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=updateInfoUsuario`,
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(dataForm),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        setSubmitForm(false);
        setEditUsuario(false);
        setDataForm({
          id_login: usuario.id_usuario,
          nombre: "",
          apellidos: "",
          usuario: "",
          email: "",
          telefono: "",
          tipo: "",
        });
        if (res.status == "ok") {
          alert("Usuario actualizado correctamente");
          reload();
        } else {
          alert("Ha ocurrido un error intenta de nuevo");
        }
      });
  }
}

function TablaMisPendientes({ initState, updateState, data }) {
  return (
    <Col xs={12} md={12} className="mb-3">
      <h1 style={{ color: "#000", marginBottom: 20 }}>Mis Pendientes</h1>
      <div
        className="ws_box"
        style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
      >
        <Container fluid></Container>
      </div>
    </Col>
  );
}

function TablaAvanzado({ initState, updateState, data }) {
  return (
    <Col xs={12} md={12} className="mb-3">
      <h1 style={{ color: "#000", marginBottom: 20 }}>Avanzado</h1>
      <div
        className="ws_box"
        style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
      >
        <Container fluid></Container>
      </div>
    </Col>
  );
}

function ReporteDiario({ initState, updateState, data, setData, setConfiguracionAvanzada,setStatusConfiguracionAvanzada  }) {

  const inputRef = useRef(null);
  const newArray = data.find( element => element.id_padre==="email_diario_copia");
  const arrayCorreos =  (newArray)  ? newArray.descripcion.split(";") : [];
  const swStatus = (newArray)  ? newArray.status : false;

  const [valueSw,setValueSw] = useState(swStatus);

  useEffect(() => {
    setValueSw(swStatus)
  },[swStatus])

  return (
    <Col xs={12} md={12} className="mb-3">
      <div
        className="ws_box"
        style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
      >
        <Container fluid>
          <div className="ws_box_header mb-3">
            <div className="d-flex justify-content-start align-items-end">
              <div>
                <h2 className="ws_table_agente_title pb-0 mb-2">
                  Reporte Diario
                </h2>
                <SingleSwitchConf isOn={ (valueSw===1) ? true : false} id={"63"} className="sw_correo" 
                handleSwitch={ (e) => {
                  setValueSw(!valueSw);
                  setStatusConfiguracionAvanzada("email_diario_copia",(!valueSw) ? 1 : 0 );
                } } />
              </div>
            </div>
          </div>

          <Row>
            <Col xs={12}>
              {
                arrayCorreos.map((t,index) => (
                  <p className="mb-2 d-inline-block tag_close" key={index}>
                    {`${t} `}
                    <IconClose
                      style={{
                        width: 20,
                        height: 20,
                        fill: "#fff",
                        cursor: "pointer",
                      }}
                      onClick={ (e) => { handleClickDelete(index) } }
                    />{" "}
                  </p>
                ))
              }
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <p>Agregar correo</p>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group>
                <Form.Control type="email" ref={inputRef} />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Button className="btn ws_btn_secundary" onClick={handleClickAgregar} >Agregar</Button>
              </Form.Group>
            </Col>
          </Row>
        </Container>
      </div>
    </Col>
  );

  function handleClickDelete(key){
    let newDescripcion = "";
    const newArray = arrayCorreos.splice(key,1)
    arrayCorreos.map((t,e,arr) => {
      let arrLength = arr.length;
      if(arrLength === e+1){
        newDescripcion  += `${t.trim()}`;
      }else{
        newDescripcion  += `${t.trim()}; `;
      }
    })
    const newData = [...data]
    newData.find( element => element.id_padre==="email_diario_copia").descripcion = newDescripcion
    setConfiguracionAvanzada("email_diario_copia",newDescripcion);
    setData(newData);
  }
  
  function handleClickAgregar(e){
    e.preventDefault();
    const value = inputRef.current.value;
  
    if(validateEmail(value)){
      let newDescripcion = "";
      arrayCorreos.push(value);
      arrayCorreos.map((t,e,arr) => {
        let arrLength = arr.length;
        if(arrLength === e+1){
          newDescripcion  += `${t.trim()}`;
        }else{
          newDescripcion  += `${t.trim()}; `;
        }
      })
    
      const newData = [...data]
      newData.find( element => element.id_padre==="email_diario_copia").descripcion = newDescripcion
      
      setConfiguracionAvanzada("email_diario_copia",newDescripcion);
      setData(newData);
      inputRef.current.value = "";
    }else{
      alert('Agregar un correo electrónico válido');
    }
  
  }
  
  function validateEmail(correo) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(correo);
  }

}

function CumpleanosAutomatizados({ initState, updateState, data, setData, setConfiguracionAvanzada,setStatusConfiguracionAvanzada }) {

  const inputRef = useRef(null);
  const newArray = data.find( element => element.id_padre==="email_birthday_copia");
  const arrayCorreos =  (newArray)  ? newArray.descripcion.split(";") : [];
  const swStatus = (newArray)  ? newArray.status : false;

  const [valueSw,setValueSw] = useState(swStatus);

  useEffect(() => {
    setValueSw(swStatus)
  },[swStatus])

  return (
    <Col xs={12} md={12} className="mb-3">
      <div
        className="ws_box"
        style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
      >
        <Container fluid>
          <div className="ws_box_header mb-3">
            <div className="d-flex justify-content-start align-items-end">
              <div>
                <h2 className="ws_table_agente_title pb-0 mb-2">
                  Cumpleaños Automatizados
                </h2>
                <SingleSwitchConf isOn={ (valueSw===1) ? true : false} id={"63"} className="sw_correo" 
                handleSwitch={ (e) => {
                  setValueSw(!valueSw);
                  setStatusConfiguracionAvanzada("email_birthday_copia",(!valueSw) ? 1 : 0 );
                } } />
              </div>
            </div>
          </div>

          <Row>
            <Col xs={12}>
              {
                arrayCorreos.map((t,index) => (
                  <p className="mb-2 d-inline-block tag_close" key={index}>
                    {`${t} `}
                    <IconClose
                      style={{
                        width: 20,
                        height: 20,
                        fill: "#fff",
                        cursor: "pointer",
                      }}
                      onClick={ (e) => { handleClickDelete(index) } }
                    />{" "}
                  </p>
                ))
              }
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <p>Agregar correo</p>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group>
                <Form.Control type="email" ref={inputRef} />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Button className="btn ws_btn_secundary" onClick={handleClickAgregar} >Agregar</Button>
              </Form.Group>
            </Col>
          </Row>
        </Container>
      </div>
    </Col>
  );

  function handleClickDelete(key){
    let newDescripcion = "";
    const newArray = arrayCorreos.splice(key,1)
    arrayCorreos.map((t,e,arr) => {
      let arrLength = arr.length;
      if(arrLength === e+1){
        newDescripcion  += `${t.trim()}`;
      }else{
        newDescripcion  += `${t.trim()}; `;
      }
    })
    const newData = [...data]
    newData.find( element => element.id_padre==="email_birthday_copia").descripcion = newDescripcion
    setConfiguracionAvanzada("email_birthday_copia",newDescripcion);
    setData(newData);
  }
  
  function handleClickAgregar(e){
    e.preventDefault();
    const value = inputRef.current.value;
  
    if(validateEmail(value)){
      let newDescripcion = "";
      arrayCorreos.push(value);
      arrayCorreos.map((t,e,arr) => {
        let arrLength = arr.length;
        if(arrLength === e+1){
          newDescripcion  += `${t.trim()}`;
        }else{
          newDescripcion  += `${t.trim()}; `;
        }
      })
    
      const newData = [...data]
      newData.find( element => element.id_padre==="email_birthday_copia").descripcion = newDescripcion
      
      setConfiguracionAvanzada("email_birthday_copia",newDescripcion);
      setData(newData);
      inputRef.current.value = "";
    }else{
      alert('Agregar un correo electrónico válido');
    }
  
  }
  
  function validateEmail(correo) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(correo);
  }

}

function CorreosConCopia({ initState, updateState, data, setData, setConfiguracionAvanzada,setStatusConfiguracionAvanzada }) {

  const inputRef = useRef(null);
  const newArray = data.find( element => element.id_padre==="email_diario_copia_cc");
  const arrayCorreos = (newArray)  ? newArray.descripcion.split("; ") : [];
  const swStatus = (newArray)  ? newArray.status : false;

  const [valueSw,setValueSw] = useState(swStatus);

  useEffect(() => {
    setValueSw(swStatus)
  },[swStatus])
  
  return (
    <Col xs={12} md={12} className="mb-3">
      <div
        className="ws_box"
        style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
      >
        <Container fluid>
          <div className="ws_box_header mb-3">
            <div className="d-flex justify-content-start align-items-end">
              <div>
                <h2 className="ws_table_agente_title pb-0 mb-2">
                  Correos con copia
                </h2>
                <SingleSwitchConf isOn={ (valueSw===1) ? true : false} id={"63"} className="sw_correo" 
                handleSwitch={ (e) => {
                  setValueSw(!valueSw);
                  setStatusConfiguracionAvanzada("email_diario_copia_cc",(!valueSw) ? 1 : 0 );
                } } />
              </div>
            </div>
          </div>

          <Row>
            <Col xs={12}>
            {
                arrayCorreos.map((t,index) => (
                  <p className="mb-2 d-inline-block tag_close" key={index}>
                    {`${t} `}
                    <IconClose
                      style={{
                        width: 20,
                        height: 20,
                        fill: "#fff",
                        cursor: "pointer",
                      }}
                      onClick={ (e) => { handleClickDelete(index) } }
                    />{" "}
                  </p>
                ))
              }
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <p>Agregar correo</p>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group>
                <Form.Control type="email" ref={inputRef} />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Button className="btn ws_btn_secundary" onClick={handleClickAgregar} >Agregar</Button>
              </Form.Group>
            </Col>
          </Row>
        </Container>
      </div>
    </Col>
  );

function handleClickDelete(key){
  let newDescripcion = "";
  const newArray = arrayCorreos.splice(key,1)
  arrayCorreos.map((t,e,arr) => {
    let arrLength = arr.length;
    if(arrLength === e+1){
      newDescripcion  += `${t.trim()}`;
    }else{
      newDescripcion  += `${t.trim()}; `;
    }
  })
  const newData = [...data]
  newData.find( element => element.id_padre==="email_diario_copia_cc").descripcion = newDescripcion
  setConfiguracionAvanzada("email_diario_copia_cc",newDescripcion);
  setData(newData);
}

function handleClickAgregar(e){
  e.preventDefault();
  const value = inputRef.current.value;

  if(validateEmail(value)){
    let newDescripcion = "";
    arrayCorreos.push(value);
    arrayCorreos.map((t,e,arr) => {
      let arrLength = arr.length;
      if(arrLength === e+1){
        newDescripcion  += `${t.trim()}`;
      }else{
        newDescripcion  += `${t.trim()}; `;
      }
    })
  
    const newData = [...data]
    newData.find( element => element.id_padre==="email_diario_copia_cc").descripcion = newDescripcion
    
    setConfiguracionAvanzada("email_diario_copia_cc",newDescripcion);
    setData(newData);
    inputRef.current.value = "";
  }else{
    alert('Agregar un correo electrónico válido');
  }

}

function validateEmail(correo) {
  var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(correo);
}

}

function LogrosAutomatizados({ initState, updateState, data }) {
  return (
    <Col xs={12} md={12} className="mb-3">
      <div
        className="ws_box"
        style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
      >
        <Container fluid>
          <div className="ws_box_header mb-3">
            <div className="d-flex justify-content-start align-items-end">
              <div>
                <h2 className="ws_table_agente_title pb-0 mb-2">
                  Logros Automatizados
                </h2>
                <SingleSwitch isOn={true} id={"63"} />
              </div>
            </div>
          </div>

          <Row>
            <Col xs={12}>
              <p className="mb-2 d-inline-block tag_close">
                mbermudez@qualitas.com.mx{" "}
                <IconClose
                  style={{
                    width: 20,
                    height: 20,
                    fill: "#fff",
                    cursor: "pointer",
                  }}
                />{" "}
              </p>
              <p className="mb-2 d-inline-block tag_close">
                valles@qualitas.com.mx{" "}
                <IconClose
                  style={{
                    width: 20,
                    height: 20,
                    fill: "#fff",
                    cursor: "pointer",
                  }}
                />{" "}
              </p>
              <p className="mb-2 d-inline-block tag_close">
                valles_emision@qualitas.com.mx{" "}
                <IconClose
                  style={{
                    width: 20,
                    height: 20,
                    fill: "#fff",
                    cursor: "pointer",
                  }}
                />{" "}
              </p>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <p>Agregar correo</p>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group>
                <Form.Control type="email" />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Button className="btn ws_btn_secundary">Agregar</Button>
              </Form.Group>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col xs={12}>
              <p>
                <SingleSwitchLeft isOn={true} id={"63"} />{" "}
                <span className="ms-3">Diamante</span>
              </p>
            </Col>
            <Col xs={12}>
              <p>
                <SingleSwitchLeft isOn={true} id={"63"} />{" "}
                <span className="ms-3">24K</span>
              </p>
            </Col>
            <Col xs={12}>
              <p>
                <SingleSwitchLeft isOn={true} id={"63"} />{" "}
                <span className="ms-3">Buena Racha</span>
              </p>
            </Col>
            <Col xs={12}>
              <p>
                <SingleSwitchLeft isOn={false} id={"63"} />{" "}
                <span className="ms-3">Mala Racha</span>
              </p>
            </Col>
            <Col xs={12}>
              <p>
                <SingleSwitchLeft isOn={false} id={"63"} />{" "}
                <span className="ms-3">Te extrañamos</span>
              </p>
            </Col>
            <Col xs={12}>
              <p>
                <SingleSwitchLeft isOn={true} id={"63"} />{" "}
                <span className="ms-3">Escalones de Bono</span>
              </p>
            </Col>
            <Col xs={12}>
              <p>
                <SingleSwitchLeft isOn={true} id={"63"} />{" "}
                <span className="ms-3">Pagos de Bono</span>
              </p>
            </Col>
            <Col xs={12}>
              <p>
                <SingleSwitchLeft isOn={true} id={"63"} />{" "}
                <span className="ms-3">Reporte mensual</span>
              </p>
            </Col>
          </Row>
        </Container>
      </div>
    </Col>
  );
}

function ReporteDiarioGerentes({ initState, updateState, data,setDataGerentes, load,reload,updateStatusReporteDiario, updateStatusReporteDiarioForGerentes }) {
  const { usuario } = useContext(AuthContext);
  const [allSwitch,setAllSwitch] = useState(false);
  
  useEffect(()=>{
    if(checkStatus(data)){
      setAllSwitch(true);
    } else{
      setAllSwitch(false);
    }
  },[data]);

  if (load) {
    return (
      <Col xs={12} md={12} className="mb-3">
        <div
          className="ws_box"
          style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
        >
          <Container fluid>
            <div className="ws_box_header mb-3">
              <div className="d-flex justify-content-start align-items-end">
                <div>
                  <h2 className="ws_table_agente_title pb-0 mb-2">
                    Reporte Diario para Gerentes
                  </h2>
                </div>
              </div>
            </div>
            <Skeleton width="100%" height={400} />
          </Container>
        </div>
      </Col>
    );
  }

  return (
    <Col xs={12} md={12} className="mb-3">
      <div
        className="ws_box"
        style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
      >
        <Container fluid>
          <div className="ws_box_header mb-3">
            <div className="d-flex justify-content-start align-items-end">
              <div>
                <h2 className="ws_table_agente_title pb-0 mb-2">
                  Reporte Diario para Gerentes
                </h2>
                <SingleSwitchLeft2 
                isOn={allSwitch} 
                handleSwitch={updateStatusReporteDiarioForGerentes}
                />
              </div>
            </div>
          </div>

          <div className="table-responsive" style={{ maxHeight: 450 }}>
            <Table striped bordered hover size="sm" className="ws_tabla">
              <thead
                style={{
                  backgroundColor: "#0a93af",
                  color: "#fff",
                  fontSize: ".9rem",
                }}
              >
                <tr>
                  <th className="text-left ps-3">NOMBRES</th>
                  <th className="text-left">EMAIL</th>
                  <th className="text-center">ESTADO</th>
                </tr>
              </thead>
              <tbody style={{ fontSize: ".9rem" }}>
                {data.length > 0 ? (
                  data.map((t, e) => {
                    return (
                      <tr key={e}>
                        <td className="text-left ps-3">{t.completo}</td>
                        <td className="text-left">{t.email}</td>
                        <td align="center">
                          <SingleSwitch2
                            isOn={t.rd == 1 ? true : false}
                            id={t.id_usuario}
                            handleSwitch={updateStatusReporteDiario}
                            type="gerente"
                          />
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={3} className="text-center">
                      No hay datos
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </Container>
      </div>
    </Col>
  );

  function checkStatus(data){
    let flag = true;
    data.map((t,e)=>{
      if(t.rd===0){
        flag = false
      } 
    })
    return flag;
  }

}

function ReporteDiarioEjecutivos({ initState, updateState, data, load, updateStatusReporteDiario, updateStatusReporteDiarioForEjecutivos }) {
  const { usuario } = useContext(AuthContext);
  const [allSwitch,setAllSwitch] = useState(false);

  useEffect(()=>{
    if(checkStatus(data)){
      setAllSwitch(true);
    } else{
      setAllSwitch(false);
    }
  },[data]);

  if (load) {
    return (
      <Col xs={12} md={12} className="mb-3">
        <div
          className="ws_box"
          style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
        >
          <Container fluid>
            <div className="ws_box_header mb-3">
              <div className="d-flex justify-content-start align-items-end">
                <div>
                  <h2 className="ws_table_agente_title pb-0 mb-2">
                    Reporte Diario para Ejecutivos
                  </h2>
                </div>
              </div>
            </div>
            <Skeleton width="100%" height={400} />
          </Container>
        </div>
      </Col>
    );
  }

  return (
    <Col xs={12} md={12} className="mb-3">
      <div
        className="ws_box"
        style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
      >
        <Container fluid>
          <div className="ws_box_header mb-3">
            <div className="d-flex justify-content-start align-items-end">
              <div>
                <h2 className="ws_table_agente_title pb-0 mb-2">
                  Reporte Diario para Ejecutivos
                </h2>
                <SingleSwitchLeft2 
                isOn={allSwitch} 
                handleSwitch={updateStatusReporteDiarioForEjecutivos}
                />
              </div>
            </div>
          </div>
          <div className="table-responsive" style={{ maxHeight: 450 }}>
            <Table striped bordered hover size="sm" className="ws_tabla">
              <thead
                style={{
                  backgroundColor: "#0a93af",
                  color: "#fff",
                  fontSize: ".9rem",
                }}
              >
                <tr>
                  <th className="text-left ps-3">NOMBRES</th>
                  <th className="text-left">EMAIL</th>
                  <th className="text-center">ESTADO</th>
                </tr>
              </thead>
              <tbody style={{ fontSize: ".9rem" }}>
                {data.length > 0 ? (
                  data.map((t, e) => {
                    // if (search === '' ||
                    //   (t.completo) && t.completo.toString().indexOf(search) !== -1 ||
                    //   (t.email) && t.email.toLowerCase().indexOf(search.toLowerCase()) !== -1
                    // ) {
                    return (
                      <tr key={e}>
                        <td className="text-left ps-3">{t.completo}</td>
                        <td className="text-left">{t.email}</td>
                        <td align="center">
                          <SingleSwitch2
                            isOn={t.rd == 1 ? true : false}
                            id={t.id_usuario}
                            handleSwitch={updateStatusReporteDiario}
                            type="ejecutivo"
                          />
                        </td>
                      </tr>
                    );
                    // }
                  })
                ) : (
                  <tr>
                    <td colSpan={3} className="text-center">
                      No hay datos
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </Container>
      </div>
    </Col>
  );

  function checkStatus(data){
    let flag = true;
    data.map((t,e)=>{
      if(t.rd===0){
        flag = false
      } 
    })
    return flag;
  }
}

function TablaPolizas({ initState, updateState, datosAgente, idAgente }) {
  const { usuario } = useContext(AuthContext);
  const { exportFileRenovacionesAgente } = initState;
  const [search, setSearch] = useState("");
  const [dataPolizas, setDataPolizas] = useState([]);
  const [valueSwitch, setValueSwitch] = useState(false);
  const [periodo, setPeriodo] = useState("anual");
  const [quatrimestre, setQuatrimestre] = useState("");
  const [month, setMonth] = useState("12");
  const [yearG, setYearG] = useState(moment().format("YYYY"));
  const [load, setLoad] = useState(true);

  const { history } = dataPolizas;

  useEffect(() => {
    getRenovacionesAgente();
  }, [yearG, month]);

  if (load) {
    return (
      <Col xs={12} md={12} className="mb-3">
        <div
          className="ws_box"
          style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
        >
          <Container fluid>
            <div className="ws_box_header mb-3">
              <div className="d-flex justify-content-start align-items-end">
                <div>
                  <h2 className="ws_table_agente_title pb-0 mb-2">Pólizas</h2>
                </div>
              </div>
            </div>
            <Skeleton width="100%" height={400} />
          </Container>
        </div>
      </Col>
    );
  }

  return (
    <Col xs={12} md={12} className="mb-3">
      <div
        className="ws_box"
        style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
      >
        {exportFileRenovacionesAgente && (
          <div className="ws_backdrop_reporte d-flex justify-content-center align-items-start">
            <h1>Generando reporte, espere por favor...</h1>
          </div>
        )}
        <Container fluid>
          <div className="ws_box_header mb-3">
            <div className="d-flex justify-content-start align-items-end">
              <div>
                <h2 className="ws_table_agente_title pb-0 mb-2">
                  Pólizas: {datosAgente.nombre}
                </h2>
                <div className="d-flex justify-content-start align-items-center">
                  <DatePickerW
                    onChange={(e) => {
                      setYearG(e.target.value);
                    }}
                    year={moment().format("YYYY")}
                    selected={yearG}
                  />
                  <DatePickerMonthW
                    className="ms-2"
                    onChange={(e) => {
                      setMonth(e.target.value);
                    }}
                    selected={month}
                  />
                </div>
              </div>
            </div>

            <div className="d-flex flex-column justify-content-between align-items-end">
              <div className="d-flex flex-row justify-content-between align-self-center align-items-center mb-2">
                <Form>
                  <Form.Control
                    type="search"
                    placeholder="Buscar"
                    className="ws_input"
                    onChange={(e) => {
                      setSearch(e.target.value);
                    }}
                  />
                </Form>
                <Dropdown className="ws_dropdown">
                  <Dropdown.Toggle id="dropdown-basic">
                    <Image
                      src={"/img/darkOpt.svg"}
                      alt="icon_opt"
                      className="ws_icon ms-2"
                    />
                  </Dropdown.Toggle>
                  <Dropdown.Menu align="end">
                    <Dropdown.Item
                      href="#"
                      onClick={(e) => {
                        updateState({
                          exportFileRenovacionesAgente: true,
                        });
                        exportToExcelRenovacionesAgente();
                      }}
                    >
                      Exportar Renovaciones
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <SwitchComponentPolizas
                className="ms-3 mb-2"
                isOn={valueSwitch}
                handleToggle={(e) => {
                  setValueSwitch(!valueSwitch);
                }}
              />
            </div>
          </div>

          {/* <Row className="mb-4">
            <Col>
              <ButtonGroup aria-label="Basic example" className="p-2 w-100 ws_btn_group">
                <Button className={`bg-qprimary active`} onClick={(e) => { handleChangeButton(e) }} attr-name="anual" >Anual</Button>
                <Button className={`bg-qprimary`} onClick={(e) => { handleChangeButton(e) }} attr-name="cuatrimestral" >Cuatrimestral</Button>
                <Button className={`bg-qprimary`} onClick={(e) => { handleChangeButton(e) }} attr-name="mensual" >Mensual</Button>
              </ButtonGroup>

              {
                (periodo === 'cuatrimestral' || periodo === 'mensual') ?
                  <div className="ws_content_select_perdiodo p-2">
                    <Row>
                      <Col sm={6}>
                        <Form>
                          <Form.Group>
                            {
                              (periodo === "cuatrimestral") ?
                                <Form.Select
                                  value={quatrimestre}
                                  id="select1"
                                  aria-label="select1"
                                  key={uuidv4()}
                                  onChange={
                                    (e) => {
                                      setQuatrimestre(e.target.value)
                                    }
                                  }
                                >
                                  <option value="">Selecciona un cuatrimestre</option>
                                  <option value="1" >Q1</option>
                                  <option value="2">Q2</option>
                                  <option value="3">Q3</option>
                                </Form.Select>
                                : (periodo === "mensual") ?
                                  <Form.Select
                                    value={month}
                                    id="select2"
                                    aria-label="select2"
                                    key={uuidv4()}
                                    onChange={
                                      (e) => {
                                        setMonth(e.target.value)
                                      }
                                    }
                                  >
                                    <option value="">Selecciona un mes</option>
                                    <option value="1">Enero</option>
                                    <option value="2">Febrero</option>
                                    <option value="3">Marzo</option>
                                    <option value="4">Abril</option>
                                    <option value="5">Mayo</option>
                                    <option value="6">Junio</option>
                                    <option value="7">Julio</option>
                                    <option value="8">Agosto</option>
                                    <option value="9">Septiembre</option>
                                    <option value="10">Octubre</option>
                                    <option value="11">Noviembre</option>
                                    <option value="12">Diciembre</option>
                                  </Form.Select>
                                  : null
                            }
                          </Form.Group>
                        </Form>
                      </Col>
                    </Row>
                  </div>
                  : null
              }

            </Col>
          </Row> */}

          <Row>
            <Col>
              {history ? (
                <>
                  <p>
                    <b>Prima neta global mes:</b> $
                    {number_format(
                      dataPolizas.history.prima_neta_global_mes,
                      2
                    )}
                  </p>
                  <p>
                    <b>Prima neta nuevas mes:</b> $
                    {number_format(
                      dataPolizas.history.prima_neta_nuevas_mes,
                      2
                    )}
                  </p>
                  <p>
                    <b>Prima neta renovada mes:</b> $
                    {number_format(
                      dataPolizas.history.prima_neta_renovada_mes,
                      2
                    )}
                  </p>
                  <p>
                    <b>Prima neta renovada mes anterior:</b> $
                    {number_format(
                      dataPolizas.history.prima_neta_renovada_mes_anterior,
                      2
                    )}
                  </p>
                </>
              ) : null}
            </Col>
          </Row>

          {!valueSwitch ? (
            <Table
              striped
              bordered
              hover
              size="sm"
              responsive
              className="ws_tabla"
            >
              <thead
                style={{
                  backgroundColor: "#0a93af",
                  color: "#fff",
                  fontSize: ".9rem",
                }}
              >
                <tr>
                  <th className="text-left ps-3">Clave</th>
                  <th className="text-center">Cliente</th>
                  <th className="text-center">Póliza</th>
                  <th className="text-center">Fechas</th>
                  <th className="text-center">Total</th>
                  {/* <th className="text-center">Estado</th> */}
                  {/* <th className="text-center"></th> */}
                </tr>
              </thead>
              <tbody style={{ fontSize: ".9rem" }}>
                {history && history.array_nuevos.length > 0 ? (
                  history.array_nuevos.map((t, e) => {
                    if (
                      search === "" ||
                      (t.clave_agente &&
                        t.clave_agente.toString().indexOf(search) !== -1) ||
                      (t.numero_serie &&
                        t.numero_serie.toString().indexOf(search) !== -1) ||
                      (t.poliza &&
                        t.poliza.toString().indexOf(search) !== -1) ||
                      (t.nombre_asegurado &&
                        t.nombre_asegurado
                          .toLowerCase()
                          .indexOf(search.toLowerCase()) !== -1)
                    ) {
                      return (
                        <tr>
                          <td className="text-left ps-3">{t.clave_agente}</td>
                          <td className="text-left ps-3">
                            <p className="mb-0">{t.nombre_asegurado}</p>
                            <p className="mb-0">{t.numero_serie}</p>
                          </td>
                          <td className="text-left ps-3">{t.poliza}</td>
                          <td className="text-left ps-3">
                            <p className="mb-0">Emisión: {t.fecha_emision}</p>
                            <p className="mb-0">Inicio: {t.fecha_emision}</p>
                            <p className="mb-0">Fin: {t.fecha_fin_vigencia}</p>
                          </td>
                          <td className="text-left ps-3">
                            ${number_format(t.prima_neta, 2)}
                          </td>
                          {/* <td className="text-left ps-3"><Button className="btn btn-primary ws_btn_secundary w-100" style={{ fontSize: '.9rem' }}>Endoso</Button></td> */}
                          {/* <td style={{ position: 'relative' }}>
                                <Dropdown className="ws_dropdown">
                                  <Dropdown.Toggle id="dropdown-basic">
                                    <Image src={'/img/darkOpt.svg'} alt="icon_opt" className="ws_icon ms-2" style={{ width: 25, height: 25 }} />
                                  </Dropdown.Toggle>
                                  <Dropdown.Menu align="end">
                                    <Dropdown.Item href="#">Ver Ficha</Dropdown.Item>
                                    <Dropdown.Item href="#">Ver Pólizas</Dropdown.Item>
                                  </Dropdown.Menu>
                                </Dropdown>
                              </td> */}
                        </tr>
                      );
                    }
                  })
                ) : (
                  <tr>
                    <td colSpan="7" className="text-center">
                      <p className="mb-0">No hay datos disponibles</p>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          ) : (
            <Table
              striped
              bordered
              hover
              size="sm"
              responsive
              className="ws_tabla"
            >
              <thead
                style={{
                  backgroundColor: "#0a93af",
                  color: "#fff",
                  fontSize: ".9rem",
                }}
              >
                <tr>
                  <th className="text-left ps-3">Clave</th>
                  <th className="text-center">Cliente</th>
                  <th className="text-center">Póliza</th>
                  <th className="text-center">Fechas</th>
                  <th className="text-center">Total</th>
                  {/* <th className="text-center">Estado</th> */}
                  {/* <th className="text-center"></th> */}
                </tr>
                {/* <tr>
                    <th className="text-left ps-3">Clave</th>
                    <th className="text-center">Cliente</th>
                    <th className="text-center">Póliza</th>
                    <th className="text-center">Fecha de Pago</th>
                    <th className="text-center">Prima</th>
                    <th className="text-center">Recibo</th>
                    <th className="text-center"></th>
                  </tr> */}
              </thead>
              <tbody style={{ fontSize: ".9rem" }}>
                {history && history.array_renovados.length > 0 ? (
                  history.array_renovados.map((t, e) => {
                    if (
                      search === "" ||
                      (t.clave_agente &&
                        t.clave_agente.toString().indexOf(search) !== -1) ||
                      (t.numero_serie &&
                        t.numero_serie.toString().indexOf(search) !== -1) ||
                      (t.poliza &&
                        t.poliza.toString().indexOf(search) !== -1) ||
                      (t.nombre_asegurado &&
                        t.nombre_asegurado
                          .toLowerCase()
                          .indexOf(search.toLowerCase()) !== -1)
                    ) {
                      return (
                        <tr>
                          <td className="text-left ps-3">{t.clave_agente}</td>
                          <td className="text-left ps-3">
                            <p className="mb-0">{t.nombre_asegurado}</p>
                            <p className="mb-0">{t.numero_serie}</p>
                          </td>
                          <td className="text-left ps-3">{t.poliza}</td>
                          <td className="text-left ps-3">
                            <p className="mb-0">Emisión: {t.fecha_emision}</p>
                            <p className="mb-0">Inicio: {t.fecha_emision}</p>
                            <p className="mb-0">Fin: {t.fecha_fin_vigencia}</p>
                          </td>
                          <td className="text-left ps-3">
                            ${number_format(t.prima_neta, 2)}
                          </td>
                          {/* <td className="text-left ps-3"><Button className="btn btn-primary ws_btn_secundary w-100" style={{ fontSize: '.9rem' }}>Endoso</Button></td> */}
                          {/* <td style={{ position: 'relative' }}>
                              <Dropdown className="ws_dropdown">
                                <Dropdown.Toggle id="dropdown-basic">
                                  <Image src={'/img/darkOpt.svg'} alt="icon_opt" className="ws_icon ms-2" style={{ width: 25, height: 25 }} />
                                </Dropdown.Toggle>
                                <Dropdown.Menu align="end">
                                  <Dropdown.Item href="#">Ver Ficha</Dropdown.Item>
                                  <Dropdown.Item href="#">Ver Pólizas</Dropdown.Item>
                                </Dropdown.Menu>
                              </Dropdown>
                            </td> */}
                        </tr>
                      );
                    }
                  })
                ) : (
                  <tr>
                    <td colSpan="7" className="text-center">
                      <p className="mb-0">No hay datos disponibles</p>
                    </td>
                  </tr>
                )}

                {/* <tr>
                    <td className="text-left ps-3">17773</td>
                    <td className="text-left ps-3">
                      <p className="mb-0">EUROLLANTAS DE SAN LUIS, S.A. DE C.V.</p>
                    </td>
                    <td className="text-left ps-3">1490060545</td>
                    <td className="text-left ps-3">
                      <p className="mb-0">30/10/2020</p>
                    </td>
                    <td className="text-left ps-3">$-3073.57</td>
                    <td className="text-center">
                      <div className="d-flex justify-content-center align-items-center" style={{ backgroundColor: '#0ca1b4', color: '#fff', borderRadius: '50%', width: 35, height: 35, margin: '0 auto' }}>
                        <p className="mb-0">1</p>
                      </div>
                    </td>
                    <td style={{ position: 'relative' }}>
                      <Dropdown className="ws_dropdown">
                        <Dropdown.Toggle id="dropdown-basic">
                          <Image src={'/img/darkOpt.svg'} alt="icon_opt" className="ws_icon ms-2" style={{ width: 25, height: 25 }} />
                        </Dropdown.Toggle>
                        <Dropdown.Menu align="end">
                          <Dropdown.Item href="#">Ver Ficha</Dropdown.Item>
                          <Dropdown.Item href="#">Ver Pólizas</Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </td>
                  </tr>
                  */}
              </tbody>
            </Table>
          )}
        </Container>
      </div>
    </Col>
  );

  function exportToExcelRenovacionesAgente() {
    const dataSend = {
      id_login: usuario.id_usuario,
      id_usuario: idAgente,
      month,
      year: yearG,
    };
    fetch(
      `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=exportToExcelRenovacionesAgente`,
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(dataSend),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        updateState({
          exportFileRenovacionesAgente: false,
        });
        window.location.href = res.link;
      });
  }

  function handleChangeButton(e) {
    const currentButton = e.target;
    const parents = currentButton.parentNode.childNodes;
    parents.forEach((element) => {
      element.classList.remove("active");
    });
    e.target.classList.add("active");
    let periodo = e.target.getAttribute("attr-name");
    setPeriodo(periodo);
  }

  function getRenovacionesAgente() {
    setLoad(true);
    const dataSend = {
      id_login: usuario.id_usuario,
      year: yearG,
      month: month,
      id_usuario: idAgente,
    };

    fetch(
      `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=getRenovacionesAgente`,
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(dataSend),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        setLoad(false);
        setDataPolizas(res.list);
        console.log(res);
      });
  }
}

function TablaPolizasAgente({
  initState,
  updateState,
  datosAgente,
  idAgente,
  size = { xs: 12, sm: 12, md: 12, lg: 12, xl: 12, xxl: 12 },
}) {
  const { usuario } = useContext(AuthContext);

  const { exportFileProdCobDetalleAgente } = initState;
  const currentMonth = moment().format("MMMM");

  const [search, setSearch] = useState("");
  const [dataPolizasCobranza, setDataPolizasCobranza] = useState([]);
  const [dataPolizasProduccion, setDataPolizasProduccion] = useState([]);
  const [valueSwitch, setValueSwitch] = useState(false);
  const [month, setMonth] = useState(moment().month(currentMonth).format('M'));
  const [yearG, setYearG] = useState(moment().format("YYYY"));
  const [load, setLoad] = useState(true);

  useEffect(() => {
    getPolizasProduccionByIdAgente();
    getPolizasCobranzaByIdAgente();
  }, [yearG, month]);

  const handleClickExportFile = (url) => {
    window.location.href = url;
  }

  if (load) {
    return (
      <Col
        xs={size.xs}
        sm={size.sm}
        md={size.md}
        lg={size.lg}
        xl={size.xl}
        xxl={size.xxl}
        className="mb-3"
      >
        <div
          className="ws_box"
          style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
        >
          <Container fluid>
            <div className="ws_box_header mb-3">
              <div className="d-flex justify-content-start align-items-end">
                <div>
                  <h2 className="ws_table_agente_title pb-0 mb-2">
                    Producción a detalle
                  </h2>
                </div>
              </div>
            </div>
            <Skeleton width="100%" height={400} />
          </Container>
        </div>
      </Col>
    );
  }

  return (
    <Col
      xs={size.xs}
      sm={size.sm}
      md={size.md}
      lg={size.lg}
      xl={size.xl}
      xxl={size.xxl}
      className="mb-3"
    >
      <div
        className="ws_box"
        style={{
          position: "relative",
          paddingTop: "1rem",
          paddingBottom: "1rem",
        }}
      >
        {exportFileProdCobDetalleAgente && (
          <div className="ws_backdrop_reporte d-flex justify-content-center align-items-start">
            <h1>Generando reporte, espere por favor...</h1>
          </div>
        )}

        <Container fluid>
          <div className="ws_box_header mb-3">
            <div className="d-flex justify-content-start align-items-end">
              <div>
                <h2 className="ws_table_agente_title pb-0 mb-2">
                  {!valueSwitch ? "Producción a detalle" : "Cobranza a detalle"}
                </h2>
                <div className="d-flex justify-content-center align-items-center">
                  <DatePickerW
                    onChange={(e) => {
                      setYearG(e.target.value);
                    }}
                    year={moment().format("YYYY")}
                    selected={yearG}
                  />
                  <DatePickerMonthW
                    className="ms-2"
                    onChange={(e) => {
                      setMonth(e.target.value);
                    }}
                    selected={month}
                  />
                  {/* <div className="mb-2 ps-2">
                    <Button
                      className="btn btn-primary ws_btn_secundary w-100"
                      style={{
                        fontSize: ".9rem",
                        border: 0,
                      }}
                      onClick={
                        (e) => {
                          handleClickExportFile("https://corp.wsoft.com.mx")
                        }
                      }
                    >
                      Exportar año
                    </Button>
                  </div> */}
                    
                </div>
              </div>
            </div>
            <div className="d-flex flex-column justify-content-between align-items-end">
              <div className="d-flex flex-row justify-content-between align-self-center align-items-center mb-2">
                <Form>
                  <Form.Control
                    type="search"
                    placeholder="Buscar"
                    className="ws_input"
                    onChange={(e) => {
                      setSearch(e.target.value);
                    }}
                  />
                </Form>
                <Dropdown className="ws_dropdown">
                  <Dropdown.Toggle id="dropdown-basic">
                    <Image
                      src={"/img/darkOpt.svg"}
                      alt="icon_opt"
                      className="ws_icon ms-2"
                    />
                  </Dropdown.Toggle>
                  <Dropdown.Menu align="end">
                    <Dropdown.Item
                      href="#"
                      onClick={(e) => {
                        updateState({
                          exportFileProdCobDetalleAgente: true,
                        });
                        exportToExcelProduccionDetalleAgente();
                      }}
                    >
                      Exportar Producción mensual
                    </Dropdown.Item>
                    <Dropdown.Item
                      href="#"
                      onClick={(e) => {
                        updateState({
                          exportFileProdCobDetalleAgente: true,
                        });
                        exportToExcelCobranzaDetalleAgente();
                      }}
                    >
                      Exportar Cobranza mensual
                    </Dropdown.Item>
                    <Dropdown.Item
                      href="#"
                      onClick={(e) => {
                        updateState({
                          exportFileProdCobDetalleAgente: true,
                        });
                        exportToExcelProduccionAnualDetalleAgente();
                      }}
                    >
                      Exportar Producción anual
                    </Dropdown.Item>
                    <Dropdown.Item
                      href="#"
                      onClick={(e) => {
                        updateState({
                          exportFileProdCobDetalleAgente: true,
                        });
                        exportToExcelCobranzaAnualDetalleAgente();
                      }}
                    >
                      Exportar Cobranza anual
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <SwitchComponentProd
                className="ms-3 mb-2"
                isOn={valueSwitch}
                handleToggle={(e) => {
                  setValueSwitch(!valueSwitch);
                }}
              />
            </div>
          </div>

          {!valueSwitch ? (
            <div className="table-responsive" style={{ maxHeight: 450 }}>
              <Table striped bordered hover size="sm" className="ws_tabla">
                <thead
                  style={{
                    backgroundColor: "#0a93af",
                    color: "#fff",
                    fontSize: ".9rem",
                  }}
                >
                  <tr>
                    <th className="text-left ps-3">Clave</th>
                    <th className="text-center">Cliente</th>
                    <th className="text-center">Póliza</th>
                    <th className="text-center">Fechas</th>
                    <th className="text-center">Total</th>
                    <th className="text-center">Estado</th>
                  </tr>
                </thead>
                <tbody style={{ fontSize: ".9rem" }}>
                  {dataPolizasProduccion.length > 0 ? (
                    dataPolizasProduccion.map((t, e) => {
                      if (
                        search === "" ||
                        (t.clave_agente &&
                          t.clave_agente.toString().indexOf(search) !== -1) ||
                        (t.numero_serie &&
                          t.numero_serie.toString().indexOf(search) !== -1) ||
                        (t.poliza &&
                          t.poliza.toString().indexOf(search) !== -1) ||
                        (t.nombre_asegurado &&
                          t.nombre_asegurado
                            .toLowerCase()
                            .indexOf(search.toLowerCase()) !== -1)
                      ) {
                        return (
                          <tr>
                            <td className="text-left ps-3">{t.clave_agente}</td>
                            <td className="text-left ps-3">
                              <p className="mb-0">{t.nombre_asegurado}</p>
                              <p className="mb-0">{t.numero_serie}</p>
                            </td>
                            <td className="text-left ps-3">{t.poliza}</td>
                            <td className="text-left ps-3">
                              <p className="mb-0">Emisión: {t.fecha_emision}</p>
                              <p className="mb-0">Inicio: {t.fecha_emision}</p>
                              <p className="mb-0">
                                Fin: {t.fecha_fin_vigencia}
                              </p>
                            </td>
                            <td className="text-left ps-3">
                              ${number_format(t.prima_neta, 2)}
                            </td>
                            <td className="text-left ps-3">
                              <Button
                                className="btn btn-primary ws_btn_secundary w-100"
                                style={{
                                  fontSize: ".9rem",
                                  backgroundColor:
                                    parseInt(t.endoso) == 0
                                      ? "#00c1ae"
                                      : "#7f2180",
                                  border: 0,
                                }}
                              >
                                {parseInt(t.endoso) == 0 ? "Póliza" : "Endoso"}
                              </Button>
                            </td>
                          </tr>
                        );
                      }
                    })
                  ) : (
                    <tr>
                      <td colSpan="6" className="text-center">
                        <p className="mb-0">No hay datos disponibles</p>
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          ) : (
            <div className="table-responsive" style={{ maxHeight: 450 }}>
              <Table
                striped
                bordered
                hover
                size="sm"
                responsive
                className="ws_tabla"
              >
                <thead
                  style={{
                    backgroundColor: "#0a93af",
                    color: "#fff",
                    fontSize: ".9rem",
                  }}
                >
                  <tr>
                    <th className="text-left ps-3">Clave</th>
                    <th className="text-center">Cliente</th>
                    <th className="text-center">Póliza</th>
                    <th className="text-center">Fecha de pago</th>
                    <th className="text-center">Prima</th>
                    <th className="text-center">Recibo</th>
                    {/* <th className="text-center"></th> */}
                  </tr>
                </thead>
                <tbody style={{ fontSize: ".9rem" }}>
                  {dataPolizasCobranza.length > 0 ? (
                    dataPolizasCobranza.map((t, e) => {
                      if (
                        search === "" ||
                        (t.clave_agente &&
                          t.clave_agente.toString().indexOf(search) !== -1) ||
                        (t.numero_serie &&
                          t.numero_serie.toString().indexOf(search) !== -1) ||
                        (t.poliza &&
                          t.poliza.toString().indexOf(search) !== -1) ||
                        (t.nombre &&
                          t.nombre
                            .toLowerCase()
                            .indexOf(search.toLowerCase()) !== -1)
                      ) {
                        return (
                          <tr>
                            <td className="text-left ps-3">{t.clave_agente}</td>
                            <td className="text-left ps-3">
                              <p className="mb-0">{t.nombre}</p>
                              <p className="mb-0">{t.numero_serie}</p>
                            </td>
                            <td className="text-left ps-3">{t.poliza}</td>
                            <td className="text-left ps-3">
                              <p className="mb-0">{t.fecha_pago}</p>
                            </td>
                            <td className="text-left ps-3">
                              ${number_format(t.prima_neta, 2)}
                            </td>
                            <td className="text-left ps-3">
                              <Button
                                className="btn btn-primary ws_btn_secundary w-100"
                                style={{
                                  fontSize: ".9rem",
                                  backgroundColor: "#00c1ae",
                                  border: 0,
                                }}
                              >
                                {t.numero_recibo}
                              </Button>
                            </td>
                          </tr>
                        );
                      }
                    })
                  ) : (
                    <tr>
                      <td colSpan="6" className="text-center">
                        <p className="mb-0">No hay datos disponibles</p>
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          )}
        </Container>
      </div>
    </Col>
  );

  function exportToExcelProduccionDetalleAgente() {
    const dataSend = {
      id_login: usuario.id_usuario,
      id_usuario: idAgente,
      year: yearG,
      month,
    };
    fetch(
      `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=exportToExcelProduccionDetalleAgente`,
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(dataSend),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        updateState({
          exportFileProdCobDetalleAgente: false,
        });
        window.location.href = res.link;
      });
  }

  function exportToExcelProduccionAnualDetalleAgente() {
    const dataSend = {
      id_login: usuario.id_usuario,
      id_usuario: idAgente,
      year: yearG,
      month,
    };
    fetch(
      `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=exportToExcelProduccionAnualDetalleAgente`,
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(dataSend),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        updateState({
          exportFileProdCobDetalleAgente: false,
        });
        window.location.href = res.link;
      });
  }

  function exportToExcelCobranzaDetalleAgente() {
    const dataSend = {
      id_login: usuario.id_usuario,
      id_usuario: idAgente,
      year: yearG,
      month,
    };
    fetch(
      `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=exportToExcelCobranzaDetalleAgente`,
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(dataSend),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        updateState({
          exportFileProdCobDetalleAgente: false,
        });
        window.location.href = res.link;
      });
  }

  function exportToExcelCobranzaAnualDetalleAgente() {
    const dataSend = {
      id_login: usuario.id_usuario,
      id_usuario: idAgente,
      year: yearG,
      month,
    };
    fetch(
      `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=exportToExcelCobranzaAnualDetalleAgente`,
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(dataSend),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        updateState({
          exportFileProdCobDetalleAgente: false,
        });
        window.location.href = res.link;
      });
  }

  function getPolizasProduccionByIdAgente() {
    setLoad(true);
    const dataSend = {
      id_login: usuario.id_usuario,
      year: yearG,
      month: month,
      id_usuario: idAgente,
    };

    fetch(
      `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=getPolizasProduccionByIdAgente`,
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(dataSend),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        setLoad(false);
        setDataPolizasProduccion(res.list);
        console.log(res);
      });
  }

  function getPolizasCobranzaByIdAgente() {
    setLoad(true);
    const dataSend = {
      id_login: usuario.id_usuario,
      year: yearG,
      month: month,
      id_usuario: idAgente,
    };

    fetch(
      `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=getPolizasCobranzaByIdAgente`,
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(dataSend),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        setLoad(false);
        setDataPolizasCobranza(res.list);
        console.log(res);
      });
  }
}

function FichaAgente({
  nombreAgente,
  idUsuario,
  initState,
  updateState,
  datosFicha,
  setDatosFicha,
  datosAgente,
  setDatosAgente,
  size = { xs: 12, sm: 12, md: 12, lg: 12, xl: 12, xxl: 12 },
}) {
  const { usuario } = useContext(AuthContext);

  const inputCurpFile = useRef(null);
  const [search, setSearch] = useState("");
  const [dataFicha, setDataFicha] = useState([]);
  const [valueSwitch, setValueSwitch] = useState(false);
  const [dataInputs,setDataInputs] = useState({
    values: [],
    id_usuario : "",
    id_login : ""
  });
  const [btnLoad,setBtnLoad] = useState(false);

  const fechaRegistro = datosFicha.fecha_registro;
  const fechaHoy = moment().format("YYYY-MM-DD H:mm:ss");
  const fechaMeses = parseInt(moment(fechaHoy).diff(moment(fechaRegistro),'months',true));

  // console.log("fecha Registro",fechaRegistro);
  // console.log("fecha hoy =>",fechaHoy);
  // console.log("Meses de diferencia",fechaMeses);

  datosFicha.inputs.sort(function(a, b) {
    if (a.position > b.position) return 1;
    if (a.position < b.position) return -1;
    return 0;
  });
  
  useEffect(()=>{
    const newData = []
    const newDataInputs = {...dataInputs}
 
    datosFicha.inputs.map((t,e)=>{
      const obj = {
        "id_padre" : t.id_padre,
        "nombre" : t.nombre_hijo
      }
      newData.push(obj)
    })
    
    newDataInputs.values = newData
    newDataInputs.id_login = usuario.id_usuario
    newDataInputs.id_usuario = idUsuario;
    console.log(newDataInputs)
    setDataInputs(newDataInputs)
  },[])

  const updateInputs = () => {
      fetch('https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=updateAllValuesFichaAgente',{
        method : "POST",
        mode: "cors",
        body : JSON.stringify(dataInputs)
      })
      .then( response => response.json() )
      .then( data => {
        if(data.status==="ok"){
          // toast.success('Datos actualizados correctamente');
          alert("Datos actualizados correctamente")
          setBtnLoad(false);
        }
      })
  }

  const uploadFiles = (file,id_padre) => {

    const {
      type,
      size,
    } = file;

    console.log('Tipo de formato:',type)

    const allowedFormats = [
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.template",
      "application/vnd.ms-word.document.macroEnabled.12",
      "application/vnd.ms-word.template.macroEnabled.12",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.template",
      "application/vnd.ms-excel.sheet.macroEnabled.12",
      "application/vnd.ms-excel.template.macroEnabled.12",
      "application/vnd.ms-excel.addin.macroEnabled.12",
      "application/vnd.ms-excel.sheet.binary.macroEnabled.12",
      "application/vnd.ms-powerpoint",
      "application/vnd.openxmlformats-officedocument.presentationml.presentation",
      "application/vnd.openxmlformats-officedocument.presentationml.template",
      "application/vnd.openxmlformats-officedocument.presentationml.slideshow",
      "application/vnd.ms-powerpoint.addin.macroEnabled.12",
      "application/vnd.ms-powerpoint.presentation.macroEnabled.12",
      "application/vnd.ms-powerpoint.presentation.macroEnabled.12",
      "application/vnd.ms-powerpoint.slideshow.macroEnabled.12",
      "application/pdf",
      "image/jpeg",
      "image/bmp",
      "image/png"
    ];
    
    if(size > 5000000){
      // toast.error('No son permitidos archivos de más de 5mb')
      alert('No son permitidos archivos de más de 5mb')
      return false;
    }

    if(!allowedFormats.includes(type)){
      // toast.error("Tipo de archivo no permitido");
      alert('Tipo de archivo no permitido')
      return false;
    }

    const data = new FormData();
    data.append('id_login',usuario.id_usuario)
    data.append('id_usuario',idUsuario)
    data.append('id_padre',id_padre)
    data.append('file',file)

    fetch('https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=uploadArchivoFichaAgente',{
      method : "POST",
      mode: "cors",
      body : data
    })
    .then( response => response.json() )
    .then( data => {
      // toast.success('Tu archivo se ha subido con éxito');
      alert('Tu archivo se ha subido con éxito')
      console.log(data)
    })
  }

  const handleClickActualizar = (type) =>{
    if(!valueSwitch){
      const newData = {...dataInputs};
      const newDatosFicha = {...datosFicha}
      const newDatosAgente = {...datosAgente}
      console.log("new data",newData);
      let name = [];
      let newName = "";
      newData.values.map( input => {
        if(input.id_padre==='io_camp_nombre' || input.id_padre==='io_camp_a_paterno' || input.id_padre==='io_camp_a_materno'){
          name.push(input.nombre)
        }
        newDatosFicha.inputs.map( datos => {
          if(datos.id_padre===input.id_padre){
            datos.nombre_hijo = input.nombre;
          }
        })
      });
      newName = `${name[1]} ${name[2]} ${name[0]}`;
      newDatosAgente.nombre = newName;
      setDatosAgente(newDatosAgente);
      setDatosFicha(newDatosFicha);
      setBtnLoad(true);
      updateInputs();
    }
    if(valueSwitch){
      console.log("Enviar datos de archivos");
    }
  }

  const handleClickOpenDocument = (file) =>{
    window.open(file,"_blank").focus();
  }

  return (
    <Col
      xs={size.xs}
      sm={size.sm}
      md={size.md}
      lg={size.lg}
      xl={size.xl}
      xxl={size.xxl}
      className="mb-3"
    >
      <div
        className="ws_box"
        style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
      >
        <Container fluid>
          {/* <Toaster 
          position="top-right"
          /> */}
          <div className="ws_box_header mb-3">
            <div className="d-flex flex-column justify-content-start align-items-start">
              <div>
                <h2 className="ws_table_agente_title pb-0 mb-2">
                  {nombreAgente}{" "}
                </h2>
              </div>
            </div>

            <div className="d-flex flex-row justify-content-between align-items-end gap-3">
              <SwitchComponentFiles
                className="ms-3 mb-2"
                isOn={valueSwitch}
                handleToggle={(e) => {
                  setValueSwitch(!valueSwitch);
                }}
              />
              {/* <Button className="btn btn-primary ws_btn_default">
                Borrar Todo
              </Button> */}
              {
                (!valueSwitch) && (
                  <Button 
                  className="btn btn-primary ws_btn_secundary"
                  onClick={
                    (e) => {
                      handleClickActualizar();
                    }
                  }
                  disabled={btnLoad}
                  >
                    { (btnLoad) ? 'Guardando...' : 'Aplicar Cambios' }
                  </Button>
                )
              }
              
            </div>
          </div>
          <hr />
          <div className="d-flex gap-3">
            <p>Registro</p>
            <div>
              <p className="mb-0" style={{ color: "#0ca1b4" }}>
                {/* 04/mayo/2017 */}
                {moment(datosFicha.fecha_registro).format("DD/MM/YYYY")}
              </p>
              <p className="mb-0" style={{ color: "#0ca1b4" }}>
                {`${fechaMeses} mes${(fechaMeses>1) ? 'es' : ''}`}
              </p>
            </div>
          </div>
          <hr />

          {!valueSwitch ? (
            <Form>
              <Row>
                {
                  (datosFicha.inputs && datosFicha.inputs.length>0)
                  ?
                  datosFicha.inputs.map((t,e) => (
                  <Col xs={6} key={e}>
                    <Form.Group className="mb-3" >
                        <Form.Label>{t.nombre_padre}</Form.Label>
                        <Form.Control
                          type="text"
                          name={t.id_padre}
                          id={t.id_padre}
                          value={
                            (dataInputs.values.length > 0) 
                            ? 
                              dataInputs.values.map((input,index) => {
                                if(t.id_padre===input.id_padre){
                                  return input.nombre;
                                }
                              }).join('')
                            : ''
                          }
                          onChange={(el) =>{
                            if(dataInputs.values.length > 0){
                              const newData = {...dataInputs}
                              const data = newData.values.map( element => element.id_padre == t.id_padre ? {...element, nombre : el.target.value } : element )
                              newData.values = data
                              setDataInputs(newData)
                            }
                          }}
                      />
                    </Form.Group>
                  </Col>
                  ))
                  : 
                  <Col xs={12}>
                    <div className="text-center">
                      <h3 className="text-center">Cargando datos...</h3>
                    </div>
                  </Col>
                }
              </Row>
            </Form>
          ) : (
            <Form>
              <Row>
                {
                  (datosFicha.files && datosFicha.files.length>0)
                  ?
                  datosFicha.files.map((t,e)=>(
                    <Col xs={6} key={e}>
                      <Form.Group className="mb-2">
                        <Form.Label>{t.nombre_padre} {(t.nombre_hijo!='') ? <>&nbsp;|&nbsp;<a href="#" onClick={
                          (e) => {
                            handleClickOpenDocument(t.nombre_hijo)
                          }
                        } style={{color:'#0A93AF'}}>Ver documento</a></> : ''}</Form.Label>
                        <Form.Label className="w-100">
                          <div className="d-grid gap-2">
                            <p
                              className="btn btn-primary btn-file text-left d-flex justify-content-between align-items-center"
                              htmlFor={"curp_file"}
                            >
                              <p className="mb-0">
                                {/* {dataForm.curp_file != ""
                                  ? dataForm.curp_file.name
                                  : "Subir Archivo"} */}
                                  Subir Archivo
                              </p>
                              <div>
                                <IconAttachment width="40px" height="40px" />
                                {/* {dataForm.curp_file != "" ? (
                                  <IconClose
                                    style={{ width: "40px", height: "40px" }}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      alert("delete file");
                                    }}
                                  />
                                ) : null} */}
                              </div>
                            </p>
                            <Form.Control
                              className="ws-control"
                              name={t.id_padre}
                              id={t.id_padre}
                              type="file"
                              style={{ display: "none" }}
                              onChange={(file) => {
                                const name = file.target.name;
                                // console.log(file.target.files[0],name)
                                uploadFiles(file.target.files[0],name)
                              }}
                              onClick={ e => (e.target.value = null) }
                            />
                          </div>
                        </Form.Label>
                      </Form.Group>
                    </Col>
                  ))
                  :
                  <Col xs={12}>
                    <div className="text-center">
                      <h3 className="text-center">Cargando datos...</h3>
                    </div>
                  </Col>
                }
              </Row>
            </Form>
          )}

          <hr />
          <div className="d-flex flex-row justify-content-end align-items-end gap-3">
            {/* <Button className="btn btn-primary ws_btn_default">
              Borrar Todo
            </Button> */}
            {
              (!valueSwitch) && (
                <Button 
                className="btn btn-primary ws_btn_secundary"
                onClick={
                  (e) => {
                    handleClickActualizar();
                  }
                }
                disabled={btnLoad}
                >
                  { (btnLoad) ? 'Guardando...' : 'Aplicar Cambios' }
                </Button>
              )
            }
          </div>
        </Container>
      </div>
    </Col>
  );

  function onFileChange(file, name) {
    // let newObj = { ...dataForm };
    // newObj[name] = file.target.files[0];
    // setDataForm(newObj);
  }

  // curp_file                 : '',
  // cvex2018_file : '',
  // beneficiario_fallecimiento_file:'',
  // rfc_homoclave_file:'',
  // cvex2019_file:'',
  // cvbo2020_file:'',
  // cvbo2019_file:'',
  // cedula_vigente_file:'',
  // bono_produccion_file:'',
  // poliza_rc_file:'',
  // cvbo2021_file:'',
}

function GraficaPeriodo({
  state,
  updateState,
  opt = "",
  year,
  selected,
  loadDatagraficaTipo,
  setLoadDataGraficaTipo,
  dataSelect = {
    selectedOficinas: [],
    selectedAgentes: "0",
    selectedTipos: "0",
  },
  size = { xs: 12, sm: 6, md: 6, lg: 6 },
}) {
  const { usuario } = useContext(AuthContext);

  const uid = uuidv4();

  const [cobranzaBefore, setCobranzaBefore] = useState(0);
  const [yearG, setYearG] = useState(selected);
  const [dataGrafica, setDataGrafica] = useState([]);
  const [dataGraficaAcumulada, setDataGraficaAcumulada] = useState([]);

  const [data, setData] = useState([]);

  const [load, setLoad] = useState(true);
  const [point, setPoint] = useState({});
  const [periodo, setPeriodo] = useState("anual");
  const [valueSwitch, setValueSwitch] = useState(true);
  const [quatrimestre, setQuatrimestre] = useState("");
  const [month, setMonth] = useState("1");

  const [yearSelected, setYearSelected] = useState(selected);

  let dataProduccion = 0;
  if (data[1]) {
    if (!valueSwitch) {
      data[1].data.map((element, index) => {
        if (element.y > 0) {
          dataProduccion = element.y;
        }
      });
    } else {
      data[1].data.map((element, index) => {
        dataProduccion += element.y;
      });
    }
  }

  useEffect(() => {
    setLoad(true);
    changeYearGraph();
  }, [yearG, opt, month]);

  useEffect(() => {
    if (loadDatagraficaTipo) {
      changeYearGraph();
    }
  }, [loadDatagraficaTipo]);

  useEffect(() => {
    if (!valueSwitch) {
      quatrimestre != ""
        ? createAQ(dataGraficaAcumulada, parseInt(quatrimestre))
        : setData(dataGraficaAcumulada);
    } else {
      quatrimestre != ""
        ? createQ(dataGrafica, parseInt(quatrimestre))
        : setData(dataGrafica);
    }
  }, [valueSwitch]);

  return (
    <Col xs={size.xs} sm={size.sm} md={size.md} lg={size.lg} className="mb-3">
      <div className="ws_box">
        <Container fluid>
          <div className="ws_box_header mb-3" style={{ marginTop: "1rem" }}>
            {/* Seleccionar año */}
            <DatePickerW
              onChange={(e) => {
                setYearG(e.target.value);
              }}
              year={year}
              selected={yearG}
            />

            <div className="ws_box_right flex-column align-items-end">
              {/* <Dropdown className="ws_dropdown">
                <Dropdown.Toggle id="dropdown-basic">
                  <Image src={'/img/darkOpt.svg'} alt="icon_opt" className="ws_icon ms-2" />
                </Dropdown.Toggle>
                <Dropdown.Menu align="end">
                  <Dropdown.Item href="#">Quitar del dashboard</Dropdown.Item>
                  <Dropdown.Item href="#">Duplicar</Dropdown.Item>
                  <Dropdown.Item href="#">Ocultar en móvil</Dropdown.Item>
                  <Dropdown.Item href="#">Exportar</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown> */}
              <p className="ws_box_subtitle mb-0">Periodo pasado</p>
              <p className="ws_box_subtitle mb-0">
                {load ? (
                  <Skeleton width="95px" />
                ) : (
                  `$${number_format(cobranzaBefore, 2)}`
                )}
              </p>
            </div>
          </div>

          <ButtonGroup
            aria-label="Basic example"
            className="p-2 w-100 ws_btn_group"
          >
            <Button
              className={`bg-qprimary active`}
              onClick={(e) => {
                handleChangeButton(e);
                setQuatrimestre("");
                setMonth("");
                valueSwitch
                  ? setData(dataGrafica)
                  : setData(dataGraficaAcumulada);
              }}
              attr-name="anual"
            >
              Anual
            </Button>
            <Button
              className={`bg-qprimary`}
              onClick={(e) => {
                handleChangeButton(e);
                setQuatrimestre("1");
                setMonth("");
              }}
              attr-name="cuatrimestral"
            >
              Cuatrimestral
            </Button>
            <Button
              className={`bg-qprimary`}
              onClick={(e) => {
                handleChangeButton(e);
                setQuatrimestre("");
                setMonth("1");
              }}
              attr-name="mensual"
            >
              Mensual
            </Button>
          </ButtonGroup>

          {periodo === "cuatrimestral" || periodo === "mensual" ? (
            <div className="ws_content_select_perdiodo">
              <Row>
                <Col sm={6}>
                  <Form>
                    <Form.Group>
                      {periodo === "cuatrimestral" ? (
                        <Form.Select
                          id="select1"
                          key={uid}
                          value={quatrimestre}
                          onChange={(e) => {
                            const val = e.target.value;
                            if (val === "") {
                              valueSwitch
                                ? setData(dataGrafica)
                                : setData(dataGraficaAcumulada);
                              setQuatrimestre("");
                            }
                            if (val === "1") {
                              valueSwitch
                                ? createQ(dataGrafica, 1)
                                : createAQ(dataGraficaAcumulada, 1);
                              setQuatrimestre("1");
                            }
                            if (val === "2") {
                              valueSwitch
                                ? createQ(dataGrafica, 2)
                                : createAQ(dataGraficaAcumulada, 2);
                              setQuatrimestre("2");
                            }
                            if (val === "3") {
                              valueSwitch
                                ? createQ(dataGrafica, 3)
                                : createAQ(dataGraficaAcumulada, 3);
                              setQuatrimestre("3");
                            }
                          }}
                        >
                          <option value="">Selecciona un cuatrimestre</option>
                          <option value="1">Q1</option>
                          <option value="2">Q2</option>
                          <option value="3">Q3</option>
                        </Form.Select>
                      ) : periodo === "mensual" ? (
                        <Form.Select
                          id="select2"
                          key={uid}
                          aria-label="select2"
                          value={month}
                          onChange={(e) => {
                            setMonth(e.target.value);
                          }}
                        >
                          <option value="">Selecciona un mes</option>
                          <option value="1">Enero</option>
                          <option value="2">Febrero</option>
                          <option value="3">Marzo</option>
                          <option value="4">Abril</option>
                          <option value="5">Mayo</option>
                          <option value="6">Junio</option>
                          <option value="7">Julio</option>
                          <option value="8">Agosto</option>
                          <option value="9">Septiembre</option>
                          <option value="10">Octubre</option>
                          <option value="11">Noviembre</option>
                          <option value="12">Diciembre</option>
                        </Form.Select>
                      ) : null}
                    </Form.Group>
                  </Form>
                </Col>
              </Row>
            </div>
          ) : null}

          <div className="d-flex justify-content-between align-items-center">
            <h2 className="p-2 ws_qty_produccion">
              {load ? (
                <Skeleton width="150px" />
              ) : (
                "$" + number_format(dataProduccion, 2)
              )}
            </h2>
            <SwitchComponent
              isOn={valueSwitch}
              handleToggle={(e) => {
                setValueSwitch(!valueSwitch);
              }}
            />
          </div>

          {!load ? (
            <>
              <div style={{ height: 450, width: "100%" }}>
                <ResponsiveLine
                  data={data}
                  // tooltip={(point) => {
                  //   setPoint(point.point)
                  //   return null
                  // }}
                  margin={{ top: 50, right: 110, bottom: 50, left: 60 }}
                  xScale={{ type: "point" }}
                  yScale={{
                    type: "linear",
                    min: "auto",
                    max: "auto",
                    stacked: false,
                    reverse: false,
                  }}
                  yFormat=" >-.2f"
                  curve="monotoneX"
                  axisTop={null}
                  axisRight={null}
                  axisBottom={{
                    orient: "bottom",
                    tickSize: 5,
                    tickPadding: 5,
                    tickRotation: 0,
                    legend: "MES",
                    legendOffset: 36,
                    legendPosition: "middle",
                  }}
                  axisLeft={{
                    orient: "left",
                    tickSize: 5,
                    tickPadding: 5,
                    tickRotation: 0,
                    legend: "",
                    legendOffset: -40,
                    legendPosition: "middle",
                  }}
                  legends={[
                    {
                      anchor: "bottom-right",
                      direction: "column",
                      justify: false,
                      translateX: 100,
                      translateY: 0,
                      itemsSpacing: 0,
                      itemDirection: "left-to-right",
                      itemWidth: 80,
                      itemHeight: 20,
                      itemOpacity: 0.75,
                      symbolSize: 12,
                      symbolShape: "circle",
                      symbolBorderColor: "rgba(0, 0, 0, .5)",
                      effects: [
                        {
                          on: "hover",
                          style: {
                            itemBackground: "rgba(0, 0, 0, .03)",
                            itemOpacity: 1,
                          },
                        },
                      ],
                    },
                  ]}
                  colors={["#39b54a", "#672d8f", "#ff1d25"]}
                  borderColor={{ from: "color" }}
                  enableGridX={false}
                  lineWidth={3}
                  // enablePoints={false}
                  // pointSize={4}
                  // pointColor={{ theme: 'background' }}
                  // pointBorderWidth={2}
                  pointBorderColor={{ from: "serieColor" }}
                  pointLabelYOffset={-12}
                  useMesh={true}
                />
              </div>
              {point.x ? (
                <div>
                  <b>Información</b>
                  <p>Concepto: {point.data.label}</p>
                  <p>Valor: ${number_format(point.data.y, 2)}</p>
                </div>
              ) : null}
            </>
          ) : (
            <div style={{ width: "100%", padding: "10px" }}>
              <Skeleton width="100%" height={400} />
            </div>
          )}
        </Container>
      </div>
    </Col>
  );

  function changeYearGraph() {
    const dataSend = {
      id_login: usuario.id_usuario,
      opt: opt,
      year: yearG,
      periodo: periodo,
      oficinas: dataSelect.selectedOficinas,
      agentes: dataSelect.selectedAgentes,
      tipo_agente: dataSelect.selectedTipos,
    };

    if (periodo === "mensual") {
      dataSend.month = month;
    }

    fetch(
      `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=changeYearGraph`,
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(dataSend),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        if (loadDatagraficaTipo) {
          setLoadDataGraficaTipo(false);
        }
        setCobranzaBefore(res.cobranza_before);
        setLoad(false);
        setDataGrafica(res.dataGrafica);
        setDataGraficaAcumulada(res.dataGraficaAcumulada);
        if (!valueSwitch) {
          quatrimestre != ""
            ? createAQ(res.dataGraficaAcumulada, parseInt(quatrimestre))
            : setData(res.dataGraficaAcumulada);
        } else {
          quatrimestre != ""
            ? createQ(res.dataGrafica, parseInt(quatrimestre))
            : setData(res.dataGrafica);
        }
      });
  }

  function createQ(data, periodo) {
    const dataQ1 = [],
      dataQ2 = [],
      dataQ3 = [];
    data.map((element, index) => {
      const q1 = [],
        q2 = [],
        q3 = [];
      element.data.forEach((element, index) => {
        if (index < 4) {
          if (index === 0) {
            q1.push({ label: element.label, x: "01 Ene", y: 0 });
          }
          q1.push(element);
        }
        if ((index > 3) & (index < 8)) {
          if (index === 4) {
            q2.push({ label: element.label, x: "01 May", y: 0 });
          }
          q2.push(element);
        }
        if ((index > 7) & (index < 12)) {
          if (index === 8) {
            q3.push({ label: element.label, x: "01 Sep", y: 0 });
          }
          q3.push(element);
        }
      });
      dataQ1.push({ id: element.id, color: element.color, data: q1 });
      dataQ2.push({ id: element.id, color: element.color, data: q2 });
      dataQ3.push({ id: element.id, color: element.color, data: q3 });
    });
    if (periodo === 1) setData(dataQ1);
    if (periodo === 2) setData(dataQ2);
    if (periodo === 3) setData(dataQ3);
  }

  function createAQ(data, periodo) {
    const dataAcumQ1 = [],
      dataAcumQ2 = [],
      dataAcumQ3 = [];
    data.map((element1, index1) => {
      const q1 = [],
        q2 = [],
        q3 = [];
      let acumuladoQ1 = 0,
        acumuladoQ2 = 0,
        acumuladoQ3 = 0;
      element1.data.forEach((element, index) => {
        if (index < 4) {
          if (index === 0) {
            q1.push({ label: element.label, x: "01 Ene", y: 0 });
          }
          q1.push(element);
          if (index === 3) {
            acumuladoQ1 = element.y;
          }
        }

        if ((index > 3) & (index < 8)) {
          if (index === 4) {
            q2.push({ label: element.label, x: "01 May", y: acumuladoQ1 });
          }
          q2.push(element);
          if (index === 7) {
            acumuladoQ2 = element.y;
          }
        }

        if ((index > 7) & (index < 12)) {
          if (index === 8) {
            q3.push({ label: element.label, x: "01 Sep", y: acumuladoQ2 });
          }
          q3.push(element);
        }
      });
      dataAcumQ1.push({ id: element1.id, color: element1.color, data: q1 });
      dataAcumQ2.push({ id: element1.id, color: element1.color, data: q2 });
      dataAcumQ3.push({ id: element1.id, color: element1.color, data: q3 });
    });
    if (periodo === 1) setData(dataAcumQ1);
    if (periodo === 2) setData(dataAcumQ2);
    if (periodo === 3) setData(dataAcumQ3);
  }

  function handleChangeButton(e) {
    const currentButton = e.target;
    const parents = currentButton.parentNode.childNodes;
    parents.forEach((element) => {
      element.classList.remove("active");
    });
    e.target.classList.add("active");
    let periodo = e.target.getAttribute("attr-name");
    setPeriodo(periodo);
  }
}

function GraficaPeriodoAgente({
  state,
  updateState,
  opt = "",
  year,
  selected,
  loadDatagraficaTipo,
  setLoadDataGraficaTipo,
  dataSelect = { id_usuario: "", claves: [] },
  size = { xs: 12, sm: 6, md: 6, lg: 6 },
}) {
  const { usuario } = useContext(AuthContext);

  const uid = uuidv4();

  const [cobranzaBefore, setCobranzaBefore] = useState(0);
  const [yearG, setYearG] = useState(selected);
  const [dataGrafica, setDataGrafica] = useState([]);
  const [dataGraficaAcumulada, setDataGraficaAcumulada] = useState([]);

  const [data, setData] = useState([]);

  const [load, setLoad] = useState(true);
  const [point, setPoint] = useState({});
  const [periodo, setPeriodo] = useState("anual");
  const [valueSwitch, setValueSwitch] = useState(true);
  const [quatrimestre, setQuatrimestre] = useState("");
  const [month, setMonth] = useState("1");

  const [yearSelected, setYearSelected] = useState(selected);

  let dataProduccion = 0;
  if (data[1]) {
    if (!valueSwitch) {
      data[1].data.map((element, index) => {
        if (element.y > 0) {
          dataProduccion = element.y;
        }
      });
    } else {
      data[1].data.map((element, index) => {
        dataProduccion += element.y;
      });
    }
  }

  useEffect(() => {
    setLoad(true);
    changeYearGraph();
  }, [yearG, opt, month]);

  useEffect(() => {
    if (loadDatagraficaTipo) {
      changeYearGraph();
    }
  }, [loadDatagraficaTipo]);

  useEffect(() => {
    if (!valueSwitch) {
      quatrimestre != ""
        ? createAQ(dataGraficaAcumulada, parseInt(quatrimestre))
        : setData(dataGraficaAcumulada);
    } else {
      quatrimestre != ""
        ? createQ(dataGrafica, parseInt(quatrimestre))
        : setData(dataGrafica);
    }
  }, [valueSwitch]);

  return (
    <Col xs={size.xs} sm={size.sm} md={size.md} lg={size.lg} className="mb-3">
      <div className="ws_box">
        <Container fluid>
          <div className="ws_box_header mb-3" style={{ marginTop: "1rem" }}>
            {/* Seleccionar año */}
            <DatePickerW
              onChange={(e) => {
                setYearG(e.target.value);
              }}
              year={year}
              selected={yearG}
            />

            <div className="ws_box_right flex-column align-items-end">
              {/* <Dropdown className="ws_dropdown">
                <Dropdown.Toggle id="dropdown-basic">
                  <Image src={'/img/darkOpt.svg'} alt="icon_opt" className="ws_icon ms-2" />
                </Dropdown.Toggle>
                <Dropdown.Menu align="end">
                  <Dropdown.Item href="#">Quitar del dashboard</Dropdown.Item>
                  <Dropdown.Item href="#">Duplicar</Dropdown.Item>
                  <Dropdown.Item href="#">Ocultar en móvil</Dropdown.Item>
                  <Dropdown.Item href="#">Exportar</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown> */}
              <p className="ws_box_subtitle mb-0">Periodo pasado</p>
              <p className="ws_box_subtitle mb-0">
                {load ? (
                  <Skeleton width="95px" />
                ) : (
                  `$${number_format(cobranzaBefore, 2)}`
                )}
              </p>
            </div>
          </div>

          <ButtonGroup
            aria-label="Basic example"
            className="p-2 w-100 ws_btn_group"
          >
            <Button
              className={`bg-qprimary active`}
              onClick={(e) => {
                handleChangeButton(e);
                setQuatrimestre("");
                setMonth("");
                valueSwitch
                  ? setData(dataGrafica)
                  : setData(dataGraficaAcumulada);
              }}
              attr-name="anual"
            >
              Anual
            </Button>
            <Button
              className={`bg-qprimary`}
              onClick={(e) => {
                handleChangeButton(e);
              }}
              attr-name="cuatrimestral"
            >
              Cuatrimestral
            </Button>
            <Button
              className={`bg-qprimary`}
              onClick={(e) => {
                handleChangeButton(e);
              }}
              attr-name="mensual"
            >
              Mensual
            </Button>
          </ButtonGroup>

          {periodo === "cuatrimestral" || periodo === "mensual" ? (
            <div className="ws_content_select_perdiodo">
              <Row>
                <Col sm={6}>
                  <Form>
                    <Form.Group>
                      {periodo === "cuatrimestral" ? (
                        <Form.Select
                          id="select1"
                          key={uid}
                          value={quatrimestre}
                          onChange={(e) => {
                            const val = e.target.value;
                            if (val === "") {
                              valueSwitch
                                ? setData(dataGrafica)
                                : setData(dataGraficaAcumulada);
                              setQuatrimestre("");
                            }
                            if (val === "1") {
                              valueSwitch
                                ? createQ(dataGrafica, 1)
                                : createAQ(dataGraficaAcumulada, 1);
                              setQuatrimestre("1");
                            }
                            if (val === "2") {
                              valueSwitch
                                ? createQ(dataGrafica, 2)
                                : createAQ(dataGraficaAcumulada, 2);
                              setQuatrimestre("2");
                            }
                            if (val === "3") {
                              valueSwitch
                                ? createQ(dataGrafica, 3)
                                : createAQ(dataGraficaAcumulada, 3);
                              setQuatrimestre("3");
                            }
                          }}
                        >
                          <option value="">Selecciona un cuatrimestre</option>
                          <option value="1">Q1</option>
                          <option value="2">Q2</option>
                          <option value="3">Q3</option>
                        </Form.Select>
                      ) : periodo === "mensual" ? (
                        <Form.Select
                          id="select2"
                          key={uid}
                          aria-label="select2"
                          value={month}
                          onChange={(e) => {
                            setMonth(e.target.value);
                          }}
                        >
                          <option value="">Selecciona un mes</option>
                          <option value="1">Enero</option>
                          <option value="2">Febrero</option>
                          <option value="3">Marzo</option>
                          <option value="4">Abril</option>
                          <option value="5">Mayo</option>
                          <option value="6">Junio</option>
                          <option value="7">Julio</option>
                          <option value="8">Agosto</option>
                          <option value="9">Septiembre</option>
                          <option value="10">Octubre</option>
                          <option value="11">Noviembre</option>
                          <option value="12">Diciembre</option>
                        </Form.Select>
                      ) : null}
                    </Form.Group>
                  </Form>
                </Col>
              </Row>
            </div>
          ) : null}

          <div className="d-flex justify-content-between align-items-center">
            <h2 className="p-2 ws_qty_produccion">
              {load ? (
                <Skeleton width="150px" />
              ) : (
                "$" + number_format(dataProduccion, 2)
              )}
            </h2>
            <SwitchComponent
              isOn={valueSwitch}
              handleToggle={(e) => {
                setValueSwitch(!valueSwitch);
              }}
            />
          </div>

          {!load ? (
            <>
              <div style={{ height: 450, width: "100%" }}>
                <ResponsiveLine
                  data={data}
                  // tooltip={(point) => {
                  //   setPoint(point.point)
                  //   return null
                  // }}
                  margin={{ top: 50, right: 110, bottom: 50, left: 60 }}
                  xScale={{ type: "point" }}
                  yScale={{
                    type: "linear",
                    min: "auto",
                    max: "auto",
                    stacked: false,
                    reverse: false,
                  }}
                  yFormat=" >-.2f"
                  curve="monotoneX"
                  axisTop={null}
                  axisRight={null}
                  axisBottom={{
                    orient: "bottom",
                    tickSize: 5,
                    tickPadding: 5,
                    tickRotation: 0,
                    legend: "MES",
                    legendOffset: 36,
                    legendPosition: "middle",
                  }}
                  axisLeft={{
                    orient: "left",
                    tickSize: 5,
                    tickPadding: 5,
                    tickRotation: 0,
                    legend: "",
                    legendOffset: -40,
                    legendPosition: "middle",
                  }}
                  legends={[
                    {
                      anchor: "bottom-right",
                      direction: "column",
                      justify: false,
                      translateX: 100,
                      translateY: 0,
                      itemsSpacing: 0,
                      itemDirection: "left-to-right",
                      itemWidth: 80,
                      itemHeight: 20,
                      itemOpacity: 0.75,
                      symbolSize: 12,
                      symbolShape: "circle",
                      symbolBorderColor: "rgba(0, 0, 0, .5)",
                      effects: [
                        {
                          on: "hover",
                          style: {
                            itemBackground: "rgba(0, 0, 0, .03)",
                            itemOpacity: 1,
                          },
                        },
                      ],
                    },
                  ]}
                  colors={["#39b54a", "#672d8f", "#ff1d25"]}
                  borderColor={{ from: "color" }}
                  enableGridX={false}
                  lineWidth={3}
                  // enablePoints={false}
                  // pointSize={4}
                  // pointColor={{ theme: 'background' }}
                  // pointBorderWidth={2}
                  pointBorderColor={{ from: "serieColor" }}
                  pointLabelYOffset={-12}
                  useMesh={true}
                />
              </div>
              {point.x ? (
                <div>
                  <b>Información</b>
                  <p>Concepto: {point.data.label}</p>
                  <p>Valor: ${number_format(point.data.y, 2)}</p>
                </div>
              ) : null}
            </>
          ) : (
            <div style={{ width: "100%", padding: "10px" }}>
              <Skeleton width="100%" height={400} />
            </div>
          )}
        </Container>
      </div>
    </Col>
  );

  function changeYearGraph() {
    const dataSend = {
      id_login: usuario.id_usuario,
      id_usuario: dataSelect.id_usuario,
      claves: dataSelect.claves,
      year: yearG,
      periodo: periodo,
    };

    if (periodo === "mensual") {
      dataSend.month = month;
    }

    fetch(
      `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=changeYearGraphAgente`,
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(dataSend),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        if (loadDatagraficaTipo) {
          setLoadDataGraficaTipo(false);
        }
        setCobranzaBefore(res.cobranza_before);
        setLoad(false);
        setDataGrafica(res.dataGrafica);
        setDataGraficaAcumulada(res.dataGraficaAcumulada);
        if (!valueSwitch) {
          quatrimestre != ""
            ? createAQ(res.dataGraficaAcumulada, parseInt(quatrimestre))
            : setData(res.dataGraficaAcumulada);
        } else {
          quatrimestre != ""
            ? createQ(res.dataGrafica, parseInt(quatrimestre))
            : setData(res.dataGrafica);
        }
      });
  }

  function createQ(data, periodo) {
    const dataQ1 = [],
      dataQ2 = [],
      dataQ3 = [];
    data.map((element, index) => {
      const q1 = [],
        q2 = [],
        q3 = [];
      element.data.forEach((element, index) => {
        if (index < 4) {
          if (index === 0) {
            q1.push({ label: element.label, x: "01 Ene", y: 0 });
          }
          q1.push(element);
        }
        if ((index > 3) & (index < 8)) {
          if (index === 4) {
            q2.push({ label: element.label, x: "01 May", y: 0 });
          }
          q2.push(element);
        }
        if ((index > 7) & (index < 12)) {
          if (index === 8) {
            q3.push({ label: element.label, x: "01 Sep", y: 0 });
          }
          q3.push(element);
        }
      });
      dataQ1.push({ id: element.id, color: element.color, data: q1 });
      dataQ2.push({ id: element.id, color: element.color, data: q2 });
      dataQ3.push({ id: element.id, color: element.color, data: q3 });
    });
    if (periodo === 1) setData(dataQ1);
    if (periodo === 2) setData(dataQ2);
    if (periodo === 3) setData(dataQ3);
  }

  function createAQ(data, periodo) {
    const dataAcumQ1 = [],
      dataAcumQ2 = [],
      dataAcumQ3 = [];
    data.map((element1, index1) => {
      const q1 = [],
        q2 = [],
        q3 = [];
      let acumuladoQ1 = 0,
        acumuladoQ2 = 0,
        acumuladoQ3 = 0;
      element1.data.forEach((element, index) => {
        if (index < 4) {
          if (index === 0) {
            q1.push({ label: element.label, x: "01 Ene", y: 0 });
          }
          q1.push(element);
          if (index === 3) {
            acumuladoQ1 = element.y;
          }
        }

        if ((index > 3) & (index < 8)) {
          if (index === 4) {
            q2.push({ label: element.label, x: "01 May", y: acumuladoQ1 });
          }
          q2.push(element);
          if (index === 7) {
            acumuladoQ2 = element.y;
          }
        }

        if ((index > 7) & (index < 12)) {
          if (index === 8) {
            q3.push({ label: element.label, x: "01 Sep", y: acumuladoQ2 });
          }
          q3.push(element);
        }
      });
      dataAcumQ1.push({ id: element1.id, color: element1.color, data: q1 });
      dataAcumQ2.push({ id: element1.id, color: element1.color, data: q2 });
      dataAcumQ3.push({ id: element1.id, color: element1.color, data: q3 });
    });
    if (periodo === 1) setData(dataAcumQ1);
    if (periodo === 2) setData(dataAcumQ2);
    if (periodo === 3) setData(dataAcumQ3);
  }

  function handleChangeButton(e) {
    const currentButton = e.target;
    const parents = currentButton.parentNode.childNodes;
    parents.forEach((element) => {
      element.classList.remove("active");
    });
    e.target.classList.add("active");
    let periodo = e.target.getAttribute("attr-name");
    setPeriodo(periodo);
  }
}

function GraficaPeriodoGrupo({
  state,
  updateState,
  opt = "",
  year,
  selected,
  loadDatagraficaTipo,
  setLoadDataGraficaTipo,
  dataSelect = { id_grupo: "" },
  size = { xs: 12, sm: 6, md: 6, lg: 6 },
}) {
  const { usuario } = useContext(AuthContext);

  const uid = uuidv4();

  const [cobranzaBefore, setCobranzaBefore] = useState(0);
  const [yearG, setYearG] = useState(selected);
  const [dataGrafica, setDataGrafica] = useState([]);
  const [dataGraficaAcumulada, setDataGraficaAcumulada] = useState([]);

  const [data, setData] = useState([]);

  const [load, setLoad] = useState(true);
  const [point, setPoint] = useState({});
  const [periodo, setPeriodo] = useState("anual");
  const [valueSwitch, setValueSwitch] = useState(true);
  const [quatrimestre, setQuatrimestre] = useState("");
  const [month, setMonth] = useState("1");

  const [yearSelected, setYearSelected] = useState(selected);

  let dataProduccion = 0;
  if (data[1]) {
    if (!valueSwitch) {
      data[1].data.map((element, index) => {
        if (element.y > 0) {
          dataProduccion = element.y;
        }
      });
    } else {
      data[1].data.map((element, index) => {
        dataProduccion += element.y;
      });
    }
  }

  useEffect(() => {
    setLoad(true);
    changeYearGraph();
  }, [yearG, opt, month]);

  useEffect(() => {
    if (loadDatagraficaTipo) {
      changeYearGraph();
    }
  }, [loadDatagraficaTipo]);

  useEffect(() => {
    if (!valueSwitch) {
      quatrimestre != ""
        ? createAQ(dataGraficaAcumulada, parseInt(quatrimestre))
        : setData(dataGraficaAcumulada);
    } else {
      quatrimestre != ""
        ? createQ(dataGrafica, parseInt(quatrimestre))
        : setData(dataGrafica);
    }
  }, [valueSwitch]);

  return (
    <Col xs={size.xs} sm={size.sm} md={size.md} lg={size.lg} className="mb-3">
      <div className="ws_box">
        <Container fluid>
          <div className="ws_box_header mb-3" style={{ marginTop: "1rem" }}>
            {/* Seleccionar año */}
            <DatePickerW
              onChange={(e) => {
                setYearG(e.target.value);
              }}
              year={year}
              selected={yearG}
            />

            <div className="ws_box_right flex-column align-items-end">
              {/* <Dropdown className="ws_dropdown">
                <Dropdown.Toggle id="dropdown-basic">
                  <Image src={'/img/darkOpt.svg'} alt="icon_opt" className="ws_icon ms-2" />
                </Dropdown.Toggle>
                <Dropdown.Menu align="end">
                  <Dropdown.Item href="#">Quitar del dashboard</Dropdown.Item>
                  <Dropdown.Item href="#">Duplicar</Dropdown.Item>
                  <Dropdown.Item href="#">Ocultar en móvil</Dropdown.Item>
                  <Dropdown.Item href="#">Exportar</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown> */}
              <p className="ws_box_subtitle mb-0">Periodo pasado</p>
              <p className="ws_box_subtitle mb-0">
                {load ? (
                  <Skeleton width="95px" />
                ) : (
                  `$${number_format(cobranzaBefore, 2)}`
                )}
              </p>
            </div>
          </div>

          <ButtonGroup
            aria-label="Basic example"
            className="p-2 w-100 ws_btn_group"
          >
            <Button
              className={`bg-qprimary active`}
              onClick={(e) => {
                handleChangeButton(e);
                setQuatrimestre("");
                setMonth("");
                valueSwitch
                  ? setData(dataGrafica)
                  : setData(dataGraficaAcumulada);
              }}
              attr-name="anual"
            >
              Anual
            </Button>
            <Button
              className={`bg-qprimary`}
              onClick={(e) => {
                handleChangeButton(e);
              }}
              attr-name="cuatrimestral"
            >
              Cuatrimestral
            </Button>
            <Button
              className={`bg-qprimary`}
              onClick={(e) => {
                handleChangeButton(e);
              }}
              attr-name="mensual"
            >
              Mensual
            </Button>
          </ButtonGroup>

          {periodo === "cuatrimestral" || periodo === "mensual" ? (
            <div className="ws_content_select_perdiodo">
              <Row>
                <Col sm={6}>
                  <Form>
                    <Form.Group>
                      {periodo === "cuatrimestral" ? (
                        <Form.Select
                          id="select1"
                          key={uid}
                          value={quatrimestre}
                          onChange={(e) => {
                            const val = e.target.value;
                            if (val === "") {
                              valueSwitch
                                ? setData(dataGrafica)
                                : setData(dataGraficaAcumulada);
                              setQuatrimestre("");
                            }
                            if (val === "1") {
                              valueSwitch
                                ? createQ(dataGrafica, 1)
                                : createAQ(dataGraficaAcumulada, 1);
                              setQuatrimestre("1");
                            }
                            if (val === "2") {
                              valueSwitch
                                ? createQ(dataGrafica, 2)
                                : createAQ(dataGraficaAcumulada, 2);
                              setQuatrimestre("2");
                            }
                            if (val === "3") {
                              valueSwitch
                                ? createQ(dataGrafica, 3)
                                : createAQ(dataGraficaAcumulada, 3);
                              setQuatrimestre("3");
                            }
                          }}
                        >
                          <option value="">Selecciona un cuatrimestre</option>
                          <option value="1">Q1</option>
                          <option value="2">Q2</option>
                          <option value="3">Q3</option>
                        </Form.Select>
                      ) : periodo === "mensual" ? (
                        <Form.Select
                          id="select2"
                          key={uid}
                          aria-label="select2"
                          value={month}
                          onChange={(e) => {
                            setMonth(e.target.value);
                          }}
                        >
                          <option value="">Selecciona un mes</option>
                          <option value="1">Enero</option>
                          <option value="2">Febrero</option>
                          <option value="3">Marzo</option>
                          <option value="4">Abril</option>
                          <option value="5">Mayo</option>
                          <option value="6">Junio</option>
                          <option value="7">Julio</option>
                          <option value="8">Agosto</option>
                          <option value="9">Septiembre</option>
                          <option value="10">Octubre</option>
                          <option value="11">Noviembre</option>
                          <option value="12">Diciembre</option>
                        </Form.Select>
                      ) : null}
                    </Form.Group>
                  </Form>
                </Col>
              </Row>
            </div>
          ) : null}

          <div className="d-flex justify-content-between align-items-center">
            <h2 className="p-2 ws_qty_produccion">
              {load ? (
                <Skeleton width="150px" />
              ) : (
                "$" + number_format(dataProduccion, 2)
              )}
            </h2>
            <SwitchComponent
              isOn={valueSwitch}
              handleToggle={(e) => {
                setValueSwitch(!valueSwitch);
              }}
            />
          </div>

          {!load ? (
            <>
              <div style={{ height: 450, width: "100%" }}>
                <ResponsiveLine
                  data={data}
                  // tooltip={(point) => {
                  //   setPoint(point.point)
                  //   return null
                  // }}
                  margin={{ top: 50, right: 110, bottom: 50, left: 60 }}
                  xScale={{ type: "point" }}
                  yScale={{
                    type: "linear",
                    min: "auto",
                    max: "auto",
                    stacked: false,
                    reverse: false,
                  }}
                  yFormat=" >-.2f"
                  curve="monotoneX"
                  axisTop={null}
                  axisRight={null}
                  axisBottom={{
                    orient: "bottom",
                    tickSize: 5,
                    tickPadding: 5,
                    tickRotation: 0,
                    legend: "MES",
                    legendOffset: 36,
                    legendPosition: "middle",
                  }}
                  axisLeft={{
                    orient: "left",
                    tickSize: 5,
                    tickPadding: 5,
                    tickRotation: 0,
                    legend: "",
                    legendOffset: -40,
                    legendPosition: "middle",
                  }}
                  legends={[
                    {
                      anchor: "bottom-right",
                      direction: "column",
                      justify: false,
                      translateX: 100,
                      translateY: 0,
                      itemsSpacing: 0,
                      itemDirection: "left-to-right",
                      itemWidth: 80,
                      itemHeight: 20,
                      itemOpacity: 0.75,
                      symbolSize: 12,
                      symbolShape: "circle",
                      symbolBorderColor: "rgba(0, 0, 0, .5)",
                      effects: [
                        {
                          on: "hover",
                          style: {
                            itemBackground: "rgba(0, 0, 0, .03)",
                            itemOpacity: 1,
                          },
                        },
                      ],
                    },
                  ]}
                  colors={["#39b54a", "#672d8f", "#ff1d25"]}
                  borderColor={{ from: "color" }}
                  enableGridX={false}
                  lineWidth={3}
                  // enablePoints={false}
                  // pointSize={4}
                  // pointColor={{ theme: 'background' }}
                  // pointBorderWidth={2}
                  pointBorderColor={{ from: "serieColor" }}
                  pointLabelYOffset={-12}
                  useMesh={true}
                />
              </div>
              {point.x ? (
                <div>
                  <b>Información</b>
                  <p>Concepto: {point.data.label}</p>
                  <p>Valor: ${number_format(point.data.y, 2)}</p>
                </div>
              ) : null}
            </>
          ) : (
            <div style={{ width: "100%", padding: "10px" }}>
              <Skeleton width="100%" height={400} />
            </div>
          )}
        </Container>
      </div>
    </Col>
  );

  function changeYearGraph() {
    const dataSend = {
      id_login: usuario.id_usuario,
      id_grupo: dataSelect.id_grupo,
      year: yearG,
      periodo: periodo,
    };

    if (periodo === "mensual") {
      dataSend.month = month;
    }

    fetch(
      `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=changeYearGraphGrupo`,
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(dataSend),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        if (loadDatagraficaTipo) {
          setLoadDataGraficaTipo(false);
        }
        setCobranzaBefore(res.cobranza_before);
        setLoad(false);
        setDataGrafica(res.dataGrafica);
        setDataGraficaAcumulada(res.dataGraficaAcumulada);
        if (!valueSwitch) {
          quatrimestre != ""
            ? createAQ(res.dataGraficaAcumulada, parseInt(quatrimestre))
            : setData(res.dataGraficaAcumulada);
        } else {
          quatrimestre != ""
            ? createQ(res.dataGrafica, parseInt(quatrimestre))
            : setData(res.dataGrafica);
        }
      });
  }

  function createQ(data, periodo) {
    const dataQ1 = [],
      dataQ2 = [],
      dataQ3 = [];
    data.map((element, index) => {
      const q1 = [],
        q2 = [],
        q3 = [];
      element.data.forEach((element, index) => {
        if (index < 4) {
          if (index === 0) {
            q1.push({ label: element.label, x: "01 Ene", y: 0 });
          }
          q1.push(element);
        }
        if ((index > 3) & (index < 8)) {
          if (index === 4) {
            q2.push({ label: element.label, x: "01 May", y: 0 });
          }
          q2.push(element);
        }
        if ((index > 7) & (index < 12)) {
          if (index === 8) {
            q3.push({ label: element.label, x: "01 Sep", y: 0 });
          }
          q3.push(element);
        }
      });
      dataQ1.push({ id: element.id, color: element.color, data: q1 });
      dataQ2.push({ id: element.id, color: element.color, data: q2 });
      dataQ3.push({ id: element.id, color: element.color, data: q3 });
    });
    if (periodo === 1) setData(dataQ1);
    if (periodo === 2) setData(dataQ2);
    if (periodo === 3) setData(dataQ3);
  }

  function createAQ(data, periodo) {
    const dataAcumQ1 = [],
      dataAcumQ2 = [],
      dataAcumQ3 = [];
    data.map((element1, index1) => {
      const q1 = [],
        q2 = [],
        q3 = [];
      let acumuladoQ1 = 0,
        acumuladoQ2 = 0,
        acumuladoQ3 = 0;
      element1.data.forEach((element, index) => {
        if (index < 4) {
          if (index === 0) {
            q1.push({ label: element.label, x: "01 Ene", y: 0 });
          }
          q1.push(element);
          if (index === 3) {
            acumuladoQ1 = element.y;
          }
        }

        if ((index > 3) & (index < 8)) {
          if (index === 4) {
            q2.push({ label: element.label, x: "01 May", y: acumuladoQ1 });
          }
          q2.push(element);
          if (index === 7) {
            acumuladoQ2 = element.y;
          }
        }

        if ((index > 7) & (index < 12)) {
          if (index === 8) {
            q3.push({ label: element.label, x: "01 Sep", y: acumuladoQ2 });
          }
          q3.push(element);
        }
      });
      dataAcumQ1.push({ id: element1.id, color: element1.color, data: q1 });
      dataAcumQ2.push({ id: element1.id, color: element1.color, data: q2 });
      dataAcumQ3.push({ id: element1.id, color: element1.color, data: q3 });
    });
    if (periodo === 1) setData(dataAcumQ1);
    if (periodo === 2) setData(dataAcumQ2);
    if (periodo === 3) setData(dataAcumQ3);
  }

  function handleChangeButton(e) {
    const currentButton = e.target;
    const parents = currentButton.parentNode.childNodes;
    parents.forEach((element) => {
      element.classList.remove("active");
    });
    e.target.classList.add("active");
    let periodo = e.target.getAttribute("attr-name");
    setPeriodo(periodo);
  }
}

function GraficaPeriodoPromotoria({
  state,
  updateState,
  opt = "",
  year,
  selected,
  loadDatagraficaTipo,
  setLoadDataGraficaTipo,
  dataSelect = { promotor: "" },
  size = { xs: 12, sm: 6, md: 6, lg: 6 },
}) {
  const { usuario } = useContext(AuthContext);

  const uid = uuidv4();

  const [cobranzaBefore, setCobranzaBefore] = useState(0);
  const [yearG, setYearG] = useState(selected);
  const [dataGrafica, setDataGrafica] = useState([]);
  const [dataGraficaAcumulada, setDataGraficaAcumulada] = useState([]);

  const [data, setData] = useState([]);

  const [load, setLoad] = useState(true);
  const [point, setPoint] = useState({});
  const [periodo, setPeriodo] = useState("anual");
  const [valueSwitch, setValueSwitch] = useState(true);
  const [quatrimestre, setQuatrimestre] = useState("");
  const [month, setMonth] = useState("1");

  const [yearSelected, setYearSelected] = useState(selected);

  let dataProduccion = 0;
  if (data[1]) {
    if (!valueSwitch) {
      data[1].data.map((element, index) => {
        if (element.y > 0) {
          dataProduccion = element.y;
        }
      });
    } else {
      data[1].data.map((element, index) => {
        dataProduccion += element.y;
      });
    }
  }

  useEffect(() => {
    setLoad(true);
    changeYearGraph();
  }, [yearG, opt, month]);

  useEffect(() => {
    if (loadDatagraficaTipo) {
      changeYearGraph();
    }
  }, [loadDatagraficaTipo]);

  useEffect(() => {
    if (!valueSwitch) {
      quatrimestre != ""
        ? createAQ(dataGraficaAcumulada, parseInt(quatrimestre))
        : setData(dataGraficaAcumulada);
    } else {
      quatrimestre != ""
        ? createQ(dataGrafica, parseInt(quatrimestre))
        : setData(dataGrafica);
    }
  }, [valueSwitch]);

  return (
    <Col xs={size.xs} sm={size.sm} md={size.md} lg={size.lg} className="mb-3">
      <div className="ws_box">
        <Container fluid>
          <div className="ws_box_header mb-3" style={{ marginTop: "1rem" }}>
            {/* Seleccionar año */}
            <DatePickerW
              onChange={(e) => {
                setYearG(e.target.value);
              }}
              year={year}
              selected={yearG}
            />

            <div className="ws_box_right flex-column align-items-end">
              {/* <Dropdown className="ws_dropdown">
                <Dropdown.Toggle id="dropdown-basic">
                  <Image src={'/img/darkOpt.svg'} alt="icon_opt" className="ws_icon ms-2" />
                </Dropdown.Toggle>
                <Dropdown.Menu align="end">
                  <Dropdown.Item href="#">Quitar del dashboard</Dropdown.Item>
                  <Dropdown.Item href="#">Duplicar</Dropdown.Item>
                  <Dropdown.Item href="#">Ocultar en móvil</Dropdown.Item>
                  <Dropdown.Item href="#">Exportar</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown> */}
              <p className="ws_box_subtitle mb-0">Periodo pasado</p>
              <p className="ws_box_subtitle mb-0">
                {load ? (
                  <Skeleton width="95px" />
                ) : (
                  `$${number_format(cobranzaBefore, 2)}`
                )}
              </p>
            </div>
          </div>

          <ButtonGroup
            aria-label="Basic example"
            className="p-2 w-100 ws_btn_group"
          >
            <Button
              className={`bg-qprimary active`}
              onClick={(e) => {
                handleChangeButton(e);
                setQuatrimestre("");
                setMonth("");
                valueSwitch
                  ? setData(dataGrafica)
                  : setData(dataGraficaAcumulada);
              }}
              attr-name="anual"
            >
              Anual
            </Button>
            <Button
              className={`bg-qprimary`}
              onClick={(e) => {
                handleChangeButton(e);
              }}
              attr-name="cuatrimestral"
            >
              Cuatrimestral
            </Button>
            <Button
              className={`bg-qprimary`}
              onClick={(e) => {
                handleChangeButton(e);
              }}
              attr-name="mensual"
            >
              Mensual
            </Button>
          </ButtonGroup>

          {periodo === "cuatrimestral" || periodo === "mensual" ? (
            <div className="ws_content_select_perdiodo">
              <Row>
                <Col sm={6}>
                  <Form>
                    <Form.Group>
                      {periodo === "cuatrimestral" ? (
                        <Form.Select
                          id="select1"
                          key={uid}
                          value={quatrimestre}
                          onChange={(e) => {
                            const val = e.target.value;
                            if (val === "") {
                              valueSwitch
                                ? setData(dataGrafica)
                                : setData(dataGraficaAcumulada);
                              setQuatrimestre("");
                            }
                            if (val === "1") {
                              valueSwitch
                                ? createQ(dataGrafica, 1)
                                : createAQ(dataGraficaAcumulada, 1);
                              setQuatrimestre("1");
                            }
                            if (val === "2") {
                              valueSwitch
                                ? createQ(dataGrafica, 2)
                                : createAQ(dataGraficaAcumulada, 2);
                              setQuatrimestre("2");
                            }
                            if (val === "3") {
                              valueSwitch
                                ? createQ(dataGrafica, 3)
                                : createAQ(dataGraficaAcumulada, 3);
                              setQuatrimestre("3");
                            }
                          }}
                        >
                          <option value="">Selecciona un cuatrimestre</option>
                          <option value="1">Q1</option>
                          <option value="2">Q2</option>
                          <option value="3">Q3</option>
                        </Form.Select>
                      ) : periodo === "mensual" ? (
                        <Form.Select
                          id="select2"
                          key={uid}
                          aria-label="select2"
                          value={month}
                          onChange={(e) => {
                            setMonth(e.target.value);
                          }}
                        >
                          <option value="">Selecciona un mes</option>
                          <option value="1">Enero</option>
                          <option value="2">Febrero</option>
                          <option value="3">Marzo</option>
                          <option value="4">Abril</option>
                          <option value="5">Mayo</option>
                          <option value="6">Junio</option>
                          <option value="7">Julio</option>
                          <option value="8">Agosto</option>
                          <option value="9">Septiembre</option>
                          <option value="10">Octubre</option>
                          <option value="11">Noviembre</option>
                          <option value="12">Diciembre</option>
                        </Form.Select>
                      ) : null}
                    </Form.Group>
                  </Form>
                </Col>
              </Row>
            </div>
          ) : null}

          <div className="d-flex justify-content-between align-items-center">
            <h2 className="p-2 ws_qty_produccion">
              {load ? (
                <Skeleton width="150px" />
              ) : (
                "$" + number_format(dataProduccion, 2)
              )}
            </h2>
            <SwitchComponent
              isOn={valueSwitch}
              handleToggle={(e) => {
                setValueSwitch(!valueSwitch);
              }}
            />
          </div>

          {!load ? (
            <>
              <div style={{ height: 450, width: "100%" }}>
                <ResponsiveLine
                  data={data}
                  // tooltip={(point) => {
                  //   setPoint(point.point)
                  //   return null
                  // }}
                  margin={{ top: 50, right: 110, bottom: 50, left: 60 }}
                  xScale={{ type: "point" }}
                  yScale={{
                    type: "linear",
                    min: "auto",
                    max: "auto",
                    stacked: false,
                    reverse: false,
                  }}
                  yFormat=" >-.2f"
                  curve="monotoneX"
                  axisTop={null}
                  axisRight={null}
                  axisBottom={{
                    orient: "bottom",
                    tickSize: 5,
                    tickPadding: 5,
                    tickRotation: 0,
                    legend: "MES",
                    legendOffset: 36,
                    legendPosition: "middle",
                  }}
                  axisLeft={{
                    orient: "left",
                    tickSize: 5,
                    tickPadding: 5,
                    tickRotation: 0,
                    legend: "",
                    legendOffset: -40,
                    legendPosition: "middle",
                  }}
                  legends={[
                    {
                      anchor: "bottom-right",
                      direction: "column",
                      justify: false,
                      translateX: 100,
                      translateY: 0,
                      itemsSpacing: 0,
                      itemDirection: "left-to-right",
                      itemWidth: 80,
                      itemHeight: 20,
                      itemOpacity: 0.75,
                      symbolSize: 12,
                      symbolShape: "circle",
                      symbolBorderColor: "rgba(0, 0, 0, .5)",
                      effects: [
                        {
                          on: "hover",
                          style: {
                            itemBackground: "rgba(0, 0, 0, .03)",
                            itemOpacity: 1,
                          },
                        },
                      ],
                    },
                  ]}
                  colors={["#39b54a", "#672d8f", "#ff1d25"]}
                  borderColor={{ from: "color" }}
                  enableGridX={false}
                  lineWidth={3}
                  // enablePoints={false}
                  // pointSize={4}
                  // pointColor={{ theme: 'background' }}
                  // pointBorderWidth={2}
                  pointBorderColor={{ from: "serieColor" }}
                  pointLabelYOffset={-12}
                  useMesh={true}
                />
              </div>
              {point.x ? (
                <div>
                  <b>Información</b>
                  <p>Concepto: {point.data.label}</p>
                  <p>Valor: ${number_format(point.data.y, 2)}</p>
                </div>
              ) : null}
            </>
          ) : (
            <div style={{ width: "100%", padding: "10px" }}>
              <Skeleton width="100%" height={400} />
            </div>
          )}
        </Container>
      </div>
    </Col>
  );

  function changeYearGraph() {
    const dataSend = {
      id_login: usuario.id_usuario,
      promotor: dataSelect.promotor,
      year: yearG,
      periodo: periodo,
    };

    if (periodo === "mensual") {
      dataSend.month = month;
    }

    fetch(
      `https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=changeYearGraphPromotoria`,
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(dataSend),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        if (loadDatagraficaTipo) {
          setLoadDataGraficaTipo(false);
        }
        setCobranzaBefore(res.cobranza_before);
        setLoad(false);
        setDataGrafica(res.dataGrafica);
        setDataGraficaAcumulada(res.dataGraficaAcumulada);
        if (!valueSwitch) {
          quatrimestre != ""
            ? createAQ(res.dataGraficaAcumulada, parseInt(quatrimestre))
            : setData(res.dataGraficaAcumulada);
        } else {
          quatrimestre != ""
            ? createQ(res.dataGrafica, parseInt(quatrimestre))
            : setData(res.dataGrafica);
        }
      });
  }

  function createQ(data, periodo) {
    const dataQ1 = [],
      dataQ2 = [],
      dataQ3 = [];
    data.map((element, index) => {
      const q1 = [],
        q2 = [],
        q3 = [];
      element.data.forEach((element, index) => {
        if (index < 4) {
          if (index === 0) {
            q1.push({ label: element.label, x: "01 Ene", y: 0 });
          }
          q1.push(element);
        }
        if ((index > 3) & (index < 8)) {
          if (index === 4) {
            q2.push({ label: element.label, x: "01 May", y: 0 });
          }
          q2.push(element);
        }
        if ((index > 7) & (index < 12)) {
          if (index === 8) {
            q3.push({ label: element.label, x: "01 Sep", y: 0 });
          }
          q3.push(element);
        }
      });
      dataQ1.push({ id: element.id, color: element.color, data: q1 });
      dataQ2.push({ id: element.id, color: element.color, data: q2 });
      dataQ3.push({ id: element.id, color: element.color, data: q3 });
    });
    if (periodo === 1) setData(dataQ1);
    if (periodo === 2) setData(dataQ2);
    if (periodo === 3) setData(dataQ3);
  }

  function createAQ(data, periodo) {
    const dataAcumQ1 = [],
      dataAcumQ2 = [],
      dataAcumQ3 = [];
    data.map((element1, index1) => {
      const q1 = [],
        q2 = [],
        q3 = [];
      let acumuladoQ1 = 0,
        acumuladoQ2 = 0,
        acumuladoQ3 = 0;
      element1.data.forEach((element, index) => {
        if (index < 4) {
          if (index === 0) {
            q1.push({ label: element.label, x: "01 Ene", y: 0 });
          }
          q1.push(element);
          if (index === 3) {
            acumuladoQ1 = element.y;
          }
        }

        if ((index > 3) & (index < 8)) {
          if (index === 4) {
            q2.push({ label: element.label, x: "01 May", y: acumuladoQ1 });
          }
          q2.push(element);
          if (index === 7) {
            acumuladoQ2 = element.y;
          }
        }

        if ((index > 7) & (index < 12)) {
          if (index === 8) {
            q3.push({ label: element.label, x: "01 Sep", y: acumuladoQ2 });
          }
          q3.push(element);
        }
      });
      dataAcumQ1.push({ id: element1.id, color: element1.color, data: q1 });
      dataAcumQ2.push({ id: element1.id, color: element1.color, data: q2 });
      dataAcumQ3.push({ id: element1.id, color: element1.color, data: q3 });
    });
    if (periodo === 1) setData(dataAcumQ1);
    if (periodo === 2) setData(dataAcumQ2);
    if (periodo === 3) setData(dataAcumQ3);
  }

  function handleChangeButton(e) {
    const currentButton = e.target;
    const parents = currentButton.parentNode.childNodes;
    parents.forEach((element) => {
      element.classList.remove("active");
    });
    e.target.classList.add("active");
    let periodo = e.target.getAttribute("attr-name");
    setPeriodo(periodo);
  }
}

function DatePickerW({ onChange, year, selected, label="" }) {
  const currentYear = year ? year : new Date().getFullYear();
  const backYears = new Date(
    new Date().setFullYear(new Date().getFullYear() - 4)
  ).getFullYear();
  const [years, setYears] = useState([]);

  useEffect(() => {
    let arrYears = [];
    for (let index = backYears; index <= currentYear; index++) {
      arrYears.push(index);
    }
    setYears(arrYears);
  }, []);

  return (
    <div className="mb-2">
      <Row>
        <Col xs={4}>
          <Form>
            {(label!='') && <Form.Label className="ms-2">{label}</Form.Label>}
            <Form.Select
              value={selected}
              aria-label="Default select example"
              className="w-select-year"
              id=""
              onChange={onChange}
            >
              {years.length > 0
                ? years.map((element, index) => (
                    // <option value={element} key={index} selected={(element === selected) ? 'selected' : ''}>{element}</option>
                    <option value={element} key={index}>
                      {element}
                    </option>
                  ))
                : null}
            </Form.Select>
          </Form>
        </Col>
      </Row>
    </div>
  );
}

function DatePickerMonthW({ onChange, selected, className,label="" }) {
  const months = [
    { name: "Enero", value: "1" },
    { name: "Febrero", value: "2" },
    { name: "Marzo", value: "3" },
    { name: "Abril", value: "4" },
    { name: "Mayo", value: "5" },
    { name: "Junio", value: "6" },
    { name: "Julio", value: "7" },
    { name: "Agosto", value: "8" },
    { name: "Septiembre", value: "9" },
    { name: "Octubre", value: "10" },
    { name: "Noviembre", value: "11" },
    { name: "Diciembre", value: "12" },
  ];

  return (
    <div className="mb-2">
      <Row>
        <Col xs={4}>
          <Form>
            {(label!='') && <Form.Label className="ms-2">{label}</Form.Label>}
            <Form.Select
              aria-label="Default select example"
              className={`w-select-year ${className}`}
              id=""
              onChange={onChange}
            >
              {months.map((element, index) => (
                <option
                  value={element.value}
                  key={index}
                  selected={element.value === selected ? "selected" : ""}
                >
                  {element.name}
                </option>
              ))}
            </Form.Select>
          </Form>
        </Col>
      </Row>
    </div>
  );
}

function SelectMultipleHeader({ index, initState, setDataSelected }) {
  const { data, loadingData } = initState;
  const [viewTab, setViewTab] = useState(0);
  const [selectOficinas, setSelectOficinas] = useState([]);
  const [select, setSelect] = useState({
    oficinas: [],
    agentes: "0",
    tipo_agente: "0",
  });
  const { agentes = [], tipos = [] } = data[viewTab];

  const { oficinas = [] } = data[index];
  const arrOficinas = [];
  oficinas.map((element) => {
    arrOficinas.push({
      label: element.nombre_oficina,
      value: element.clave_oficina,
    });
  });

  useEffect(() => {
    setDataSelected(select);
  }, [select]);

  return (
    <Row>
      <Col xs={12} md={4}>
        {!loadingData ? (
          <React.Fragment>
            <Form.Label className="text-center ws_color_primario d-block">
              <p style={{ fontSize: "1.2rem" }} className="mb-0">
                Oficinas
              </p>
            </Form.Label>
            <MultiSelect
              options={arrOficinas}
              value={selectOficinas}
              onChange={(props) => {
                setSelectOficinas(props);
                const newOficinas = [];
                props.map((element) => {
                  newOficinas.push(element.value);
                });
                let newObj = { ...select };
                newObj.oficinas = newOficinas;
                setSelect(newObj);
              }}
              labelledBy="Selecciona una oficina"
              overrideStrings={{
                allItemsAreSelected: "Se ha seleccionado todo",
                clearSearch: "Limpiar Búsqueda",
                noOptions: "No hay datos",
                search: "Buscar",
                selectAll: "Seleccionar todo",
                selectAllFiltered: "Seleccionar todo (Filtrado)",
                selectSomeItems: "Elegir una oficina...",
              }}
              hasSelectAll={false}
            />
          </React.Fragment>
        ) : (
          <Skeleton />
        )}
      </Col>
      <Col xs={12} md={4}>
        {!loadingData ? (
          <React.Fragment>
            <Form.Label className="text-center ws_color_primario d-block">
              <p style={{ fontSize: "1.2rem" }} className="mb-0">
                Agentes
              </p>
            </Form.Label>
            <Form.Select
              className="ws_select_opt"
              aria-label="Default select example"
              value={select.agentes}
              id="agentes"
              name="agentes"
              onChange={(e) => {
                select.agentes = e.target.value;
                setSelect({
                  ...select,
                  [e.target.name]: e.target.value,
                });
              }}
            >
              {agentes.map((agente, index) => (
                <option value={agente.value} key={index}>
                  {agente.name}
                </option>
              ))}
            </Form.Select>
          </React.Fragment>
        ) : (
          <Skeleton />
        )}
      </Col>
      <Col xs={12} md={4}>
        {!loadingData ? (
          <React.Fragment>
            <Form.Label className="text-center ws_color_primario d-block">
              <p style={{ fontSize: "1.2rem" }} className="mb-0">
                Tipos
              </p>
            </Form.Label>
            <Form.Select
              className="ws_select_opt"
              aria-label="Default select example"
              value={select.tipo_agente}
              id="tipo_agente"
              name="tipo_agente"
              onChange={(e) => {
                select.tipo_agente = e.target.value;
                setSelect({
                  ...select,
                  [e.target.name]: e.target.value,
                });
              }}
            >
              {tipos.map((tipos, index) => (
                <option value={tipos.value} key={index}>
                  {tipos.name}
                </option>
              ))}
            </Form.Select>
          </React.Fragment>
        ) : (
          <Skeleton />
        )}
      </Col>
    </Row>
  );
}

function CardAgente({
  data = {
    nombre: "",
    foto: "",
    cargo: "",
    insignias: "3",
    produccion: "0",
    porcentaje: "0",
    stars: "0",
  },
  datosFicha = null,
  handleClickPoliza,
  handleClickInsignias,
  handleClickMetas,
  handleClickFichas,
  size = { xs: 12, sm: 12, md: 12, lg: 12, xl: 6, xxl: 6 },
}) {
  let tipo_agente = "";

  if (data.cargo == "1") {
    tipo_agente = "Agente FA";
  } else if (data.cargo == "2") {
    tipo_agente = "Agente consolidado";
  } else {
    tipo_agente = "Agente especial";
  }

  let stars = [];

  for (let index = 0; index < data.stars; index++) {
    stars.push(<IconStar key={index} width={"50px"} height={"50px"} />);
  }

  return (
    <Col
      xs={size.xs}
      sm={size.sm}
      md={size.md}
      lg={size.lg}
      xl={size.xl}
      xxl={size.xxl}
      className="mb-3"
    >
      <div
        className="ws_box"
        style={{
          position: "relative",
          paddingTop: "1rem",
          paddingBottom: "1rem",
        }}
      >
        {/* <div className="ws_backdrop d-flex justify-content-center align-items-center"><h1>No disponible por el momento</h1></div> */}
        <Container fluid>
          <div className="ws_card_agente">
            <div className="ws_box_right flex-column align-items-end">
              {/* <Dropdown className="ws_dropdown">
                <Dropdown.Toggle id="dropdown-basic">
                  <Image src={'/img/darkOpt.svg'} alt="icon_opt" className="ws_icon ms-2" />
                </Dropdown.Toggle>
                <Dropdown.Menu align="end">
                  <Dropdown.Item href="#">Quitar del dashboard</Dropdown.Item>
                  <Dropdown.Item href="#">Duplicar</Dropdown.Item>
                  <Dropdown.Item href="#">Ocultar en móvil</Dropdown.Item>
                  <Dropdown.Item href="#">Exportar</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown> */}
            </div>
            <div className="ws_card_body">
              <div className="d-flex gap-2">
                <Image
                  src={
                    data.foto != ""
                      ? data.foto
                      : "https://acyn.wsoft.com.mx/corp/img/profile.png"
                  }
                  className="ws_profile_agente"
                />
                <div className="d-flex flex-column">
                  <p className="ws_card_name mb-0 ms-2">{data.nombre}</p>
                  <div className="ws_card_rating">{stars}</div>
                  <p className="ws_card_cargo mb-1 ms-2 mt-1">
                    <b>{tipo_agente}</b>
                  </p>
                  <p className="ws_card_produccion mb-1 ms-2">
                    ${number_format(data.produccion, 2)}
                  </p>
                </div>
              </div>

              <div className="box_pr_bk_bar mt-4 mb-1">
                <div
                  className="box_pr_bar"
                  style={{
                    width: `${
                      data.porcentaje > 100
                        ? 100
                        : data.porcentaje < 0
                        ? 0
                        : data.porcentaje
                    }%`,
                    backgroundColor: "#0ca1b4",
                  }}
                ></div>
              </div>
              <p className="ws_card_porcentaje_texto">
                Participación de producción{" "}
                <span style={{ color: "#0ca1b4" }}>{data.porcentaje}%</span>
              </p>

              <div className="ws_card_buttons mt-5 d-flex flex-column gap-3 flex-md-row gap-md-0 gap-lg-3 justify-content-between">
                <Button
                  className="ws_btn_secundary_transparent btn-sm"
                  style={{ borderRadius: "2px" }}
                  onClick={handleClickPoliza}
                >
                  Pólizas nuevas / renovadas
                </Button>
                {/* <Button className="ws_btn_secundary_transparent btn-sm" style={{ borderRadius: '2px' }} onClick={handleClickInsignias}>Ver Insignias</Button> */}
                {/* <Button className="ws_btn_secundary_transparent btn-sm" style={{ borderRadius: '2px' }} onClick={handleClickMetas}>Agregar Metas</Button> */}
                {
                  (datosFicha!=null) && (
                    <Button
                      className="ws_btn_secundary_transparent btn-sm"
                      style={{ borderRadius: "2px" }}
                      onClick={handleClickFichas}
                    >
                      Ver Ficha
                    </Button>
                  )
                }
                
              </div>
            </div>
          </div>
        </Container>
      </div>
    </Col>
  );
}

//FORMATO EN NÚMEROS
function number_format(number, decimals, decPoint, thousandsSep) {
  number = (number + "").replace(/[^0-9+\-Ee.]/g, "");
  var n = !isFinite(+number) ? 0 : +number;
  var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
  var sep = typeof thousandsSep === "undefined" ? "," : thousandsSep;
  var dec = typeof decPoint === "undefined" ? "." : decPoint;
  var s = "";
  var toFixedFix = function (n, prec) {
    var k = Math.pow(10, prec);
    return "" + (Math.round(n * k) / k).toFixed(prec);
  };
  s = (prec ? toFixedFix(n, prec) : "" + Math.round(n)).split(".");
  if (s[0].length > 3) {
    s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
  }
  if ((s[1] || "").length < prec) {
    s[1] = s[1] || "";
    s[1] += new Array(prec - s[1].length + 1).join("0");
  }
  return s.join(dec);
}

function SingleSwitchConf({ isOn, id, className, handleSwitch = function () {} }) {
  const [valueSwitch, setValueSwitch] = useState(isOn);
  useEffect(()=>{
    setValueSwitch(isOn);
  },[isOn]);
  return (
    <SwitchOnOff
      isOn={valueSwitch}
      handleToggle={(e) => {
        setValueSwitch(!valueSwitch);
        handleSwitch();
      }}
      className={className}
    />
  );
}

function SingleSwitch({ isOn, id, className, handleSwitch = function () {} }) {
  const [valueSwitch, setValueSwitch] = useState(isOn);
  return (
    <SwitchOnOff
      isOn={valueSwitch}
      handleToggle={(e) => {
        setValueSwitch(!valueSwitch);
        handleSwitch();
      }}
      className={className}
    />
  );
}

function SingleSwitchConfirm({ isOn, id,text,className, handleSwitch = function () {} }) {
  const [valueSwitch, setValueSwitch] = useState(isOn);
  return (
    <SwitchOnOff
      isOn={valueSwitch}
      handleToggle={(e) => {
        if(window.confirm(text)){
          // setValueSwitch(!valueSwitch);
          handleSwitch();
        }
      }}
      className={className}
    />
  );
}

function SingleSwitch2({ isOn, id, className, handleSwitch = function () {},type }) {
  const [valueSwitch, setValueSwitch] = useState(isOn);
  useEffect(()=>{
    setValueSwitch(isOn);
  },[isOn])
  return (
    <SwitchOnOff
      isOn={valueSwitch}
      handleToggle={(e) => {
        setValueSwitch(!valueSwitch);
        handleSwitch(id,!valueSwitch,type);
      }}
      className={className}
    />
  );

}

function SingleSwitch3({ isOn, id, className, handleSwitch = function () {} }) {
  const [valueSwitch, setValueSwitch] = useState(isOn);
  useEffect(()=>{
    setValueSwitch(isOn);
  },[isOn])
  return (
    <SwitchOnOff
      isOn={valueSwitch}
      handleToggle={(e) => {
        setValueSwitch(!valueSwitch);
        handleSwitch(id,!valueSwitch);
      }}
      className={className}
    />
  );

}

function SingleSwitchLeft({ isOn, id, className,handleSwitch = function () {} }) {
  const [valueSwitch, setValueSwitch] = useState(isOn);
  useEffect(()=>{
    setValueSwitch(isOn);
  },[isOn]);
  return (
    <SwitchOnOffLeft
      isOn={valueSwitch}
      handleToggle={(e) => {
        setValueSwitch(!valueSwitch);
        handleSwitch();
      }}
      className={className}
    />
  );
}

function SingleSwitchLeft2({ isOn, id, className,handleSwitch = function () {} }) {
  const [valueSwitch, setValueSwitch] = useState(isOn);
  useEffect(()=>{
    setValueSwitch(isOn);
  },[isOn]);
  return (
    <SwitchOnOffLeft
      isOn={valueSwitch}
      handleToggle={(e) => {
        setValueSwitch(!valueSwitch);
        handleSwitch(!valueSwitch);
      }}
      className={className}
    />
  );
}

export {
  Navbar,
  NavbarLogin,
  Asidebar,
  Dashboard,
  BoxVentas,
  BoxMetas,
  BoxMetas2,
  TablaAgentes,
  TablaAgentesGrupo,
  TablaAgentesPromotoria,
  TablaHistorico,
  TablaBonosDiamante,
  TablaBonos24k,
  TablaBonosBuenaRacha,
  TablaBonosMalaRacha,
  TablaBonosTeExtranamos,
  TablaBonosEscalones,
  TablaBonosPago,
  TablaBonosReporteMensual,
  TablaGrupos,
  TablaFlotillas,
  TablaReportes,
  TablaEditarGrupos,
  TablaMisOficinas,
  TablaMisAgentes,
  TablaMisFormularios,
  TablaMisUsuarios,
  TablaMisPendientes,
  TablaAvanzado,
  GraficaPeriodo,
  GraficaPeriodoAgente,
  DatePickerW,
  DatePickerMonthW,
  ContentHeader,
  SelectMultipleHeader,
  CardAgente,
  TablaAgentesByQuatrimestre,
  TablaAgentesClaves,
  TablaLogros,
  CarteraIndividual,
  CarteraFlotillas,
  SegmentacionCartera,
  TablaPagoBonos,
  TablaPromotorias,
  TablaEditarPromotorias,
  TablaPolizas,
  FichaAgente,
  ReporteDiario,
  CumpleanosAutomatizados,
  CorreosConCopia,
  LogrosAutomatizados,
  ReporteDiarioGerentes,
  ReporteDiarioEjecutivos,
  SegmentacionCarteraOficina,
  CarteraIndividualOficina,
  CarteraFlotillasOficina,
  TablaPolizasAgente,
  BoxMetasOficina,
  GraficaPeriodoGrupo,
  GraficaPeriodoPromotoria,
  TablaMiFormularioAgentes,
  TablaReservaPendientesCobertura,
  TablaReservaPendientesMarca
};